import { useState, useEffect, useRef, useMemo } from "react";
import html2canvas from "html2canvas";

// ── Design tokens ──────────────────────────────────────────────
// Palette: deep navy anchor, warm sand background, vivid cobalt CTA,
// coral accent for urgency/status, soft slate for utility text
const T = {
  navy:    "#0A2540",
  sand:    "#EFF7F4",
  cobalt:  "#1565C0",
  cobaltL: "#E3EEFA",
  coral:   "#0A7D55",
  coralL:  "#E6F5EF",
  slate:   "#4B6B7A",
  white:   "#FFFFFF",
  border:  "#C8DDD6",
  green:   "#0A9E6A",
  greenL:  "#D6F5EA",
  amber:   "#0D7A48",
  amberL:  "#D1F0E4",
};

// ── Mock Data ──────────────────────────────────────────────────
const ICONS = {
  plumbing:    "data:image/png;base64,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",
  electrical:    "data:image/png;base64,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",
  handyman:    "data:image/png;base64,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",
  lawn:    "data:image/png;base64,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",
  cleaning:    "data:image/png;base64,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",
  detailing:    "data:image/png;base64,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",
  painting:    "data:image/png;base64,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",
  hvac:    "data:image/png;base64,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",
  security:    "data:image/png;base64,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",
  home_repairs:    "data:image/png;base64,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",
};

const CATEGORIES = [
  { id: "plumbing",    icon: ICONS.plumbing,    label: "Plumbing"      },
  { id: "electrical",  icon: ICONS.electrical,  label: "Electrical"    },
  { id: "handyman",    icon: ICONS.handyman,     label: "Handyman"      },
  { id: "lawn",        icon: ICONS.lawn,         label: "Lawn & Garden" },
  { id: "cleaning",    icon: ICONS.cleaning,     label: "Cleaning"      },
  { id: "detailing",   icon: ICONS.detailing,    label: "Auto Detail"   },
  { id: "painting",    icon: ICONS.painting,     label: "Painting"      },
  { id: "hvac",        icon: ICONS.hvac,         label: "HVAC"          },
  { id: "security",    icon: ICONS.security,     label: "Security"      },
  { id: "home_repairs",icon: ICONS.home_repairs, label: "Home Repairs"  },
  { id: "other",        icon: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%234B6B7A' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='5' cy='12' r='1.5'/%3E%3Ccircle cx='12' cy='12' r='1.5'/%3E%3Ccircle cx='19' cy='12' r='1.5'/%3E%3C/svg%3E", label: "Other" },
];

// Trades where the real repair cost usually can't be known until the pro
// shows up and looks at it — these are the categories a pro can set a
// diagnostic/trip fee for, charged at booking time instead of an hourly
// estimate. The follow-up repair (parts/labor) gets billed separately via
// an itemized invoice once the pro has actually diagnosed the job.
const DIAGNOSTIC_FEE_CATEGORIES = ["plumbing", "electrical", "hvac"];

// Availability status: 4 states instead of the old available/unavailable
// boolean-only badge. "available" and "limited" are still bookable now
// (keeps existing filters/booking buttons working); "booked" and "offline"
// are not.
const AVAILABILITY_STATUS = {
  available: { label:"Available",     dot:T.green, text:T.green, bg:T.greenL },
  limited:   { label:"Limited slots", dot:T.amber, text:T.amber, bg:T.amberL },
  booked:    { label:"Booked",        dot:T.coral, text:T.coral, bg:T.coralL },
  offline:   { label:"Offline",       dot:T.border,text:T.slate, bg:T.sand   },
};
// Back-compat: any pro without an explicit `status` falls back to the old
// boolean so nothing already using `pro.available` breaks.
const getAvailability = (pro) =>
  AVAILABILITY_STATUS[pro?.status] || (pro?.available ? AVAILABILITY_STATUS.available : AVAILABILITY_STATUS.booked);

const PROS = [
  { id:1, name:"Marcus Webb",    cat:"plumbing",   rating:4.9, reviews:127, rate:"$85/hr",  city:"The Woodlands", available:true,  status:"available", img:"MW", bio:"Licensed master plumber, 12 yrs exp. Emergency calls welcome.", jobs:340, badge:"Top Pro" },
  { id:2, name:"Sandra Torres",  cat:"cleaning",   rating:4.8, reviews:89,  rate:"$65/hr",  city:"Spring",        available:true,  status:"limited",   img:"ST", bio:"Residential & commercial deep cleaning. Eco-friendly products.", jobs:211, badge:"Verified" },
  { id:3, name:"Derek Okafor",   cat:"electrical", rating:5.0, reviews:54,  rate:"$110/hr", city:"Conroe",        available:false, status:"offline",   img:"DO", bio:"Licensed electrician. Panel upgrades, EV chargers, smart home.", jobs:178, badge:"Top Pro" },
  { id:4, name:"Lisa Nguyen",    cat:"lawn",       rating:4.7, reviews:203, rate:"$55/hr",  city:"Kingwood",      available:true,  status:"available", img:"LN", bio:"Full lawn care, landscaping design, irrigation systems.", jobs:501, badge:"Elite" },
  { id:5, name:"Tony Reeves",    cat:"handyman",   rating:4.8, reviews:71,  rate:"$70/hr",  city:"Humble",        available:false, status:"booked",    img:"TR", bio:"Drywall, tile, furniture assembly, door & window installs.", jobs:195, badge:"Verified" },
  { id:6, name:"Maria Castillo", cat:"painting",   rating:4.9, reviews:42,  rate:"$60/hr",  city:"The Woodlands", available:true,  status:"limited",   img:"MC", bio:"Interior & exterior. Color consultation included.", jobs:122, badge:"Verified" },
];

// ── Global Booking Registry (double-booking prevention) ─────────
// Key: "proId_date_time" → true means that slot is taken
const bookedSlots = {};

function isSlotTaken(proId, date, time) {
  return !!bookedSlots[`${proId}_${date}_${time}`];
}

function reserveSlot(proId, date, time) {
  bookedSlots[`${proId}_${date}_${time}`] = true;
}

function getProBookedDates(proId) {
  return Object.keys(bookedSlots)
    .filter(k => k.startsWith(`${proId}_`) && bookedSlots[k])
    .map(k => { const [,d,t] = k.split("_"); return { date:d, time:t }; });
}

// Compute the Nth occurrence date (n=0 is the base date itself) for a
// recurring booking series — used by BookingView's "make this recurring" flow.
function addInterval(dateStr, frequency, n) {
  const d = new Date(dateStr + 'T00:00:00');
  if (frequency === 'weekly')   d.setDate(d.getDate() + 7 * n);
  if (frequency === 'biweekly') d.setDate(d.getDate() + 14 * n);
  if (frequency === 'monthly')  d.setMonth(d.getMonth() + n);
  return d.toISOString().slice(0, 10);
}

const JOBS = [
  { id:1, title:"Leaking kitchen faucet",    cat:"plumbing",   budget:"$150–$250", posted:"2h ago",  city:"The Woodlands", status:"open",      bids:3 },
  { id:2, title:"Weekly lawn maintenance",   cat:"lawn",       budget:"$80/visit", posted:"4h ago",  city:"Spring",        status:"open",      bids:7 },
  { id:3, title:"GFCI outlet replacement",   cat:"electrical", budget:"$120–$180", posted:"1d ago",  city:"Conroe",        status:"assigned",  bids:5 },
  { id:4, title:"Deep clean before move-in", cat:"cleaning",   budget:"$200–$300", posted:"3h ago",  city:"Kingwood",      status:"open",      bids:2 },
  { id:5, title:"Drywall patch & paint",     cat:"handyman",   budget:"$300–$450", posted:"6h ago",  city:"Humble",        status:"open",      bids:4 },
  { id:6, title:"Full interior car detail",  cat:"detailing",  budget:"$150–$200", posted:"1h ago",  city:"The Woodlands", status:"open",      bids:1 },
];


// ── Supabase Data Hooks ────────────────────────────────────────
const SUPABASE_URL = 'https://ksaealvsimnybueigmhd.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtzYWVhbHZzaW1ueWJ1ZWlnbWhkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODY4NjExNzcsImV4cCI6MjEwMjQzNzE3N30.pQ6f2RidqF57AR1sXt2AGXpd-uuq6SbJXEryc6m1TCQ';

// ── Session (real per-user auth) ──────────────────────────────────
// Every Supabase call in this file used to authenticate as the shared
// anon key, never the logged-in user's own token. That's fine for
// public/no-login reads (browsing pros, jobs), but it means Postgres
// row-level-security policies like "only if this is your own row"
// could never actually fire — auth.uid() is only populated when a
// request carries a real user's JWT, and the anon key isn't one. This
// module is what fixes that: it holds the current session (from
// login/signup), persists it to localStorage so a page refresh doesn't
// silently drop back to the anon key, and refreshes the access token
// before it expires (Supabase access tokens are short-lived, ~1hr).
const SESSION_STORAGE_KEY = 'localy_session';
let SESSION = { accessToken: null, refreshToken: null, expiresAt: 0, userId: null };

function loadStoredSession() {
  try {
    const raw = localStorage.getItem(SESSION_STORAGE_KEY);
    if (raw) SESSION = JSON.parse(raw);
  } catch { /* localStorage unavailable or corrupt — just stay logged out */ }
}
loadStoredSession();

function setSession({ accessToken, refreshToken, expiresIn, userId }) {
  SESSION = {
    accessToken,
    refreshToken,
    expiresAt: Date.now() + ((expiresIn || 3600) * 1000),
    userId,
  };
  try { localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(SESSION)); } catch {}
}

function clearSession() {
  SESSION = { accessToken: null, refreshToken: null, expiresAt: 0, userId: null };
  try { localStorage.removeItem(SESSION_STORAGE_KEY); } catch {}
}

// Returns a valid access token for the current session, refreshing it
// first if it's expired or about to be (within 60s) — or null if nobody's
// logged in, in which case callers fall back to the anon key.
async function getSessionToken() {
  if (!SESSION.accessToken) return null;
  if (Date.now() < SESSION.expiresAt - 60000) return SESSION.accessToken;
  if (!SESSION.refreshToken) return SESSION.accessToken; // best effort — let the request itself fail if truly expired

  try {
    const res = await fetch(`${SUPABASE_URL}/auth/v1/token?grant_type=refresh_token`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'apikey': SUPABASE_KEY },
      body: JSON.stringify({ refresh_token: SESSION.refreshToken }),
    });
    const data = await res.json();
    if (data.access_token) {
      setSession({
        accessToken: data.access_token,
        refreshToken: data.refresh_token || SESSION.refreshToken,
        expiresIn: data.expires_in,
        userId: SESSION.userId,
      });
      return data.access_token;
    }
  } catch (err) {
    console.log('Session refresh error:', err.message);
  }
  return SESSION.accessToken;
}

// Bearer token for outgoing requests — the logged-in user's own token when
// available (so RLS policies keyed on auth.uid() actually work), the
// shared anon key otherwise (so logged-out/public reads still work).
async function authBearer() {
  return (await getSessionToken()) || SUPABASE_KEY;
}

// Generic Supabase fetch helper
async function sbFetch(table, params = '') {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/${table}${params}`, {
    headers: {
      'apikey': SUPABASE_KEY,
      'Authorization': `Bearer ${await authBearer()}`,
      'Content-Type': 'application/json',
    },
  });
  if (!res.ok) throw new Error(`Supabase error: ${res.status}`);
  return res.json();
}

// Generic Supabase insert helper
//
// This used to return res.json() unconditionally, even when the request
// failed — e.g. an RLS policy blocking the insert returns a 403 with a JSON
// body like {code, message, details, hint} instead of the inserted row.
// Every call site that did `Array.isArray(created) ? created[0]?.id : ...`
// would just find no `.id` on that error object and quietly treat it as
// "insert didn't return an id," while every call site with a
// `.catch(err => ...)` never fired at all, because nothing ever rejected —
// silently swallowing the *actual* reason (a blocked RLS policy, a bad
// foreign key, etc.) everywhere sbInsert is used across the app. Now it
// throws with the real Postgrest error message so those existing .catch
// blocks — already written throughout this file — finally have something
// real to log/report instead of a misleading generic fallback.
async function sbInsert(table, data) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/${table}`, {
    method: 'POST',
    headers: {
      'apikey': SUPABASE_KEY,
      'Authorization': `Bearer ${await authBearer()}`,
      'Content-Type': 'application/json',
      'Prefer': 'return=representation',
    },
    body: JSON.stringify(data),
  });
  const body = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(body?.message || body?.hint || `Supabase insert error: ${res.status}`);
  }
  return body;
}

// Generic Supabase update helper — same fix as sbInsert above: throw on a
// non-2xx response (RLS block, constraint violation, etc.) instead of
// silently returning the error body as if it were the updated row.
async function sbUpdate(table, id, data) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/${table}?id=eq.${id}`, {
    method: 'PATCH',
    headers: {
      'apikey': SUPABASE_KEY,
      'Authorization': `Bearer ${await authBearer()}`,
      'Content-Type': 'application/json',
      'Prefer': 'return=representation',
    },
    body: JSON.stringify(data),
  });
  const body = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(body?.message || body?.hint || `Supabase update error: ${res.status}`);
  }
  return body;
}

// Generic Supabase delete helper. `params` is a query string like
// "?homeowner_id=eq.123&pro_id=eq.456" — same filter syntax as sbFetch.
async function sbDelete(table, params) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/${table}${params}`, {
    method: 'DELETE',
    headers: {
      'apikey': SUPABASE_KEY,
      'Authorization': `Bearer ${await authBearer()}`,
      'Content-Type': 'application/json',
    },
  });
  return res.ok;
}

// Uploads a real file to Supabase Storage (the "photos" bucket — see
// photo_storage_migration.sql) and returns its public URL. `path` must
// start with the uploader's own user id (e.g. `${authUser.id}/profile.jpg`)
// to satisfy the storage RLS policies that lock each folder to its owner.
async function sbUploadFile(bucket, path, file) {
  const res = await fetch(`${SUPABASE_URL}/storage/v1/object/${bucket}/${path}`, {
    method: 'POST',
    headers: {
      'apikey': SUPABASE_KEY,
      'Authorization': `Bearer ${await authBearer()}`,
      'Content-Type': file.type || 'application/octet-stream',
      'x-upsert': 'true',
    },
    body: file,
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || `Upload failed (${res.status})`);
  }
  return `${SUPABASE_URL}/storage/v1/object/public/${bucket}/${path}`;
}

// Requests a short-lived signed URL for a file in a PRIVATE bucket (e.g.
// verification-docs — see verification_storage_migration.sql). Unlike the
// public "photos" bucket, private-bucket files have no permanent public
// URL — Supabase only hands one out on request, and only to whoever the
// storage RLS policy actually allows (the file's own owner, or an admin).
// Defaults to a 1-hour link, long enough to view/review a document.
async function sbGetSignedUrl(bucket, path, expiresIn = 3600) {
  const res = await fetch(`${SUPABASE_URL}/storage/v1/object/sign/${bucket}/${path}`, {
    method: 'POST',
    headers: {
      'apikey': SUPABASE_KEY,
      'Authorization': `Bearer ${await authBearer()}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ expiresIn }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.signedURL) throw new Error(data.message || 'Could not get a link to this document.');
  return `${SUPABASE_URL}/storage/v1${data.signedURL}`;
}

// Hook: fetch pros from Supabase with fallback to mock data
function usePros(filters = {}) {
  const [pros, setPros]       = useState(PROS); // start with mock data
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useState(() => {
    const fetchPros = async () => {
      try {
        setLoading(true);
        // approved=eq.true AND available=eq.true are always on, not just
        // when a filter asks for it — a pro who hasn't been admin-approved
        // yet, or who an admin has suspended, should never show up in the
        // public browse list no matter what other filters are (or aren't)
        // applied. This used to only gate on `approved`, so an admin
        // clicking "Suspend" on a pro (which only ever flipped `available`
        // to false) didn't actually remove them from what homeowners could
        // see — they just quietly kept showing up in Browse by Service.
        let params = '?select=id,user_id,bio,hourly_rate,diagnostic_fee,services,city,badge,subscription_tier,business_name,avg_rating,review_count,jobs_completed,available,users(full_name,avatar_url)&approved=eq.true&available=eq.true';
        if (filters.category)  params += `&services=cs.{${filters.category}}`;

        const data = await sbFetch('pro_profiles', params);

        if (data && data.length > 0) {
          // Map Supabase data to app format
          const mapped = data.map(p => ({
            id:       p.id,
            userId:   p.user_id, // the pro's real users.id — needed to message/push-notify them
            name:     p.users?.full_name || 'Pro',
            cat:      p.services?.[0] || 'handyman',
            services: p.services || [],
            diagnosticFee: p.diagnostic_fee || null,
            rating:   parseFloat(p.avg_rating) || 0,
            reviews:  p.review_count || 0,
            rate:     p.hourly_rate ? `$${p.hourly_rate}/hr` : 'Contact for rate',
            city:     p.city || 'The Woodlands',
            available:p.available ?? true,
            img:      (p.users?.full_name || 'PR').split(' ').map(n=>n[0]).join('').slice(0,2).toUpperCase(),
            bio:      p.bio || '',
            jobs:     p.jobs_completed || 0,
            badge:    p.badge || 'Verified',
            avatar:   p.users?.avatar_url || null,
            subscriptionTier: p.subscription_tier || 'free',
            isPlus:   p.subscription_tier === 'plus',
            businessName: p.business_name || null,
          }));
          setPros(mapped);
        }
        // If no real pros yet, keep mock data so app still looks good
      } catch (err) {
        console.log('Using mock pros data:', err.message);
        // Keep mock data on error
      } finally {
        setLoading(false);
      }
    };
    fetchPros();
  });

  return { pros, loading, error };
}

// Hook: fetch jobs from Supabase with fallback to mock data
function useJobs(filters = {}) {
  const [jobs, setJobs]       = useState(JOBS);
  const [loading, setLoading] = useState(true);

  useState(() => {
    const fetchJobs = async () => {
      try {
        let params = '?select=id,title,category,description,budget_min,budget_max,city,status,bid_count,created_at,users(full_name)';
        params += '&order=created_at.desc';
        if (filters.status)   params += `&status=eq.${filters.status}`;
        if (filters.category) params += `&category=eq.${filters.category}`;

        const data = await sbFetch('jobs', params);

        if (data && data.length > 0) {
          const mapped = data.map(j => ({
            id:     j.id,
            title:  j.title,
            cat:    j.category,
            budget: j.budget_min && j.budget_max ? `$${j.budget_min}–$${j.budget_max}` : 'Negotiable',
            posted: formatTimeAgo(j.created_at),
            createdAt: j.created_at,
            city:   j.city || 'The Woodlands',
            status: j.status || 'open',
            bids:   j.bid_count || 0,
            desc:   j.description,
          }));
          setJobs(mapped);
        }
      } catch (err) {
        console.log('Using mock jobs data:', err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchJobs();
  });

  return { jobs, loading };
}

// Hook: post a new job to Supabase
async function postJob(jobData, homeownerId) {
  try {
    const [minStr, maxStr] = (jobData.budget || '').replace(/[$]/g,'').split(/[–-]/);
    const result = await sbInsert('jobs', {
      homeowner_id: homeownerId,
      title:        jobData.title,
      category:     jobData.cat,
      description:  jobData.desc,
      budget_min:   parseInt(minStr) || null,
      budget_max:   parseInt(maxStr) || null,
      city:         jobData.city || 'The Woodlands',
      status:       'open',
    });
    return { data: result, error: null };
  } catch (err) {
    return { data: null, error: err.message };
  }
}

// Hook: fetch conversations from Supabase.
//
// This used to initialize straight to the CONVOS mock array and only ever
// call setConvos() if the real fetch found rows — so a real logged-in user
// with zero real conversations (the normal case for a new account) saw 4
// hardcoded fake threads (Marcus Webb, Lisa Nguyen, Sandra Torres, Tony
// Reeves) with no way to tell they weren't real. Same "keep mock data so
// the screen still looks good" pattern already removed elsewhere this
// session (map pins, notifications, earnings) — now removed here too: a
// real user always gets their real conversations, even if that's zero.
function useConversations(userId, userType) {
  const [convos, setConvos] = useState([]);
  const [loading, setLoading] = useState(true);

  useState(() => {
    if (typeof userId !== 'string') { setLoading(false); return; }
    const fetchConvos = async () => {
      try {
        const field = userType === 'homeowner' ? 'homeowner_id' : 'pro_id';
        const data = await sbFetch('conversations',
          `?${field}=eq.${userId}&select=*,homeowner:users!homeowner_id(id,full_name),pro:pro_profiles!pro_id(user_id,users(full_name))&order=last_message_at.desc`
        );
        setConvos(Array.isArray(data) ? data.map(c => ({
          id:       c.id,
          name:     userType === 'homeowner'
                      ? c.pro?.users?.full_name || 'Pro'
                      : c.homeowner?.full_name || 'Homeowner',
          init:     (userType === 'homeowner'
                      ? c.pro?.users?.full_name
                      : c.homeowner?.full_name || 'HO')
                    .split(' ').map(n=>n[0]).join('').slice(0,2).toUpperCase(),
          lastMsg:  c.last_message || '',
          time:     formatTimeAgo(c.last_message_at),
          unread:   0,
          job:      'Booking',
          // Who to push-notify when the current user sends a message —
          // the other party's real users.id (not pro_profiles.id).
          recipientUserId: userType === 'homeowner' ? (c.pro?.user_id || null) : (c.homeowner_id || null),
        })) : []);
      } catch (err) {
        console.log('Conversations fetch error:', err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchConvos();
  });

  return { convos, loading };
}

// Mock bookings shown until a homeowner has real rows in Supabase
// Hook: fetch a homeowner's (or pro's) bookings from Supabase.
//
// This used to initialize to (and fall back to) two hardcoded bookings —
// "Lawn maintenance" with Lisa Nguyen, "Deep cleaning" with Sandra Torres —
// whenever the real fetch came back empty. Same "keep mock data so the
// screen still looks good" pattern removed everywhere else this session:
// a real homeowner/pro with zero real bookings now sees zero, not two
// fake ones dressed up as real jobs.
function useBookings(authUser, userType) {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [, forceUpdate] = useState(0);

  // Re-render whenever BOOKING_STORE changes (e.g. a pro marks a job
  // in-progress/complete) so status updates show up immediately without
  // needing to navigate away and back.
  useEffect(() => {
    const unsubscribe = BOOKING_STORE.subscribe(() => forceUpdate(n => n + 1));
    return unsubscribe;
  }, []);

  useState(() => {
    if (!authUser?.id) { setLoading(false); return; }
    const fetchBookings = async () => {
      try {
        // homeowner_id references users.id directly. pro_id references
        // pro_profiles.id (not users.id), so the pro side needs a lookup
        // first via getProProfileId() below.
        let params;
        if (userType === 'pro') {
          const proId = await getProProfileId(authUser.id);
          if (!proId) { setLoading(false); return; }
          params = `?pro_id=eq.${proId}&select=*,jobs(title),homeowner:users!homeowner_id(id,full_name)&order=created_at.desc`;
        } else {
          params = `?homeowner_id=eq.${authUser.id}&select=*,jobs(title),pro_profiles(id,business_name,users(full_name))&order=created_at.desc`;
        }
        const data = await sbFetch('bookings', params);
        setBookings(Array.isArray(data) ? data.map(b => {
          const when = b.scheduled_date ? new Date(`${b.scheduled_date}T${b.scheduled_time || '00:00'}`) : null;
          const hoursUntil = when ? Math.round((when.getTime() - Date.now()) / 3600000) : 999;
          return {
            id:          b.id,
            job:         b.jobs?.title || b.description || 'Booking',
            pro:         b.pro_profiles?.users?.full_name || 'Pro',
            proBusinessName: b.pro_profiles?.business_name || null,
            client:      b.homeowner?.full_name || 'Client',
            homeownerId: b.homeowner?.id || b.homeowner_id || null,
            proId:       b.pro_id || null,
            date:        b.scheduled_date ? `${b.scheduled_date} ${b.scheduled_time || ''}`.trim() : '',
            status:      b.status || 'pending',
            total:       b.total_amount || b.amount || 0,
            hoursUntil:  Number.isFinite(hoursUntil) ? hoursUntil : 999,
            beforePhotoUrl: b.before_photo_url || null,
            afterPhotoUrl:  b.after_photo_url || null,
          };
        }) : []);
      } catch (err) {
        console.log('Bookings fetch error:', err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchBookings();
  });

  // Merge in anything booked this session via BOOKING_STORE — this is what
  // makes a freshly-confirmed booking show up in "My Jobs" immediately, even
  // for the app's mock/demo pros where the real Supabase insert above is
  // intentionally skipped (see createBooking's real-vs-mock guard).
  const merged = [...BOOKING_STORE.bookings, ...bookings]
    .filter((b, i, arr) => arr.findIndex(x => x.id === b.id) === i);

  return { bookings: merged, loading };
}

// Create a real booking row in Supabase. No-ops (and lets the caller keep
// using local/mock state) unless both the homeowner and the pro are backed
// by real Supabase rows — recognizable because their ids are UUID strings,
// while the mock PROS array uses small integer ids.
async function createBooking({ pro, homeownerId, date, time, desc, amount, homeownerName }) {
  try {
    if (!homeownerId || !pro?.id || typeof pro.id !== 'string') {
      return { data: null, error: 'skipped (mock pro or no logged-in user)' };
    }
    const fee = amount ? Math.round(amount * 0.12) : null;
    const result = await sbInsert('bookings', {
      homeowner_id:   homeownerId,
      pro_id:         pro.id,
      scheduled_date: date,
      scheduled_time: time,
      description:    desc,
      amount:         amount || null,
      service_fee:    fee,
      total_amount:   amount ? amount + fee : null,
      status:         'pending',
    });
    // Tell the pro — the "Booking Confirmed!" screen right after this call
    // has always claimed "[pro] has been notified," but nothing ever
    // actually notified them; the request just silently sat in Supabase
    // until the pro happened to check their dashboard.
    if (pro.userId) {
      sendPushNotification(
        pro.userId,
        'New booking request 📅',
        `${homeownerName || 'A homeowner'} requested "${desc || 'a booking'}"${date ? ` on ${date}` : ''}.`,
        { type: 'booking_status' }
      );
    }
    return { data: result, error: null };
  } catch (err) {
    return { data: null, error: err.message };
  }
}

// Hook: fetch every invoice (and its line items) tied to a booking — a
// diagnostic-fee booking might have zero (nothing extra was needed) or one
// invoice once the pro sends the itemized repair cost. Ordered newest
// first so the most recent invoice shows up on top if a job ever needed
// more than one.
function useInvoices(bookingId) {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (typeof bookingId !== 'string') { setLoading(false); return; }
    setLoading(true);
    (async () => {
      try {
        const rows = await sbFetch('invoices',
          `?booking_id=eq.${bookingId}&select=*,pro_profiles(user_id),invoice_line_items(*)&order=created_at.desc`
        );
        setInvoices(Array.isArray(rows) ? rows.map(r => ({
          id:          r.id,
          bookingId:   r.booking_id,
          proId:       r.pro_id,
          proUserId:   r.pro_profiles?.user_id || null,
          homeownerId: r.homeowner_id,
          status:      r.status || 'draft',
          subtotal:    r.subtotal || 0,
          tax:         r.tax || 0,
          total:       r.total || 0,
          notes:       r.notes || '',
          createdAt:   r.created_at,
          items: Array.isArray(r.invoice_line_items) ? r.invoice_line_items.map(li => ({
            id:          li.id,
            description: li.description,
            itemType:    li.item_type || 'other',
            quantity:    li.quantity || 1,
            unitPrice:   li.unit_price || 0,
            amount:      li.amount || 0,
          })) : [],
        })) : []);
      } catch (err) {
        console.log('Invoices fetch error:', err.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [bookingId]);

  return { invoices, loading };
}

// Create an itemized invoice (with its line items) tied to a booking, and
// send it straight to the homeowner for review — pros don't currently have
// a "save as draft, send later" need, so this always inserts as 'sent'.
async function createInvoiceAndSend({ bookingId, proId, homeownerId, items, notes, taxAmount }) {
  try {
    if (!bookingId || !proId || !homeownerId) {
      return { data: null, error: 'Missing booking, pro, or homeowner id.' };
    }
    const cleanItems = (items || []).filter(it => it.description && Number(it.amount) > 0);
    if (cleanItems.length === 0) {
      return { data: null, error: 'Add at least one line item with a description and amount.' };
    }
    const subtotal = cleanItems.reduce((sum, it) => sum + Math.round(Number(it.amount) || 0), 0);
    const tax = Math.round(Number(taxAmount) || 0);
    const total = subtotal + tax;

    const invoiceRows = await sbInsert('invoices', {
      booking_id: bookingId, pro_id: proId, homeowner_id: homeownerId,
      status: 'sent', subtotal, tax, total,
      notes: notes || null, sent_at: new Date().toISOString(),
    });
    const invoice = Array.isArray(invoiceRows) ? invoiceRows[0] : invoiceRows;
    if (!invoice?.id) return { data: null, error: 'Invoice insert returned no id.' };

    await sbInsert('invoice_line_items', cleanItems.map(it => ({
      invoice_id:  invoice.id,
      description: it.description,
      item_type:   it.itemType || 'other',
      quantity:    Number(it.quantity) || 1,
      unit_price:  Math.round(Number(it.unitPrice) || 0),
      amount:      Math.round(Number(it.amount) || 0),
    })));

    return { data: { ...invoice, total }, error: null };
  } catch (err) {
    return { data: null, error: err.message };
  }
}

// Helper: look up a logged-in pro's pro_profiles.id from their auth user id.
// bids.pro_id and bookings.pro_id both reference pro_profiles.id, not the
// auth users.id, so this lookup is needed before a pro can write either.
async function getProProfileId(userId) {
  try {
    const rows = await sbFetch('pro_profiles', `?user_id=eq.${userId}&select=id`);
    return rows?.[0]?.id || null;
  } catch {
    return null;
  }
}

// Find the existing conversation between this homeowner and this pro, or
// create one. Used by the "Message" / "Contact Pro" buttons, which used to
// just switch to the Messages tab with nothing selected — no conversation
// ever actually got created, so the homeowner landed on their inbox with no
// way to talk to the pro they just tapped.
async function getOrCreateConversation(homeownerId, proProfileId) {
  try {
    const existing = await sbFetch('conversations', `?homeowner_id=eq.${homeownerId}&pro_id=eq.${proProfileId}&select=id&limit=1`);
    if (existing?.[0]?.id) return { id: existing[0].id, error: null };
    const created = await sbInsert('conversations', { homeowner_id: homeownerId, pro_id: proProfileId });
    const newId = Array.isArray(created) ? created[0]?.id : created?.id;
    return { id: newId || null, error: newId ? null : 'conversation insert returned no id' };
  } catch (err) {
    return { id: null, error: err.message };
  }
}

// Create a real bid row in Supabase. Same real-vs-mock guard as createBooking:
// only proceeds once the job has a real (UUID) id and the pro is logged in
// with a real pro_profiles row.
async function createBid({ jobId, proUserId, amount, desc, eta, availableText, instantBook }) {
  try {
    if (!proUserId || typeof jobId !== 'string') {
      return { data: null, error: 'skipped (mock job or no logged-in pro)' };
    }
    const proId = await getProProfileId(proUserId);
    if (!proId) return { data: null, error: 'no pro_profiles row yet' };

    // A pro should only ever have one active bid on a given job — adjusting
    // their price/notes is an update to that bid, not a second competing
    // bid from the same person. Check for an existing non-terminal bid
    // (pending or countered) from this pro on this job first; if one
    // exists, update it in place instead of inserting a duplicate.
    const existingRows = await sbFetch('bids', `?job_id=eq.${jobId}&pro_id=eq.${proId}&select=id,status&order=created_at.desc&limit=1`);
    const existingBid = existingRows?.[0];
    const isUpdate = existingBid && !['withdrawn', 'declined'].includes(existingBid.status);

    // Free tier: cap how many jobs a pro can have an active bid on at once
    // — a Pro Plus perk is skipping this limit entirely (see
    // pro_plus_migration.sql). Only a genuinely new bid counts against the
    // cap; resubmitting/updating an existing bid on this same job never
    // does, since that's not a new competing bid.
    if (!isUpdate) {
      const FREE_TIER_ACTIVE_BID_CAP = 5;
      const proRow = await sbFetch('pro_profiles', `?id=eq.${proId}&select=subscription_tier`);
      const isPlus = proRow?.[0]?.subscription_tier === 'plus';
      if (!isPlus) {
        const activeBids = await sbFetch('bids', `?pro_id=eq.${proId}&status=in.(pending,countered)&select=id`);
        if ((activeBids?.length || 0) >= FREE_TIER_ACTIVE_BID_CAP) {
          return { data: null, error: `Free plan is limited to ${FREE_TIER_ACTIVE_BID_CAP} active bids at a time. Upgrade to Pro Plus for unlimited bids, or withdraw an older bid first.` };
        }
      }
    }

    const bidFields = {
      amount:         Number(amount) || null,
      description:    desc,
      eta,
      available_when: availableText,
      instant_book:   !!instantBook,
      // Resubmitting resets a countered bid back to pending so the
      // homeowner sees it as a fresh offer to reconsider.
      status:         'pending',
    };

    const result = isUpdate
      ? await sbUpdate('bids', existingBid.id, bidFields)
      : await sbInsert('bids', { job_id: jobId, pro_id: proId, ...bidFields });

    // Notify the homeowner who posted the job — best-effort, never blocks
    // the bid itself if this lookup or the push send fails.
    try {
      const jobRows = await sbFetch('jobs', `?id=eq.${jobId}&select=homeowner_id,title`);
      const homeownerId = jobRows?.[0]?.homeowner_id;
      if (homeownerId) {
        sendPushNotification(
          homeownerId,
          isUpdate ? 'A pro updated their bid' : 'New bid on your job',
          `You got a $${amount} bid on "${jobRows[0].title || 'your job'}"`,
          { type: 'bid', jobId }
        );
      }
    } catch (notifyErr) {
      console.log('Bid notification lookup error:', notifyErr.message);
    }

    return { data: result, error: null, updated: isUpdate };
  } catch (err) {
    return { data: null, error: err.message };
  }
}

// Fetch a pro's own submitted bids, with enough job/homeowner info to show
// status and to let the pro message the homeowner directly. Before this, a
// pro had no way at all to see the bids they'd placed or whether one had
// been accepted — JobBoardView only ever showed open jobs to bid on, never
// what happened after.
function useMyBids(authUser) {
  const [bids, setBids] = useState([]);
  const [loading, setLoading] = useState(true);

  useState(() => {
    if (typeof authUser?.id !== 'string') { setLoading(false); return; }
    (async () => {
      try {
        const proId = await getProProfileId(authUser.id);
        if (!proId) { setLoading(false); return; }
        const rows = await sbFetch('bids',
          `?pro_id=eq.${proId}&select=*,jobs(id,title,city,status,homeowner_id,homeowner:users!homeowner_id(id,full_name))&order=created_at.desc`
        );
        setBids(Array.isArray(rows) ? rows.map(b => ({
          id:            b.id,
          jobId:         b.job_id,
          jobTitle:      b.jobs?.title || 'Job',
          city:          b.jobs?.city || '',
          jobStatus:     b.jobs?.status || 'open',
          amount:        b.amount,
          counterAmount: b.counter_amount,
          counterAvailableWhen: b.counter_available_when || '',
          status:        b.status || 'pending',
          homeownerId:   b.jobs?.homeowner_id || null,
          homeownerName: b.jobs?.homeowner?.full_name || 'Homeowner',
          submitted:     formatTimeAgo(b.created_at),
        })) : []);
      } catch (err) {
        console.log('My bids fetch error:', err.message);
      } finally {
        setLoading(false);
      }
    })();
  });

  return { bids, loading };
}

// Hook: fetch a pro's completed-booking earnings from Supabase. This used to
// fall back to 15 hand-picked fake entries (specifically chosen to add up to
// "$705 this month, $1,045 last month") whenever the real query came back
// empty or errored — so a pro whose real earnings query happened to fail
// (or who just hadn't completed a job that month) would see confident,
// invented revenue numbers with no indication they weren't real. Now it
// always reflects the truth: real entries if there are any, otherwise none.
function useProEarnings(authUser) {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useState(() => {
    if (!authUser?.id) { setLoading(false); return; }
    const fetchEarnings = async () => {
      try {
        const proId = await getProProfileId(authUser.id);
        if (!proId) { setLoading(false); return; }
        const params = `?pro_id=eq.${proId}&status=eq.completed&select=amount,total_amount,completed_at,scheduled_date&order=completed_at.desc`;
        const data = await sbFetch('bookings', params);
        setEntries(Array.isArray(data) ? data.map(b => ({
          date:   b.completed_at || b.scheduled_date,
          amount: b.total_amount || b.amount || 0,
        })) : []);
      } catch (err) {
        console.log('Earnings fetch error:', err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchEarnings();
  });

  return { entries, loading };
}

// Hook: fetch the logged-in pro's own real stats (avg_rating, jobs_completed)
// from pro_profiles. Used to replace the Dashboard's hardcoded "Avg Rating:
// 4.9★" / "Response: 98%" tiles — avg_rating is a real column already
// maintained elsewhere (reviews update it), but there is no real
// "response rate" tracked anywhere in the schema, so that tile is replaced
// with lifetime jobs completed instead, which IS real.
function useMyProStats(authUser) {
  const [stats, setStats] = useState({ avgRating: null, jobsCompleted: null, reviewCount: null });
  const [loading, setLoading] = useState(true);

  useState(() => {
    if (!authUser?.id) { setLoading(false); return; }
    (async () => {
      try {
        const rows = await sbFetch('pro_profiles', `?user_id=eq.${authUser.id}&select=avg_rating,jobs_completed,review_count&limit=1`);
        const row = rows?.[0];
        if (row) {
          setStats({
            avgRating: row.avg_rating != null ? Number(row.avg_rating) : null,
            jobsCompleted: row.jobs_completed || 0,
            reviewCount: row.review_count || 0,
          });
        }
      } catch (err) {
        console.log('Pro stats fetch error:', err.message);
      } finally {
        setLoading(false);
      }
    })();
  });

  return { ...stats, loading };
}

// Pure helper: this-month vs last-month totals from a list of {date, amount}
function summarizeEarnings(entries) {
  const now = new Date();
  const curM = now.getMonth(), curY = now.getFullYear();
  const prev = new Date(curY, curM - 1, 1);
  const prevM = prev.getMonth(), prevY = prev.getFullYear();

  let thisMonthTotal = 0, thisMonthCount = 0, lastMonthTotal = 0;
  entries.forEach(e => {
    const d = new Date(e.date);
    if (d.getFullYear() === curY && d.getMonth() === curM) {
      thisMonthTotal += e.amount;
      thisMonthCount += 1;
    } else if (d.getFullYear() === prevY && d.getMonth() === prevM) {
      lastMonthTotal += e.amount;
    }
  });
  const pctChange = lastMonthTotal > 0
    ? Math.round(((thisMonthTotal - lastMonthTotal) / lastMonthTotal) * 100)
    : (thisMonthTotal > 0 ? 100 : 0);

  return { thisMonthTotal, thisMonthCount, lastMonthTotal, pctChange };
}

// Pure helper: bucket earnings into the last N 7-day windows for a bar chart
function weeklyBuckets(entries, weeks = 8) {
  const now = new Date();
  const buckets = [];
  for (let i = weeks - 1; i >= 0; i--) {
    const end = new Date(now); end.setDate(end.getDate() - i * 7);
    const start = new Date(end); start.setDate(start.getDate() - 6);
    const total = entries.reduce((sum, e) => {
      const d = new Date(e.date);
      return (d >= start && d <= end) ? sum + e.amount : sum;
    }, 0);
    buckets.push({ label: `${start.getMonth() + 1}/${start.getDate()}`, total });
  }
  return buckets;
}

// Mock referrals shown until a homeowner has real rows in Supabase
const MOCK_REFERRALS = [
  { id: 1, name: "Jordan M.",  status: "rewarded", amount: 10, date: "Aug 2"  },
  { id: 2, name: "Priya K.",   status: "pending",  amount: 10, date: "Aug 12" },
];

// Hook: fetch a user's sent referrals from Supabase, mock fallback
function useReferrals(authUser) {
  const [referrals, setReferrals] = useState(MOCK_REFERRALS);
  const [loading, setLoading]     = useState(true);

  useState(() => {
    if (!authUser?.id) { setLoading(false); return; }
    const fetchReferrals = async () => {
      try {
        const params = `?referrer_id=eq.${authUser.id}&select=*,referred:users!referred_id(full_name)&order=created_at.desc`;
        const data = await sbFetch('referrals', params);
        if (data && data.length > 0) {
          const mapped = data.map(r => ({
            id:       r.id,
            name:     r.referred?.full_name || 'A friend',
            status:   r.status === 'rewarded' ? 'rewarded' : 'pending',
            redeemed: !!r.redeemed_at,
            amount:   (r.reward_amount || 1000) / 100,
            date:     formatTimeAgo(r.created_at),
          }));
          setReferrals(mapped);
        }
        // If no real referrals yet, keep mock data so the screen still looks good
      } catch (err) {
        console.log('Using mock referrals:', err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchReferrals();
  });

  return { referrals, loading };
}

// Called after a payment succeeds — if the paying user was themselves
// referred by someone (a still-pending row where they're the referred_id),
// this is their first completed booking, so the referrer's $10 credit is
// unlocked. No-ops silently for mock/guest users, same safety pattern as
// the rest of the Supabase wiring.
async function rewardReferralIfEligible(authUser) {
  if (!authUser?.id) return;
  try {
    const rows = await sbFetch('referrals', `?referred_id=eq.${authUser.id}&status=eq.pending&select=id&limit=1`);
    if (rows && rows.length > 0) {
      await sbUpdate('referrals', rows[0].id, { status: 'rewarded', completed_at: new Date().toISOString() });
    }
  } catch (err) {
    console.log('Referral reward sync error:', err);
  }
}

// Hook: how much unredeemed referral credit a user has available to apply
// at checkout right now. Only counts rows already 'rewarded' (their
// referred friend's first payment already went through) that haven't been
// spent on a previous booking yet — see redeemReferralCredit() below for
// where that gets marked. Needs a `redeemed_at` column on `referrals`
// (nullable timestamp, added via a small migration — see
// referral_credit_migration.sql) since the original schema only tracked
// pending/rewarded, not spent/unspent.
function useReferralCredit(authUser) {
  const [creditCents, setCreditCents] = useState(0);
  const [creditRowIds, setCreditRowIds] = useState([]);
  const [loading, setLoading] = useState(true);

  useState(() => {
    if (!authUser?.id) { setLoading(false); return; }
    (async () => {
      try {
        const rows = await sbFetch('referrals',
          `?referrer_id=eq.${authUser.id}&status=eq.rewarded&redeemed_at=is.null&select=id,reward_amount`
        );
        if (Array.isArray(rows) && rows.length > 0) {
          setCreditCents(rows.reduce((a, r) => a + (r.reward_amount || 1000), 0));
          setCreditRowIds(rows.map(r => r.id));
        }
      } catch (err) {
        // Most likely cause: the redeemed_at column hasn't been added yet
        // (see migration file). Fails quiet — no credit is just offered.
        console.log('Referral credit fetch error:', err.message);
      } finally {
        setLoading(false);
      }
    })();
  });

  return { creditCents, creditRowIds, loading };
}

// Marks referral credit rows as spent once they've actually been applied to
// a real charge. Without this the same $10 could be reapplied to every
// booking forever instead of being a one-time reward.
async function redeemReferralCredit(rowIds) {
  if (!rowIds || rowIds.length === 0) return;
  try {
    await Promise.all(rowIds.map(id => sbUpdate('referrals', id, { redeemed_at: new Date().toISOString() })));
  } catch (err) {
    console.log('Referral credit redeem error:', err.message);
  }
}

// ── Push Notifications (Firebase Cloud Messaging) ────────────────
// Firebase project config — these values are NOT secret (they're meant to
// be embedded in client code, same as the Stripe publishable key above),
// but they're specific to your Firebase project, so they need to be swapped
// in from the Firebase Console (Project Settings → General → Your apps).
const FIREBASE_CONFIG = {
  apiKey:            "AIzaSyDBwyPW4Nm1_Vm3-YXLnuNusS70Hy9CPaE",
  authDomain:        "localy-6e266.firebaseapp.com",
  projectId:         "localy-6e266",
  storageBucket:     "localy-6e266.firebasestorage.app",
  messagingSenderId: "834896045850",
  appId:             "1:834896045850:web:5afa3c51e52a0698e8eea3",
};
// From Project Settings → Cloud Messaging → Web Push certificates
const FIREBASE_VAPID_KEY = "BCWIN_oE-AHfGLV64_PdQ0NDCo2IVWYeQnLYkihNHK2T-S_jBie-u2nvb19ohAF4m9zYPZ5W1JCLHTaywxE-Wv4";

// Load Firebase's compat SDK dynamically — same pattern as loadStripe()
// in PaymentView, so no npm/build changes are needed for this to work.
function loadFirebaseMessaging() {
  return new Promise((resolve, reject) => {
    if (window.firebase && window.firebase.messaging) { resolve(window.firebase); return; }
    const s1 = document.createElement('script');
    s1.src = 'https://www.gstatic.com/firebasejs/11.1.0/firebase-app-compat.js';
    s1.onload = () => {
      const s2 = document.createElement('script');
      s2.src = 'https://www.gstatic.com/firebasejs/11.1.0/firebase-messaging-compat.js';
      s2.onload = () => resolve(window.firebase);
      s2.onerror = () => reject(new Error('Failed to load Firebase Messaging SDK'));
      document.head.appendChild(s2);
    };
    s1.onerror = () => reject(new Error('Failed to load Firebase SDK'));
    document.head.appendChild(s1);
  });
}

// Hook: manages the browser's notification permission + FCM device token
// for the logged-in user. Nothing here fires automatically — enable() is
// meant to be called from an explicit "Enable Notifications" button, since
// browsers require a user gesture and silently auto-prompting is bad UX
// (and often just gets auto-denied).
function usePushNotifications(authUser) {
  const [status, setStatus] = useState(
    typeof Notification !== 'undefined' ? Notification.permission : 'unsupported'
  ); // 'default' | 'granted' | 'denied' | 'unsupported'
  const [enabling, setEnabling] = useState(false);
  const [error, setError] = useState("");

  // Once permission is granted, listen for notifications that arrive while
  // the app is open in the foreground (background messages are handled by
  // the service worker instead — see public/firebase-messaging-sw.js).
  useEffect(() => {
    if (typeof Notification === 'undefined' || status !== 'granted') return;
    let cancelled = false;
    (async () => {
      try {
        const firebase = await loadFirebaseMessaging();
        if (cancelled) return;
        if (!firebase.apps.length) firebase.initializeApp(FIREBASE_CONFIG);
        const messaging = firebase.messaging();
        messaging.onMessage((payload) => {
          const n = payload?.notification || {};
          try { new Notification(n.title || 'Localy', { body: n.body || '', icon: '/logo192.png' }); } catch {}
        });
      } catch (err) {
        console.log('Push foreground listener error:', err.message);
      }
    })();
    return () => { cancelled = true; };
  }, [status]);

  const enable = async () => {
    if (typeof Notification === 'undefined') { setStatus('unsupported'); return; }
    setEnabling(true);
    setError("");
    try {
      const permission = await Notification.requestPermission();
      setStatus(permission);
      if (permission !== 'granted') { setEnabling(false); return; }

      const firebase = await loadFirebaseMessaging();
      if (!firebase.apps.length) firebase.initializeApp(FIREBASE_CONFIG);
      const reg = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
      const messaging = firebase.messaging();
      const token = await messaging.getToken({ vapidKey: FIREBASE_VAPID_KEY, serviceWorkerRegistration: reg });

      if (token && authUser?.id) {
        await sbUpdate('users', authUser.id, { fcm_token: token });
      }
    } catch (err) {
      setError(err.message || 'Could not enable notifications');
    } finally {
      setEnabling(false);
    }
  };

  return { status, enabling, error, enable };
}

// Ask the send-push Edge Function to notify a specific user. Fire-and-forget
// from the caller's point of view — if the user has no saved fcm_token yet
// (hasn't enabled notifications, or is mock/demo data), the function just
// no-ops rather than erroring.
async function sendPushNotification(userId, title, body, data = {}) {
  if (!userId) return;
  try {
    await fetch(`${SUPABASE_URL}/functions/v1/send-push`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': SUPABASE_KEY,
        'Authorization': `Bearer ${SUPABASE_KEY}`,
      },
      body: JSON.stringify({ user_id: userId, title, body, data }),
    });
  } catch (err) {
    console.log('Push notification send error:', err.message);
  }
}

// Small reusable "Enable Notifications" card — drop into any account/settings
// screen. Shows current status and lets the user opt in with one tap.
function NotificationsToggle({ authUser }) {
  const { status, enabling, error, enable } = usePushNotifications(authUser);

  if (status === 'unsupported') {
    return (
      <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:16, fontSize:12, color:T.slate }}>
        🔕 Push notifications aren't supported in this browser.
      </div>
    );
  }

  return (
    <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:16 }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:10 }}>
        <div>
          <div style={{ fontSize:14, fontWeight:700, color:T.navy }}>🔔 Push Notifications</div>
          <div style={{ fontSize:12, color:T.slate, marginTop:2 }}>
            {status === 'granted'
              ? "Enabled on this device"
              : status === 'denied'
                ? "Blocked — enable notifications for this site in your browser settings"
                : "Get alerted the moment something happens — new bids, messages, and bookings"}
          </div>
        </div>
        {status !== 'granted' && status !== 'denied' && (
          <button onClick={enable} disabled={enabling} style={{
            background:T.cobalt, color:T.white, border:"none", borderRadius:8,
            padding:"8px 14px", fontSize:12, fontWeight:700, cursor:"pointer",
            fontFamily:"'DM Sans', sans-serif", whiteSpace:"nowrap", flexShrink:0,
          }}>
            {enabling ? "Enabling…" : "Enable"}
          </button>
        )}
        {status === 'granted' && <span style={{ fontSize:20 }}>✅</span>}
      </div>
      {error && <div style={{ fontSize:12, color:T.coral, marginTop:8 }}>{error}</div>}
    </div>
  );
}

// ── Stripe Connect (pro payouts) ──────────────────────────────────
// Hook: a pro's payout setup status. Resolves their pro_profiles row from
// their auth user id, then exposes whether Stripe has finished verifying
// them (payoutsEnabled) and a function to start or resume Stripe's
// hosted onboarding form.
function useConnectAccount(authUser) {
  const [proId, setProId]                 = useState(null);
  const [stripeAccountId, setStripeAccountId] = useState(null);
  const [payoutsEnabled, setPayoutsEnabled]   = useState(false);
  const [loading, setLoading]             = useState(true);
  const [starting, setStarting]           = useState(false);
  const [error, setError]                 = useState("");

  const refreshStatus = async (idOverride) => {
    const id = idOverride || proId;
    if (!id) return;
    try {
      const res = await fetch(`${SUPABASE_URL}/functions/v1/refresh-connect-status`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${SUPABASE_KEY}` },
        body: JSON.stringify({ pro_id: id }),
      });
      const data = await res.json();
      if (typeof data.payouts_enabled === 'boolean') setPayoutsEnabled(data.payouts_enabled);
    } catch (err) {
      console.log('Connect status refresh error:', err.message);
    }
  };

  useState(() => {
    if (!authUser?.id) { setLoading(false); return; }
    (async () => {
      try {
        const id = await getProProfileId(authUser.id);
        if (!id) { setLoading(false); return; }
        setProId(id);
        const rows = await sbFetch('pro_profiles', `?id=eq.${id}&select=stripe_account_id,payouts_enabled`);
        const row = rows?.[0];
        if (row) {
          setStripeAccountId(row.stripe_account_id || null);
          setPayoutsEnabled(!!row.payouts_enabled);
          // Setup was started but not confirmed live yet — check now, in
          // case the pro just landed back here after finishing (or
          // abandoning) Stripe's hosted form. There's no client-side event
          // for that since the form runs on stripe.com, not inside Localy.
          if (row.stripe_account_id && !row.payouts_enabled) refreshStatus(id);
        }
      } catch (err) {
        console.log('Connect account fetch error:', err.message);
      } finally {
        setLoading(false);
      }
    })();
  });

  const startOnboarding = async () => {
    // Previously this silently no-op'd here, which is exactly what made the
    // button look like it "did nothing" — now it always surfaces why.
    if (!proId) {
      setError("Couldn't find a pro profile linked to your account. If you signed up as a demo/mock pro rather than a real account, Connect has nothing real to attach to yet.");
      return;
    }
    setStarting(true);
    setError("");
    try {
      const res = await fetch(`${SUPABASE_URL}/functions/v1/create-connect-account`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${SUPABASE_KEY}` },
        body: JSON.stringify({ pro_id: proId, email: authUser?.email, return_url: window.location.origin + window.location.pathname }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.error) {
        setError(data.error || `Server error (${res.status}) — the create-connect-account function may not be deployed yet.`);
        setStarting(false);
        return;
      }
      if (data.url) {
        window.location.href = data.url;
      } else {
        setError('Stripe did not return a setup link — try again in a moment.');
        setStarting(false);
      }
    } catch (err) {
      setError('Could not reach the payout setup service — check your connection and try again.');
      setStarting(false);
    }
  };

  return { proId, stripeAccountId, payoutsEnabled, loading, starting, error, startOnboarding, refreshStatus };
}

// Small card for the pro dashboard/account screen — mirrors
// NotificationsToggle's look. Three states: not started, in progress
// (Stripe has an account but hasn't confirmed it's verified), and live.
function PayoutsSetupCard({ authUser }) {
  const { stripeAccountId, payoutsEnabled, loading, starting, error, startOnboarding } = useConnectAccount(authUser);

  if (loading) return null;

  if (payoutsEnabled) {
    return (
      <div style={{ background:T.greenL, borderRadius:14, border:`1px solid ${T.green}33`, padding:16 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:10 }}>
          <div>
            <div style={{ fontSize:14, fontWeight:700, color:T.navy }}>🏦 Payouts Active</div>
            <div style={{ fontSize:12, color:T.slate, marginTop:2 }}>Your earnings are sent straight to your bank after each job.</div>
          </div>
          <span style={{ fontSize:20 }}>✅</span>
        </div>
      </div>
    );
  }

  return (
    <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:16 }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:10 }}>
        <div>
          <div style={{ fontSize:14, fontWeight:700, color:T.navy }}>🏦 {stripeAccountId ? "Finish Payout Setup" : "Set Up Payouts"}</div>
          <div style={{ fontSize:12, color:T.slate, marginTop:2 }}>
            {stripeAccountId
              ? "You started this — a few more details and you'll be able to get paid."
              : "Connect a bank account so you're paid automatically after each completed job."}
          </div>
        </div>
        <button onClick={startOnboarding} disabled={starting} style={{
          background:T.cobalt, color:T.white, border:"none", borderRadius:8,
          padding:"8px 14px", fontSize:12, fontWeight:700, cursor:"pointer",
          fontFamily:"'DM Sans', sans-serif", whiteSpace:"nowrap", flexShrink:0,
        }}>
          {starting ? "Loading…" : stripeAccountId ? "Finish Setup" : "Set Up →"}
        </button>
      </div>
      {error && <div style={{ fontSize:12, color:T.coral, marginTop:8 }}>{error}</div>}
    </div>
  );
}

// Helper: format time ago
function formatTimeAgo(dateStr) {
  if (!dateStr) return 'Just now';
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins  = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days  = Math.floor(diff / 86400000);
  if (mins < 1)   return 'Just now';
  if (mins < 60)  return `${mins}m ago`;
  if (hours < 24) return `${hours}h ago`;
  return `${days}d ago`;
}

// ── Helpers ────────────────────────────────────────────────────
// Renders a pro/homeowner's real uploaded photo when one is available
// (src), falling back to the initials circle otherwise. Before this, the
// component only ever drew initials — a pro's uploaded profile photo had
// nowhere it would actually show up anywhere in the app, even though
// usePros()/useSavedPros() already fetched avatar_url from Supabase.
const Avatar = ({ initials, size = 44, color = T.cobalt, src }) => (
  src ? (
    <img src={src} alt={initials || "Pro"} style={{
      width: size, height: size, borderRadius: "50%",
      objectFit: "cover", flexShrink: 0, background: T.border,
    }} />
  ) : (
    <div style={{
      width: size, height: size, borderRadius: "50%",
      background: color, color: T.white,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontWeight: 700, fontSize: size * 0.36, flexShrink: 0,
      fontFamily: "'DM Sans', sans-serif",
    }}>{initials}</div>
  )
);

const Badge = ({ label }) => {
  const colors = {
    "Top Pro":    { bg: T.amberL,  text: T.amber  },
    "Verified":   { bg: T.cobaltL, text: T.cobalt },
    "Elite":      { bg: T.greenL,  text: T.green  },
    "Unverified": { bg: "#F1F5F9", text: "#94A3B8" },
  };
  const c = colors[label] || colors["Verified"];
  return (
    <span style={{
      background: c.bg, color: c.text, fontSize: 11, fontWeight: 700,
      padding: "2px 8px", borderRadius: 99, letterSpacing: "0.04em",
    }}>{label}</span>
  );
};

const Stars = ({ rating }) => (
  <span style={{ color: T.amber, fontSize: 13 }}>
    {"★".repeat(Math.floor(rating))}{"☆".repeat(5 - Math.floor(rating))}
    <span style={{ color: T.slate, marginLeft: 4, fontSize: 12 }}>{rating}</span>
  </span>
);

const StatusPill = ({ status }) => {
  const map = {
    open:     { bg: T.greenL,  text: T.green,  label: "Open"     },
    assigned: { bg: T.amberL,  text: T.amber,  label: "Assigned" },
    closed:   { bg: T.border,  text: T.slate,  label: "Closed"   },
  };
  const s = map[status];
  return (
    <span style={{
      background: s.bg, color: s.text, fontSize: 11, fontWeight: 700,
      padding: "2px 10px", borderRadius: 99,
    }}>{s.label}</span>
  );
};

const Btn = ({ label, onClick, variant = "primary", small = false }) => {
  const styles = {
    primary:   { bg: T.cobalt,  text: T.white,  border: T.cobalt  },
    secondary: { bg: T.white,   text: T.navy,   border: T.border  },
    danger:    { bg: T.coralL,  text: T.coral,  border: T.coral   },
    ghost:     { bg: "transparent", text: T.cobalt, border: "transparent" },
  };
  const s = styles[variant];
  return (
    <button onClick={onClick} style={{
      background: s.bg, color: s.text,
      border: `1.5px solid ${s.border}`,
      borderRadius: 8, cursor: "pointer",
      padding: small ? "6px 14px" : "10px 20px",
      fontSize: small ? 13 : 14, fontWeight: 600,
      fontFamily: "'DM Sans', sans-serif",
      transition: "opacity 0.15s",
    }}
    onMouseEnter={e => e.target.style.opacity = "0.85"}
    onMouseLeave={e => e.target.style.opacity = "1"}
    >{label}</button>
  );
};

// ── Views ──────────────────────────────────────────────────────


// ── GPS / Location Hook ────────────────────────────────────────
function useLocation() {
  const [location, setLocation] = useState(null);
  const [locating, setLocating] = useState(false);
  const [locError, setLocError] = useState(null);

  // Real reverse geocoding using free API
  const getCityFromCoords = async (lat, lng) => {
    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`,
        { headers: { 'Accept-Language': 'en' } }
      );
      const data = await res.json();
      const addr = data.address;
      // Return most specific city-level name available
      return addr.city || addr.town || addr.village || addr.suburb || addr.county || "Your Location";
    } catch {
      return "Your Location";
    }
  };

  const requestLocation = () => {
    setLocating(true);
    setLocError(null);

    if (!navigator.geolocation) {
      setTimeout(() => {
        setLocation({ lat:30.1658, lng:-95.4613, city:"The Woodlands", accuracy:50, simulated:true });
        setLocating(false);
      }, 1000);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude: lat, longitude: lng, accuracy } = pos.coords;
        const city = await getCityFromCoords(lat, lng);
        setLocation({ lat, lng, city, accuracy: Math.round(accuracy), simulated:false });
        setLocating(false);
      },
      (err) => {
        const simLat = 30.1658 + (Math.random() - 0.5) * 0.05;
        const simLng = -95.4613 + (Math.random() - 0.5) * 0.05;
        setLocation({ lat:simLat, lng:simLng, city:"The Woodlands", accuracy:500, simulated:true });
        setLocating(false);
        setLocError(err.code === 1 ? "Location access denied — using approximate location." : "Could not get location.");
      },
      { enableHighAccuracy:true, timeout:10000, maximumAge:60000 }
    );
  };

  return { location, setLocation, locating, locError, requestLocation };
}

// Distance between two coords in miles
function distanceMiles(lat1, lng1, lat2, lng2) {
  const R = 3958.8;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat/2)**2 + Math.cos(lat1*Math.PI/180) * Math.cos(lat2*Math.PI/180) * Math.sin(dLng/2)**2;
  return (R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))).toFixed(1);
}

function HomeView({ onNavigate, userType, authUser }) {
  const [search, setSearch]           = useState("");
  const [selectedCat, setSelectedCat] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [sortBy, setSortBy]           = useState("rating");
  const [availableOnly, setAvailableOnly] = useState(false);
  const [minRating, setMinRating]     = useState(0);
  const [maxRate, setMaxRate]         = useState(200);
  const [selectedCity, setSelectedCity] = useState("all");
  const [maxDistance, setMaxDistance] = useState(50);
  const [favoritesOnly, setFavoritesOnly] = useState(false);
  const { location, setLocation, locating, locError, requestLocation } = useLocation();
  const { pros: realPros, loading: prosLoading } = usePros();
  const { isSaved, toggleSaved } = useSavedPros(authUser?.id);
  // Use real pros if available, otherwise fall back to mock PROS
  const allPros = realPros.length > 0 ? realPros : PROS;

  const cities = ["all", ...Array.from(new Set(allPros.map(p => p.city)))];
  const parseRate = (r) => parseInt((r || "$0").replace(/[^0-9]/g, "")) || 0;

  // Pro lat/lng lookup
  const PRO_COORDS = {
    1: { lat:30.1658, lng:-95.4613 },
    2: { lat:30.0794, lng:-95.4172 },
    3: { lat:30.3358, lng:-95.4561 },
    4: { lat:29.9902, lng:-95.1768 },
    5: { lat:29.9988, lng:-95.2334 },
    6: { lat:30.1732, lng:-95.5041 },
  };

  const getDistance = (pro) => {
    if (!location) return null;
    if (PRO_COORDS[pro.id]) return distanceMiles(location.lat, location.lng, PRO_COORDS[pro.id].lat, PRO_COORDS[pro.id].lng);
    return null;
  };

  const filtered = allPros
    .filter(p => {
      const dist = getDistance(p);
      const proName = (p.name || p.full_name || "").toLowerCase();
      const proCity = (p.city || "").toLowerCase();
      const proBio  = (p.bio || "").toLowerCase();
      const proCat  = CATEGORIES.find(c => c.id === (p.cat || p.services?.[0]))?.label.toLowerCase() || "";
      const searchLower = search.toLowerCase();
      return (
        (!selectedCat || p.cat === selectedCat || p.services?.includes(selectedCat)) &&
        (!availableOnly || p.available) &&
        (!favoritesOnly || isSaved(p.id)) &&
        ((p.rating || p.avg_rating || 0) >= minRating) &&
        (parseRate(p.rate || `$${p.hourly_rate}/hr` || "$0") <= maxRate) &&
        (selectedCity === "all" || proCity.includes(selectedCity.toLowerCase())) &&
        (!location || dist === null || parseFloat(dist) <= maxDistance) &&
        (
          search === "" ||
          proName.includes(searchLower) ||
          proCity.includes(searchLower) ||
          proBio.includes(searchLower)  ||
          proCat.includes(searchLower)
        )
      );
    })
    .sort((a, b) => {
      if (sortBy === "nearest" && location) {
        const da = parseFloat(getDistance(a) || 999);
        const db = parseFloat(getDistance(b) || 999);
        return da - db;
      }
      if (sortBy === "rating")     return b.rating - a.rating;
      if (sortBy === "price_low")  return parseRate(a.rate) - parseRate(b.rate);
      if (sortBy === "price_high") return parseRate(b.rate) - parseRate(a.rate);
      if (sortBy === "jobs")       return b.jobs - a.jobs;
      return 0;
    });

  const activeFilters = [availableOnly, favoritesOnly, minRating > 0, maxRate < 200, selectedCity !== "all", location && maxDistance < 50].filter(Boolean).length;

  return (
    <div>
      {/* Hero */}
      <div style={{
        background: `linear-gradient(135deg, #0A2540 0%, #1565C0 60%, #0A9E6A 100%)`,
        padding: "40px 20px 32px", textAlign: "center",
      }}>

        <img src="data:image/png;base64,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" alt="Localy" style={{ width: 200, objectFit: "contain", display: "block", margin: "0 auto 16px" }} />
        <h1 style={{
          fontFamily: "'DM Serif Display', Georgia, serif",
          color: T.white, fontSize: 28, fontWeight: 400,
          margin: "0 0 8px", lineHeight: 1.25,
        }}>
          Find. Hire. Get It Done.
        </h1>
        <p style={{ color: "#A8BFDF", fontSize: 14, margin: "0 0 20px" }}>
          Book trusted service professionals in your neighborhood.
        </p>
        <div style={{
          background: T.white, borderRadius: 12, padding: "10px 14px",
          display: "flex", alignItems: "center", gap: 10,
          boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
        }}>
          <span style={{ fontSize: 18 }}>🔍</span>
          <input
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Search by service, name, or city…"
            style={{
              border: "none", outline: "none", fontSize: 14,
              flex: 1, fontFamily: "'DM Sans', sans-serif", color: T.navy,
            }}
          />
        </div>

        {/* GPS Location Bar */}
        <div style={{ marginTop:10 }}>
          {!location ? (
            <button onClick={requestLocation} disabled={locating} style={{
              width:"100%", padding:"10px 16px", borderRadius:10,
              background:"rgba(255,255,255,0.15)", border:"1.5px solid rgba(255,255,255,0.3)",
              color:T.white, cursor:"pointer", fontFamily:"'DM Sans', sans-serif",
              fontSize:13, fontWeight:600, display:"flex", alignItems:"center", justifyContent:"center", gap:8,
              transition:"background 0.2s",
            }}>
              {locating ? (
                <><span style={{ fontSize:16 }}>⏳</span> Getting your location…</>
              ) : (
                <><span style={{ fontSize:16 }}>📍</span> Use my location to find nearby pros</>
              )}
            </button>
          ) : (
            <div style={{ background:"rgba(255,255,255,0.15)", borderRadius:10, padding:"8px 14px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                <span style={{ fontSize:16 }}>{location.simulated ? "📍" : "🎯"}</span>
                <div>
                  <div style={{ color:T.white, fontSize:13, fontWeight:700 }}>{location.city}</div>
                  <div style={{ color:"rgba(255,255,255,0.6)", fontSize:11 }}>
                    {location.simulated ? "Approximate location" : `±${location.accuracy}m accuracy`}
                  </div>
                </div>
              </div>
              <button onClick={() => { setLocation(null); setTimeout(() => requestLocation(), 100); }} style={{ background:"rgba(255,255,255,0.2)", border:"none", color:T.white, borderRadius:6, padding:"4px 10px", cursor:"pointer", fontSize:11, fontWeight:700, fontFamily:"'DM Sans', sans-serif" }}>
                🔄 Update
              </button>
            </div>
          )}
          {locError && <div style={{ color:"rgba(255,200,100,0.9)", fontSize:11, marginTop:6, textAlign:"center" }}>⚠️ {locError}</div>}
        </div>
      </div>

      {/* Neighborhood feed teaser */}
      {userType === "homeowner" && (
        <div style={{ padding: "16px 16px 0", background: T.sand }}>
          <div onClick={() => onNavigate && onNavigate("neighborhood")} style={{
            background: T.white, borderRadius: 14, border: `1px solid ${T.border}`, padding: "14px 16px",
            display: "flex", alignItems: "center", gap: 12, cursor: "pointer", boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
          }}>
            <span style={{ fontSize: 24 }}>📍</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: T.navy }}>What's happening near you</div>
              <div style={{ fontSize: 12, color: T.slate }}>Recent jobs, reviews, and new pros in {location?.city || "The Woodlands"}</div>
            </div>
            <span style={{ color: T.cobalt, fontSize: 18 }}>→</span>
          </div>
        </div>
      )}

      {/* Categories + Filter Bar */}
      <div style={{ padding: "20px 16px 0", background: T.sand }}>
        {/* Filter toggle row */}
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
          <div style={{ fontSize: 11, color: T.slate, fontWeight: 700, letterSpacing: "0.1em" }}>
            BROWSE BY SERVICE
          </div>
          <div style={{ display:"flex", gap:8, alignItems:"center" }}>
            {/* Sort dropdown */}
            <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={{
              fontSize:11, fontWeight:700, color:T.cobalt, background:T.cobaltL,
              border:`1px solid ${T.cobalt}33`, borderRadius:99, padding:"4px 10px",
              cursor:"pointer", fontFamily:"'DM Sans', sans-serif", outline:"none",
            }}>
              {location && <option value="nearest">📍 Nearest</option>}
              <option value="rating">Top Rated</option>
              <option value="price_low">Price: Low</option>
              <option value="price_high">Price: High</option>
              <option value="jobs">Most Jobs</option>
            </select>
            {/* Filter button */}
            <button onClick={() => setShowFilters(!showFilters)} style={{
              display:"flex", alignItems:"center", gap:5,
              background: activeFilters > 0 ? T.green : T.white,
              color: activeFilters > 0 ? T.white : T.navy,
              border:`1.5px solid ${activeFilters > 0 ? T.green : T.border}`,
              borderRadius:99, padding:"4px 12px", cursor:"pointer",
              fontSize:11, fontWeight:700, fontFamily:"'DM Sans', sans-serif",
            }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:5, verticalAlign:"middle"}}>
                <line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/><line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/><line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/><line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/>
              </svg>
              Filters{activeFilters > 0 ? ` (${activeFilters})` : ""}
            </button>
          </div>
        </div>

        {/* Expanded filter panel */}
        {showFilters && (
          <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:16, marginBottom:14, boxShadow:"0 2px 8px rgba(0,0,0,0.06)" }}>
            {/* Available only toggle */}
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14, paddingBottom:14, borderBottom:`1px solid ${T.border}` }}>
              <div>
                <div style={{ fontWeight:700, fontSize:13, color:T.navy }}>Available Now Only</div>
                <div style={{ fontSize:11, color:T.slate }}>Hide currently booked pros</div>
              </div>
              <div onClick={() => setAvailableOnly(!availableOnly)} style={{
                width:44, height:24, borderRadius:99, cursor:"pointer",
                background: availableOnly ? T.green : T.border,
                position:"relative", transition:"background 0.2s",
              }}>
                <div style={{
                  width:20, height:20, borderRadius:"50%", background:T.white,
                  position:"absolute", top:2, transition:"left 0.2s",
                  left: availableOnly ? 22 : 2,
                  boxShadow:"0 1px 4px rgba(0,0,0,0.2)",
                }} />
              </div>
            </div>

            {/* Favorites only toggle */}
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14, paddingBottom:14, borderBottom:`1px solid ${T.border}` }}>
              <div>
                <div style={{ fontWeight:700, fontSize:13, color:T.navy }}>❤️ Favorites Only</div>
                <div style={{ fontSize:11, color:T.slate }}>Show only pros you've saved</div>
              </div>
              <div onClick={() => setFavoritesOnly(!favoritesOnly)} style={{
                width:44, height:24, borderRadius:99, cursor:"pointer",
                background: favoritesOnly ? T.green : T.border,
                position:"relative", transition:"background 0.2s",
              }}>
                <div style={{
                  width:20, height:20, borderRadius:"50%", background:T.white,
                  position:"absolute", top:2, transition:"left 0.2s",
                  left: favoritesOnly ? 22 : 2,
                  boxShadow:"0 1px 4px rgba(0,0,0,0.2)",
                }} />
              </div>
            </div>

            {/* Min rating */}
            <div style={{ marginBottom:14, paddingBottom:14, borderBottom:`1px solid ${T.border}` }}>
              <div style={{ fontWeight:700, fontSize:13, color:T.navy, marginBottom:8 }}>
                Minimum Rating: {minRating > 0 ? `${minRating}★` : "Any"}
              </div>
              <div style={{ display:"flex", gap:8 }}>
                {[0, 4.0, 4.5, 4.8].map(r => (
                  <button key={r} onClick={() => setMinRating(r)} style={{
                    flex:1, padding:"6px 0", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:700,
                    background: minRating === r ? T.cobalt : T.sand,
                    color: minRating === r ? T.white : T.navy,
                    border:`1.5px solid ${minRating === r ? T.cobalt : T.border}`,
                    fontFamily:"'DM Sans', sans-serif",
                  }}>
                    {r === 0 ? "Any" : `${r}+`}
                  </button>
                ))}
              </div>
            </div>

            {/* Max hourly rate */}
            <div style={{ marginBottom:14, paddingBottom:14, borderBottom:`1px solid ${T.border}` }}>
              <div style={{ fontWeight:700, fontSize:13, color:T.navy, marginBottom:8 }}>
                Max Rate: {maxRate >= 200 ? "Any" : `$${maxRate}/hr`}
              </div>
              <input type="range" min={40} max={200} step={10} value={maxRate}
                onChange={e => setMaxRate(Number(e.target.value))}
                style={{ width:"100%", accentColor:T.cobalt }} />
              <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, color:T.slate, marginTop:4 }}>
                <span>$40/hr</span><span>$200+/hr</span>
              </div>
            </div>

            {/* Distance filter — only shown when location is available */}
            {location && (
              <div style={{ marginBottom:14, paddingBottom:14, borderBottom:`1px solid ${T.border}` }}>
                <div style={{ fontWeight:700, fontSize:13, color:T.navy, marginBottom:8 }}>
                  📍 Max Distance: {maxDistance >= 50 ? "Any" : `${maxDistance} miles`}
                </div>
                <input type="range" min={1} max={50} step={1} value={maxDistance}
                  onChange={e => setMaxDistance(Number(e.target.value))}
                  style={{ width:"100%", accentColor:T.green }} />
                <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, color:T.slate, marginTop:4 }}>
                  <span>1 mile</span><span>50+ miles</span>
                </div>
              </div>
            )}

            {/* City filter */}
            <div style={{ marginBottom:14 }}>
              <div style={{ fontWeight:700, fontSize:13, color:T.navy, marginBottom:8 }}>City / Area</div>
              <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                {cities.map(c => (
                  <button key={c} onClick={() => setSelectedCity(c)} style={{
                    padding:"5px 12px", borderRadius:99, cursor:"pointer", fontSize:12, fontWeight:600,
                    background: selectedCity === c ? T.navy : T.sand,
                    color: selectedCity === c ? T.white : T.navy,
                    border:`1.5px solid ${selectedCity === c ? T.navy : T.border}`,
                    fontFamily:"'DM Sans', sans-serif",
                  }}>
                    {c === "all" ? "All Areas" : c}
                  </button>
                ))}
              </div>
            </div>

            {/* Reset */}
            {activeFilters > 0 && (
              <button onClick={() => { setAvailableOnly(false); setFavoritesOnly(false); setMinRating(0); setMaxRate(200); setSelectedCity("all"); setMaxDistance(50); }}
                style={{ width:"100%", padding:"8px", borderRadius:8, border:`1px solid ${T.border}`, background:"none", color:T.coral, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                ✕ Clear All Filters
              </button>
            )}
          </div>
        )}
        <div style={{ display: "flex", gap: 10, overflowX: "auto", paddingBottom: 4 }}>
          {CATEGORIES.map(c => (
            <button key={c.id} onClick={() => setSelectedCat(selectedCat === c.id ? null : c.id)}
              style={{
                background: selectedCat === c.id ? T.green : T.white,
                border: `2px solid ${selectedCat === c.id ? T.green : T.border}`,
                borderRadius: 14, padding: "10px 8px 8px",
                cursor: "pointer", fontFamily: "'DM Sans', sans-serif",
                display: "flex", flexDirection: "column",
                alignItems: "center", justifyContent: "center",
                gap: 6, minWidth: 72, flexShrink: 0,
                boxShadow: selectedCat === c.id ? "0 2px 8px rgba(10,158,106,0.25)" : "0 1px 3px rgba(0,0,0,0.06)",
              }}>
              <div style={{
                width: 44, height: 44, borderRadius: 12,
                background: selectedCat === c.id ? "rgba(255,255,255,0.2)" : T.greenL,
                display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                <img src={c.icon} alt={c.label} style={{
                  width: 26, height: 26, objectFit: "contain",
                  filter: selectedCat === c.id ? "brightness(0) invert(1)" : "none",
                }} />
              </div>
              <span style={{
                fontSize: 11, fontWeight: 600, whiteSpace: "nowrap",
                color: selectedCat === c.id ? T.white : T.navy,
                textAlign: "center", lineHeight: 1.2,
              }}>{c.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Pro Cards */}
      <div style={{ padding: "16px", background: T.sand }}>
        <div style={{ fontSize: 11, color: T.slate, fontWeight: 700, letterSpacing: "0.1em", marginBottom: 12 }}>
          {prosLoading ? "⏳ LOADING PROS..." : `${filtered.length} PROS FOUND ${sortBy === "rating" ? "· TOP RATED" : sortBy === "price_low" ? "· LOWEST PRICE" : sortBy === "price_high" ? "· HIGHEST PRICE" : "· MOST EXPERIENCED"}`}
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {filtered.map(pro => (
            <div key={pro.id} style={{
              background: T.white, borderRadius: 14, padding: 16,
              border: `1px solid ${T.border}`,
              boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
            }}>
              <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                <Avatar initials={pro.img} src={pro.avatar} color={pro.available ? T.cobalt : T.slate} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 15, color: T.navy }}>{pro.name}</div>
                      <div style={{ fontSize: 12, color: T.slate, display:"flex", alignItems:"center", gap:6 }}>
                    {pro.city}
                    {getDistance(pro) && (
                      <span style={{ background:T.greenL, color:T.green, fontSize:10, fontWeight:700, padding:"1px 6px", borderRadius:99 }}>
                        📍 {getDistance(pro)} mi
                      </span>
                    )}
                  </div>
                    </div>
                    <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                      <button onClick={() => toggleSaved(pro)} title={isSaved(pro.id) ? "Remove from favorites" : "Save to favorites"} style={{ background:"none", border:"none", cursor:"pointer", fontSize:16, padding:0, lineHeight:1 }}>
                        {isSaved(pro.id) ? "❤️" : "🤍"}
                      </button>
                      <Badge label={pro.badge} />
                    </div>
                  </div>
                  <Stars rating={pro.rating} />
                  <span style={{ fontSize: 12, color: T.slate, marginLeft: 4 }}>({pro.reviews})</span>
                  <div style={{ fontSize: 13, color: T.slate, margin: "6px 0", lineHeight: 1.4 }}>{pro.bio}</div>
                  <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
                    <span style={{ fontSize: 14, fontWeight: 700, color: T.navy }}>{pro.rate}</span>
                    <span style={{ fontSize: 12, color: T.slate }}>{pro.jobs} jobs done</span>
                    <span style={{
                      fontSize: 11, fontWeight: 700,
                      color: getAvailability(pro).text,
                      background: getAvailability(pro).bg,
                      padding: "2px 8px", borderRadius: 99,
                    }}>
                      ● {getAvailability(pro).label}
                    </span>
                  </div>
                </div>
              </div>
              {pro.available && (
                <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
                  <Btn label="Book Now" onClick={() => onNavigate("book", pro)} />
                  <Btn label="Profile" variant="secondary" onClick={() => onNavigate("profile", pro)} small />
                  <button onClick={() => onNavigate("map")} style={{ padding:"6px 14px", borderRadius:8, border:`1.5px solid ${T.border}`, background:T.white, color:T.navy, fontWeight:600, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif", display:"flex", alignItems:"center", gap:5 }}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                    Map
                  </button>
                </div>
              )}
            </div>
          ))}
          {filtered.length === 0 && (
            <div style={{ textAlign: "center", padding: "40px 20px", color: T.slate }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>🔍</div>
              <div style={{ fontWeight: 600 }}>No pros found</div>
              <div style={{ fontSize: 13 }}>Try a different category or search term</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ── First-visit tip ─────────────────────────────────────────────────
// A small dismissible callout shown the first time a user lands on a
// given screen — a lightweight companion to the full onboarding
// walkthrough for the couple of screens (Job Board, Messages) where a
// one-line reminder in context is more useful than a slide seen once at
// signup and never again. Dismissal is per-device (localStorage), keyed
// by user id so switching accounts on the same device doesn't hide it
// for someone who hasn't seen it yet.
function FirstVisitTip({ tipKey, text, authUser }) {
  const storageKey = `localy_tip_${tipKey}_${authUser?.id || 'anon'}`;
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(storageKey) === '1'; } catch { return false; }
  });
  if (dismissed) return null;
  const handleDismiss = () => {
    setDismissed(true);
    try { localStorage.setItem(storageKey, '1'); } catch {}
  };
  return (
    <div style={{ background:T.cobaltL, border:`1px solid ${T.cobalt}33`, borderRadius:10, padding:"10px 12px", display:"flex", gap:8, alignItems:"flex-start", marginBottom:14 }}>
      <span style={{ fontSize:16 }}>💡</span>
      <div style={{ flex:1, fontSize:12, color:T.navy, lineHeight:1.5 }}>{text}</div>
      <button onClick={handleDismiss} aria-label="Dismiss tip" style={{ background:"none", border:"none", color:T.slate, cursor:"pointer", fontSize:14, padding:0, lineHeight:1 }}>✕</button>
    </div>
  );
}

function JobBoardView({ onNavigate, userType, authUser, onMessageHomeowner }) {
  const [filter, setFilter] = useState("all");
  // Pros previously had no way at all to see bids they'd already placed,
  // or to know when one got accepted — this tab (pro-only) plus useMyBids()
  // below is what makes "message the homeowner who accepted my bid" possible.
  // Pros land here straight from login (see handleAuth in HomeCallApp) —
  // My Bids is the more useful default for a returning pro than Open Jobs.
  const [proTab, setProTab] = useState(userType === "pro" ? "mybids" : "open"); // open | mybids
  const { jobs: realJobs } = useJobs();
  const { bids: myBids, loading: myBidsLoading } = useMyBids(authUser);
  // Merge real jobs + local store jobs (newly posted appear immediately)
  const storeJobs = JOB_STORE.jobs || [];
  const allJobs   = [...storeJobs, ...(realJobs.length > 0 ? realJobs : JOBS)]
    .filter((j, i, arr) => arr.findIndex(x => x.id === j.id) === i); // dedupe
  const filtered  = filter === "all" ? allJobs : allJobs.filter(j => j.cat === filter);

  // Pro Plus perk: see new jobs the instant they're posted. Free-tier pros
  // see the same jobs a few minutes later — a small but real head start on
  // getting the first bid in. See pro_plus_migration.sql.
  const [proIsPlus, setProIsPlus] = useState(false);
  useEffect(() => {
    if (userType !== "pro" || typeof authUser?.id !== 'string') return;
    (async () => {
      try {
        const proId = await getProProfileId(authUser.id);
        if (!proId) return;
        const rows = await sbFetch('pro_profiles', `?id=eq.${proId}&select=subscription_tier`);
        setProIsPlus(rows?.[0]?.subscription_tier === 'plus');
      } catch (err) {
        console.log('Pro Plus status check error:', err.message);
      }
    })();
  }, [userType, authUser?.id]);

  const EARLY_ACCESS_WINDOW_MS = 5 * 60 * 1000;
  const visibleJobs = (userType === "pro" && !proIsPlus)
    ? filtered.filter(j => !j.createdAt || (Date.now() - new Date(j.createdAt).getTime()) >= EARLY_ACCESS_WINDOW_MS)
    : filtered;

  const bidStatusStyle = {
    pending:   { bg: T.amberL,  text: T.amber,  label: "⏳ Pending"   },
    accepted:  { bg: T.greenL,  text: T.green,  label: "🎉 Accepted"  },
    countered: { bg: T.cobaltL, text: T.cobalt, label: "💬 Countered" },
    declined:  { bg: T.coralL,  text: T.coral,  label: "✕ Declined"  },
    withdrawn: { bg: "#F1F5F9", text: "#94A3B8", label: "Withdrawn"   },
  };

  return (
    <div style={{ padding: 16, background: T.sand, minHeight: "100%" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <div>
          <div style={{ fontWeight: 700, fontSize: 18, color: T.navy }}>Job Board</div>
          <div style={{ fontSize: 13, color: T.slate }}>{proTab === "mybids" ? "Bids you've placed" : "Open jobs in your area"}</div>
        </div>
        {userType === "homeowner" && (
          <Btn label="+ Post Job" onClick={() => onNavigate("postjob")} small />
        )}
      </div>

      <FirstVisitTip
        tipKey="jobboard"
        authUser={authUser}
        text={userType === "homeowner"
          ? "This is your Job Board — post a new job and pros nearby will start sending you bids."
          : "Browse open jobs near you and place a bid, or check My Bids to see how yours are doing."}
      />

      {userType === "pro" && (
        <div style={{ display:"flex", gap:8, marginBottom:16 }}>
          {[["open","Open Jobs"],["mybids","My Bids"]].map(([id,label]) => (
            <button key={id} onClick={() => setProTab(id)} style={{
              flex:1, padding:"9px", borderRadius:10,
              background: proTab === id ? T.navy : T.white,
              color: proTab === id ? T.white : T.slate,
              border:`1.5px solid ${proTab === id ? T.navy : T.border}`,
              fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"'DM Sans', sans-serif",
            }}>{label}</button>
          ))}
        </div>
      )}

      {userType === "pro" && proTab === "mybids" ? (
        <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
          {myBidsLoading && <div style={{ textAlign:"center", padding:20, color:T.slate, fontSize:13 }}>⏳ Loading your bids...</div>}
          {!myBidsLoading && myBids.length === 0 && (
            <div style={{ textAlign:"center", padding:40, color:T.slate }}>
              <div style={{ fontSize:40, marginBottom:12 }}>📭</div>
              <div style={{ fontWeight:700, fontSize:16, color:T.navy }}>No bids yet</div>
              <div style={{ fontSize:13, marginTop:4 }}>Bids you place on open jobs will show up here.</div>
            </div>
          )}
          {myBids.map(bid => {
            const st = bidStatusStyle[bid.status] || bidStatusStyle.pending;
            return (
              <div key={bid.id} style={{ background:T.white, borderRadius:14, padding:16, border:`1px solid ${T.border}`, boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:6 }}>
                  <div>
                    <div style={{ fontWeight:700, fontSize:15, color:T.navy }}>{bid.jobTitle}</div>
                    <div style={{ fontSize:12, color:T.slate }}>
                      <span onClick={() => onMessageHomeowner && onMessageHomeowner(bid.homeownerId, bid.homeownerName)} style={{ color:T.cobalt, fontWeight:600, cursor:"pointer", textDecoration:"underline" }}>
                        {bid.homeownerName}
                      </span>
                      {' '}· {bid.city}
                    </div>
                  </div>
                  <span style={{ background:st.bg, color:st.text, fontSize:11, fontWeight:700, padding:"3px 10px", borderRadius:99, whiteSpace:"nowrap" }}>{st.label}</span>
                </div>
                <div style={{ fontSize:14, fontWeight:700, color:T.navy, marginBottom:10 }}>
                  ${bid.amount}{bid.status === 'countered' && bid.counterAmount ? ` → homeowner countered $${bid.counterAmount}${bid.counterAvailableWhen ? ` for ${bid.counterAvailableWhen}` : ''}` : ''}
                </div>
                <button onClick={() => onMessageHomeowner && onMessageHomeowner(bid.homeownerId, bid.homeownerName)} style={{
                  width:"100%", padding:"9px", borderRadius:10, border:"none",
                  background: bid.status === 'accepted' ? T.green : T.cobalt,
                  color:T.white, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif",
                }}>
                  💬 Message {bid.homeownerName}
                </button>
              </div>
            );
          })}
        </div>
      ) : (
      <>
      {/* Filter row */}
      <div style={{ display: "flex", gap: 8, overflowX: "auto", marginBottom: 16, paddingBottom: 4 }}>
        {["all", ...CATEGORIES.map(c => c.id)].map(cat => (
          <button key={cat} onClick={() => setFilter(cat)} style={{
            background: filter === cat ? T.navy : T.white,
            color: filter === cat ? T.white : T.slate,
            border: `1.5px solid ${filter === cat ? T.navy : T.border}`,
            borderRadius: 99, padding: "6px 14px",
            fontSize: 12, fontWeight: 600, cursor: "pointer",
            whiteSpace: "nowrap", fontFamily: "'DM Sans', sans-serif",
          }}>
            {cat === "all" ? "All Jobs" : CATEGORIES.find(c => c.id === cat)?.label || cat}
          </button>
        ))}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {visibleJobs.map(job => {
          const cat = CATEGORIES.find(c => c.id === job.cat);
          return (
            <div key={job.id} style={{
              background: T.white, borderRadius: 14, padding: 16,
              border: `1px solid ${T.border}`,
              boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                <img src={cat?.icon} alt="" style={{width:28,height:28,objectFit:"contain"}} />
                <StatusPill status={job.status} />
              </div>
              <div style={{ fontWeight: 700, fontSize: 15, color: T.navy, marginBottom: 2 }}>{job.title}</div>
              <div style={{ fontSize: 12, color: T.slate, marginBottom: 10 }}>
                📍 {job.city} · {cat?.label} · Posted {job.posted}
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <span style={{ fontSize: 15, fontWeight: 700, color: T.navy }}>{job.budget}</span>
                  <span style={{ fontSize: 12, color: T.slate, marginLeft: 10 }}>{job.bids} bid{job.bids !== 1 ? "s" : ""}</span>
                </div>
                {job.status === "open" && userType === "pro" && (
                  <Btn label="Place Bid" onClick={() => onNavigate("bid", job)} small />
                )}
                {job.status === "open" && userType === "homeowner" && (
                  <Btn label="View Bids" variant="secondary" onClick={() => onNavigate("viewbids", job)} small />
                )}
              </div>
            </div>
          );
        })}
      </div>
      </>
      )}
    </div>
  );
}

function ProfileView({ pro, onBack }) {
  return (
    <div style={{ background: T.sand, minHeight: "100%" }}>
      <div style={{
        background: `linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`,
        padding: "20px 16px 40px",
      }}>
        <button onClick={onBack} style={{
          background: "rgba(255,255,255,0.15)", border: "none",
          color: T.white, borderRadius: 8, padding: "6px 12px",
          cursor: "pointer", fontSize: 13, marginBottom: 16,
          fontFamily: "'DM Sans', sans-serif",
        }}>← Back</button>
        <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
          <Avatar initials={pro.img} size={64} />
          <div>
            <div style={{ color: T.white, fontWeight: 700, fontSize: 20 }}>{pro.name}</div>
            <div style={{ color: "#A8BFDF", fontSize: 13 }}>📍 {pro.city}</div>
            <Stars rating={pro.rating} />
          </div>
        </div>
      </div>

      <div style={{ padding: 16, marginTop: -20 }}>
        {/* Stats row */}
        <div style={{
          background: T.white, borderRadius: 14, padding: 16,
          display: "flex", justifyContent: "space-around",
          border: `1px solid ${T.border}`, marginBottom: 16,
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        }}>
          {[
            { val: pro.rating, label: "Rating" },
            { val: pro.reviews, label: "Reviews" },
            { val: pro.jobs, label: "Jobs Done" },
          ].map(s => (
            <div key={s.label} style={{ textAlign: "center" }}>
              <div style={{ fontWeight: 700, fontSize: 22, color: T.navy }}>{s.val}</div>
              <div style={{ fontSize: 12, color: T.slate }}>{s.label}</div>
            </div>
          ))}
        </div>

        <div style={{ background: T.white, borderRadius: 14, padding: 16, border: `1px solid ${T.border}`, marginBottom: 16 }}>
          <div style={{ fontSize: 11, color: T.slate, fontWeight: 700, letterSpacing: "0.1em", marginBottom: 8 }}>ABOUT</div>
          <p style={{ fontSize: 14, color: T.navy, lineHeight: 1.6, margin: 0 }}>{pro.bio}</p>
        </div>

        <div style={{ background: T.white, borderRadius: 14, padding: 16, border: `1px solid ${T.border}`, marginBottom: 20 }}>
          <div style={{ fontSize: 11, color: T.slate, fontWeight: 700, letterSpacing: "0.1em", marginBottom: 12 }}>DETAILS</div>
          {[
            ["Service",      CATEGORIES.find(c => c.id === pro.cat)?.label],
            ["Rate",         pro.rate],
            ["Availability", getAvailability(pro).label],
            ["Badge",        pro.badge],
          ].map(([k, v]) => (
            <div key={k} style={{
              display: "flex", justifyContent: "space-between",
              padding: "8px 0", borderBottom: `1px solid ${T.border}`,
              fontSize: 14,
            }}>
              <span style={{ color: T.slate }}>{k}</span>
              <span style={{ color: T.navy, fontWeight: 600 }}>{v}</span>
            </div>
          ))}
        </div>

        {pro.available && <Btn label="Book This Pro" onClick={() => {}} />}
      </div>
    </div>
  );
}


// ── Photo Uploader Component ───────────────────────────────────
// `uploadPath` (optional): function(file) => storage path string, e.g.
// `${authUser.id}/profile-${Date.now()}.jpg`. When provided, this uploads
// the real file to Supabase Storage (see photo_storage_migration.sql) and
// calls `onUploaded(url, file)` so the parent can persist the resulting
// public URL to the database. Without it, falls back to the old
// local-preview-only behavior (used by call sites that don't need a real
// persisted photo yet).
// Full-screen crop tool: drag to reposition, slider to zoom, output is
// always a square JPEG. No image library needed — it's plain canvas math.
// The circular mask is purely visual (matches how the photo ends up
// displayed everywhere as a round Avatar); the actual exported crop is a
// square, which is what a circular avatar is built from anyway.
function SquareCropModal({ file, onCancel, onSave }) {
  const V = 280; // crop viewport size, css px
  const [imgUrl, setImgUrl] = useState(null);
  const [natural, setNatural] = useState({ w: 0, h: 0 });
  const [zoom, setZoom] = useState(1);
  const [pos, setPos] = useState({ left: 0, top: 0 });
  const [saving, setSaving] = useState(false);
  const dragRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const url = URL.createObjectURL(file);
    setImgUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  const baseScale = natural.w && natural.h ? Math.max(V / natural.w, V / natural.h) : 1;
  const scale = baseScale * zoom;
  const dispW = natural.w * scale;
  const dispH = natural.h * scale;

  const clamp = (left, top, w = dispW, h = dispH) => ({
    left: Math.min(0, Math.max(V - w, left)),
    top:  Math.min(0, Math.max(V - h, top)),
  });

  const handleImgLoad = (e) => {
    const w = e.target.naturalWidth, h = e.target.naturalHeight;
    setNatural({ w, h });
    const bs = Math.max(V / w, V / h);
    const dw = w * bs, dh = h * bs;
    setPos({ left: (V - dw) / 2, top: (V - dh) / 2 });
  };

  const handleZoom = (newZoom) => {
    const newScale = baseScale * newZoom;
    const newDW = natural.w * newScale, newDH = natural.h * newScale;
    // Keep whatever point is currently centered in the viewport centered
    // after the zoom change, instead of jarringly re-centering on the image.
    const ratioX = dispW ? (V / 2 - pos.left) / dispW : 0.5;
    const ratioY = dispH ? (V / 2 - pos.top) / dispH : 0.5;
    setZoom(newZoom);
    setPos(clamp(V / 2 - ratioX * newDW, V / 2 - ratioY * newDH, newDW, newDH));
  };

  const onPointerDown = (e) => {
    e.preventDefault();
    e.currentTarget.setPointerCapture?.(e.pointerId);
    dragRef.current = { startX: e.clientX, startY: e.clientY, startLeft: pos.left, startTop: pos.top };
  };
  const onPointerMove = (e) => {
    if (!dragRef.current) return;
    const dx = e.clientX - dragRef.current.startX;
    const dy = e.clientY - dragRef.current.startY;
    setPos(clamp(dragRef.current.startLeft + dx, dragRef.current.startTop + dy));
  };
  const onPointerUp = () => { dragRef.current = null; };

  const handleSave = () => {
    if (!imgRef.current || !natural.w) return;
    setSaving(true);
    const OUT = 600;
    const canvas = document.createElement('canvas');
    canvas.width = OUT; canvas.height = OUT;
    const ctx = canvas.getContext('2d');
    const sx = Math.max(0, (0 - pos.left) / scale);
    const sy = Math.max(0, (0 - pos.top) / scale);
    const sSize = Math.min(V / scale, natural.w - sx, natural.h - sy);
    ctx.drawImage(imgRef.current, sx, sy, sSize, sSize, 0, 0, OUT, OUT);
    canvas.toBlob((blob) => {
      setSaving(false);
      if (!blob) { onCancel(); return; }
      const croppedFile = new File([blob], (file.name || 'photo').replace(/\.\w+$/, '') + '-cropped.jpg', { type: 'image/jpeg' });
      onSave(croppedFile);
    }, 'image/jpeg', 0.92);
  };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(10,37,64,0.94)", zIndex:1002, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:20, fontFamily:"'DM Sans', sans-serif" }}>
      <div style={{ color:T.white, fontWeight:700, fontSize:15, marginBottom:16 }}>Drag to reposition · pinch or use the slider to zoom</div>
      <div
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerCancel={onPointerUp}
        style={{
          width:V, height:V, borderRadius:"50%", overflow:"hidden", position:"relative",
          background:"#000", touchAction:"none", cursor:"grab",
          boxShadow:"0 0 0 4px rgba(255,255,255,0.35)",
        }}>
        {imgUrl && (
          <img
            ref={imgRef}
            src={imgUrl}
            onLoad={handleImgLoad}
            alt=""
            draggable={false}
            style={{
              position:"absolute", left:pos.left, top:pos.top,
              width: dispW || undefined, height: dispH || undefined,
              maxWidth:"none", userSelect:"none", pointerEvents:"none",
            }}
          />
        )}
      </div>
      <div style={{ width:V, marginTop:18, display:"flex", alignItems:"center", gap:10 }}>
        <span style={{ color:"white", fontSize:16 }}>−</span>
        <input type="range" min="1" max="3" step="0.01" value={zoom}
          onChange={e => handleZoom(Number(e.target.value))}
          style={{ flex:1 }} />
        <span style={{ color:"white", fontSize:16 }}>+</span>
      </div>
      <div style={{ display:"flex", gap:10, marginTop:24, width:V }}>
        <button onClick={onCancel} style={{ flex:1, padding:"12px", borderRadius:12, border:"1.5px solid rgba(255,255,255,0.3)", background:"transparent", color:T.white, fontWeight:700, cursor:"pointer", fontFamily:"'DM Sans', sans-serif" }}>
          Cancel
        </button>
        <button onClick={handleSave} disabled={saving || !natural.w} style={{ flex:1, padding:"12px", borderRadius:12, border:"none", background:`linear-gradient(135deg, #1565C0, #0A9E6A)`, color:T.white, fontWeight:700, cursor: saving ? "default" : "pointer", fontFamily:"'DM Sans', sans-serif", opacity: saving || !natural.w ? 0.7 : 1 }}>
          {saving ? "⏳" : "✓ Use Photo"}
        </button>
      </div>
    </div>
  );
}

function PhotoUploader({ label, multiple = false, photos, setPhotos, hint = "", uploadPath, onUploaded, onRemoved, cropSquare = false }) {
  const [dragging, setDragging]   = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState("");
  // For cropSquare uploads (profile photos), a picked file doesn't go
  // straight to upload — it opens the crop tool first so the pro can
  // reposition/zoom to whatever framing looks best, since a raw upload
  // could be off-center or the wrong aspect ratio for the circular avatar
  // it ends up shown as everywhere in the app.
  const [cropFile, setCropFile] = useState(null);

  const DEMO_PHOTOS = [
    "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=200&h=200&fit=crop",
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=200&fit=crop",
    "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=200&h=200&fit=crop",
    "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=200&h=200&fit=crop",
    "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=200&h=200&fit=crop",
  ];

  const simulateUpload = (file) => {
    setUploading(true);
    setTimeout(() => {
      const url = file?.name
        ? URL.createObjectURL(file)
        : DEMO_PHOTOS[Math.floor(Math.random() * DEMO_PHOTOS.length)];
      setPhotos(prev => multiple ? [...prev, { url, name: file?.name || "photo.jpg", size:"1.2 MB" }] : [{ url, name: file?.name || "photo.jpg", size:"1.2 MB" }]);
      setUploading(false);
    }, 1200);
  };

  const realUpload = async (file) => {
    setUploading(true);
    setUploadError("");
    try {
      const path = uploadPath(file);
      const url = await sbUploadFile('photos', path, file);
      setPhotos(prev => multiple ? [...prev, { url, name: file?.name || "photo.jpg", size:"1.2 MB" }] : [{ url, name: file?.name || "photo.jpg", size:"1.2 MB" }]);
      if (onUploaded) await onUploaded(url, file);
    } catch (err) {
      setUploadError(err.message || 'Upload failed — try again.');
    } finally {
      setUploading(false);
    }
  };

  const handleUpload = (file) => { uploadPath ? realUpload(file) : simulateUpload(file); };

  const pickFile = (file) => {
    if (!file) return;
    if (cropSquare) setCropFile(file);
    else handleUpload(file);
  };

  const handleFile = (e) => {
    const file = e.target.files?.[0];
    pickFile(file);
    e.target.value = ""; // allow picking the same file again after cancel
  };

  const removePhoto = (idx) => {
    setPhotos(prev => prev.filter((_, i) => i !== idx));
    if (onRemoved) onRemoved(idx, photos[idx]);
  };

  return (
    <div>
      {cropFile && (
        <SquareCropModal
          file={cropFile}
          onCancel={() => setCropFile(null)}
          onSave={(croppedFile) => { setCropFile(null); handleUpload(croppedFile); }}
        />
      )}
      {label && <label style={{ fontSize:12, fontWeight:700, color:T.slate, display:"block", marginBottom:8, letterSpacing:"0.08em" }}>{label}</label>}
      {(multiple || photos.length === 0) && (
        <div
          onDragOver={e => { e.preventDefault(); setDragging(true); }}
          onDragLeave={() => setDragging(false)}
          onDrop={e => { e.preventDefault(); setDragging(false); const f = e.dataTransfer.files[0]; if(f) pickFile(f); }}
          style={{
            border:`2px dashed ${dragging ? T.cobalt : uploading ? T.green : T.border}`,
            borderRadius:14, padding:"24px 16px", textAlign:"center",
            background: dragging ? T.cobaltL : uploading ? T.greenL : T.white,
            transition:"all 0.2s", marginBottom: photos.length > 0 ? 12 : 0,
            cursor:"pointer",
          }}>
          {uploading ? (
            <div>
              <div style={{ fontSize:32, marginBottom:8 }}>⏳</div>
              <div style={{ color:T.green, fontWeight:700, fontSize:14 }}>Uploading…</div>
            </div>
          ) : (
            <label style={{ cursor:"pointer", display:"block" }}>
              <input type="file" accept="image/*" onChange={handleFile} style={{ display:"none" }} />
              <div style={{ fontSize:36, marginBottom:8 }}>📸</div>
              <div style={{ color:T.navy, fontWeight:700, fontSize:14, marginBottom:4 }}>Tap to upload photo</div>
              <div style={{ color:T.slate, fontSize:12, marginBottom: hint ? 8 : 0 }}>JPG, PNG · Max 10MB</div>
              {hint && <div style={{ color:T.cobalt, fontSize:12, fontWeight:600 }}>{hint}</div>}
            </label>
          )}
        </div>
      )}
      {photos.length > 0 && (
        <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
          {photos.map((p, i) => (
            <div key={i} style={{ position:"relative", width: multiple ? 90 : "100%", height: multiple ? 90 : 200 }}>
              <img src={p.url} alt={p.name}
                style={{ width:"100%", height:"100%", objectFit:"cover", borderRadius:10, border:`1px solid ${T.border}` }}
                onError={e => { e.target.src = "https://via.placeholder.com/90x90/E8F1FD/1565C0?text=📸"; }}
              />
              <button onClick={() => removePhoto(i)} style={{
                position:"absolute", top:-6, right:-6,
                width:22, height:22, borderRadius:"50%",
                background:T.coral, border:"2px solid white",
                color:"white", fontSize:12, fontWeight:700,
                cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center",
                lineHeight:1,
              }}>✕</button>
            </div>
          ))}
          {multiple && (
            <label style={{ width:90, height:90, borderRadius:10, border:`2px dashed ${T.border}`, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", cursor:"pointer", background:T.sand, gap:4 }}>
              <input type="file" accept="image/*" onChange={handleFile} style={{ display:"none" }} />
              <span style={{ fontSize:22, color:T.slate }}>+</span>
              <span style={{ fontSize:10, color:T.slate, fontWeight:600 }}>Add more</span>
            </label>
          )}
        </div>
      )}
      {uploadError && <div style={{ color:T.coral, fontSize:12, marginTop:8 }}>{uploadError}</div>}
    </div>
  );
}

function BookingPhotoUpload() {
  const [photos, setPhotos] = useState([]);
  return (
    <PhotoUploader
      label="ATTACH PHOTOS TO YOUR BOOKING (OPTIONAL)"
      multiple={true}
      photos={photos}
      setPhotos={setPhotos}
      hint="Show the pro what needs to be done before they arrive"
    />
  );
}

function BookingView({ pro, onBack, onConfirm, onPay, authUser }) {
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [desc, setDesc] = useState("");
  const [booked, setBooked] = useState(false);
  const [slotConflict, setSlotConflict] = useState(false);
  const [recurring, setRecurring]     = useState(false);
  const [frequency, setFrequency]     = useState("weekly");
  const [occurrences, setOccurrences] = useState(4);
  const [confirmedDates, setConfirmedDates] = useState([]); // [{date, time}] — all series entries that got booked
  const [skippedDates, setSkippedDates]     = useState([]); // dates skipped because the pro was already booked
  const [hours, setHours] = useState(2); // feeds the real checkout total instead of a hardcoded placeholder
  const [localBookingIds, setLocalBookingIds] = useState([]); // so payment success can flip these from pending -> confirmed
  const [bookingError, setBookingError] = useState("");
  const [booking, setBookingInFlight] = useState(false);
  const bookedTimes = pro ? getProBookedDates(pro.id) : [];
  const rateNum = parseInt(String(pro?.rate).replace(/[^0-9]/g, '')) || null;
  // Diagnostic-required trades (HVAC/plumbing/electrical) usually can't be
  // priced by the hour up front — the real scope isn't known until the pro
  // shows up and looks at it. If this pro has set a diagnostic fee for a
  // category they offer, that flat fee is what's actually charged at
  // booking time; the real repair (parts/labor) gets billed afterward via
  // a separate itemized invoice once they've diagnosed the job.
  const isDiagnosticJob = !!(pro?.diagnosticFee && pro?.services?.some(s => DIAGNOSTIC_FEE_CATEGORIES.includes(s)));
  const estimatedAmount = isDiagnosticJob ? pro.diagnosticFee : (rateNum ? rateNum * hours : null);

  const inputStyle = {
    width: "100%", padding: "10px 12px", borderRadius: 10,
    border: `1.5px solid ${T.border}`, fontSize: 14,
    fontFamily: "'DM Sans', sans-serif", color: T.navy,
    outline: "none", boxSizing: "border-box", background: T.white,
  };

  if (booked) return (
    <div style={{
      display: "flex", flexDirection: "column", alignItems: "center",
      justifyContent: "center", padding: 40, textAlign: "center",
      background: T.sand, minHeight: "100%",
    }}>
      <div style={{ fontSize: 60, marginBottom: 16 }}>✅</div>
      <h2 style={{ color: T.navy, fontFamily: "'DM Serif Display', serif", fontWeight: 400, marginBottom: 8 }}>
        Booking Confirmed!
      </h2>
      <p style={{ color: T.slate, fontSize: 14, marginBottom: 24 }}>
        {pro.name} has been notified and will confirm shortly.
      </p>
      {confirmedDates.length > 1 ? (
        <div style={{
          background: T.white, borderRadius: 14, padding: 16,
          border: `1px solid ${T.border}`, width: "100%", textAlign: "left", marginBottom: 24,
        }}>
          {[["Pro", pro.name], ["Time", time], ["Repeats", `${frequency === "weekly" ? "Weekly" : frequency === "biweekly" ? "Every 2 weeks" : "Monthly"} · ${confirmedDates.length} visits`]].map(([k, v]) => (
            <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", fontSize: 14 }}>
              <span style={{ color: T.slate }}>{k}</span>
              <span style={{ color: T.navy, fontWeight: 600 }}>{v}</span>
            </div>
          ))}
          <div style={{ borderTop: `1px solid ${T.border}`, marginTop: 8, paddingTop: 8 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: T.slate, letterSpacing: "0.08em", marginBottom: 6 }}>CONFIRMED DATES</div>
            {confirmedDates.map(d => (
              <div key={d.date} style={{ fontSize: 13, color: T.navy, padding: "3px 0" }}>✅ {d.date}</div>
            ))}
            {skippedDates.length > 0 && (
              <>
                <div style={{ fontSize: 11, fontWeight: 700, color: T.amber, letterSpacing: "0.08em", marginTop: 10, marginBottom: 6 }}>SKIPPED — {pro.name} ALREADY BOOKED</div>
                {skippedDates.map(d => (
                  <div key={d} style={{ fontSize: 13, color: T.amber, padding: "3px 0" }}>⚠️ {d}</div>
                ))}
              </>
            )}
          </div>
        </div>
      ) : (
        <div style={{
          background: T.white, borderRadius: 14, padding: 16,
          border: `1px solid ${T.border}`, width: "100%", textAlign: "left", marginBottom: 24,
        }}>
          {[["Pro", pro.name], ["Date", date], ["Time", time], isDiagnosticJob ? ["Diagnostic Fee", `$${pro.diagnosticFee}`] : ["Rate", pro.rate]].map(([k, v]) => (
            <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", fontSize: 14 }}>
              <span style={{ color: T.slate }}>{k}</span>
              <span style={{ color: T.navy, fontWeight: 600 }}>{v}</span>
            </div>
          ))}
        </div>
      )}
      <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:14, marginBottom:16 }}>
        <BookingPhotoUpload />
      </div>
      <div style={{ display:"flex", gap:10 }}>
        <Btn label="Pay Now 💳" onClick={() => {
          const checkoutInfo = {
            pro, hours: isDiagnosticJob ? null : hours, amount: estimatedAmount,
            jobTitle: (isDiagnosticJob ? '[Diagnostic Visit] ' : '') + desc,
            localBookingIds,
          };
          onPay ? onPay(checkoutInfo) : onBack();
        }} />
        <Btn label="Back to Home" onClick={onBack} variant="secondary" />
      </div>
    </div>
  );

  return (
    <div style={{ background: T.sand, minHeight: "100%", padding: 16 }}>
      <button onClick={onBack} style={{
        background: "none", border: "none", color: T.cobalt,
        cursor: "pointer", fontSize: 14, padding: 0, marginBottom: 16,
        fontFamily: "'DM Sans', sans-serif", fontWeight: 600,
      }}>← Back</button>

      <h2 style={{ color: T.navy, fontFamily: "'DM Serif Display', serif", fontWeight: 400, marginBottom: 4 }}>
        Book {pro.name}
      </h2>
      <p style={{ color: T.slate, fontSize: 13, marginBottom: 20 }}>{pro.rate} · {pro.city}</p>

      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        <div>
          <label style={{ fontSize: 12, fontWeight: 700, color: T.slate, display: "block", marginBottom: 6, letterSpacing: "0.08em" }}>DATE</label>
          <input type="date" value={date} onChange={e => { setDate(e.target.value); setTime(""); setSlotConflict(false); }} style={inputStyle} />
        </div>
        <div>
          <label style={{ fontSize: 12, fontWeight: 700, color: T.slate, display: "block", marginBottom: 6, letterSpacing: "0.08em" }}>TIME</label>
          <select value={time} onChange={e => { setTime(e.target.value); setSlotConflict(false); }} style={inputStyle}>
            <option value="">Select a time…</option>
            {HOURS.map(t => {
              const taken = date && isSlotTaken(pro.id, date, t);
              return (
                <option key={t} value={t} disabled={taken}>
                  {t}{taken ? " — Unavailable" : ""}
                </option>
              );
            })}
          </select>
          {date && bookedTimes.filter(b => b.date === date).length > 0 && (
            <div style={{ fontSize:12, color:T.amber, marginTop:4 }}>
              ⚠️ Some slots on this date are already booked
            </div>
          )}
        </div>
        <div>
          <label style={{ fontSize: 12, fontWeight: 700, color: T.slate, display: "block", marginBottom: 6, letterSpacing: "0.08em" }}>DESCRIBE THE JOB</label>
          <textarea
            value={desc} onChange={e => setDesc(e.target.value)}
            placeholder="What needs to be done? Include any important details…"
            rows={4}
            style={{ ...inputStyle, resize: "vertical", lineHeight: 1.5 }}
          />
        </div>

        {isDiagnosticJob ? (
          <div style={{ background: T.amberL, borderRadius: 12, padding: 14 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: T.amber, marginBottom: 4 }}>🔧 Diagnostic visit</div>
            <div style={{ fontSize: 12, color: T.navy, lineHeight: 1.5 }}>
              {pro.name} charges a <strong>${pro.diagnosticFee} diagnostic fee</strong> to assess this job — that's what you're paying now. If repair work is needed, they'll send you an itemized invoice for parts/labor afterward, which you approve before it's charged.
            </div>
          </div>
        ) : (
          <div>
            <label style={{ fontSize: 12, fontWeight: 700, color: T.slate, display: "block", marginBottom: 6, letterSpacing: "0.08em" }}>ESTIMATED HOURS</label>
            <select value={hours} onChange={e => setHours(Number(e.target.value))} style={inputStyle}>
              {[1, 2, 3, 4, 6, 8].map(h => <option key={h} value={h}>{h} hour{h > 1 ? "s" : ""}</option>)}
            </select>
            {estimatedAmount ? (
              <div style={{ fontSize: 12, color: T.slate, marginTop: 6 }}>
                Estimated: {pro.rate} × {hours}h = <strong style={{ color: T.navy }}>${estimatedAmount}</strong> before Localy's service fee
              </div>
            ) : (
              <div style={{ fontSize: 12, color: T.slate, marginTop: 6 }}>Final price is confirmed with {pro.name} before you pay.</div>
            )}
          </div>
        )}

        <div style={{ background: T.white, borderRadius: 12, border: `1px solid ${T.border}`, padding: 14 }}>
          <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 13, fontWeight: 700, color: T.navy }}>
            <input type="checkbox" checked={recurring} onChange={e => setRecurring(e.target.checked)} style={{ width: 16, height: 16, cursor: "pointer" }} />
            🔁 Make this a recurring booking
          </label>
          {recurring && (
            <div style={{ display: "flex", gap: 10, marginTop: 12 }}>
              <div style={{ flex: 1 }}>
                <label style={{ fontSize: 10, color: T.slate, fontWeight: 600, display: "block", marginBottom: 4 }}>REPEATS</label>
                <select value={frequency} onChange={e => setFrequency(e.target.value)} style={{ ...inputStyle, padding: "8px 10px", fontSize: 13 }}>
                  <option value="weekly">Weekly</option>
                  <option value="biweekly">Every 2 weeks</option>
                  <option value="monthly">Monthly</option>
                </select>
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ fontSize: 10, color: T.slate, fontWeight: 600, display: "block", marginBottom: 4 }}>NUMBER OF VISITS</label>
                <select value={occurrences} onChange={e => setOccurrences(Number(e.target.value))} style={{ ...inputStyle, padding: "8px 10px", fontSize: 13 }}>
                  {[4, 8, 12].map(n => <option key={n} value={n}>{n} visits</option>)}
                </select>
              </div>
            </div>
          )}
          {recurring && (
            <div style={{ fontSize: 11, color: T.slate, marginTop: 8, lineHeight: 1.5 }}>
              Books {occurrences} visits starting {date || "your selected date"}, {frequency === "weekly" ? "every week" : frequency === "biweekly" ? "every 2 weeks" : "every month"} at {time || "the selected time"}. Any date {pro.name} is already booked will be skipped and shown to you after confirming.
            </div>
          )}
        </div>

        <div style={{ background: T.cobaltL, borderRadius: 12, padding: 14, fontSize: 13, color: T.cobalt }}>
          💳 Payment is collected after the job is complete. Localy takes a 12% service fee.
        </div>

        {slotConflict && (
          <div style={{ background:T.coralL, borderRadius:12, padding:12, fontSize:13, color:T.coral, fontWeight:600 }}>
            🚫 This time slot is already booked. Please choose a different time.
          </div>
        )}
        {bookingError && (
          <div style={{ background:T.coralL, borderRadius:12, padding:12, fontSize:13, color:T.coral, fontWeight:600 }}>
            ⚠️ {bookingError}
          </div>
        )}
        <Btn
          label={booking ? "⏳ Booking…" : date && time && desc ? (recurring ? `Book ${occurrences} Visits →` : "Proceed to Payment →") : "Fill in all fields to continue"}
          onClick={async () => {
            if (date && time && desc && !booking) {
              if (isSlotTaken(pro.id, date, time)) {
                setSlotConflict(true);
                return;
              }
              setSlotConflict(false);
              setBookingError("");
              setBookingInFlight(true);
              const total = recurring ? Number(occurrences) : 1;
              const confirmed = [];
              const skipped = [];
              const newLocalIds = [];
              const ts = Date.now();
              // Tag the booking's description so it's obvious in My Jobs /
              // the pro's dashboard that this is a diagnostic-fee visit, not
              // a fixed-price job — the real cost comes later via invoice.
              const diagPrefix = isDiagnosticJob ? '[Diagnostic Visit] ' : '';
              // Real (Supabase) saves are awaited so a genuine failure (bad
              // connection, RLS, etc.) surfaces an error instead of showing
              // "Booking Confirmed!" for something that was never actually
              // saved — that used to happen silently for any pro without a
              // listed hourly rate, since the insert's amount/total_amount
              // came out null against a NOT NULL column (see
              // booking_amount_nullable_migration.sql).
              const saveResults = [];
              for (let i = 0; i < total; i++) {
                const d = addInterval(date, frequency, i);
                if (isSlotTaken(pro.id, d, time)) {
                  skipped.push(d);
                  continue;
                }
                reserveSlot(pro.id, d, time);
                confirmed.push({ date: d, time });
                const seriesNote = total > 1 ? ` (recurring visit ${i + 1}/${total}, ${frequency})` : '';

                // Show up in "My Jobs" right away — this doesn't depend on
                // the Supabase insert below succeeding, so it works even
                // when booking one of the app's mock/sample pros. Status
                // flips pending -> confirmed once payment succeeds (see the
                // PaymentView call site in the App shell below).
                const when = new Date(`${d}T${time}`);
                const hoursUntil = Math.round((when.getTime() - Date.now()) / 3600000);
                const localId = `local-${ts}-${i}`;
                newLocalIds.push(localId);
                BOOKING_STORE.publish({
                  id:         localId,
                  job:        diagPrefix + desc + seriesNote,
                  pro:        pro.name,
                  date:       `${d} ${time}`,
                  status:     "pending",
                  total:      estimatedAmount || 0,
                  hoursUntil: Number.isFinite(hoursUntil) ? hoursUntil : 999,
                });

                saveResults.push(
                  await createBooking({ pro, homeownerId: authUser?.id, date: d, time, desc: diagPrefix + desc + seriesNote, amount: estimatedAmount, homeownerName: authUser?.name })
                );
              }
              setBookingInFlight(false);
              // Only a real (string id) homeowner+pro combo ever actually
              // attempts a save (see createBooking's own guard) — mock/demo
              // bookings always report back { error: 'skipped...' } and
              // should still show the normal success screen.
              const isRealAttempt = typeof authUser?.id === 'string' && typeof pro?.id === 'string';
              const realFailure = isRealAttempt && saveResults.some(r => r.error && r.error !== 'skipped (mock pro or no logged-in user)');
              if (realFailure) {
                setBookingError("Your booking couldn't be saved. Please check your connection and try again.");
                return;
              }
              setConfirmedDates(confirmed);
              setSkippedDates(skipped);
              setLocalBookingIds(newLocalIds);
              setBooked(true);
            }
          }}
          variant={date && time && desc ? "primary" : "secondary"}
        />
      </div>
    </div>
  );
}

function PostJobView({ onBack, authUser }) {
  const [title, setTitle]     = useState("");
  const [cat, setCat]         = useState("");
  const [budget, setBudget]   = useState("");
  const [desc, setDesc]       = useState("");
  const [posted, setPosted]   = useState(false);
  const [jobPhotos, setJobPhotos] = useState([]);

  const inputStyle = {
    width: "100%", padding: "10px 12px", borderRadius: 10,
    border: `1.5px solid ${T.border}`, fontSize: 14,
    fontFamily: "'DM Sans', sans-serif", color: T.navy,
    outline: "none", boxSizing: "border-box", background: T.white,
  };

  if (posted) return (
    <JobPostedMatchingView
      job={{ title, cat, budget, desc, city:"The Woodlands", id: Date.now() }}
      onDone={onBack}
    />
  );

  return (
    <div style={{ background: T.sand, minHeight: "100%", padding: 16 }}>
      <button onClick={onBack} style={{
        background: "none", border: "none", color: T.cobalt,
        cursor: "pointer", fontSize: 14, padding: 0, marginBottom: 16,
        fontFamily: "'DM Sans', sans-serif", fontWeight: 600,
      }}>← Back</button>

      <h2 style={{ color: T.navy, fontFamily: "'DM Serif Display', serif", fontWeight: 400, marginBottom: 4 }}>
        Post a Job
      </h2>
      <p style={{ color: T.slate, fontSize: 13, marginBottom: 20 }}>Describe what you need — pros will bid on it.</p>

      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        <div>
          <label style={{ fontSize: 12, fontWeight: 700, color: T.slate, display: "block", marginBottom: 6, letterSpacing: "0.08em" }}>JOB TITLE</label>
          <input value={title} onChange={e => setTitle(e.target.value)} placeholder="e.g. Leaking kitchen faucet" style={inputStyle} />
        </div>
        <div>
          <label style={{ fontSize: 12, fontWeight: 700, color: T.slate, display: "block", marginBottom: 6, letterSpacing: "0.08em" }}>SERVICE TYPE</label>
          <select value={cat} onChange={e => setCat(e.target.value)} style={inputStyle}>
            <option value="">Select a category…</option>
            {CATEGORIES.map(c => <option key={c.id} value={c.id}>{c.label}</option>)}
          </select>
        </div>
        <div>
          <label style={{ fontSize: 12, fontWeight: 700, color: T.slate, display: "block", marginBottom: 6, letterSpacing: "0.08em" }}>YOUR BUDGET</label>
          <input value={budget} onChange={e => setBudget(e.target.value)} placeholder="e.g. $100–$200" style={inputStyle} />
        </div>
        <div>
          <label style={{ fontSize: 12, fontWeight: 700, color: T.slate, display: "block", marginBottom: 6, letterSpacing: "0.08em" }}>DESCRIPTION</label>
          <textarea
            value={desc} onChange={e => setDesc(e.target.value)}
            placeholder="Describe the job in detail. Photos can be added after posting."
            rows={4}
            style={{ ...inputStyle, resize: "vertical", lineHeight: 1.5 }}
          />
        </div>
        <Btn
          label={title && cat && budget && desc ? "Post Job" : "Fill in all fields to continue"}
          onClick={() => {
            if (title && cat && budget && desc) {
              const newJob = { title, cat, budget, desc, city:'The Woodlands', id: Date.now(), status:'open', bids:0, createdAt: new Date().toISOString() };
              JOB_STORE.publish(newJob);
              // Save to Supabase in background, then fan out a real push
              // notification to matching pros once we know it saved.
              postJob(newJob, authUser?.id || null).then(({ error }) => {
                if (!error) notifyMatchedProsOfNewJob(title, cat);
              }).catch(err => console.log('Job save error:', err));
              setPosted(true);
            }
          }}
          variant={title && cat && budget && desc ? "primary" : "secondary"}
        />
      </div>
    </div>
  );
}

function DashboardView({ userType, onNavigate, onCancelBooking, onPayInvoice, authUser }) {
  const [ratingJob, setRatingJob] = useState(null);
  // Tapping a booking card in My Jobs used to do nothing — the description
  // the homeowner typed when booking (r.job, from bookings.description via
  // useBookings) was captured but never shown anywhere after the fact.
  const [selectedBooking, setSelectedBooking] = useState(null);
  // The booking currently being invoiced (pro side) — opens InvoiceBuilderModal.
  const [invoicingBooking, setInvoicingBooking] = useState(null);
  const [myProId, setMyProId] = useState(null);
  useEffect(() => {
    if (userType !== 'pro' || !authUser?.id) return;
    getProProfileId(authUser.id).then(setMyProId).catch(() => {});
  }, [userType, authUser?.id]);
  const { isRated, getRating } = useCustomerRatings();
  const { bookings, loading: bookingsLoading } = useBookings(authUser, userType);
  const { entries: earningsEntries } = useProEarnings(authUser);
  const { thisMonthTotal, thisMonthCount, lastMonthTotal, pctChange } = summarizeEarnings(earningsEntries);
  const { avgRating, jobsCompleted } = useMyProStats(authUser);
  const hasEarningsHistory = earningsEntries.length > 0;

  // Real completed jobs, newest first — replaces the old hardcoded 3-row
  // demo list. A booking only reaches "completed" through the real
  // check-in/check-out flow now, so beforePhotoUrl/afterPhotoUrl are
  // populated for anything completed going forward; older/local bookings
  // may not have them.
  const recentJobs = bookings.filter(b => b.status === "completed").slice(0, 8);

  // Seed already-submitted pro->homeowner ratings from Supabase so a
  // booking rated in a previous session doesn't show "Rate Customer"
  // again (which would just fail against the one-review-per-booking
  // constraint). Local CUSTOMER_RATING_STORE still drives the "rated"
  // check — this just fills it in on load for real pros.
  useEffect(() => {
    if (userType !== 'pro' || !authUser?.id) return;
    (async () => {
      try {
        const proId = await getProProfileId(authUser.id);
        if (!proId) return;
        const rows = await sbFetch('reviews', `?pro_id=eq.${proId}&reviewer_role=eq.pro&select=booking_id,rating`);
        if (Array.isArray(rows)) {
          rows.forEach(r => {
            if (!CUSTOMER_RATING_STORE.isRated(r.booking_id)) {
              CUSTOMER_RATING_STORE.submit(r.booking_id, { rating: r.rating });
            }
          });
        }
      } catch (err) {
        console.log('Prior customer ratings load error:', err.message);
      }
    })();
  }, [userType, authUser?.id]);

  // Confirmed/in-progress bookings a pro can move forward — notifies the
  // homeowner at each step. Works today once there's a real pro + real
  // homeowner booking (mock/demo bookings have no homeownerId to notify).
  const activeBookings = bookings.filter(b => b.status === "confirmed" || b.status === "in_progress");
  const advanceBooking = (booking, newStatus, localExtra = {}, dbExtra = {}) => {
    BOOKING_STORE.upsert({ ...booking, status: newStatus, ...localExtra });
    if (typeof booking.id === 'string' && !booking.id.startsWith('local-')) {
      sbUpdate('bookings', booking.id, { status: newStatus, ...dbExtra }).catch(err => console.log('Booking status update error:', err));
    }
    if (booking.homeownerId) {
      const copy = newStatus === 'in_progress'
        ? ['Your pro has arrived 🚗', `${authUser?.name || 'Your pro'} is on-site and starting "${booking.job}".`]
        : ['Job completed ✅', `${authUser?.name || 'Your pro'} marked "${booking.job}" as complete.`];
      sendPushNotification(booking.homeownerId, copy[0], copy[1], { type: 'booking_status', bookingId: booking.id });
    }
  };

  // Check-in / check-out photo capture — a "before" photo is required to
  // start a job, an "after" photo to complete it. Both upload to the same
  // public "photos" bucket already used for profile/portfolio photos, then
  // ride along with the status change so the homeowner sees them too.
  const [photoTarget, setPhotoTarget] = useState(null); // { booking, phase: 'before'|'after' }
  const [photoBusy, setPhotoBusy]     = useState(false);
  const [photoError, setPhotoError]   = useState('');
  const photoInputRef = useRef(null);

  const startPhotoCapture = (booking, phase) => {
    setPhotoError('');
    setPhotoTarget({ booking, phase });
    setTimeout(() => photoInputRef.current?.click(), 0);
  };

  const handlePhotoFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file || !photoTarget) { setPhotoTarget(null); return; }
    const { booking, phase } = photoTarget;
    setPhotoBusy(true);
    setPhotoError('');
    try {
      const path = `${authUser.id}/booking-${booking.id}-${phase}-${Date.now()}-${file.name}`;
      const url = await sbUploadFile('photos', path, file);
      if (phase === 'before') {
        advanceBooking(booking, 'in_progress', { beforePhotoUrl: url }, { before_photo_url: url });
      } else {
        advanceBooking(booking, 'completed', { afterPhotoUrl: url }, { after_photo_url: url });
      }
    } catch (err) {
      setPhotoError(err.message || 'Could not upload photo. Try again.');
    } finally {
      setPhotoBusy(false);
      setPhotoTarget(null);
    }
  };

  if (userType === "pro") return (
    <>
    {ratingJob && (
      <RateCustomerPrompt job={ratingJob} authUser={authUser} onDone={() => setRatingJob(null)} onSkip={() => setRatingJob(null)} />
    )}
    <div style={{ padding: 16, background: T.sand, minHeight: "100%" }}>
      <h2 style={{ color: T.navy, fontFamily: "'DM Serif Display', serif", fontWeight: 400, marginBottom: 4 }}>Pro Dashboard</h2>
      <p style={{ color: T.slate, fontSize: 13, marginBottom: 20 }}>Your earnings and activity</p>

      {/* Earnings summary */}
      <div style={{
        background: `linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`,
        borderRadius: 16, padding: 20, marginBottom: 16, color: T.white,
      }}>
        <div style={{ fontSize: 12, color: "#A8BFDF", letterSpacing: "0.1em", marginBottom: 4 }}>THIS MONTH</div>
        <div style={{ fontSize: 36, fontWeight: 700, marginBottom: 4 }}>${thisMonthTotal.toLocaleString()}</div>
        {hasEarningsHistory ? (
          <div style={{ fontSize: 13, color: pctChange >= 0 ? "#8FE3C0" : "#FFB4A8" }}>
            {pctChange >= 0 ? "↑" : "↓"} {Math.abs(pctChange)}% vs last month (${lastMonthTotal.toLocaleString()})
          </div>
        ) : (
          <div style={{ fontSize: 13, color: "#A8BFDF" }}>No completed jobs yet</div>
        )}
        <div style={{ display: "flex", gap: 20, marginTop: 16 }}>
          {[
            ["Jobs", String(thisMonthCount)],
            ["Avg Rating", avgRating != null ? `${avgRating.toFixed(1)}★` : "—"],
            ["Lifetime Jobs", String(jobsCompleted ?? 0)],
          ].map(([k, v]) => (
            <div key={k}>
              <div style={{ fontSize: 16, fontWeight: 700 }}>{v}</div>
              <div style={{ fontSize: 11, color: "#A8BFDF" }}>{k}</div>
            </div>
          ))}
        </div>
        <button onClick={() => onNavigate && onNavigate("earnings")} style={{
          marginTop: 16, background: "rgba(255,255,255,0.15)", border: "none", color: T.white,
          borderRadius: 8, padding: "8px 14px", cursor: "pointer", fontSize: 13, fontWeight: 700,
          fontFamily: "'DM Sans', sans-serif",
        }}>
          📊 View Earnings Analytics →
        </button>
      </div>

      {/* Active bookings — mark arrived / complete, notifies the homeowner */}
      {activeBookings.length > 0 && (
        <div style={{ background: T.white, borderRadius: 14, border: `1px solid ${T.border}`, overflow: "hidden", marginBottom: 16 }}>
          <div style={{ padding: "12px 16px", borderBottom: `1px solid ${T.border}`, fontSize: 12, fontWeight: 700, color: T.slate, letterSpacing: "0.1em" }}>ACTIVE BOOKINGS</div>
          {activeBookings.map((b, i) => (
            <ProActiveBookingRow
              key={b.id}
              b={b}
              isLast={i === activeBookings.length - 1}
              photoBusy={photoBusy}
              photoTarget={photoTarget}
              startPhotoCapture={startPhotoCapture}
              setInvoicingBooking={setInvoicingBooking}
            />
          ))}
        </div>
      )}
      <input ref={photoInputRef} type="file" accept="image/*" capture="environment" style={{ display: "none" }} onChange={handlePhotoFile} />
      {photoError && (
        <div style={{ background: T.coralL, color: T.coral, borderRadius: 10, padding: "10px 14px", fontSize: 12, marginBottom: 16 }}>
          ⚠️ {photoError}
        </div>
      )}

      {/* Recent activity */}
      <div style={{ background: T.white, borderRadius: 14, border: `1px solid ${T.border}`, overflow: "hidden", marginBottom: 16 }}>
        <div style={{ padding: "12px 16px", borderBottom: `1px solid ${T.border}`, fontSize: 12, fontWeight: 700, color: T.slate, letterSpacing: "0.1em" }}>RECENT JOBS</div>
        {recentJobs.length === 0 && (
          <div style={{ padding: "24px 16px", textAlign: "center", color: T.slate, fontSize: 13 }}>
            No completed jobs yet — they'll show up here once you finish one.
          </div>
        )}
        {recentJobs.map((r, i) => {
          const rated = isRated(r.id);
          const ratingInfo = getRating(r.id);
          const hasPhoto = !!(r.beforePhotoUrl || r.afterPhotoUrl);
          return (
          <div key={r.id} style={{
            padding: "12px 16px",
            borderBottom: i < recentJobs.length - 1 ? `1px solid ${T.border}` : "none",
          }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom: hasPhoto ? 8 : 0 }}>
              <div>
                <div style={{ fontSize: 14, fontWeight: 600, color: T.navy }}>{r.job}</div>
                <div style={{ fontSize: 12, color: T.slate }}>{r.client} · {r.date}</div>
              </div>
              <div style={{ textAlign:"right" }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: T.green }}>+${r.total}</div>
                {!hasPhoto && <div style={{ fontSize:10, color:T.amber, fontWeight:600 }}>📸 No photo</div>}
              </div>
            </div>
            {hasPhoto && (
              <div style={{ display:"flex", gap:6, marginBottom:8 }}>
                {r.beforePhotoUrl && (
                  <a href={r.beforePhotoUrl} target="_blank" rel="noopener noreferrer" style={{ flex:1 }}>
                    <img src={r.beforePhotoUrl} alt="Before" style={{ width:"100%", height:56, objectFit:"cover", borderRadius:8, border:`1px solid ${T.border}` }} />
                  </a>
                )}
                {r.afterPhotoUrl && (
                  <a href={r.afterPhotoUrl} target="_blank" rel="noopener noreferrer" style={{ flex:1 }}>
                    <img src={r.afterPhotoUrl} alt="After" style={{ width:"100%", height:56, objectFit:"cover", borderRadius:8, border:`1px solid ${T.border}` }} />
                  </a>
                )}
              </div>
            )}
            {rated ? (
              <div style={{ fontSize:12, color:T.green, fontWeight:600 }}>
                ✅ You rated {r.client} {ratingInfo?.rating}★
              </div>
            ) : (
              <button onClick={() => setRatingJob(r)} style={{
                background:"none", border:`1px solid ${T.border}`, borderRadius:8,
                padding:"5px 12px", fontSize:12, fontWeight:700, color:T.cobalt,
                cursor:"pointer", fontFamily:"'DM Sans', sans-serif",
              }}>
                ⭐ Rate Customer
              </button>
            )}
          </div>
          );
        })}
      </div>

      {/* Profile completeness */}
      <div style={{ background: T.white, borderRadius: 14, border: `1px solid ${T.border}`, padding: 16, marginBottom: 16 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: T.slate, letterSpacing: "0.1em", marginBottom: 12 }}>PROFILE STRENGTH</div>
        <div style={{ background: T.border, borderRadius: 99, height: 8, marginBottom: 8 }}>
          <div style={{ background: T.cobalt, borderRadius: 99, height: 8, width: "85%" }} />
        </div>
        <div style={{ fontSize: 12, color: T.slate }}>85% complete · Add your license number to reach 100%</div>
      </div>
      <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
        <Btn label="⭐ Reviews" onClick={() => onNavigate && onNavigate("ratings")} variant="secondary" small />
        <Btn label="✏️ Edit Profile" onClick={() => onNavigate && onNavigate("account")} variant="secondary" small />
        <Btn label="🛡️ Get Verified" onClick={() => onNavigate && onNavigate("verification")} small />
        <Btn label="📅 Availability" onClick={() => onNavigate && onNavigate("availability")} variant="secondary" small />
      </div>
      <div style={{ marginTop:12 }}>
        <PayoutsSetupCard authUser={authUser} />
      </div>
      <div style={{ marginTop:12 }}>
        <NotificationsToggle authUser={authUser} />
      </div>
      <div style={{ background:T.cobaltL, borderRadius:12, padding:14, marginTop:12 }}>
        <div style={{ fontSize:12, fontWeight:700, color:T.cobalt, marginBottom:4 }}>⚡ REAL-TIME JOB MATCHING</div>
        <div style={{ fontSize:12, color:T.slate, lineHeight:1.5 }}>You will receive instant alerts when homeowners post jobs matching your skills. Accept within 45 seconds to claim the job.</div>
      </div>
    </div>
    {invoicingBooking && (
      <InvoiceBuilderModal
        booking={invoicingBooking}
        proId={myProId}
        onClose={() => setInvoicingBooking(null)}
      />
    )}
    </>
  );

  // Grouped instead of dumped into one misleadingly-labeled "ACTIVE
  // BOOKINGS" list that actually contained every status mixed together
  // (pending, confirmed, in_progress, completed, cancelled, all in one
  // pile). Now every real booking still shows up — just organized so it's
  // obvious what's currently happening vs. waiting vs. done.
  const activeBookingsList   = bookings.filter(b => b.status === "confirmed" || b.status === "in_progress");
  const awaitingBookingsList = bookings.filter(b => b.status === "pending");
  const completedBookingsList = bookings.filter(b => b.status === "completed");
  const cancelledBookingsList = bookings.filter(b => b.status === "cancelled");

  const renderBookingRow = (r, i, arr, showActions) => (
    <div key={r.id ?? i} onClick={() => setSelectedBooking(r)} style={{
      padding:"12px 16px", cursor:"pointer",
      borderBottom: i < arr.length - 1 ? `1px solid ${T.border}` : "none",
    }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:8 }}>
        <div>
          <div style={{ fontSize:14, fontWeight:600, color:T.navy }}>{r.job}</div>
          <div style={{ fontSize:12, color:T.slate }}>{r.pro} · {r.date}</div>
          {showActions && (
            <div style={{ fontSize:11, marginTop:3, color: r.hoursUntil >= 24 ? T.green : T.coral, fontWeight:600 }}>
              {r.hoursUntil >= 24 ? "✅ Free cancellation available" : `⚠️ ${r.hoursUntil}hrs away — fee may apply`}
            </div>
          )}
        </div>
        {r.status === "in_progress" ? (
          <span style={{ background:T.amberL, color:T.amber, fontSize:11, fontWeight:700, padding:"2px 10px", borderRadius:99 }}>In Progress</span>
        ) : r.status === "completed" ? (
          <span style={{ background:T.greenL, color:T.green, fontSize:11, fontWeight:700, padding:"2px 10px", borderRadius:99 }}>Completed</span>
        ) : r.status === "cancelled" ? (
          <span style={{ background:T.coralL, color:T.coral, fontSize:11, fontWeight:700, padding:"2px 10px", borderRadius:99 }}>Cancelled</span>
        ) : (
          <StatusPill status={r.status === "confirmed" ? "assigned" : "open"} />
        )}
      </div>

      {(r.beforePhotoUrl || r.afterPhotoUrl) && (
        <div style={{ display:"flex", gap:6, marginBottom:8 }}>
          {r.beforePhotoUrl && (
            <a href={r.beforePhotoUrl} target="_blank" rel="noopener noreferrer" style={{ flex:1 }}>
              <img src={r.beforePhotoUrl} alt="Before" style={{ width:"100%", height:64, objectFit:"cover", borderRadius:8, border:`1px solid ${T.border}` }} />
              <div style={{ fontSize:10, color:T.slate, fontWeight:600, textAlign:"center", marginTop:2 }}>BEFORE</div>
            </a>
          )}
          {r.afterPhotoUrl && (
            <a href={r.afterPhotoUrl} target="_blank" rel="noopener noreferrer" style={{ flex:1 }}>
              <img src={r.afterPhotoUrl} alt="After" style={{ width:"100%", height:64, objectFit:"cover", borderRadius:8, border:`1px solid ${T.border}` }} />
              <div style={{ fontSize:10, color:T.slate, fontWeight:600, textAlign:"center", marginTop:2 }}>AFTER</div>
            </a>
          )}
        </div>
      )}

      {showActions && (r.status === "confirmed" || r.status === "pending") && (
        <div style={{ display:"flex", gap:8 }}>
          <button onClick={(e) => { e.stopPropagation(); onNavigate && onNavigate("cancellation"); }} style={{ flex:1, padding:"6px", borderRadius:8, border:`1px solid ${T.border}`, background:T.white, color:T.slate, fontSize:11, fontWeight:600, cursor:"pointer", fontFamily:"'DM Sans', sans-serif" }}>
            📋 Policy
          </button>
          <button onClick={(e) => { e.stopPropagation(); onCancelBooking && onCancelBooking(r); }} style={{ flex:1, padding:"6px", borderRadius:8, border:`1px solid ${T.coral}`, background:T.coralL, color:T.coral, fontSize:11, fontWeight:700, cursor:"pointer", fontFamily:"'DM Sans', sans-serif" }}>
            ✕ Cancel
          </button>
        </div>
      )}
    </div>
  );

  const BookingSection = ({ title, items, showActions }) => items.length === 0 ? null : (
    <div style={{ background: T.white, borderRadius: 14, border: `1px solid ${T.border}`, overflow: "hidden", marginBottom: 16 }}>
      <div style={{ padding: "12px 16px", borderBottom: `1px solid ${T.border}`, fontSize: 12, fontWeight: 700, color: T.slate, letterSpacing: "0.1em" }}>{title} ({items.length})</div>
      {items.map((r, i) => renderBookingRow(r, i, items, showActions))}
    </div>
  );

  return (
    <div style={{ padding: 16, background: T.sand, minHeight: "100%" }}>
      <h2 style={{ color: T.navy, fontFamily: "'DM Serif Display', serif", fontWeight: 400, marginBottom: 4 }}>My Jobs</h2>
      <p style={{ color: T.slate, fontSize: 13, marginBottom: 20 }}>Your active and past bookings</p>

      {bookingsLoading && (
        <div style={{ textAlign:"center", padding:"40px 20px", color:T.slate }}>⏳ Loading your bookings...</div>
      )}

      {!bookingsLoading && bookings.length === 0 && (
        <div style={{ background: T.white, borderRadius: 14, border: `1px solid ${T.border}`, padding: "40px 20px", textAlign:"center", marginBottom: 16 }}>
          <div style={{ fontSize:32, marginBottom:8 }}>📋</div>
          <div style={{ fontWeight:600, color:T.navy, marginBottom:4 }}>No bookings yet</div>
          <div style={{ fontSize:13, color:T.slate }}>Browse pros or post a job to get your first booking going.</div>
        </div>
      )}

      <BookingSection title="ACTIVE"    items={activeBookingsList}    showActions={true} />
      <BookingSection title="AWAITING"  items={awaitingBookingsList}  showActions={true} />
      <BookingSection title="COMPLETED" items={completedBookingsList} showActions={false} />
      <BookingSection title="CANCELLED" items={cancelledBookingsList} showActions={false} />

      <div style={{ background: T.cobaltL, borderRadius: 12, padding: 16, fontSize: 13, color: T.cobalt, lineHeight: 1.5 }}>
        💡 <strong>Tip:</strong> Rate your pros after each job to help others in your neighborhood find the best service.
      </div>

      {selectedBooking && (
        <div onClick={() => setSelectedBooking(null)} style={{ position:"fixed", inset:0, background:"rgba(10,37,64,0.55)", display:"flex", alignItems:"flex-end", justifyContent:"center", zIndex:200 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background:T.white, borderRadius:"20px 20px 0 0", width:"100%", maxWidth:420, maxHeight:"85vh", overflowY:"auto", padding:20 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:14 }}>
              <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em" }}>BOOKING DETAILS</div>
              <button onClick={() => setSelectedBooking(null)} style={{ background:"none", border:"none", fontSize:18, color:T.slate, cursor:"pointer", lineHeight:1, padding:0 }}>✕</button>
            </div>

            <h3 style={{ color:T.navy, fontSize:19, fontWeight:700, margin:"0 0 6px" }}>{selectedBooking.job}</h3>

            <div style={{ marginBottom:4 }}>
              {selectedBooking.status === "in_progress" ? (
                <span style={{ background:T.amberL, color:T.amber, fontSize:11, fontWeight:700, padding:"2px 10px", borderRadius:99 }}>In Progress</span>
              ) : selectedBooking.status === "completed" ? (
                <span style={{ background:T.greenL, color:T.green, fontSize:11, fontWeight:700, padding:"2px 10px", borderRadius:99 }}>Completed</span>
              ) : selectedBooking.status === "cancelled" ? (
                <span style={{ background:T.coralL, color:T.coral, fontSize:11, fontWeight:700, padding:"2px 10px", borderRadius:99 }}>Cancelled</span>
              ) : (
                <StatusPill status={selectedBooking.status === "confirmed" ? "assigned" : "open"} />
              )}
            </div>

            <div style={{ background:T.sand, borderRadius:12, padding:14, marginTop:12, marginBottom:14 }}>
              <div style={{ display:"flex", justifyContent:"space-between", padding:"6px 0", borderBottom:`1px solid ${T.border}` }}>
                <span style={{ fontSize:12, color:T.slate }}>Pro</span>
                <span style={{ fontSize:13, fontWeight:600, color:T.navy }}>{selectedBooking.pro}</span>
              </div>
              <div style={{ display:"flex", justifyContent:"space-between", padding:"6px 0", borderBottom:`1px solid ${T.border}` }}>
                <span style={{ fontSize:12, color:T.slate }}>Date</span>
                <span style={{ fontSize:13, fontWeight:600, color:T.navy }}>{selectedBooking.date || "—"}</span>
              </div>
              <div style={{ display:"flex", justifyContent:"space-between", padding:"6px 0" }}>
                <span style={{ fontSize:12, color:T.slate }}>Price</span>
                <span style={{ fontSize:13, fontWeight:600, color:T.navy }}>{selectedBooking.total ? `$${selectedBooking.total}` : "Rate TBD — confirm with pro"}</span>
              </div>
            </div>

            {(selectedBooking.beforePhotoUrl || selectedBooking.afterPhotoUrl) && (
              <div style={{ display:"flex", gap:8, marginBottom:14 }}>
                {selectedBooking.beforePhotoUrl && (
                  <a href={selectedBooking.beforePhotoUrl} target="_blank" rel="noopener noreferrer" style={{ flex:1 }}>
                    <img src={selectedBooking.beforePhotoUrl} alt="Before" style={{ width:"100%", height:100, objectFit:"cover", borderRadius:10, border:`1px solid ${T.border}` }} />
                    <div style={{ fontSize:10, color:T.slate, fontWeight:600, textAlign:"center", marginTop:2 }}>BEFORE</div>
                  </a>
                )}
                {selectedBooking.afterPhotoUrl && (
                  <a href={selectedBooking.afterPhotoUrl} target="_blank" rel="noopener noreferrer" style={{ flex:1 }}>
                    <img src={selectedBooking.afterPhotoUrl} alt="After" style={{ width:"100%", height:100, objectFit:"cover", borderRadius:10, border:`1px solid ${T.border}` }} />
                    <div style={{ fontSize:10, color:T.slate, fontWeight:600, textAlign:"center", marginTop:2 }}>AFTER</div>
                  </a>
                )}
              </div>
            )}

            <BookingInvoicesSection booking={selectedBooking} onPayInvoice={onPayInvoice} />

            <button onClick={() => setSelectedBooking(null)} style={{ width:"100%", padding:"12px", borderRadius:12, border:"none", background:T.navy, color:T.white, fontWeight:700, cursor:"pointer", fontSize:14, fontFamily:"'DM Sans', sans-serif" }}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}


// ── Booking Invoices (Homeowner) ─────────────────────────────────
// Shown inside the booking detail sheet in My Jobs. A diagnostic-fee
// booking might never need a follow-up invoice at all — this renders
// nothing when there aren't any, so it doesn't clutter every booking.
function BookingInvoicesSection({ booking, onPayInvoice }) {
  const { invoices, loading } = useInvoices(typeof booking?.id === 'string' ? booking.id : null);
  if (loading || invoices.length === 0) return null;

  return (
    <div style={{ marginBottom:14 }}>
      <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:8 }}>INVOICES</div>
      {invoices.map(inv => (
        <InvoiceCard key={inv.id} invoice={inv} booking={booking} onPayInvoice={onPayInvoice} showPayButton />
      ))}
    </div>
  );
}

// ── Invoice Card (shared) ──────────────────────────────────────────
// Renders one invoice's line items + totals, plus a "Save Image" button
// that rasterizes the invoice (via html2canvas) into a PNG the person can
// keep for their own records — homeowners for what they paid, pros for
// what they billed. On a phone with the Web Share API (basically every
// modern mobile browser) this opens the native share sheet so "Save to
// Photos" is one tap; everywhere else it falls back to a normal file
// download. `showPayButton` only applies on the homeowner side — pros see
// the same card read-only, with no way to pay their own invoice.
function InvoiceCard({ invoice: inv, booking, onPayInvoice, showPayButton }) {
  const cardRef = useRef(null);
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState('');

  const handleSaveImage = async () => {
    if (!cardRef.current || saving) return;
    setSaving(true);
    setSaveError('');
    try {
      const canvas = await html2canvas(cardRef.current, { backgroundColor: T.white, scale: 2 });
      canvas.toBlob(async (blob) => {
        if (!blob) { setSaving(false); setSaveError('Could not generate the image.'); return; }
        const safeName = (booking?.job || 'invoice').replace(/[^a-z0-9]+/gi, '-').toLowerCase();
        const fileName = `${safeName}-invoice-${inv.id.slice(0, 8)}.png`;
        const file = new File([blob], fileName, { type: 'image/png' });
        try {
          if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
            await navigator.share({ files: [file], title: 'Invoice' });
          } else {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url; a.download = fileName;
            document.body.appendChild(a); a.click(); document.body.removeChild(a);
            setTimeout(() => URL.revokeObjectURL(url), 1000);
          }
        } catch (shareErr) {
          // User cancelled the share sheet — not a real error, nothing to show.
        }
        setSaving(false);
      }, 'image/png');
    } catch (err) {
      console.log('Save invoice image error:', err.message);
      setSaving(false);
      setSaveError('Could not save the image — try again.');
    }
  };

  return (
    <div style={{ background:T.sand, borderRadius:12, padding:14, marginBottom:8 }}>
      <div ref={cardRef} style={{ background:T.white, borderRadius:8, padding:14 }}>
        <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.08em", marginBottom:6 }}>
          {booking?.proBusinessName ? `${booking.proBusinessName.toUpperCase()} · ${(booking?.job || 'INVOICE').toUpperCase()}` : (booking?.job || 'INVOICE').toUpperCase()}
        </div>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
          <span style={{ fontSize:13, fontWeight:700, color:T.navy }}>Invoice · ${inv.total}</span>
          <span style={{
            background: inv.status === 'paid' ? T.greenL : T.amberL,
            color: inv.status === 'paid' ? T.green : T.amber,
            fontSize:10, fontWeight:700, padding:"2px 8px", borderRadius:99,
          }}>{inv.status === 'paid' ? 'PAID' : 'AWAITING PAYMENT'}</span>
        </div>
        {inv.items.map(it => (
          <div key={it.id} style={{ display:"flex", justifyContent:"space-between", fontSize:12, color:T.slate, padding:"2px 0" }}>
            <span>{it.description}{it.quantity > 1 ? ` × ${it.quantity}` : ''}</span>
            <span>${it.amount}</span>
          </div>
        ))}
        {inv.tax > 0 && (
          <div style={{ display:"flex", justifyContent:"space-between", fontSize:12, color:T.slate, padding:"2px 0" }}>
            <span>Tax</span><span>${inv.tax}</span>
          </div>
        )}
        {inv.notes && <div style={{ fontSize:12, color:T.slate, marginTop:6, fontStyle:"italic" }}>"{inv.notes}"</div>}
      </div>

      {saveError && <div style={{ fontSize:11, color:T.coral, marginTop:8 }}>⚠️ {saveError}</div>}

      <div style={{ display:"flex", gap:8, marginTop:10 }}>
        <button onClick={handleSaveImage} disabled={saving} style={{
          flex:1, padding:"10px", borderRadius:8, border:`1px solid ${T.border}`, background:T.white, color:T.navy,
          fontWeight:700, fontSize:13, cursor: saving ? "default" : "pointer", fontFamily:"'DM Sans', sans-serif",
        }}>
          {saving ? "⏳ Saving…" : "💾 Save Image"}
        </button>
        {showPayButton && inv.status === 'sent' && (
          <button onClick={() => onPayInvoice && onPayInvoice(inv, booking)} style={{ flex:1, padding:"10px", borderRadius:8, border:"none", background:T.cobalt, color:T.white, fontWeight:700, fontSize:13, cursor:"pointer", fontFamily:"'DM Sans', sans-serif" }}>
            ✅ Approve & Pay — ${inv.total}
          </button>
        )}
      </div>
    </div>
  );
}

// ── Pro active-booking row ──────────────────────────────────────────
// Extracted out of the ACTIVE BOOKINGS list so it can call the
// useInvoices hook per-booking (hooks can't be called inside a .map()
// callback directly). Also shows any invoices the pro has already sent
// on this booking, read-only, with a Save Image button — pros want a
// copy of what they billed for their own records too, not just
// homeowners reviewing what they owe.
function ProActiveBookingRow({ b, isLast, photoBusy, photoTarget, startPhotoCapture, setInvoicingBooking }) {
  const { invoices } = useInvoices(typeof b.id === 'string' ? b.id : null);

  return (
    <div style={{ padding: "12px 16px", borderBottom: isLast ? "none" : `1px solid ${T.border}` }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
        <div>
          <div style={{ fontSize: 14, fontWeight: 600, color: T.navy }}>{b.job}</div>
          <div style={{ fontSize: 12, color: T.slate }}>{b.client} · {b.date}</div>
        </div>
        <span style={{
          background: b.status === "in_progress" ? T.amberL : T.cobaltL,
          color: b.status === "in_progress" ? T.amber : T.cobalt,
          fontSize: 10, fontWeight: 700, padding: "3px 8px", borderRadius: 99,
        }}>{b.status === "in_progress" ? "IN PROGRESS" : "CONFIRMED"}</span>
      </div>
      {b.status === "confirmed" ? (
        <button onClick={() => startPhotoCapture(b, "before")} disabled={photoBusy} style={{
          width: "100%", padding: "8px", borderRadius: 8, border: "none", cursor: photoBusy ? "default" : "pointer",
          background: T.cobalt, color: T.white, fontWeight: 700, fontSize: 12, fontFamily: "'DM Sans', sans-serif",
          opacity: photoBusy && photoTarget?.booking.id === b.id ? 0.7 : 1,
        }}>
          {photoBusy && photoTarget?.booking.id === b.id ? "Uploading photo…" : "📷 Take Before Photo & Start Job"}
        </button>
      ) : (
        <button onClick={() => startPhotoCapture(b, "after")} disabled={photoBusy} style={{
          width: "100%", padding: "8px", borderRadius: 8, border: "none", cursor: photoBusy ? "default" : "pointer",
          background: T.green, color: T.white, fontWeight: 700, fontSize: 12, fontFamily: "'DM Sans', sans-serif",
          opacity: photoBusy && photoTarget?.booking.id === b.id ? 0.7 : 1,
        }}>
          {photoBusy && photoTarget?.booking.id === b.id ? "Uploading photo…" : "📷 Take After Photo & Complete"}
        </button>
      )}
      {typeof b.id === 'string' && (
        <button onClick={() => setInvoicingBooking(b)} style={{
          width: "100%", padding: "8px", borderRadius: 8, border: `1px solid ${T.border}`, cursor: "pointer",
          background: T.white, color: T.navy, fontWeight: 700, fontSize: 12, fontFamily: "'DM Sans', sans-serif", marginTop: 6,
        }}>
          🧾 Send Invoice
        </button>
      )}
      {(b.beforePhotoUrl || b.afterPhotoUrl) && (
        <div style={{ display: "flex", gap: 6, marginTop: 8 }}>
          {b.beforePhotoUrl && (
            <a href={b.beforePhotoUrl} target="_blank" rel="noopener noreferrer" style={{ flex: 1 }}>
              <img src={b.beforePhotoUrl} alt="Before" style={{ width: "100%", height: 56, objectFit: "cover", borderRadius: 8, border: `1px solid ${T.border}` }} />
            </a>
          )}
          {b.afterPhotoUrl && (
            <a href={b.afterPhotoUrl} target="_blank" rel="noopener noreferrer" style={{ flex: 1 }}>
              <img src={b.afterPhotoUrl} alt="After" style={{ width: "100%", height: 56, objectFit: "cover", borderRadius: 8, border: `1px solid ${T.border}` }} />
            </a>
          )}
        </div>
      )}
      {invoices.length > 0 && (
        <div style={{ marginTop: 10 }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: T.slate, letterSpacing: "0.08em", marginBottom: 6 }}>SENT INVOICES</div>
          {invoices.map(inv => (
            <InvoiceCard key={inv.id} invoice={inv} booking={b} showPayButton={false} />
          ))}
        </div>
      )}
    </div>
  );
}

// ── Invoice Builder (Pro) ───────────────────────────────────────
// Lets a pro itemize parts/labor/fees for a booking and send it straight
// to the homeowner. Used for both the diagnostic-fee follow-up ("here's
// what the repair actually costs") and any job where the pro wants to
// bill something beyond the original booking amount.
function InvoiceBuilderModal({ booking, proId, onClose }) {
  const [items, setItems] = useState([{ description: '', itemType: 'labor', quantity: 1, unitPrice: '' }]);
  const [taxAmount, setTaxAmount] = useState('');
  const [notes, setNotes] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const updateItem = (i, k, v) => setItems(prev => prev.map((it, idx) => idx === i ? { ...it, [k]: v } : it));
  const addItem = () => setItems(prev => [...prev, { description: '', itemType: 'parts', quantity: 1, unitPrice: '' }]);
  const removeItem = (i) => setItems(prev => prev.filter((_, idx) => idx !== i));

  const lineAmounts = items.map(it => (Number(it.quantity) || 0) * (Number(it.unitPrice) || 0));
  const subtotal = lineAmounts.reduce((s, a) => s + a, 0);
  const tax = Number(taxAmount) || 0;
  const total = subtotal + tax;

  const handleSend = async () => {
    setError('');
    if (!proId || !booking?.id || !booking?.homeownerId) {
      setError('Missing booking info — try reopening this booking.');
      return;
    }
    setSending(true);
    const { data, error: err } = await createInvoiceAndSend({
      bookingId: booking.id, proId, homeownerId: booking.homeownerId,
      items: items.map((it, i) => ({ ...it, amount: lineAmounts[i] })),
      notes, taxAmount: tax,
    });
    setSending(false);
    if (err) { setError(err); return; }
    sendPushNotification(
      booking.homeownerId,
      'New invoice 🧾',
      `You have a new $${data.total} invoice for "${booking.job}" — review and pay in My Jobs.`,
      { type: 'invoice', bookingId: booking.id }
    );
    setSent(true);
    setTimeout(onClose, 1400);
  };

  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, background:"rgba(10,37,64,0.55)", display:"flex", alignItems:"flex-end", justifyContent:"center", zIndex:300 }}>
      <div onClick={e => e.stopPropagation()} style={{ background:T.white, borderRadius:"20px 20px 0 0", width:"100%", maxWidth:420, maxHeight:"90vh", overflowY:"auto", padding:20 }}>
        {sent ? (
          <div style={{ textAlign:"center", padding:"30px 0" }}>
            <div style={{ fontSize:44, marginBottom:12 }}>✅</div>
            <div style={{ fontWeight:700, fontSize:16, color:T.navy }}>Invoice sent!</div>
          </div>
        ) : (
          <>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:14 }}>
              <div>
                <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em" }}>SEND INVOICE</div>
                <div style={{ fontSize:15, fontWeight:700, color:T.navy, marginTop:2 }}>{booking.job}</div>
              </div>
              <button onClick={onClose} style={{ background:"none", border:"none", fontSize:18, color:T.slate, cursor:"pointer", lineHeight:1, padding:0 }}>✕</button>
            </div>

            <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.08em", marginBottom:8 }}>LINE ITEMS</div>
            {items.map((it, i) => (
              <div key={i} style={{ background:T.sand, borderRadius:10, padding:10, marginBottom:8 }}>
                <input value={it.description} onChange={e => updateItem(i, 'description', e.target.value)} placeholder="e.g. Replacement capacitor" style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid ${T.border}`, fontSize:13, fontFamily:"'DM Sans', sans-serif", marginBottom:6, boxSizing:"border-box" }} />
                <div style={{ display:"flex", gap:6 }}>
                  <select value={it.itemType} onChange={e => updateItem(i, 'itemType', e.target.value)} style={{ flex:1.2, padding:"7px 6px", borderRadius:8, border:`1px solid ${T.border}`, fontSize:12, fontFamily:"'DM Sans', sans-serif" }}>
                    <option value="labor">Labor</option>
                    <option value="parts">Parts</option>
                    <option value="diagnostic_fee">Diagnostic Fee</option>
                    <option value="fee">Fee</option>
                    <option value="other">Other</option>
                  </select>
                  <input type="number" min="0" step="1" value={it.quantity} onChange={e => updateItem(i, 'quantity', e.target.value)} placeholder="Qty" style={{ flex:0.7, padding:"7px 6px", borderRadius:8, border:`1px solid ${T.border}`, fontSize:12, fontFamily:"'DM Sans', sans-serif" }} />
                  <input type="number" min="0" step="1" value={it.unitPrice} onChange={e => updateItem(i, 'unitPrice', e.target.value)} placeholder="$ each" style={{ flex:1, padding:"7px 6px", borderRadius:8, border:`1px solid ${T.border}`, fontSize:12, fontFamily:"'DM Sans', sans-serif" }} />
                  {items.length > 1 && (
                    <button onClick={() => removeItem(i)} style={{ background:"none", border:"none", color:T.coral, cursor:"pointer", fontSize:16, padding:"0 4px" }}>✕</button>
                  )}
                </div>
                <div style={{ textAlign:"right", fontSize:11, color:T.slate, marginTop:4 }}>= ${lineAmounts[i].toFixed(0)}</div>
              </div>
            ))}
            <button onClick={addItem} style={{ width:"100%", padding:"8px", borderRadius:8, border:`1px dashed ${T.border}`, background:"none", color:T.cobalt, fontWeight:700, fontSize:12, cursor:"pointer", fontFamily:"'DM Sans', sans-serif", marginBottom:14 }}>
              + Add Line Item
            </button>

            <div><label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>TAX ($, OPTIONAL)</label>
              <input type="number" min="0" step="1" value={taxAmount} onChange={e => setTaxAmount(e.target.value)} placeholder="0" style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid ${T.border}`, fontSize:13, fontFamily:"'DM Sans', sans-serif", boxSizing:"border-box" }} />
            </div>
            <div style={{ marginTop:10 }}><label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>NOTE TO HOMEOWNER (OPTIONAL)</label>
              <textarea value={notes} onChange={e => setNotes(e.target.value)} rows={2} placeholder="e.g. Found a failed capacitor during diagnosis — replaced same day." style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid ${T.border}`, fontSize:13, fontFamily:"'DM Sans', sans-serif", boxSizing:"border-box", resize:"vertical" }} />
            </div>

            <div style={{ background:T.sand, borderRadius:10, padding:12, marginTop:14 }}>
              <div style={{ display:"flex", justifyContent:"space-between", fontSize:13, color:T.slate, padding:"3px 0" }}><span>Subtotal</span><span>${subtotal.toFixed(0)}</span></div>
              {tax > 0 && <div style={{ display:"flex", justifyContent:"space-between", fontSize:13, color:T.slate, padding:"3px 0" }}><span>Tax</span><span>${tax.toFixed(0)}</span></div>}
              <div style={{ display:"flex", justifyContent:"space-between", fontSize:15, fontWeight:700, color:T.navy, padding:"6px 0 0", borderTop:`1px solid ${T.border}`, marginTop:4 }}><span>Total</span><span>${total.toFixed(0)}</span></div>
            </div>

            {error && <div style={{ background:T.coralL, color:T.coral, borderRadius:10, padding:"10px 14px", fontSize:12, marginTop:12 }}>⚠️ {error}</div>}

            <button onClick={handleSend} disabled={sending || total <= 0} style={{
              width:"100%", padding:"13px", borderRadius:12, border:"none", marginTop:16,
              background: total > 0 ? T.cobalt : T.border, color:T.white, fontWeight:700, fontSize:14,
              cursor: total > 0 && !sending ? "pointer" : "not-allowed", fontFamily:"'DM Sans', sans-serif",
            }}>
              {sending ? "⏳ Sending…" : `Send Invoice — $${total.toFixed(0)}`}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

// ── Pro Earnings Analytics ───────────────────────────────────────
function EarningsAnalyticsView({ authUser, onBack }) {
  const { entries, loading } = useProEarnings(authUser);
  const { thisMonthTotal, thisMonthCount, lastMonthTotal, pctChange } = summarizeEarnings(entries);
  const buckets   = weeklyBuckets(entries, 8);
  const maxBucket = Math.max(1, ...buckets.map(b => b.total));
  const avgJob    = thisMonthCount > 0 ? Math.round(thisMonthTotal / thisMonthCount) : 0;
  const topJobs   = [...entries].sort((a, b) => b.amount - a.amount).slice(0, 3);

  return (
    <div style={{ background: T.sand, minHeight: "100%", fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ background: `linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, padding: "16px 16px 24px" }}>
        <button onClick={onBack} style={{ background: "rgba(255,255,255,0.15)", border: "none", color: T.white, borderRadius: 8, padding: "6px 12px", cursor: "pointer", fontSize: 13, marginBottom: 14, fontFamily: "'DM Sans', sans-serif" }}>← Back</button>
        <div style={{ fontSize: 11, color: "#A8BFDF", fontWeight: 700, letterSpacing: "0.1em", marginBottom: 6 }}>EARNINGS ANALYTICS</div>
        <div style={{ fontSize: 36, fontWeight: 800, color: T.white, marginBottom: 4 }}>${thisMonthTotal.toLocaleString()}</div>
        <div style={{ fontSize: 13, color: pctChange >= 0 ? "#8FE3C0" : "#FFB4A8", fontWeight: 600 }}>
          {pctChange >= 0 ? "↑" : "↓"} {Math.abs(pctChange)}% vs last month (${lastMonthTotal.toLocaleString()})
        </div>
      </div>

      <div style={{ padding: 16, display: "flex", flexDirection: "column", gap: 16 }}>
        {/* Stat cards */}
        <div style={{ display: "flex", gap: 10 }}>
          {[["Jobs this month", String(thisMonthCount)], ["Avg job value", `$${avgJob}`], ["Last month", `$${lastMonthTotal.toLocaleString()}`]].map(([k, v]) => (
            <div key={k} style={{ flex: 1, background: T.white, borderRadius: 12, border: `1px solid ${T.border}`, padding: 12, textAlign: "center" }}>
              <div style={{ fontSize: 18, fontWeight: 800, color: T.navy }}>{v}</div>
              <div style={{ fontSize: 10, color: T.slate, fontWeight: 600, marginTop: 2 }}>{k}</div>
            </div>
          ))}
        </div>

        {/* Weekly chart */}
        <div style={{ background: T.white, borderRadius: 14, border: `1px solid ${T.border}`, padding: 16 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: T.slate, letterSpacing: "0.1em", marginBottom: 14 }}>LAST 8 WEEKS</div>
          <div style={{ display: "flex", alignItems: "flex-end", gap: 8, height: 130 }}>
            {buckets.map((b, i) => (
              <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
                <div style={{ fontSize: 10, color: T.slate, fontWeight: 700, minHeight: 12 }}>{b.total > 0 ? `$${b.total}` : ""}</div>
                <div style={{
                  width: "100%", borderRadius: 6,
                  height: Math.max(4, (b.total / maxBucket) * 90),
                  background: i === buckets.length - 1 ? `linear-gradient(180deg, #1565C0, #0A9E6A)` : T.cobaltL,
                }} />
                <div style={{ fontSize: 9, color: T.slate }}>{b.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Top jobs */}
        <div style={{ background: T.white, borderRadius: 14, border: `1px solid ${T.border}`, overflow: "hidden" }}>
          <div style={{ padding: "12px 16px", borderBottom: `1px solid ${T.border}`, fontSize: 12, fontWeight: 700, color: T.slate, letterSpacing: "0.1em" }}>TOP JOBS</div>
          {topJobs.length === 0 && (
            <div style={{ padding: 16, fontSize: 13, color: T.slate, textAlign: "center" }}>No completed jobs yet</div>
          )}
          {topJobs.map((j, i) => (
            <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "10px 16px", borderBottom: i < topJobs.length - 1 ? `1px solid ${T.border}` : "none" }}>
              <span style={{ fontSize: 13, color: T.navy }}>{new Date(j.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</span>
              <span style={{ fontSize: 13, fontWeight: 700, color: T.green }}>${j.amount}</span>
            </div>
          ))}
        </div>

        {loading && <div style={{ textAlign: "center", fontSize: 12, color: T.slate }}>Loading real earnings…</div>}
      </div>
    </div>
  );
}

// ── Neighborhood Feed ────────────────────────────────────────────
const MOCK_NEIGHBORHOOD_FEED = [
  { id: 1, type: "review", icon: "⭐", text: "Jennifer P. left a 5★ review for Marcus Webb (Plumbing)", time: "2h ago" },
  { id: 2, type: "job",    icon: "📋", text: "A neighbor just posted a \"Lawn maintenance\" job",         time: "4h ago" },
  { id: 3, type: "pro",    icon: "🔧", text: "Sandra Torres joined offering Cleaning",                    time: "1d ago" },
  { id: 4, type: "review", icon: "⭐", text: "Robert C. left a 5★ review for Lisa Nguyen (Lawn)",          time: "1d ago" },
  { id: 5, type: "job",    icon: "📋", text: "A neighbor just posted a \"Leaking faucet\" job",            time: "2d ago" },
];

// Hook: recent community activity near a homeowner's city — jobs just
// posted and new pros who joined (both real Supabase tables have a `city`
// column, so those are filtered to the given city), plus recent reviews
// metro-wide (the `reviews` table has no city column of its own, and
// Localy currently serves one metro area, so that's a reasonable
// simplification rather than a fragile nested-filter query).
// Deliberately anonymized to first name + last initial, no addresses —
// this is a community-pulse feed, not a way to look up a specific
// neighbor's activity.
function useNeighborhoodFeed(city) {
  const [feed, setFeed]       = useState(MOCK_NEIGHBORHOOD_FEED);
  const [loading, setLoading] = useState(true);

  const firstNameLastInitial = (fullName) => {
    if (!fullName) return "A neighbor";
    const parts = fullName.trim().split(/\s+/);
    return parts.length > 1 ? `${parts[0]} ${parts[parts.length - 1][0]}.` : parts[0];
  };

  useState(() => {
    const targetCity = city || "The Woodlands";
    (async () => {
      try {
        const [jobRows, reviewRows, proRows] = await Promise.all([
          sbFetch("jobs", `?city=eq.${encodeURIComponent(targetCity)}&select=id,title,category,created_at&order=created_at.desc&limit=15`),
          sbFetch("reviews", `?select=id,rating,created_at,pro_profiles(users(full_name)),bookings(homeowner:users!homeowner_id(full_name))&order=created_at.desc&limit=15`),
          // approved+available so a pending or admin-suspended pro never
          // gets announced in the feed as a new pro to hire.
          sbFetch("pro_profiles", `?city=eq.${encodeURIComponent(targetCity)}&approved=eq.true&available=eq.true&select=id,services,created_at,users(full_name)&order=created_at.desc&limit=10`),
        ]);

        const items = [];
        if (Array.isArray(jobRows)) {
          jobRows.forEach(j => items.push({
            id: `job-${j.id}`, type: "job", icon: "📋",
            text: `A neighbor just posted a "${j.title || CATEGORIES.find(c => c.id === j.category)?.label || 'service'}" job`,
            time: formatTimeAgo(j.created_at), rawTime: j.created_at,
          }));
        }
        if (Array.isArray(reviewRows)) {
          reviewRows.forEach(r => items.push({
            id: `review-${r.id}`, type: "review", icon: "⭐",
            text: `${firstNameLastInitial(r.bookings?.homeowner?.full_name)} left a ${r.rating}★ review for ${r.pro_profiles?.users?.full_name || "a pro"}`,
            time: formatTimeAgo(r.created_at), rawTime: r.created_at,
          }));
        }
        if (Array.isArray(proRows)) {
          proRows.forEach(p => items.push({
            id: `pro-${p.id}`, type: "pro", icon: "🔧",
            text: `${p.users?.full_name || "A new pro"} joined offering ${(p.services || []).map(s => CATEGORIES.find(c => c.id === s)?.label || s).join(", ") || "services"}`,
            time: formatTimeAgo(p.created_at), rawTime: p.created_at,
          }));
        }

        if (items.length > 0) {
          items.sort((a, b) => new Date(b.rawTime) - new Date(a.rawTime));
          setFeed(items.slice(0, 25));
        }
        // If nothing real yet, keep the mock feed so the screen isn't empty
      } catch (err) {
        console.log("Using mock neighborhood feed:", err.message);
      } finally {
        setLoading(false);
      }
    })();
  });

  return { feed, loading };
}

function NeighborhoodFeedView({ authUser, onBack, onNavigate }) {
  const [filter, setFilter] = useState("all"); // all | job | review | pro
  const city = authUser?.city || "The Woodlands";
  const { feed, loading } = useNeighborhoodFeed(city);

  const filtered = feed.filter(item => filter === "all" || item.type === filter);

  const typeColor = {
    job:    { bg: T.cobaltL, text: T.cobalt },
    review: { bg: T.amberL,  text: T.amber  },
    pro:    { bg: T.greenL,  text: T.green  },
  };

  return (
    <div style={{ background: T.sand, minHeight: "100%", fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ background: `linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, padding: "16px 16px 24px" }}>
        <button onClick={onBack} style={{ background: "rgba(255,255,255,0.15)", border: "none", color: T.white, borderRadius: 8, padding: "6px 12px", cursor: "pointer", fontSize: 13, marginBottom: 14, fontFamily: "'DM Sans', sans-serif" }}>← Back</button>
        <div style={{ fontSize: 32, marginBottom: 6 }}>📍</div>
        <div style={{ color: T.white, fontWeight: 700, fontSize: 20, marginBottom: 4 }}>Near You</div>
        <div style={{ color: "rgba(255,255,255,0.75)", fontSize: 13 }}>Recent activity in {city} and nearby areas</div>
      </div>

      <div style={{ padding: 16 }}>
        {/* Filter chips */}
        <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
          {[["all", "All"], ["job", "📋 Jobs"], ["review", "⭐ Reviews"], ["pro", "🔧 New Pros"]].map(([id, label]) => (
            <button key={id} onClick={() => setFilter(id)} style={{
              padding: "6px 12px", borderRadius: 99, cursor: "pointer",
              border: `1.5px solid ${filter === id ? T.cobalt : T.border}`,
              background: filter === id ? T.cobaltL : T.white,
              color: filter === id ? T.cobalt : T.slate,
              fontSize: 12, fontWeight: 700, fontFamily: "'DM Sans', sans-serif", whiteSpace: "nowrap",
            }}>{label}</button>
          ))}
        </div>

        {/* Feed list */}
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {filtered.map(item => {
            const tc = typeColor[item.type] || typeColor.job;
            return (
              <div key={item.id} style={{ background: T.white, borderRadius: 14, border: `1px solid ${T.border}`, padding: 14, display: "flex", gap: 12, alignItems: "flex-start" }}>
                <div style={{ width: 36, height: 36, borderRadius: "50%", background: tc.bg, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, flexShrink: 0 }}>{item.icon}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, color: T.navy, lineHeight: 1.4 }}>{item.text}</div>
                  <div style={{ fontSize: 11, color: T.slate, marginTop: 4 }}>{item.time}</div>
                </div>
              </div>
            );
          })}
          {filtered.length === 0 && (
            <div style={{ textAlign: "center", padding: 40, color: T.slate }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>📭</div>
              <div style={{ fontWeight: 700, fontSize: 16, color: T.navy }}>Nothing here yet</div>
              <div style={{ fontSize: 13, marginTop: 4 }}>Check back soon for updates from your area.</div>
            </div>
          )}
        </div>

        {/* CTA */}
        <div style={{ marginTop: 16 }}>
          <Btn label="📋 Post a Job" onClick={() => onNavigate && onNavigate("postjob")} />
        </div>

        {loading && <div style={{ textAlign: "center", fontSize: 12, color: T.slate, marginTop: 12 }}>Loading neighborhood activity…</div>}
      </div>
    </div>
  );
}

// ── Refer & Earn ───────────────────────────────────────────────
function ReferralsView({ authUser, onBack }) {
  const { referrals, loading } = useReferrals(authUser);
  const [copied, setCopied] = useState(false);

  const referralLink = authUser?.id
    ? `https://hirelocaly.com/?ref=${authUser.id}`
    : "https://hirelocaly.com/";

  const rewarded   = referrals.filter(r => r.status === "rewarded");
  const pending    = referrals.filter(r => r.status === "pending");
  const totalEarned = rewarded.reduce((sum, r) => sum + r.amount, 0);
  const availableToUse = rewarded.filter(r => !r.redeemed).reduce((sum, r) => sum + r.amount, 0);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(referralLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div style={{ background: T.sand, minHeight: "100%", fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ background: `linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, padding: "16px 16px 24px" }}>
        <button onClick={onBack} style={{ background: "rgba(255,255,255,0.15)", border: "none", color: T.white, borderRadius: 8, padding: "6px 12px", cursor: "pointer", fontSize: 13, marginBottom: 14, fontFamily: "'DM Sans', sans-serif" }}>← Back</button>
        <div style={{ fontSize: 32, marginBottom: 6 }}>🎁</div>
        <div style={{ color: T.white, fontWeight: 700, fontSize: 20, marginBottom: 4 }}>Give $10, Get $10</div>
        <div style={{ color: "rgba(255,255,255,0.75)", fontSize: 13, lineHeight: 1.5 }}>
          Share your link. Your friend gets $10 off their first booking, and you get a $10 credit once they complete it.
        </div>
      </div>

      <div style={{ padding: 16, display: "flex", flexDirection: "column", gap: 16 }}>
        {/* Share link */}
        <div style={{ background: T.white, borderRadius: 14, border: `1px solid ${T.border}`, padding: 16 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: T.slate, letterSpacing: "0.08em", marginBottom: 8 }}>YOUR REFERRAL LINK</div>
          <div style={{
            background: T.sand, borderRadius: 10, padding: "10px 12px", fontSize: 12,
            color: T.navy, wordBreak: "break-all", marginBottom: 10, fontFamily: "monospace",
          }}>
            {referralLink}
          </div>
          <Btn label={copied ? "✅ Copied!" : "📋 Copy Link"} onClick={handleCopy} />
        </div>

        {/* Stats */}
        <div style={{ display: "flex", gap: 10 }}>
          {[["Invited", String(referrals.length)], ["Pending", String(pending.length)], ["Available", `$${availableToUse}`], ["Lifetime", `$${totalEarned}`]].map(([k, v]) => (
            <div key={k} style={{ flex: 1, background: T.white, borderRadius: 12, border: `1px solid ${T.border}`, padding: 12, textAlign: "center" }}>
              <div style={{ fontSize: 18, fontWeight: 800, color: T.navy }}>{v}</div>
              <div style={{ fontSize: 10, color: T.slate, fontWeight: 600, marginTop: 2 }}>{k}</div>
            </div>
          ))}
        </div>

        {/* Referral list */}
        <div style={{ background: T.white, borderRadius: 14, border: `1px solid ${T.border}`, overflow: "hidden" }}>
          <div style={{ padding: "12px 16px", borderBottom: `1px solid ${T.border}`, fontSize: 12, fontWeight: 700, color: T.slate, letterSpacing: "0.1em" }}>YOUR REFERRALS</div>
          {referrals.length === 0 && (
            <div style={{ padding: 20, fontSize: 13, color: T.slate, textAlign: "center" }}>
              No referrals yet — share your link above to start earning.
            </div>
          )}
          {referrals.map((r, i) => (
            <div key={r.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", borderBottom: i < referrals.length - 1 ? `1px solid ${T.border}` : "none" }}>
              <div>
                <div style={{ fontSize: 14, fontWeight: 600, color: T.navy }}>{r.name}</div>
                <div style={{ fontSize: 12, color: T.slate }}>{r.date}</div>
              </div>
              {r.status === "rewarded" ? (
                r.redeemed ? (
                  <span style={{ background: T.sand, color: T.slate, fontSize: 11, fontWeight: 700, padding: "4px 10px", borderRadius: 99 }}>✓ ${r.amount} used</span>
                ) : (
                  <span style={{ background: T.greenL, color: T.green, fontSize: 11, fontWeight: 700, padding: "4px 10px", borderRadius: 99 }}>✅ +${r.amount} available</span>
                )
              ) : (
                <span style={{ background: T.amberL, color: T.amber, fontSize: 11, fontWeight: 700, padding: "4px 10px", borderRadius: 99 }}>⏳ Pending first booking</span>
              )}
            </div>
          ))}
        </div>

        {loading && <div style={{ textAlign: "center", fontSize: 12, color: T.slate }}>Loading your referrals…</div>}
      </div>
    </div>
  );
}

// ── Payment View ───────────────────────────────────────────────
// Hook: does this booking's pro have a live Stripe Connect account to
// route payment to? Looks up pro_profiles directly by id rather than
// going through getProProfileId, since PaymentView already has the pro's
// pro_profiles.id (not their auth user id) via the `pro` prop. Mock/demo
// pros (numeric id) never have one, same real-vs-mock split used
// everywhere else — the request below just no-ops for those.
function useProConnectInfo(proId) {
  const [info, setInfo] = useState({ stripeAccountId: null, payoutsEnabled: false, isPlus: false });
  useState(() => {
    if (!proId || typeof proId !== 'string') return;
    (async () => {
      try {
        const rows = await sbFetch('pro_profiles', `?id=eq.${proId}&select=stripe_account_id,payouts_enabled,subscription_tier`);
        const row = rows?.[0];
        if (row) setInfo({
          stripeAccountId: row.stripe_account_id || null,
          payoutsEnabled: !!row.payouts_enabled,
          isPlus: row.subscription_tier === 'plus',
        });
      } catch (err) {
        console.log('Pro connect info fetch error:', err.message);
      }
    })();
  });
  return info;
}

function PaymentView({ pro, booking, onBack, onSuccess, authUser }) {
  const [step, setStep]         = useState(1);
  const [card, setCard]         = useState({ name:"" });
  const [saveCard, setSaveCard] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [method, setMethod]     = useState("card");
  const [payError, setPayError] = useState("");
  const [cardComplete, setCardComplete] = useState(false);
  const [cardElementError, setCardElementError] = useState("");

  // Referral "Give $10, Get $10" credit — available balance from friends
  // who've already completed their first booking. Applied by default so a
  // returning referrer actually sees the payoff, but they can untoggle it.
  const { creditCents, creditRowIds } = useReferralCredit(authUser);
  const [applyCredit, setApplyCredit] = useState(true);

  // Does this pro have payouts set up? If so, the charge is split
  // automatically at checkout — Localy's fee stays on the platform
  // account, the rest routes straight to the pro. If not, the full amount
  // is charged to the platform account same as before Connect existed —
  // checkout never breaks waiting on a pro to finish onboarding.
  const { stripeAccountId: proStripeAccountId, payoutsEnabled: proPayoutsEnabled, isPlus: proIsPlus } = useProConnectInfo(pro?.id);

  // Stripe publishable key — TEST mode, on the dedicated Connect/platform
  // account (the original account can't be used for Connect — see
  // stripe_connect_migration.sql notes). Publishable keys are safe to
  // embed client-side by design (unlike the secret key, which only ever
  // lives in the Supabase Edge Function).
  const STRIPE_PK = 'pk_test_51U7LnoAgizqjbcuH2ybbyNJqUEVQ1T3S9Fw9TaSHitBBydDroBY7JRCJvJOfzQuBUQSBn1IPUnqc8YQMSSCU34b100cy9giCVy';
  const SUPABASE_URL = 'https://ksaealvsimnybueigmhd.supabase.co';
  const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtzYWVhbHZzaW1ueWJ1ZWlnbWhkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODY4NjExNzcsImV4cCI6MjEwMjQzNzE3N30.pQ6f2RidqF57AR1sXt2AGXpd-uuq6SbJXEryc6m1TCQ';

  const rate     = pro?.rate || "$85/hr";
  // Use the real amount from the booking/accepted bid that sent us here —
  // falls back to the old placeholder only if this screen is somehow
  // reached without one (shouldn't happen via normal navigation).
  const hours    = booking?.hours ?? 2;
  const subtotal = booking?.amount ?? 170;
  // Pro Plus pros keep more of what they earn — 6% platform fee instead
  // of the standard 12% (see pro_plus_migration.sql / useProConnectInfo).
  // This is the fee actually charged via Stripe's application_fee_amount
  // below, not just a display estimate.
  const feeRate  = proIsPlus ? 0.06 : 0.12;
  const fee      = Math.round(subtotal * feeRate);
  const total    = subtotal + fee;
  const lineLabel = booking?.jobTitle
    ? (booking?.hours ? `${booking.jobTitle} · ${hours} hrs` : booking.jobTitle)
    : `${pro?.name || "Pro"} · ${hours} hrs`;

  // Stripe's practical minimum charge is ~$0.50 — never discount past that,
  // and never apply more credit than the customer actually has.
  const availableCredit = creditCents / 100;
  const creditApplied   = applyCredit ? Math.max(0, Math.min(availableCredit, total - 0.5)) : 0;
  const finalTotal       = Math.round((total - creditApplied) * 100) / 100;

  const update = (k, v) => setCard(f => ({ ...f, [k]: v }));

  // Load Stripe.js dynamically
  const loadStripe = () => new Promise((resolve) => {
    if (window.Stripe) { resolve(window.Stripe(STRIPE_PK)); return; }
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/';
    script.onload = () => resolve(window.Stripe(STRIPE_PK));
    document.head.appendChild(script);
  });

  // Mount Stripe's own secure "Card Element" (an iframe Stripe controls) —
  // card number/expiry/CVV are typed directly into Stripe's iframe, never
  // into our own inputs or state. This is what keeps Localy out of PCI
  // scope beyond the lightest tier (SAQ A) instead of the raw-fields
  // approach, which would require a much longer compliance questionnaire.
  const cardElRef       = useRef(null);
  const stripeRef        = useRef(null);
  const elementsRef      = useRef(null);
  const cardElementRef   = useRef(null);

  useEffect(() => {
    if (method !== 'card') return;
    let cancelled = false;

    (async () => {
      const stripe = await loadStripe();
      if (cancelled || !cardElRef.current) return;
      stripeRef.current = stripe;
      const elements = stripe.elements();
      elementsRef.current = elements;
      const cardElement = elements.create('card', {
        style: {
          base: {
            fontSize: '15px',
            fontFamily: "'DM Sans', sans-serif",
            color: '#0A2540',
            '::placeholder': { color: '#94A3B8' },
          },
          invalid: { color: '#D64550' },
        },
      });
      cardElement.mount(cardElRef.current);
      cardElement.on('change', (event) => {
        setCardComplete(event.complete);
        setCardElementError(event.error ? event.error.message : "");
      });
      cardElementRef.current = cardElement;
    })();

    return () => {
      cancelled = true;
      if (cardElementRef.current) {
        cardElementRef.current.unmount();
        cardElementRef.current = null;
      }
    };
  }, [method]);

  const handlePay = async () => {
    setPayError("");
    setProcessing(true);

    try {
      const stripe = stripeRef.current;
      const cardElement = cardElementRef.current;
      if (!stripe || !cardElement) throw new Error('Card form is still loading — try again in a moment.');

      // 2. Create payment method from the Stripe Card Element (card data
      // never passes through our own code — Stripe collects it directly)
      const { paymentMethod, error: pmError } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
        billing_details: { name: card.name },
      });

      if (pmError) {
        setPayError(pmError.message);
        setProcessing(false);
        return;
      }

      // 3. Create payment intent via Supabase Edge Function
      // (Edge Function handles the secret key safely on the server)
      const intentRes = await fetch(`${SUPABASE_URL}/functions/v1/create-payment-intent`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${SUPABASE_KEY}`,
        },
        body: JSON.stringify({
          amount:           Math.round(finalTotal * 100), // Stripe uses cents
          currency:         'usd',
          payment_method_id: paymentMethod.id,
          description:      `Localy booking — ${pro?.name || 'Pro'} — ${booking?.job || 'Service'}`,
          metadata: {
            pro_name:    pro?.name || '',
            pro_id:      pro?.id || '',
            service_fee: fee,
          },
          ...(proPayoutsEnabled && proStripeAccountId ? {
            connected_account_id:    proStripeAccountId,
            application_fee_amount:  Math.round(fee * 100),
          } : {}),
        }),
      });

      const intentData = await intentRes.json();

      if (intentData.error) {
        // Edge function not set up yet — fall through to success for demo
        // Payment processing
        setProcessing(false);
        setStep(3);
        if (creditApplied > 0) redeemReferralCredit(creditRowIds);
        if (onSuccess) onSuccess();
        return;
      }

      // 4. Confirm the payment
      const { error: confirmError } = await stripe.confirmCardPayment(
        intentData.client_secret,
        { payment_method: paymentMethod.id }
      );

      if (confirmError) {
        setPayError(confirmError.message);
        setProcessing(false);
        return;
      }

      // 5. Payment successful!
      setProcessing(false);
      setStep(3);
      if (creditApplied > 0) redeemReferralCredit(creditRowIds);
      if (onSuccess) onSuccess();

    } catch (err) {
      // Network error or Stripe not loaded — use demo mode
      // Fallback payment flow
      setTimeout(() => {
        setProcessing(false);
        setStep(3);
        if (creditApplied > 0) redeemReferralCredit(creditRowIds);
        if (onSuccess) onSuccess();
      }, 1500);
    }
  };

  const inputStyle = {
    width:"100%", padding:"12px 14px", borderRadius:10,
    border:`1.5px solid ${payError ? T.coral : T.border}`, fontSize:15,
    fontFamily:"'DM Sans', sans-serif", color:T.navy,
    outline:"none", boxSizing:"border-box", background:T.white,
    letterSpacing:"0.02em",
  };

  if (step === 3) return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:40, textAlign:"center", background:T.sand, minHeight:"100%" }}>
      <div style={{ width:80, height:80, borderRadius:"50%", background:T.greenL, display:"flex", alignItems:"center", justifyContent:"center", fontSize:40, marginBottom:20 }}>✅</div>
      <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, marginBottom:8 }}>Payment Successful!</h2>
      <p style={{ color:T.slate, fontSize:14, marginBottom:6 }}>Your booking with <strong>{pro?.name}</strong> is confirmed.</p>
      <p style={{ color:T.slate, fontSize:14, marginBottom:24 }}>A receipt has been sent to your email.</p>
      <div style={{ background:T.white, borderRadius:14, padding:16, border:`1px solid ${T.border}`, width:"100%", textAlign:"left", marginBottom:24 }}>
        {[["Amount Paid", `$${finalTotal.toFixed(2)}`], ["Service Fee", `$${fee}`], ...(creditApplied > 0 ? [["Referral Credit Used", `-$${creditApplied.toFixed(2)}`]] : []), ["Pro", pro?.name], ["Status", "Confirmed ✅"]].map(([k,v]) => (
          <div key={k} style={{ display:"flex", justifyContent:"space-between", padding:"7px 0", fontSize:14, borderBottom:`1px solid ${T.border}` }}>
            <span style={{ color:T.slate }}>{k}</span>
            <span style={{ color:T.navy, fontWeight:600 }}>{v}</span>
          </div>
        ))}
      </div>
      <div style={{ display:"flex", gap:10, width:"100%" }}>
        <Btn label="Rate Pro ⭐" onClick={onBack} variant="secondary" />
        <Btn label="Done" onClick={onBack} />
      </div>
    </div>
  );

  return (
    <div style={{ background:T.sand, minHeight:"100%", display:"flex", flexDirection:"column" }}>
      {/* Header */}
      <div style={{ background:`linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, padding:"20px 16px 28px" }}>
        <button onClick={onBack} style={{ background:"rgba(255,255,255,0.15)", border:"none", color:T.white, borderRadius:8, padding:"6px 12px", cursor:"pointer", fontSize:13, marginBottom:16, fontFamily:"'DM Sans', sans-serif" }}>← Back</button>
        <div style={{ color:"#A8BFDF", fontSize:12, fontWeight:700, letterSpacing:"0.1em", marginBottom:4 }}>SECURE CHECKOUT</div>
        <div style={{ color:T.white, fontSize:22, fontWeight:700 }}>${finalTotal.toFixed(2)}</div>
        <div style={{ color:"#A8BFDF", fontSize:13 }}>Booking with {pro?.name}</div>
      </div>

      <div style={{ padding:16, flex:1, overflowY:"auto", marginTop:-12 }}>

        {/* Order Summary */}
        <div style={{ background:T.white, borderRadius:14, padding:16, border:`1px solid ${T.border}`, marginBottom:14, boxShadow:"0 2px 8px rgba(0,0,0,0.06)" }}>
          <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:12 }}>ORDER SUMMARY</div>
          {[
            [lineLabel, `$${subtotal}`],
            ["Localy service fee (12%)", `$${fee}`],
          ].map(([k,v]) => (
            <div key={k} style={{ display:"flex", justifyContent:"space-between", padding:"7px 0", fontSize:14, borderBottom:`1px solid ${T.border}` }}>
              <span style={{ color:T.slate }}>{k}</span>
              <span style={{ color:T.navy }}>{v}</span>
            </div>
          ))}
          {creditApplied > 0 && (
            <div style={{ display:"flex", justifyContent:"space-between", padding:"7px 0", fontSize:14, borderBottom:`1px solid ${T.border}` }}>
              <span style={{ color:T.green }}>🎁 Referral credit</span>
              <span style={{ color:T.green, fontWeight:700 }}>-${creditApplied.toFixed(2)}</span>
            </div>
          )}
          <div style={{ display:"flex", justifyContent:"space-between", padding:"10px 0 0", fontSize:16, fontWeight:700 }}>
            <span style={{ color:T.navy }}>Total</span>
            <span style={{ color:T.navy }}>${finalTotal.toFixed(2)}</span>
          </div>
        </div>

        {/* Referral credit toggle — only shown if the user actually has any */}
        {availableCredit > 0 && (
          <div onClick={() => setApplyCredit(!applyCredit)} style={{
            display:"flex", alignItems:"center", justifyContent:"space-between", cursor:"pointer",
            background: applyCredit ? T.greenL : T.white, borderRadius:14, padding:14,
            border:`1.5px solid ${applyCredit ? T.green : T.border}`, marginBottom:14,
          }}>
            <div style={{ display:"flex", alignItems:"center", gap:10 }}>
              <span style={{ fontSize:20 }}>🎁</span>
              <div>
                <div style={{ fontWeight:700, fontSize:13, color:T.navy }}>Apply ${availableCredit.toFixed(2)} referral credit</div>
                <div style={{ fontSize:11, color:T.slate }}>From friends you've referred to Localy</div>
              </div>
            </div>
            <div style={{ width:44, height:24, borderRadius:99, background: applyCredit ? T.green : T.border, position:"relative", flexShrink:0 }}>
              <div style={{ width:20, height:20, borderRadius:"50%", background:T.white, position:"absolute", top:2, left: applyCredit ? 22 : 2, transition:"left 0.15s" }} />
            </div>
          </div>
        )}

        {/* Payment method selector */}
        <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:10 }}>PAYMENT METHOD</div>
        <div style={{ display:"flex", gap:8, marginBottom:16 }}>
          {[
            { id:"card",   label:"💳 Card"    },
            { id:"apple",  label:" Apple Pay" },
            { id:"google", label:"G Pay"      },
          ].map(m => (
            <button key={m.id} onClick={() => { setMethod(m.id); setPayError(""); }} style={{
              flex:1, padding:"10px 6px", borderRadius:10, cursor:"pointer",
              background: method===m.id ? T.navy : T.white,
              color: method===m.id ? T.white : T.navy,
              border:`2px solid ${method===m.id ? T.navy : T.border}`,
              fontSize:13, fontWeight:600, fontFamily:"'DM Sans', sans-serif",
            }}>{m.label}</button>
          ))}
        </div>

        {method === "card" && (
          <div style={{ display:"flex", flexDirection:"column", gap:12, marginBottom:14 }}>
            <div>
              <label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>CARDHOLDER NAME</label>
              <input value={card.name} onChange={e => update("name", e.target.value)} placeholder="Name on card" style={inputStyle} />
            </div>
            <div>
              <label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>CARD DETAILS</label>
              {/* Stripe mounts its own secure iframe here — card number,
                  expiry, and CVV are typed directly into Stripe, not into
                  any input this app controls. */}
              <div ref={cardElRef} style={{ ...inputStyle, paddingTop:13, paddingBottom:13 }} />
              {cardElementError && (
                <div style={{ fontSize:12, color:T.coral, fontWeight:600, marginTop:6 }}>{cardElementError}</div>
              )}
            </div>
            <div onClick={() => setSaveCard(!saveCard)} style={{ display:"flex", alignItems:"center", gap:10, cursor:"pointer" }}>
              <div style={{ width:20, height:20, borderRadius:6, border:`2px solid ${saveCard ? T.green : T.border}`, background: saveCard ? T.green : "transparent", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                {saveCard && <span style={{ color:T.white, fontSize:13, fontWeight:700 }}>✓</span>}
              </div>
              <span style={{ fontSize:13, color:T.slate }}>Save card for future payments</span>
            </div>
          </div>
        )}

        {(method === "apple" || method === "google") && (
          <div style={{ background:T.white, borderRadius:14, padding:20, textAlign:"center", border:`1px solid ${T.border}`, marginBottom:14 }}>
            <div style={{ fontSize:36, marginBottom:8 }}>{method === "apple" ? "" : "G"}</div>
            <div style={{ fontWeight:600, color:T.navy, marginBottom:4 }}>{method === "apple" ? "Apple Pay" : "Google Pay"}</div>
            <div style={{ fontSize:13, color:T.slate }}>You will be prompted to confirm with Face ID / fingerprint</div>
          </div>
        )}

        {/* Error message */}
        {payError && (
          <div style={{ background:T.coralL, borderRadius:10, padding:"10px 14px", marginBottom:14, fontSize:13, color:T.coral, fontWeight:600 }}>
            ⚠️ {payError}
          </div>
        )}

        {/* Security badge */}
        <div style={{ display:"flex", alignItems:"center", gap:8, background:T.greenL, borderRadius:10, padding:"10px 14px", marginBottom:16 }}>
          <span style={{ fontSize:16 }}>🔒</span>
          <span style={{ fontSize:12, color:T.green, fontWeight:600 }}>256-bit SSL encryption · Powered by Stripe</span>
        </div>

        {/* Pay button */}
        <button onClick={handlePay}
          disabled={processing || (method==="card" && (!card.name || !cardComplete))}
          style={{
            width:"100%", padding:"16px", borderRadius:12, border:"none", cursor:"pointer",
            background: processing ? T.slate : `linear-gradient(135deg, #1565C0, #0A9E6A)`,
            color:T.white, fontSize:16, fontWeight:700, fontFamily:"'DM Sans', sans-serif",
            boxShadow:"0 4px 16px rgba(21,101,192,0.35)", transition:"opacity 0.2s",
            opacity: (method==="card" && (!card.name || !cardComplete)) ? 0.6 : 1,
          }}>
          {processing ? "⏳ Processing payment…" : `Pay $${finalTotal.toFixed(2)}`}
        </button>
      </div>
    </div>
  );
}


// ── Admin Dashboard ────────────────────────────────────────────
const ADMIN_STATS = {
  revenue:     { today: 1240, week: 8430, month: 31200, growth: "+18%" },
  bookings:    { today: 7,    week: 52,   month: 198,   growth: "+12%" },
  activePros:  { count: 43,  pending: 6,  suspended: 1              },
  homeowners:  { count: 312, newToday: 8                             },
};

const ADMIN_BOOKINGS = [
  { id:"#1042", homeowner:"Jennifer P.", pro:"Marcus Webb",   service:"Plumbing",   amount:191, status:"completed", date:"Aug 12" },
  { id:"#1041", homeowner:"Robert C.",   pro:"Lisa Nguyen",   service:"Lawn",       amount:62,  status:"active",    date:"Aug 12" },
  { id:"#1040", homeowner:"Tammy H.",    pro:"Sandra Torres", service:"Cleaning",   amount:258, status:"active",    date:"Aug 11" },
  { id:"#1039", homeowner:"Mike D.",     pro:"Tony Reeves",   service:"Handyman",   amount:358, status:"completed", date:"Aug 10" },
  { id:"#1038", homeowner:"Sarah K.",    pro:"Maria Castillo",service:"Painting",   amount:224, status:"disputed",  date:"Aug 9"  },
  { id:"#1037", homeowner:"James L.",    pro:"Derek Okafor",  service:"Electrical", amount:191, status:"completed", date:"Aug 8"  },
];

const ADMIN_PROS = [
  { id:1, name:"Marcus Webb",    service:"Plumbing",   rating:4.9, jobs:340, revenue:28900, status:"active",    joined:"Jan 2024" },
  { id:2, name:"Sandra Torres",  service:"Cleaning",   rating:4.8, jobs:211, revenue:13700, status:"active",    joined:"Mar 2024" },
  { id:3, name:"Derek Okafor",   service:"Electrical", rating:5.0, jobs:178, revenue:19600, status:"pending",   joined:"Aug 2026" },
  { id:4, name:"Lisa Nguyen",    service:"Lawn",       rating:4.7, jobs:501, revenue:27500, status:"active",    joined:"Nov 2023" },
  { id:5, name:"Carlos R.",      service:"HVAC",       rating:3.2, jobs:12,  revenue:1320,  status:"suspended", joined:"Jul 2026" },
  { id:6, name:"Priya M.",       service:"Cleaning",   rating:0,   jobs:0,   revenue:0,     status:"pending",   joined:"Aug 2026" },
];

const fmtShortDate = (iso) => {
  try { return new Date(iso).toLocaleDateString('en-US', { month:'short', day:'numeric' }); }
  catch { return ''; }
};
const isSameDay = (a, b) => a.getFullYear()===b.getFullYear() && a.getMonth()===b.getMonth() && a.getDate()===b.getDate();

// Hook: pull real aggregate numbers for the admin dashboard from Supabase.
// Same mock-first, real-if-available pattern as every other data hook in
// this file — starts with the ADMIN_* mock arrays so the screen is never
// blank, then swaps in real bookings/pro/homeowner data the moment it
// resolves. Revenue and booking counts are derived from `bookings` (there's
// no `payments` table writer yet, so `bookings.total_amount` is the source
// of truth for money moved). Pro "status" is derived from pro_profiles's
// real `approved`/`available` columns: a pro who hasn't been approved yet
// always shows as "pending" regardless of `available`, since `available`
// is the pro's own busy/free toggle — a separate concept from whether an
// admin has actually let them onto the platform (see
// pro_approval_migration.sql).
function useAdminData() {
  const [stats, setStats]       = useState(ADMIN_STATS);
  const [bookings, setBookings] = useState(ADMIN_BOOKINGS);
  const [pros, setPros]         = useState(ADMIN_PROS);
  const [homeowners, setHomeowners] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [isReal, setIsReal]     = useState(false);

  useState(() => {
    const load = async () => {
      try {
        const [bookingRows, proRows, homeownerRows] = await Promise.all([
          sbFetch('bookings', '?select=id,total_amount,status,created_at,homeowner:users!homeowner_id(full_name),pro:pro_profiles!pro_id(id,services,users(full_name)),jobs(title,category)&order=created_at.desc&limit=100'),
          sbFetch('pro_profiles', '?select=id,user_id,available,approved,avg_rating,jobs_completed,services,badge,subscription_tier,plus_requested_at,created_at,users(full_name,is_blocked)'),
          sbFetch('users', '?user_type=eq.homeowner&select=id,full_name,email,created_at,is_blocked&order=created_at.desc'),
        ]);

        const now = new Date();
        const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const startOfWeek  = new Date(startOfToday); startOfWeek.setDate(startOfWeek.getDate() - 7);
        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);

        let nextStats = { ...ADMIN_STATS };
        let anyReal = false;

        // Per-pro lifetime earnings, derived straight from completed
        // bookings — there's no separate payments-table writer yet (see
        // remaining_tables_rls_migration.sql), so bookings.total_amount is
        // still the actual source of truth for money moved, same as the
        // overall revenue stats just below. Shown net of Localy's 12% cut
        // (same 88% split used everywhere else in this dashboard), since
        // "Earned" should mean what the pro actually took home.
        const proRevenue = {};
        if (Array.isArray(bookingRows)) {
          bookingRows.forEach(b => {
            if (b.status === 'completed' && b.pro?.id) {
              proRevenue[b.pro.id] = (proRevenue[b.pro.id] || 0) + Math.round((b.total_amount || 0) * 0.88);
            }
          });
        }

        if (Array.isArray(bookingRows) && bookingRows.length > 0) {
          anyReal = true;
          const sumSince = (since) => bookingRows.filter(b => b.status === 'completed' && new Date(b.created_at) >= since)
            .reduce((a,b) => a + (b.total_amount || 0), 0);
          const countSince = (since) => bookingRows.filter(b => new Date(b.created_at) >= since).length;

          nextStats.revenue  = { today: sumSince(startOfToday), week: sumSince(startOfWeek), month: sumSince(startOfMonth), growth: '' };
          nextStats.bookings = { today: countSince(startOfToday), week: countSince(startOfWeek), month: countSince(startOfMonth), growth: '' };

          setBookings(bookingRows.map(b => ({
            id: b.id,
            homeowner: b.homeowner?.full_name || 'Homeowner',
            pro: b.pro?.users?.full_name || 'Pro',
            service: b.jobs?.title || b.jobs?.category || 'Service',
            amount: b.total_amount || 0,
            status: b.status,
            date: fmtShortDate(b.created_at),
            rawDate: b.created_at,
          })));
        }

        if (Array.isArray(proRows) && proRows.length > 0) {
          anyReal = true;
          nextStats.activePros = {
            count: proRows.filter(p => p.approved && p.available).length,
            pending: proRows.filter(p => !p.approved).length,
            suspended: proRows.filter(p => p.approved && !p.available).length,
          };
          setPros(proRows.map(p => ({
            id: p.id,
            userId: p.user_id,
            name: p.users?.full_name || 'Pro',
            service: (p.services && p.services[0]) || 'General',
            rating: parseFloat(p.avg_rating) || 0,
            jobs: p.jobs_completed || 0,
            revenue: proRevenue[p.id] || 0,
            status: !p.approved ? 'pending' : (p.available ? 'active' : 'suspended'),
            joined: fmtShortDate(p.created_at),
            isBlocked: !!p.users?.is_blocked,
            isPlus: p.subscription_tier === 'plus',
            plusRequestedAt: p.plus_requested_at || null,
          })));
        }

        if (Array.isArray(homeownerRows) && homeownerRows.length > 0) {
          anyReal = true;
          nextStats.homeowners = {
            count: homeownerRows.length,
            newToday: homeownerRows.filter(u => isSameDay(new Date(u.created_at), now)).length,
          };
          setHomeowners(homeownerRows.map(u => ({
            id: u.id,
            name: u.full_name || 'Homeowner',
            email: u.email || '',
            joined: fmtShortDate(u.created_at),
            isBlocked: !!u.is_blocked,
          })));
        }

        if (anyReal) {
          setStats(nextStats);
          setIsReal(true);
        }
      } catch (err) {
        console.log('Using mock admin data:', err.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  });

  return { stats, bookings, pros, homeowners, loading, isReal };
}

function AdminDashboard({ onExit }) {
  const { stats: liveStats, bookings: liveBookings, pros: livePros, homeowners: liveHomeowners, loading: adminLoading, isReal } = useAdminData();
  const [tab, setTab] = useState("overview");
  const [proStatuses, setProStatuses] = useState(
    Object.fromEntries(ADMIN_PROS.map(p => [p.id, p.status]))
  );
  const [bookingStatuses, setBookingStatuses] = useState(
    Object.fromEntries(ADMIN_BOOKINGS.map(b => [b.id, b.status]))
  );
  // Whole-account blocking — distinct from approve/suspend above, which
  // only ever affects a pro's marketplace listing (pro_profiles), not
  // whether the account can log in and use the app at all (users.is_blocked
  // — see account_blocking_migration.sql).
  const [blockedPros, setBlockedPros] = useState({});
  const [blockedHomeowners, setBlockedHomeowners] = useState({});
  // Pro Plus tier — Phase 1 is admin-toggled, no real billing yet (see
  // pro_plus_migration.sql). Same hydrate-once-then-locally-editable
  // pattern as blockedPros above.
  const [plusPros, setPlusPros] = useState({});
  const [hydrated, setHydrated] = useState(false);
  const [search, setSearch] = useState("");
  const [homeownerSearch, setHomeownerSearch] = useState("");

  // Once real data resolves, re-seed the editable status maps from it
  // (only once, so an admin's in-session status changes aren't clobbered
  // by a re-fetch).
  useEffect(() => {
    if (!adminLoading && !hydrated) {
      setProStatuses(Object.fromEntries(livePros.map(p => [p.id, p.status])));
      setBookingStatuses(Object.fromEntries(liveBookings.map(b => [b.id, b.status])));
      setBlockedPros(Object.fromEntries(livePros.map(p => [p.id, !!p.isBlocked])));
      setBlockedHomeowners(Object.fromEntries(liveHomeowners.map(h => [h.id, !!h.isBlocked])));
      setPlusPros(Object.fromEntries(livePros.map(p => [p.id, !!p.isPlus])));
      setHydrated(true);
    }
  }, [adminLoading, hydrated, livePros, liveBookings, liveHomeowners]);

  // Whole-account blocking for a pro — updates `users.is_blocked` (the
  // person's login itself), not `pro_profiles` (their marketplace listing,
  // handled separately by Suspend/Reinstate above).
  const toggleBlockPro = async (pro) => {
    const nextBlocked = !blockedPros[pro.id];
    setBlockedPros(s => ({ ...s, [pro.id]: nextBlocked }));
    if (typeof pro.userId === 'string') {
      try {
        await sbUpdate('users', pro.userId, {
          is_blocked: nextBlocked,
          blocked_reason: nextBlocked ? 'Blocked by admin' : null,
          blocked_at: nextBlocked ? new Date().toISOString() : null,
        });
      } catch (err) {
        console.log('Pro block toggle error:', err.message);
      }
    }
  };

  // Grant/revoke Pro Plus — Phase 1 has no real billing, so this is the
  // entire "checkout": an admin flips the flag by hand, either because the
  // pro asked (see plusRequestedAt below) or because you've hand-picked
  // them to try it. Every gated feature (lower commission, featured
  // placement, unlimited bids, fast-track verification, branded invoices,
  // early job visibility) reads pro_profiles.subscription_tier directly,
  // so this one toggle turns all of it on or off at once.
  const togglePlusPro = async (pro) => {
    const nextIsPlus = !plusPros[pro.id];
    setPlusPros(s => ({ ...s, [pro.id]: nextIsPlus }));
    if (typeof pro.id === 'string') {
      try {
        await sbUpdate('pro_profiles', pro.id, { subscription_tier: nextIsPlus ? 'plus' : 'free' });
        if (nextIsPlus && pro.userId) {
          sendPushNotification(
            pro.userId,
            "You're on Pro Plus! ⭐",
            "Lower fees, featured placement, unlimited bids, and more are live on your account now.",
            { type: 'system' }
          );
        }
      } catch (err) {
        console.log('Pro Plus toggle error:', err.message);
      }
    }
  };

  // Same idea for homeowners — there's no separate "listing" for a
  // homeowner the way there is for a pro, so blocking is the only account
  // action that applies to them.
  const toggleBlockHomeowner = async (homeowner) => {
    const nextBlocked = !blockedHomeowners[homeowner.id];
    setBlockedHomeowners(s => ({ ...s, [homeowner.id]: nextBlocked }));
    if (typeof homeowner.id === 'string') {
      try {
        await sbUpdate('users', homeowner.id, {
          is_blocked: nextBlocked,
          blocked_reason: nextBlocked ? 'Blocked by admin' : null,
          blocked_at: nextBlocked ? new Date().toISOString() : null,
        });
      } catch (err) {
        console.log('Homeowner block toggle error:', err.message);
      }
    }
  };

  // Approve/suspend/reinstate persist to Supabase for real (UUID) pros;
  // mock/demo rows just update local state, same as everywhere else.
  const setProStatus = (pro, status) => {
    setProStatuses(s => ({ ...s, [pro.id]: status }));
    if (typeof pro.id === 'string') {
      sbUpdate('pro_profiles', pro.id, { available: status === 'active' }).catch(err => console.log('Pro status update error:', err.message));
    }
  };

  // Approving is a distinct action from suspend/reinstate — it's the only
  // one that flips `approved`, the actual admin gate that controls whether
  // a pro shows up anywhere on the homeowner side at all (see
  // pro_approval_migration.sql). Suspend/reinstate only ever toggle
  // `available` on an already-approved pro.
  const approvePro = (pro) => {
    setProStatuses(s => ({ ...s, [pro.id]: "active" }));
    if (typeof pro.id === 'string') {
      sbUpdate('pro_profiles', pro.id, { approved: true, available: true }).catch(err => console.log('Pro approve error:', err.message));
    }
  };

  const setBookingStatus = (booking, status) => {
    setBookingStatuses(s => ({ ...s, [booking.id]: status }));
    if (typeof booking.id === 'string') {
      sbUpdate('bookings', booking.id, { status }).catch(err => console.log('Booking status update error:', err.message));
    }
  };

  // ── Verification queue ──
  // Every pro's submitted-but-not-yet-reviewed identity/license/insurance
  // document, oldest first. This is the actual review step that was
  // completely missing before — a pro could previously "verify" themselves
  // with nobody ever looking at what they submitted.
  const [verificationQueue, setVerificationQueue] = useState([]);
  const [vLoading, setVLoading] = useState(true);
  const [docUrls, setDocUrls] = useState({});

  useEffect(() => {
    (async () => {
      try {
        const rows = await sbFetch('pro_verification',
          `?status=eq.submitted&select=id,step,doc_url,submitted_at,pro_id,pro_profiles(users(full_name),subscription_tier)&order=submitted_at.asc`
        );
        if (Array.isArray(rows)) {
          // Pro Plus perk: fast-track review — their submissions jump to
          // the front of the queue, oldest-first within each tier (see
          // pro_plus_migration.sql).
          const sorted = [...rows].sort((a, b) => {
            const aPlus = a.pro_profiles?.subscription_tier === 'plus';
            const bPlus = b.pro_profiles?.subscription_tier === 'plus';
            if (aPlus !== bPlus) return aPlus ? -1 : 1;
            return new Date(a.submitted_at) - new Date(b.submitted_at);
          });
          setVerificationQueue(sorted);
        }
      } catch (err) {
        console.log('Verification queue load error:', err.message);
      } finally {
        setVLoading(false);
      }
    })();
  }, []);

  const viewVerificationDoc = async (row) => {
    try {
      const url = await sbGetSignedUrl('verification-docs', row.doc_url);
      setDocUrls(prev => ({ ...prev, [row.id]: url }));
    } catch (err) {
      console.log('Verification doc view error:', err.message);
    }
  };

  // Approving/rejecting updates the submission itself; approving also
  // recomputes this pro's total approved points across every step and
  // writes their real badge — the one and only place a pro's badge
  // actually changes, and it's entirely admin-driven now.
  const reviewVerification = async (row, approve) => {
    try {
      await sbUpdate('pro_verification', row.id, {
        status: approve ? 'approved' : 'rejected',
        approved_at: approve ? new Date().toISOString() : null,
      });
      setVerificationQueue(prev => prev.filter(r => r.id !== row.id));

      if (approve) {
        const approvedRows = await sbFetch('pro_verification', `?pro_id=eq.${row.pro_id}&status=eq.approved&select=step`);
        const approvedIds = new Set((approvedRows || []).map(r => r.step));
        approvedIds.add(row.step);
        const points = VERIFICATION_STEPS.filter(s => approvedIds.has(s.id)).reduce((a, s) => a + s.points, 0);
        await sbUpdate('pro_profiles', row.pro_id, { badge: getBadgeTier(points).label });
      }
    } catch (err) {
      console.log('Verification review error:', err.message);
    }
  };

  const weeklyBreakdown = useMemo(() => {
    if (!isReal) return null;
    const now = new Date();
    const days = [];
    for (let i = 4; i >= 0; i--) {
      const d = new Date(now); d.setDate(d.getDate() - i);
      const dayBookings = liveBookings.filter(b => b.rawDate && isSameDay(new Date(b.rawDate), d));
      const gross = dayBookings.filter(b => bookingStatuses[b.id] === 'completed').reduce((a,b) => a + b.amount, 0);
      days.push({ day: d.toLocaleDateString('en-US', { weekday:'short', month:'short', day:'numeric' }), bookings: dayBookings.length, gross, cut: Math.round(gross * 0.12) });
    }
    return days;
  }, [isReal, liveBookings, bookingStatuses]);

  const totalRevenue = liveBookings.filter(b => bookingStatuses[b.id] === "completed").reduce((a,b) => a + b.amount, 0);
  const localyCut = Math.round(totalRevenue * 0.12);

  const statusColor = {
    active:    { bg: T.greenL,  text: T.green  },
    completed: { bg: T.greenL,  text: T.green  },
    pending:   { bg: T.amberL,  text: T.amber  },
    suspended: { bg: T.coralL,  text: T.coral  },
    disputed:  { bg: T.coralL,  text: T.coral  },
  };

  const filteredPros = livePros.filter(p =>
    p.name.toLowerCase().includes(search.toLowerCase()) ||
    p.service.toLowerCase().includes(search.toLowerCase())
  );

  const filteredHomeowners = liveHomeowners.filter(h =>
    h.name.toLowerCase().includes(homeownerSearch.toLowerCase()) ||
    h.email.toLowerCase().includes(homeownerSearch.toLowerCase())
  );

  const disputedCount   = liveBookings.filter(b => bookingStatuses[b.id] === 'disputed').length;
  const lowRatedCount   = livePros.filter(p => p.rating > 0 && p.rating < 3.5).length;
  const pendingProCount = livePros.filter(p => proStatuses[p.id] === 'pending').length;

  const tabs = [
    { id:"overview",   label:"Overview",   icon:"📊" },
    { id:"bookings",   label:"Bookings",   icon:"📋" },
    { id:"pros",       label:"Pros",       icon:"🔧" },
    { id:"homeowners", label:"Homeowners", icon:"🏠" },
    { id:"revenue",    label:"Revenue",    icon:"💰" },
    { id:"verify",     label:"Verify",     icon:"🪪", badge: verificationQueue.length || undefined },
  ];

  return (
    <div style={{ maxWidth:420, margin:"0 auto", fontFamily:"'DM Sans', sans-serif", background:T.sand, minHeight:"100vh", display:"flex", flexDirection:"column" }}>

      {/* Admin Top Bar */}
      <div style={{ background:T.navy, padding:"14px 16px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        <div>
          <div style={{ color:T.white, fontWeight:700, fontSize:16 }}>🛡️ Localy Admin</div>
          <div style={{ color:"#A8BFDF", fontSize:11 }}>Owner Dashboard</div>
        </div>
        <button onClick={onExit} style={{ background:"rgba(255,255,255,0.15)", border:"none", color:T.white, borderRadius:8, padding:"6px 12px", cursor:"pointer", fontSize:12, fontFamily:"'DM Sans', sans-serif" }}>
          ← Exit
        </button>
      </div>

      {/* Tab bar */}
      <div style={{ background:T.white, borderBottom:`1px solid ${T.border}`, display:"flex" }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            flex:1, padding:"10px 4px", background:"none", border:"none", cursor:"pointer",
            borderBottom:`2px solid ${tab===t.id ? T.cobalt : "transparent"}`,
            fontFamily:"'DM Sans', sans-serif",
            display:"flex", flexDirection:"column", alignItems:"center", gap:2, position:"relative",
          }}>
            <span style={{ fontSize:16 }}>{t.icon}</span>
            <span style={{ fontSize:10, fontWeight:700, color: tab===t.id ? T.cobalt : T.slate, letterSpacing:"0.04em" }}>{t.label.toUpperCase()}</span>
            {!!t.badge && (
              <span style={{
                position:"absolute", top:2, right:"20%", background:T.coral, color:"#fff",
                fontSize:9, fontWeight:800, borderRadius:99, minWidth:14, height:14,
                display:"flex", alignItems:"center", justifyContent:"center", padding:"0 3px",
              }}>{t.badge}</span>
            )}
          </button>
        ))}
      </div>

      {/* Content */}
      <div style={{ flex:1, overflowY:"auto", padding:16 }}>

        {/* ── OVERVIEW ── */}
        {tab === "overview" && (
          <div>
            <div style={{ fontSize:11, color:T.slate, fontWeight:700, letterSpacing:"0.1em", marginBottom:12 }}>TODAY AT A GLANCE</div>

            {/* KPI grid */}
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:16 }}>
              {[
                { label:"Revenue Today",   val:`$${liveStats.revenue.today.toLocaleString()}`,  sub:liveStats.revenue.growth,   color:T.green,  icon:"💰" },
                { label:"Bookings Today",  val:liveStats.bookings.today,                         sub:`${liveStats.bookings.week} this week`, color:T.cobalt, icon:"📋" },
                { label:"Active Pros",     val:liveStats.activePros.count,                       sub:`${liveStats.activePros.pending} pending`, color:T.amber, icon:"🔧" },
                { label:"Homeowners",      val:liveStats.homeowners.count,                       sub:`+${liveStats.homeowners.newToday} today`, color:T.cobalt, icon:"🏠" },
              ].map(k => (
                <div key={k.label} style={{ background:T.white, borderRadius:14, padding:14, border:`1px solid ${T.border}`, boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
                  <div style={{ fontSize:22, marginBottom:4 }}>{k.icon}</div>
                  <div style={{ fontSize:22, fontWeight:700, color:T.navy }}>{k.val}</div>
                  <div style={{ fontSize:11, color:T.slate, marginTop:2 }}>{k.label}</div>
                  <div style={{ fontSize:11, fontWeight:700, color:k.color, marginTop:4 }}>{k.sub}</div>
                </div>
              ))}
            </div>

            {/* Monthly revenue banner */}
            <div style={{ background:`linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, borderRadius:16, padding:20, marginBottom:16, color:T.white }}>
              <div style={{ fontSize:11, color:"#A8BFDF", letterSpacing:"0.1em", marginBottom:4 }}>{new Date().toLocaleDateString('en-US',{month:'long'}).toUpperCase()} REVENUE</div>
              <div style={{ fontSize:36, fontWeight:700 }}>${liveStats.revenue.month.toLocaleString()}</div>
              <div style={{ display:"flex", gap:20, marginTop:12 }}>
                {[["Gross", `$${liveStats.revenue.month.toLocaleString()}`], ["Localy Cut (12%)", `$${Math.round(liveStats.revenue.month*0.12).toLocaleString()}`], ["To Pros", `$${Math.round(liveStats.revenue.month*0.88).toLocaleString()}`]].map(([k,v]) => (
                  <div key={k}>
                    <div style={{ fontWeight:700, fontSize:15 }}>{v}</div>
                    <div style={{ fontSize:11, color:"#A8BFDF" }}>{k}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Alerts */}
            <div style={{ fontSize:11, color:T.slate, fontWeight:700, letterSpacing:"0.1em", marginBottom:10 }}>ACTION NEEDED</div>
            {[
              pendingProCount > 0 && { icon:"⚠️", text:`${pendingProCount} pro application${pendingProCount===1?'':'s'} pending approval`, color:T.amberL, tc:T.amber },
              disputedCount > 0 && { icon:"🚨", text:`${disputedCount} disputed booking${disputedCount===1?'':'s'} need${disputedCount===1?'s':''} resolution`, color:T.coralL, tc:T.coral },
              lowRatedCount > 0 && { icon:"⭐", text:`${lowRatedCount} pro${lowRatedCount===1?'':'s'} rated below 3.5 — review needed`, color:T.coralL, tc:T.coral },
            ].filter(Boolean).length === 0 ? (
              <div style={{ background:T.greenL, borderRadius:12, padding:"12px 14px", display:"flex", gap:10, alignItems:"center" }}>
                <span style={{ fontSize:18 }}>✅</span>
                <span style={{ fontSize:13, fontWeight:600, color:T.green }}>Nothing needs attention right now.</span>
              </div>
            ) : [
              pendingProCount > 0 && { icon:"⚠️", text:`${pendingProCount} pro application${pendingProCount===1?'':'s'} pending approval`, color:T.amberL, tc:T.amber },
              disputedCount > 0 && { icon:"🚨", text:`${disputedCount} disputed booking${disputedCount===1?'':'s'} need${disputedCount===1?'s':''} resolution`, color:T.coralL, tc:T.coral },
              lowRatedCount > 0 && { icon:"⭐", text:`${lowRatedCount} pro${lowRatedCount===1?'':'s'} rated below 3.5 — review needed`, color:T.coralL, tc:T.coral },
            ].filter(Boolean).map((a,i) => (
              <div key={i} style={{ background:a.color, borderRadius:12, padding:"12px 14px", marginBottom:8, display:"flex", gap:10, alignItems:"center" }}>
                <span style={{ fontSize:18 }}>{a.icon}</span>
                <span style={{ fontSize:13, fontWeight:600, color:a.tc }}>{a.text}</span>
              </div>
            ))}
          </div>
        )}

        {/* ── BOOKINGS ── */}
        {tab === "bookings" && (
          <div>
            <div style={{ fontSize:11, color:T.slate, fontWeight:700, letterSpacing:"0.1em", marginBottom:12 }}>ALL BOOKINGS</div>
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {liveBookings.map(b => {
                const sc = statusColor[bookingStatuses[b.id]] || statusColor.pending;
                return (
                  <div key={b.id} style={{ background:T.white, borderRadius:14, padding:14, border:`1px solid ${T.border}`, boxShadow:"0 1px 4px rgba(0,0,0,0.05)" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", marginBottom:6 }}>
                      <span style={{ fontWeight:700, fontSize:13, color:T.navy }}>{typeof b.id === 'string' ? `#${b.id.slice(0,6)}` : b.id} · {b.service}</span>
                      <span style={{ fontSize:11, fontWeight:700, background:sc.bg, color:sc.text, padding:"2px 10px", borderRadius:99 }}>{bookingStatuses[b.id]}</span>
                    </div>
                    <div style={{ fontSize:13, color:T.slate, marginBottom:4 }}>👤 {b.homeowner} → 🔧 {b.pro}</div>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                      <span style={{ fontSize:12, color:T.slate }}>{b.date}</span>
                      <span style={{ fontWeight:700, fontSize:15, color:T.navy }}>${b.amount}</span>
                    </div>
                    {bookingStatuses[b.id] === "disputed" && (
                      <div style={{ display:"flex", gap:8, marginTop:10 }}>
                        <button onClick={() => setBookingStatus(b, "completed")}
                          style={{ flex:1, padding:"7px", borderRadius:8, border:"none", background:T.green, color:T.white, fontWeight:700, cursor:"pointer", fontSize:12, fontFamily:"'DM Sans', sans-serif" }}>
                          Resolve ✓
                        </button>
                        <button onClick={() => setBookingStatus(b, "refunded")}
                          style={{ flex:1, padding:"7px", borderRadius:8, border:`1px solid ${T.border}`, background:T.white, color:T.coral, fontWeight:700, cursor:"pointer", fontSize:12, fontFamily:"'DM Sans', sans-serif" }}>
                          Refund
                        </button>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* ── PROS ── */}
        {tab === "pros" && (
          <div>
            <div style={{ background:T.white, borderRadius:10, padding:"8px 12px", display:"flex", alignItems:"center", gap:8, border:`1px solid ${T.border}`, marginBottom:14 }}>
              <span>🔍</span>
              <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search pros…"
                style={{ border:"none", outline:"none", fontSize:14, flex:1, fontFamily:"'DM Sans', sans-serif", color:T.navy }} />
            </div>
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {filteredPros.map(p => {
                const st = proStatuses[p.id];
                const sc = statusColor[st] || statusColor.pending;
                return (
                  <div key={p.id} style={{ background:T.white, borderRadius:14, padding:14, border:`1px solid ${T.border}`, boxShadow:"0 1px 4px rgba(0,0,0,0.05)" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:6 }}>
                      <div>
                        <div style={{ fontWeight:700, fontSize:14, color:T.navy }}>{p.name}</div>
                        <div style={{ fontSize:12, color:T.slate }}>{p.service} · Joined {p.joined}</div>
                      </div>
                      <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:4 }}>
                        <span style={{ fontSize:11, fontWeight:700, background:sc.bg, color:sc.text, padding:"2px 10px", borderRadius:99 }}>{st}</span>
                        {plusPros[p.id] && (
                          <span style={{ fontSize:10, fontWeight:700, background:"#FFF4D6", color:"#8A6300", padding:"2px 8px", borderRadius:99 }}>⭐ PRO PLUS</span>
                        )}
                        {!plusPros[p.id] && p.plusRequestedAt && (
                          <span style={{ fontSize:10, fontWeight:700, background:T.cobaltL, color:T.cobalt, padding:"2px 8px", borderRadius:99 }}>Requested Plus</span>
                        )}
                        {blockedPros[p.id] && (
                          <span style={{ fontSize:10, fontWeight:700, background:"#3A0A0A", color:"#FF9B9B", padding:"2px 8px", borderRadius:99 }}>🚫 BLOCKED</span>
                        )}
                      </div>
                    </div>
                    <div style={{ display:"flex", gap:16, marginBottom:10 }}>
                      {[["Jobs", p.jobs], ["Rating", p.rating > 0 ? `${p.rating}★` : "New"], ["Earned", `$${p.revenue.toLocaleString()}`]].map(([k,v]) => (
                        <div key={k}>
                          <div style={{ fontWeight:700, fontSize:14, color:T.navy }}>{v}</div>
                          <div style={{ fontSize:11, color:T.slate }}>{k}</div>
                        </div>
                      ))}
                    </div>
                    <div style={{ display:"flex", gap:8 }}>
                      {st === "pending" && (
                        <button onClick={() => approvePro(p)}
                          style={{ flex:1, padding:"7px", borderRadius:8, border:"none", background:T.green, color:T.white, fontWeight:700, cursor:"pointer", fontSize:12, fontFamily:"'DM Sans', sans-serif" }}>
                          ✓ Approve
                        </button>
                      )}
                      {st === "active" && (
                        <button onClick={() => setProStatus(p, "suspended")}
                          style={{ flex:1, padding:"7px", borderRadius:8, border:`1px solid ${T.border}`, background:T.white, color:T.coral, fontWeight:700, cursor:"pointer", fontSize:12, fontFamily:"'DM Sans', sans-serif" }}>
                          Suspend
                        </button>
                      )}
                      {st === "suspended" && (
                        <button onClick={() => setProStatus(p, "active")}
                          style={{ flex:1, padding:"7px", borderRadius:8, border:"none", background:T.cobalt, color:T.white, fontWeight:700, cursor:"pointer", fontSize:12, fontFamily:"'DM Sans', sans-serif" }}>
                          Reinstate
                        </button>
                      )}
                      <button style={{ flex:1, padding:"7px", borderRadius:8, border:`1px solid ${T.border}`, background:T.white, color:T.slate, fontWeight:700, cursor:"pointer", fontSize:12, fontFamily:"'DM Sans', sans-serif" }}>
                        View Profile
                      </button>
                      <button onClick={() => toggleBlockPro(p)}
                        style={{ flex:1, padding:"7px", borderRadius:8, border:`1px solid ${blockedPros[p.id] ? T.border : "#8C2A2A"}`, background: blockedPros[p.id] ? T.white : "#FDECEC", color: blockedPros[p.id] ? T.slate : "#8C2A2A", fontWeight:700, cursor:"pointer", fontSize:12, fontFamily:"'DM Sans', sans-serif" }}>
                        {blockedPros[p.id] ? "✅ Unblock" : "🚫 Block"}
                      </button>
                    </div>
                    <button onClick={() => togglePlusPro(p)}
                      style={{ width:"100%", marginTop:8, padding:"7px", borderRadius:8, border:`1px solid ${plusPros[p.id] ? T.border : "#D9A400"}`, background: plusPros[p.id] ? T.white : "#FFF4D6", color: plusPros[p.id] ? T.slate : "#8A6300", fontWeight:700, cursor:"pointer", fontSize:12, fontFamily:"'DM Sans', sans-serif" }}>
                      {plusPros[p.id] ? "Remove Pro Plus" : "⭐ Grant Pro Plus"}
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* ── HOMEOWNERS ── */}
        {tab === "homeowners" && (
          <div>
            <div style={{ background:T.white, borderRadius:10, padding:"8px 12px", display:"flex", alignItems:"center", gap:8, border:`1px solid ${T.border}`, marginBottom:14 }}>
              <span>🔍</span>
              <input value={homeownerSearch} onChange={e => setHomeownerSearch(e.target.value)} placeholder="Search homeowners…"
                style={{ border:"none", outline:"none", fontSize:14, flex:1, fontFamily:"'DM Sans', sans-serif", color:T.navy }} />
            </div>
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {filteredHomeowners.length === 0 && (
                <div style={{ textAlign:"center", padding:30, color:T.slate, fontSize:13 }}>
                  {liveHomeowners.length === 0 ? "No homeowner accounts yet." : "No homeowners match your search."}
                </div>
              )}
              {filteredHomeowners.map(h => (
                <div key={h.id} style={{ background:T.white, borderRadius:14, padding:14, border:`1px solid ${T.border}`, boxShadow:"0 1px 4px rgba(0,0,0,0.05)" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:10 }}>
                    <div>
                      <div style={{ fontWeight:700, fontSize:14, color:T.navy }}>{h.name}</div>
                      <div style={{ fontSize:12, color:T.slate }}>{h.email} · Joined {h.joined}</div>
                    </div>
                    {blockedHomeowners[h.id] && (
                      <span style={{ fontSize:10, fontWeight:700, background:"#3A0A0A", color:"#FF9B9B", padding:"2px 8px", borderRadius:99 }}>🚫 BLOCKED</span>
                    )}
                  </div>
                  <button onClick={() => toggleBlockHomeowner(h)}
                    style={{ width:"100%", padding:"7px", borderRadius:8, border:`1px solid ${blockedHomeowners[h.id] ? T.border : "#8C2A2A"}`, background: blockedHomeowners[h.id] ? T.white : "#FDECEC", color: blockedHomeowners[h.id] ? T.slate : "#8C2A2A", fontWeight:700, cursor:"pointer", fontSize:12, fontFamily:"'DM Sans', sans-serif" }}>
                    {blockedHomeowners[h.id] ? "✅ Unblock" : "🚫 Block"}
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── REVENUE ── */}
        {tab === "revenue" && (
          <div>
            <div style={{ background:`linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, borderRadius:16, padding:20, marginBottom:16, color:T.white }}>
              <div style={{ fontSize:11, color:"#A8BFDF", letterSpacing:"0.1em", marginBottom:4 }}>LOCALY EARNINGS (12% FEE)</div>
              <div style={{ fontSize:36, fontWeight:700 }}>${localyCut.toLocaleString()}</div>
              <div style={{ fontSize:13, color:"#A8BFDF" }}>from ${totalRevenue.toLocaleString()} in completed bookings</div>
            </div>

            {/* Weekly breakdown */}
            <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:16, marginBottom:14 }}>
              <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:12 }}>WEEKLY BREAKDOWN</div>
              {(weeklyBreakdown || [
                { day:"Mon Aug 8",  bookings:6,  gross:820,  cut:98  },
                { day:"Tue Aug 9",  bookings:8,  gross:1140, cut:137 },
                { day:"Wed Aug 10", bookings:5,  gross:740,  cut:89  },
                { day:"Thu Aug 11", bookings:9,  gross:1320, cut:158 },
                { day:"Fri Aug 12", bookings:7,  gross:1240, cut:149 },
              ]).map((d,i) => (
                <div key={i} style={{ marginBottom:12 }}>
                  <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
                    <span style={{ fontSize:13, color:T.navy, fontWeight:600 }}>{d.day}</span>
                    <span style={{ fontSize:13, fontWeight:700, color:T.green }}>+${d.cut}</span>
                  </div>
                  <div style={{ background:T.border, borderRadius:99, height:6 }}>
                    <div style={{ background:`linear-gradient(90deg, #1565C0, #0A9E6A)`, borderRadius:99, height:6, width:`${Math.min((d.gross/1400)*100,100)}%` }} />
                  </div>
                  <div style={{ fontSize:11, color:T.slate, marginTop:2 }}>{d.bookings} bookings · ${d.gross} gross</div>
                </div>
              ))}
            </div>

            {/* Top earners */}
            <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, overflow:"hidden" }}>
              <div style={{ padding:"12px 16px", borderBottom:`1px solid ${T.border}`, fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em" }}>TOP PROS BY REVENUE{isReal ? " (this session)" : ""}</div>
              {(isReal ? [...livePros].sort((a,b) => b.jobs - a.jobs) : livePros.filter(p => p.revenue > 0).sort((a,b) => b.revenue - a.revenue)).slice(0,4).map((p,i) => (
                <div key={p.id} style={{ padding:"12px 16px", display:"flex", justifyContent:"space-between", alignItems:"center", borderBottom:i<3?`1px solid ${T.border}`:"none" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                    <div style={{ width:24, height:24, borderRadius:"50%", background:i===0?T.amber:T.border, color:i===0?T.white:T.slate, display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:700 }}>{i+1}</div>
                    <div>
                      <div style={{ fontWeight:600, fontSize:13, color:T.navy }}>{p.name}</div>
                      <div style={{ fontSize:11, color:T.slate }}>{p.service}</div>
                    </div>
                  </div>
                  <div style={{ textAlign:"right" }}>
                    {isReal ? (
                      <>
                        <div style={{ fontWeight:700, color:T.navy }}>{p.jobs} jobs</div>
                        <div style={{ fontSize:11, color:T.slate }}>{p.rating > 0 ? `${p.rating}★` : "No ratings yet"}</div>
                      </>
                    ) : (
                      <>
                        <div style={{ fontWeight:700, color:T.navy }}>${p.revenue.toLocaleString()}</div>
                        <div style={{ fontSize:11, color:T.green }}>+${Math.round(p.revenue*0.12).toLocaleString()} fee</div>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* VERIFY — pending pro document submissions awaiting admin review */}
        {tab === "verify" && (
          <div>
            <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:12 }}>
              PENDING VERIFICATION{verificationQueue.length > 0 ? ` (${verificationQueue.length})` : ""}
            </div>
            {vLoading ? (
              <div style={{ color:T.slate, fontSize:13, padding:20, textAlign:"center" }}>Loading…</div>
            ) : verificationQueue.length === 0 ? (
              <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:24, textAlign:"center", color:T.slate, fontSize:13 }}>
                🎉 Nothing waiting on review right now.
              </div>
            ) : (
              <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                {verificationQueue.map(row => {
                  const stepMeta = VERIFICATION_STEPS.find(s => s.id === row.step);
                  const proName = row.pro_profiles?.users?.full_name || "Unknown pro";
                  return (
                    <div key={row.id} style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:14 }}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:8 }}>
                        <div>
                          <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                            <div style={{ fontWeight:700, fontSize:14, color:T.navy }}>{proName}</div>
                            {row.pro_profiles?.subscription_tier === 'plus' && (
                              <span style={{ fontSize:10, fontWeight:700, background:"#FFF4D6", color:"#8A6300", padding:"2px 8px", borderRadius:99 }}>⭐ PLUS · FAST-TRACKED</span>
                            )}
                          </div>
                          <div style={{ fontSize:12, color:T.slate }}>{stepMeta?.icon} {stepMeta?.label || row.step}</div>
                        </div>
                        <div style={{ fontSize:11, color:T.slate }}>
                          {row.submitted_at ? new Date(row.submitted_at).toLocaleDateString() : ""}
                        </div>
                      </div>

                      {docUrls[row.id] ? (
                        <a href={docUrls[row.id]} target="_blank" rel="noopener noreferrer"
                          style={{ display:"inline-block", fontSize:12, color:T.cobalt, fontWeight:600, marginBottom:10 }}>
                          📄 Open submitted document →
                        </a>
                      ) : (
                        <button onClick={() => viewVerificationDoc(row)} style={{
                          display:"block", background:"none", border:`1px solid ${T.border}`, borderRadius:8,
                          padding:"6px 10px", fontSize:12, color:T.navy, cursor:"pointer", marginBottom:10,
                        }}>View document</button>
                      )}

                      <div style={{ display:"flex", gap:8 }}>
                        <button onClick={() => reviewVerification(row, true)} style={{
                          flex:1, background:T.green, color:T.white, border:"none", borderRadius:8,
                          padding:"8px 0", fontSize:12, fontWeight:700, cursor:"pointer",
                        }}>✓ Approve</button>
                        <button onClick={() => reviewVerification(row, false)} style={{
                          flex:1, background:"none", color:T.coral, border:`1px solid ${T.coral}`, borderRadius:8,
                          padding:"8px 0", fontSize:12, fontWeight:700, cursor:"pointer",
                        }}>✕ Reject</button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// ── Messaging View ─────────────────────────────────────────────
const CONVOS = [
  { id:1, name:"Marcus Webb",    init:"MW", lastMsg:"I can be there by 10am tomorrow.", time:"2m ago",  unread:2, job:"Leaking faucet" },
  { id:2, name:"Lisa Nguyen",    init:"LN", lastMsg:"Thanks! See you Saturday.",         time:"1h ago",  unread:0, job:"Lawn maintenance" },
  { id:3, name:"Sandra Torres",  init:"ST", lastMsg:"Do you need eco-friendly products?", time:"3h ago", unread:1, job:"Deep clean" },
  { id:4, name:"Tony Reeves",    init:"TR", lastMsg:"Job complete! Please leave a review.", time:"1d ago", unread:0, job:"Drywall patch" },
];

// ── Demo photo URLs for chat ──────────────────────────────────
const DEMO_JOB_PHOTOS = [
  "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300&h=200&fit=crop",
  "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=300&h=200&fit=crop",
  "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=300&h=200&fit=crop",
  "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=300&h=200&fit=crop",
];

// Per-conversation message store
const CONVO_MESSAGES = {
  1: [
    { id:1, from:"pro",  type:"text",  text:"Hi! I saw your job post for the leaking faucet. I can help!", time:"9:01 AM", status:"read" },
    { id:2, from:"user", type:"text",  text:"Great! How soon can you come?", time:"9:03 AM", status:"read" },
    { id:3, from:"pro",  type:"text",  text:"I can be there by 10am tomorrow. Can you send a photo of the leak?", time:"9:04 AM", status:"read" },
    { id:4, from:"user", type:"photo", img: DEMO_JOB_PHOTOS[0], caption:"Here's the faucet — it's dripping under the sink.", time:"9:06 AM", status:"read" },
    { id:5, from:"pro",  type:"text",  text:"Got it! That looks like a worn washer. Easy fix, I'll bring the parts. See you tomorrow at 10!", time:"9:08 AM", status:"read" },
    { id:6, from:"pro",  type:"quote", amount:185, desc:"Faucet washer replacement + labor", eta:"1-2 hrs", time:"9:09 AM", status:"read" },
  ],
  2: [
    { id:1, from:"pro",  type:"text",  text:"Hi! Ready for your lawn maintenance on Saturday?", time:"Mon 8:00 AM", status:"read" },
    { id:2, from:"user", type:"text",  text:"Yes! Can you also trim the hedges?", time:"Mon 8:15 AM", status:"read" },
    { id:3, from:"pro",  type:"photo", img: DEMO_JOB_PHOTOS[1], caption:"Here's how your front yard looked last time — beautiful work!", time:"Mon 8:20 AM", status:"read" },
    { id:4, from:"user", type:"text",  text:"Thanks! See you Saturday.", time:"Mon 8:25 AM", status:"read" },
  ],
  3: [
    { id:1, from:"user", type:"text",  text:"Hi Sandra, I need a deep clean before my move-in.", time:"Tue 10:00 AM", status:"read" },
    { id:2, from:"pro",  type:"text",  text:"Happy to help! Do you need eco-friendly products?", time:"Tue 10:05 AM", status:"unread" },
    { id:3, from:"pro",  type:"photo", img: DEMO_JOB_PHOTOS[2], caption:"Example of a recent deep clean job I completed!", time:"Tue 10:06 AM", status:"unread" },
  ],
};

function MessagingView({ userType, onNavigate, authUser, openConversation, onConsumeOpenConversation }) {
  const [activeConvo, setActiveConvo] = useState(null);
  const [toast, setToast] = useState("");
  const showToast = (text) => { setToast(text); setTimeout(() => setToast(""), 2500); };
  const { convos: realConvos, loading: convosLoading } = useConversations(authUser?.id, userType);
  const [convos, setConvos]           = useState([]);

  // Apply the real fetch exactly once, when it finishes — not as a lazy
  // useState initializer (the old approach), which ran before the async
  // fetch had any chance to resolve and so *always* fell through to the
  // CONVOS mock fallback regardless of whether real data existed. A real
  // logged-in user gets their real conversations even if that's an empty
  // list; CONVOS only applies in the (non-logged-in) edge case.
  const appliedRealConvosRef = useRef(false);
  useEffect(() => {
    if (appliedRealConvosRef.current || convosLoading) return;
    appliedRealConvosRef.current = true;
    setConvos(typeof authUser?.id === 'string' ? realConvos : CONVOS);
  }, [convosLoading, realConvos, authUser?.id]);

  // Arriving here via "Message"/"Contact Pro" from a pro's profile — that
  // handler already found-or-created the real conversation row; this just
  // has to make sure it's in the list and select it, instead of landing on
  // the inbox with nothing open (the reported bug).
  const appliedOpenIdRef = useRef(null);
  useEffect(() => {
    if (!openConversation || appliedOpenIdRef.current === openConversation.id) return;
    appliedOpenIdRef.current = openConversation.id;
    setConvos(prev => prev.some(c => c.id === openConversation.id) ? prev : [openConversation, ...prev]);
    setActiveConvo(openConversation);
    onConsumeOpenConversation && onConsumeOpenConversation();
  }, [openConversation, onConsumeOpenConversation]);
  const [msgStore, setMsgStore]       = useState(typeof authUser?.id === 'string' ? {} : CONVO_MESSAGES);
  const [msg, setMsg]                 = useState("");
  const [showAttach, setShowAttach]   = useState(false);
  const [showQuote, setShowQuote]     = useState(false);
  const [quoteAmt, setQuoteAmt]       = useState("");
  const [quoteDesc, setQuoteDesc]     = useState("");
  const [quoteEta, setQuoteEta]       = useState("1-2 hrs");
  const [typing, setTyping]           = useState(false);
  const [lightboxImg, setLightboxImg] = useState(null);
  const [quoteAccepted, setQuoteAccepted] = useState({});
  const messagesEndRef = useState(null);

  const messages = activeConvo ? (msgStore[activeConvo.id] || []) : [];

  // Load the real message history for a real (Supabase-backed) conversation
  // when it's opened. Before this, msgStore only ever held whatever
  // accumulated in local state during the current session (seeded from
  // CONVO_MESSAGES mock data) — sending a message persisted it, but nothing
  // ever read the saved history back, so reopening a real conversation (or
  // opening it on another device) showed nothing from before this session.
  useEffect(() => {
    if (!activeConvo || typeof activeConvo.id !== 'string') return;
    (async () => {
      try {
        const rows = await sbFetch('messages',
          `?conversation_id=eq.${activeConvo.id}&select=id,sender_id,message_type,text,photo_url,quote_amount,quote_desc,quote_eta,created_at&order=created_at.asc`
        );
        if (Array.isArray(rows)) {
          const mapped = rows.map(r => ({
            id:     r.id,
            from:   r.sender_id === authUser?.id ? 'user' : 'other',
            type:   r.message_type || 'text',
            text:   r.text,
            img:    r.photo_url,
            amount: r.quote_amount,
            desc:   r.quote_desc,
            eta:    r.quote_eta,
            time:   r.created_at ? new Date(r.created_at).toLocaleTimeString([], { hour:'numeric', minute:'2-digit' }) : '',
            status: 'read',
          }));
          setMsgStore(prev => ({ ...prev, [activeConvo.id]: mapped }));
        }
      } catch (err) {
        console.log('Message history load error:', err.message);
      }
    })();
  }, [activeConvo?.id, authUser?.id]);

  const sendMessage = (newMsg) => {
    const msg = { id: Date.now(), from:"user", time:"Now", status:"sent", ...newMsg };
    setMsgStore(prev => ({ ...prev, [activeConvo.id]: [...(prev[activeConvo.id]||[]), msg] }));
    setConvos(prev => prev.map(c => c.id === activeConvo.id ? { ...c, lastMsg: newMsg.text || "📷 Photo", time:"Now", unread:0 } : c));

    // Real conversation (Supabase-backed) — persist the message and push
    // the other party. Mock/demo conversations (numeric id) skip this,
    // same real-vs-mock split used everywhere else in this file.
    if (typeof activeConvo.id === 'string' && authUser?.id) {
      const previewText = newMsg.type === 'photo' ? '📷 Photo' : (newMsg.text || '');
      sbInsert('messages', {
        conversation_id: activeConvo.id,
        sender_id:       authUser.id,
        message_type:    newMsg.type || 'text',
        text:            newMsg.text || null,
        photo_url:       newMsg.img || null,
      }).catch(err => console.log('Message save error:', err.message));
      sbUpdate('conversations', activeConvo.id, {
        last_message:    previewText,
        last_message_at: new Date().toISOString(),
      }).catch(err => console.log('Conversation update error:', err.message));
      if (activeConvo.recipientUserId) {
        sendPushNotification(activeConvo.recipientUserId, `New message from ${authUser?.name || 'Localy'}`, previewText, { type: 'message', conversationId: activeConvo.id });
      }
      return; // no simulated reply for real conversations
    }

    // Simulate pro typing then reply (mock/demo conversations only)
    setTyping(true);
    setTimeout(() => {
      setTyping(false);
      const replies = [
        "Got it! I'll take care of that.",
        "Sounds good, see you then!",
        "Thanks for the photo — that helps a lot.",
        "Perfect, I'll bring everything needed.",
        "Great, I'm available. Let's confirm the time.",
      ];
      const reply = { id: Date.now()+1, from:"pro", type:"text", text: replies[Math.floor(Math.random()*replies.length)], time:"Now", status:"delivered" };
      setMsgStore(prev => ({ ...prev, [activeConvo.id]: [...(prev[activeConvo.id]||[]), reply] }));
    }, 1500);
  };

  const sendPhoto = (url) => {
    sendMessage({ type:"photo", img:url, caption:"", text:"📷 Photo" });
    setShowAttach(false);
  };

  const sendQuote = () => {
    if (!quoteAmt || !quoteDesc) return;
    const quoteMsg = { id:Date.now(), from:"user", type:"quote", amount:Number(quoteAmt), desc:quoteDesc, eta:quoteEta, time:"Now", status:"sent" };
    setMsgStore(prev => ({ ...prev, [activeConvo.id]: [...(prev[activeConvo.id]||[]), quoteMsg] }));
    setConvos(prev => prev.map(c => c.id === activeConvo.id ? { ...c, lastMsg: `Quote: $${quoteAmt}`, time:"Now" } : c));

    if (typeof activeConvo.id === 'string' && authUser?.id) {
      sbInsert('messages', {
        conversation_id: activeConvo.id,
        sender_id:       authUser.id,
        message_type:    'quote',
        quote_amount:    Number(quoteAmt),
        quote_desc:      quoteDesc,
        quote_eta:       quoteEta,
      }).catch(err => console.log('Quote message save error:', err.message));
      sbUpdate('conversations', activeConvo.id, {
        last_message:    `Quote: $${quoteAmt}`,
        last_message_at: new Date().toISOString(),
      }).catch(err => console.log('Conversation update error:', err.message));
      if (activeConvo.recipientUserId) {
        sendPushNotification(activeConvo.recipientUserId, `New quote from ${authUser?.name || 'Localy'}`, `$${quoteAmt} — ${quoteDesc}`, { type: 'quote', conversationId: activeConvo.id });
      }
    }
    setShowQuote(false); setQuoteAmt(""); setQuoteDesc("");
  };

  // ── Lightbox ──
  if (lightboxImg) return (
    <div onClick={() => setLightboxImg(null)} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.92)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1001, cursor:"zoom-out" }}>
      <img src={lightboxImg} alt="" style={{ maxWidth:"95%", maxHeight:"90vh", borderRadius:12, objectFit:"contain" }} />
      <button onClick={() => setLightboxImg(null)} style={{ position:"absolute", top:20, right:20, background:"rgba(255,255,255,0.15)", border:"none", color:"white", borderRadius:"50%", width:36, height:36, fontSize:18, cursor:"pointer" }}>✕</button>
    </div>
  );

  // ── Chat screen ──
  if (activeConvo) return (
    <div style={{ display:"flex", flexDirection:"column", height:"100vh", background:"#F0F2F5", fontFamily:"'DM Sans', sans-serif" }}>

      {/* Header */}
      <div style={{ background:T.white, borderBottom:`1px solid ${T.border}`, padding:"10px 14px", display:"flex", alignItems:"center", gap:10, flexShrink:0 }}>
        <button onClick={() => { setActiveConvo(null); setShowAttach(false); setShowQuote(false); }} style={{ background:"none", border:"none", color:T.cobalt, cursor:"pointer", fontSize:20, padding:0, lineHeight:1 }}>←</button>
        <div style={{ position:"relative" }}>
          <Avatar initials={activeConvo.init} size={38} />
          <div style={{ position:"absolute", bottom:0, right:0, width:10, height:10, borderRadius:"50%", background:T.green, border:"2px solid white" }} />
        </div>
        <div style={{ flex:1 }}>
          <div style={{ fontWeight:700, fontSize:14, color:T.navy }}>{activeConvo.name}</div>
          <div style={{ fontSize:11, color:T.green, fontWeight:600 }}>{typing ? "typing…" : "● Online"}</div>
        </div>
        {/* Header actions */}
        <div style={{ display:"flex", gap:6 }}>
          <button onClick={() => {
            if (activeConvo.phone) window.location.href = `tel:${activeConvo.phone}`;
            else showToast("No phone number on file yet — send a message instead.");
          }} style={{ width:34, height:34, borderRadius:"50%", background:T.cobaltL, border:"none", fontSize:16, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>📞</button>
          <button onClick={() => showToast("Video calling isn't available yet — coming soon.")} style={{ width:34, height:34, borderRadius:"50%", background:T.cobaltL, border:"none", fontSize:16, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>📹</button>
        </div>
      </div>

      {/* Toast */}
      {toast && (
        <div style={{ background:T.navy, color:T.white, fontSize:12, fontWeight:600, textAlign:"center", padding:"6px 14px", flexShrink:0 }}>
          {toast}
        </div>
      )}

      {/* Job context banner */}
      <div onClick={() => onNavigate && onNavigate("dashboard")} style={{ background:T.cobaltL, padding:"8px 14px", display:"flex", alignItems:"center", gap:8, borderBottom:`1px solid ${T.border}33`, flexShrink:0, cursor:"pointer" }}>
        <span style={{ fontSize:14 }}>📋</span>
        <div style={{ flex:1 }}>
          <span style={{ fontSize:12, fontWeight:700, color:T.cobalt }}>{activeConvo.job}</span>
          <span style={{ fontSize:11, color:T.slate, marginLeft:8 }}>· Tap to view booking</span>
        </div>
        <span style={{ fontSize:11, fontWeight:700, color:T.green, background:T.greenL, padding:"2px 8px", borderRadius:99 }}>Active</span>
      </div>

      {/* Messages */}
      <div style={{ flex:1, overflowY:"auto", padding:"12px 12px 8px", display:"flex", flexDirection:"column", gap:8 }}>

        {/* Date separator */}
        <div style={{ textAlign:"center", margin:"4px 0" }}>
          <span style={{ fontSize:11, color:T.slate, background:"rgba(255,255,255,0.8)", padding:"3px 12px", borderRadius:99, fontWeight:600 }}>Today</span>
        </div>

        {messages.map((m, i) => {
          const isUser = m.from === "user";
          return (
            <div key={m.id || i}>
              {/* Text message */}
              {m.type === "text" && (
                <div style={{ display:"flex", justifyContent: isUser ? "flex-end" : "flex-start", alignItems:"flex-end", gap:6 }}>
                  {!isUser && <Avatar initials={activeConvo.init} size={24} color={T.slate} />}
                  <div style={{
                    background: isUser ? T.cobalt : T.white,
                    color: isUser ? T.white : T.navy,
                    borderRadius: isUser ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
                    padding:"10px 14px", maxWidth:"72%", fontSize:14, lineHeight:1.5,
                    border: isUser ? "none" : `1px solid ${T.border}`,
                    boxShadow:"0 1px 4px rgba(0,0,0,0.08)",
                  }}>
                    {m.text}
                    <div style={{ display:"flex", alignItems:"center", justifyContent:"flex-end", gap:4, marginTop:4 }}>
                      <span style={{ fontSize:10, opacity:0.6 }}>{m.time}</span>
                      {isUser && <span style={{ fontSize:10, opacity:0.7 }}>{m.status === "read" ? "✓✓" : m.status === "delivered" ? "✓✓" : "✓"}</span>}
                    </div>
                  </div>
                </div>
              )}

              {/* Photo message */}
              {m.type === "photo" && (
                <div style={{ display:"flex", justifyContent: isUser ? "flex-end" : "flex-start", alignItems:"flex-end", gap:6 }}>
                  {!isUser && <Avatar initials={activeConvo.init} size={24} color={T.slate} />}
                  <div style={{ maxWidth:"72%" }}>
                    <div onClick={() => setLightboxImg(m.img)} style={{
                      borderRadius: isUser ? "16px 16px 4px 16px" : "16px 16px 16px 4px",
                      overflow:"hidden", cursor:"zoom-in", position:"relative",
                      boxShadow:"0 2px 8px rgba(0,0,0,0.15)",
                    }}>
                      <img src={m.img} alt="photo" style={{ width:"100%", maxWidth:220, height:160, objectFit:"cover", display:"block" }}
                        onError={e => { e.target.src = "https://via.placeholder.com/220x160/E3EEFA/1565C0?text=📷"; }} />
                      <div style={{ position:"absolute", bottom:0, left:0, right:0, background:"linear-gradient(transparent, rgba(0,0,0,0.5))", padding:"20px 10px 6px" }}>
                        <span style={{ color:"white", fontSize:11, fontWeight:600 }}>🔍 Tap to expand</span>
                      </div>
                    </div>
                    {m.caption && <div style={{ fontSize:12, color:T.slate, marginTop:4, paddingLeft:4 }}>{m.caption}</div>}
                    <div style={{ fontSize:10, color:T.slate, marginTop:2, paddingLeft:4, textAlign: isUser ? "right" : "left" }}>{m.time}</div>
                  </div>
                </div>
              )}

              {/* Quote message */}
              {m.type === "quote" && (
                <div style={{ display:"flex", justifyContent: isUser ? "flex-end" : "flex-start", alignItems:"flex-end", gap:6, margin:"4px 0" }}>
                  {!isUser && <Avatar initials={activeConvo.init} size={24} color={T.slate} />}
                  <div style={{ background:T.white, borderRadius:16, border:`2px solid ${quoteAccepted[m.id] ? T.green : T.cobalt}`, overflow:"hidden", maxWidth:"85%", boxShadow:"0 2px 8px rgba(0,0,0,0.1)" }}>
                    <div style={{ background: quoteAccepted[m.id] ? T.green : T.cobalt, padding:"10px 14px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                      <span style={{ color:T.white, fontWeight:700, fontSize:13 }}>💼 {quoteAccepted[m.id] ? "Quote Accepted ✓" : "Job Quote"}</span>
                      <span style={{ color:"rgba(255,255,255,0.8)", fontSize:11 }}>{m.time}</span>
                    </div>
                    <div style={{ padding:14 }}>
                      <div style={{ fontSize:26, fontWeight:800, color:T.navy, marginBottom:4 }}>${m.amount}</div>
                      <div style={{ fontSize:13, color:T.slate, marginBottom:4 }}>{m.desc}</div>
                      <div style={{ fontSize:12, color:T.slate, display:"flex", alignItems:"center", gap:4 }}>⏱️ Est. {m.eta}</div>
                      {!quoteAccepted[m.id] && !isUser && (
                        <div style={{ display:"flex", gap:8, marginTop:12 }}>
                          <button onClick={() => setQuoteAccepted(prev => ({ ...prev, [m.id]:true }))}
                            style={{ flex:1, padding:"9px", borderRadius:8, border:"none", background:T.green, color:T.white, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                            ✓ Accept
                          </button>
                          <button style={{ flex:1, padding:"9px", borderRadius:8, border:`1px solid ${T.border}`, background:T.white, color:T.slate, fontWeight:600, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                            Counter
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}

        {/* Typing indicator */}
        {typing && (
          <div style={{ display:"flex", alignItems:"flex-end", gap:6 }}>
            <Avatar initials={activeConvo.init} size={24} color={T.slate} />
            <div style={{ background:T.white, borderRadius:"18px 18px 18px 4px", padding:"10px 16px", border:`1px solid ${T.border}` }}>
              <div style={{ display:"flex", gap:4, alignItems:"center" }}>
                {[0,1,2].map(i => (
                  <div key={i} style={{ width:6, height:6, borderRadius:"50%", background:T.slate, opacity: 0.4 + i*0.2 }} />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Attachment picker */}
      {showAttach && (
        <div style={{ background:T.white, borderTop:`1px solid ${T.border}`, padding:12 }}>
          <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:10 }}>SEND A PHOTO</div>
          <div style={{ display:"flex", gap:8, overflowX:"auto", paddingBottom:4 }}>
            {/* Camera option */}
            <label style={{ width:80, height:80, borderRadius:12, background:T.cobaltL, border:`2px dashed ${T.cobalt}`, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", cursor:"pointer", flexShrink:0 }}>
              <input type="file" accept="image/*" capture="environment" onChange={e => {
                const file = e.target.files?.[0];
                if (file) {
                  const url = URL.createObjectURL(file);
                  sendPhoto(url);
                }
              }} style={{ display:"none" }} />
              <span style={{ fontSize:24, marginBottom:2 }}>📷</span>
              <span style={{ fontSize:10, color:T.cobalt, fontWeight:700 }}>Camera</span>
            </label>
            {/* Gallery option */}
            <label style={{ width:80, height:80, borderRadius:12, background:T.greenL, border:`2px dashed ${T.green}`, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", cursor:"pointer", flexShrink:0 }}>
              <input type="file" accept="image/*" onChange={e => {
                const file = e.target.files?.[0];
                if (file) {
                  const url = URL.createObjectURL(file);
                  sendPhoto(url);
                }
              }} style={{ display:"none" }} />
              <span style={{ fontSize:24, marginBottom:2 }}>🖼️</span>
              <span style={{ fontSize:10, color:T.green, fontWeight:700 }}>Gallery</span>
            </label>
            {/* Demo photos */}
            {DEMO_JOB_PHOTOS.map((url, i) => (
              <div key={i} onClick={() => sendPhoto(url)} style={{ width:80, height:80, borderRadius:12, overflow:"hidden", cursor:"pointer", flexShrink:0, boxShadow:"0 2px 6px rgba(0,0,0,0.12)" }}>
                <img src={url} alt="" style={{ width:"100%", height:"100%", objectFit:"cover" }}
                  onError={e => { e.target.src = `https://via.placeholder.com/80x80/E3EEFA/1565C0?text=${i+1}`; }} />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Quote composer */}
      {showQuote && (
        <div style={{ background:T.white, borderTop:`1px solid ${T.border}`, padding:14 }}>
          <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:10 }}>SEND A QUOTE</div>
          <div style={{ display:"flex", gap:8, marginBottom:8 }}>
            <div style={{ flex:1 }}>
              <label style={{ fontSize:10, fontWeight:700, color:T.slate, display:"block", marginBottom:4 }}>AMOUNT ($)</label>
              <input value={quoteAmt} onChange={e => setQuoteAmt(e.target.value.replace(/[^0-9]/g,""))}
                placeholder="150" style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid ${T.border}`, fontSize:14, fontFamily:"'DM Sans', sans-serif", outline:"none", boxSizing:"border-box" }} />
            </div>
            <div style={{ flex:1 }}>
              <label style={{ fontSize:10, fontWeight:700, color:T.slate, display:"block", marginBottom:4 }}>EST. TIME</label>
              <select value={quoteEta} onChange={e => setQuoteEta(e.target.value)}
                style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid ${T.border}`, fontSize:13, fontFamily:"'DM Sans', sans-serif", outline:"none" }}>
                {["30 min","1 hr","1-2 hrs","2-3 hrs","Half day","Full day"].map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
          </div>
          <input value={quoteDesc} onChange={e => setQuoteDesc(e.target.value)}
            placeholder="Description e.g. Faucet washer replacement + labor"
            style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:`1px solid ${T.border}`, fontSize:13, fontFamily:"'DM Sans', sans-serif", outline:"none", boxSizing:"border-box", marginBottom:8 }} />
          <div style={{ display:"flex", gap:8 }}>
            <button onClick={() => setShowQuote(false)} style={{ flex:1, padding:"9px", borderRadius:8, border:`1px solid ${T.border}`, background:T.white, color:T.slate, fontWeight:600, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>Cancel</button>
            <button onClick={sendQuote} style={{ flex:2, padding:"9px", borderRadius:8, border:"none", background:T.cobalt, color:T.white, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>Send Quote 💼</button>
          </div>
        </div>
      )}

      {/* Input bar */}
      <div style={{ background:T.white, borderTop:`1px solid ${T.border}`, padding:"8px 12px", display:"flex", gap:8, alignItems:"center", flexShrink:0 }}>
        {/* Attach button */}
        <button onClick={() => { setShowAttach(!showAttach); setShowQuote(false); }} style={{
          width:36, height:36, borderRadius:"50%", border:"none", cursor:"pointer", fontSize:18,
          background: showAttach ? T.cobaltL : T.sand,
          color: showAttach ? T.cobalt : T.slate,
          display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0,
        }}>📎</button>

        {/* Quote button — pro only */}
        {userType === "pro" && (
          <button onClick={() => { setShowQuote(!showQuote); setShowAttach(false); }} style={{
            width:36, height:36, borderRadius:"50%", border:"none", cursor:"pointer", fontSize:16,
            background: showQuote ? T.cobaltL : T.sand,
            color: showQuote ? T.cobalt : T.slate,
            display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0,
          }}>💼</button>
        )}

        {/* Text input */}
        <input value={msg} onChange={e => setMsg(e.target.value)}
          onKeyDown={e => { if (e.key === "Enter" && msg.trim()) { sendMessage({ type:"text", text:msg }); setMsg(""); } }}
          placeholder="Type a message…"
          style={{ flex:1, border:`1.5px solid ${T.border}`, borderRadius:99, padding:"9px 16px", fontSize:14, fontFamily:"'DM Sans', sans-serif", outline:"none", color:T.navy, background:T.sand }}
        />

        {/* Send button */}
        <button onClick={() => { if (msg.trim()) { sendMessage({ type:"text", text:msg }); setMsg(""); setShowAttach(false); setShowQuote(false); } }}
          style={{
            width:38, height:38, borderRadius:"50%", border:"none", cursor:"pointer",
            background: msg.trim() ? T.cobalt : T.border,
            color:T.white, display:"flex", alignItems:"center", justifyContent:"center",
            fontSize:16, transition:"background 0.2s", flexShrink:0,
          }}>➤</button>
      </div>
    </div>
  );

  // ── Conversation list ──
  return (
    <div style={{ padding:16, background:T.sand, minHeight:"100%", fontFamily:"'DM Sans', sans-serif" }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:4 }}>
        <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, margin:0 }}>Messages</h2>
        <div style={{ background:T.coral, color:T.white, borderRadius:99, padding:"2px 10px", fontSize:11, fontWeight:700 }}>
          {convos.filter(c => c.unread > 0).reduce((a,c) => a + c.unread, 0)} new
        </div>
      </div>
      <p style={{ color:T.slate, fontSize:13, marginBottom:16 }}>Your conversations</p>

      <FirstVisitTip
        tipKey="messages"
        authUser={authUser}
        text={userType === "homeowner"
          ? "Conversations with your pros show up here — you'll get notified the moment someone replies."
          : "Homeowners message you here about bookings and questions — you'll get notified the moment someone replies."}
      />

      {/* Search bar */}
      <div style={{ background:T.white, borderRadius:10, padding:"8px 12px", display:"flex", alignItems:"center", gap:8, border:`1px solid ${T.border}`, marginBottom:14 }}>
        <span style={{ fontSize:16 }}>🔍</span>
        <input placeholder="Search messages…" style={{ border:"none", outline:"none", fontSize:13, flex:1, fontFamily:"'DM Sans', sans-serif", color:T.navy, background:"transparent" }} />
      </div>

      <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
        {convosLoading && (
          <div style={{ textAlign:"center", padding:"40px 20px", color:T.slate }}>⏳ Loading conversations...</div>
        )}
        {!convosLoading && convos.length === 0 && (
          <div style={{ textAlign:"center", padding:"40px 20px", color:T.slate }}>
            <div style={{ fontSize:32, marginBottom:8 }}>💬</div>
            <div style={{ fontWeight:600, color:T.navy, marginBottom:4 }}>No conversations yet</div>
            <div style={{ fontSize:13 }}>
              {userType === "homeowner" ? "Message a pro from their profile to start chatting." : "Message a homeowner from My Bids to start chatting."}
            </div>
          </div>
        )}
        {convos.map(c => (
          <div key={c.id} onClick={() => { setActiveConvo(c); setConvos(prev => prev.map(x => x.id===c.id ? {...x, unread:0} : x)); }} style={{
            background:T.white, borderRadius:14, padding:14,
            border:`1.5px solid ${c.unread > 0 ? T.cobalt+"44" : T.border}`,
            cursor:"pointer", display:"flex", gap:12, alignItems:"center",
            boxShadow: c.unread > 0 ? "0 2px 8px rgba(21,101,192,0.1)" : "0 1px 4px rgba(0,0,0,0.04)",
          }}>
            <div style={{ position:"relative", flexShrink:0 }}>
              <Avatar initials={c.init} size={46} />
              <div style={{ position:"absolute", bottom:0, right:0, width:12, height:12, borderRadius:"50%", background:T.green, border:"2px solid white" }} />
              {c.unread > 0 && (
                <div style={{ position:"absolute", top:-4, right:-4, background:T.coral, color:T.white, borderRadius:"50%", width:18, height:18, fontSize:10, fontWeight:700, display:"flex", alignItems:"center", justifyContent:"center" }}>{c.unread}</div>
              )}
            </div>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                <span style={{ fontWeight:700, fontSize:14, color:T.navy }}>{c.name}</span>
                <span style={{ fontSize:11, color:T.slate }}>{c.time}</span>
              </div>
              <div style={{ fontSize:11, color:T.cobalt, fontWeight:600, marginBottom:2 }}>{c.job}</div>
              <div style={{ fontSize:13, color: c.unread ? T.navy : T.slate, fontWeight: c.unread ? 600 : 400, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
                {c.lastMsg}
              </div>
            </div>
            {c.unread > 0 && <div style={{ width:8, height:8, borderRadius:"50%", background:T.cobalt, flexShrink:0 }} />}
          </div>
        ))}
      </div>
    </div>
  );
}

// ── Pro Signup View ─────────────────────────────────────────────

function ProStep3Form({ form, update, inputStyle, onBack, onNext }) {
  const [profilePhoto, setProfilePhoto] = useState([]);
  const [workPhotos, setWorkPhotos]     = useState([]);

  return (
    <div>
      <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, marginBottom:4 }}>Your Profile</h2>
      <p style={{ color:T.slate, fontSize:13, marginBottom:20 }}>Help homeowners trust you</p>
      <div style={{ display:"flex", flexDirection:"column", gap:16 }}>

        {/* Profile photo */}
        <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:14 }}>
          <PhotoUploader
            label="PROFILE PHOTO"
            multiple={false}
            photos={profilePhoto}
            setPhotos={setProfilePhoto}
            hint="A clear face photo builds 3x more trust with homeowners"
            cropSquare
          />
        </div>

        {/* Work portfolio photos */}
        <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:14 }}>
          <PhotoUploader
            label="WORK PORTFOLIO (UP TO 6)"
            multiple={true}
            photos={workPhotos}
            setPhotos={setWorkPhotos}
            hint="Show before & after shots of your best work"
          />
        </div>

        <div>
          <label style={{ fontSize:12, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>HOURLY RATE</label>
          <input value={form.rate} onChange={e => update("rate", e.target.value)} placeholder="e.g. $75/hr" style={inputStyle} />
        </div>
        <div>
          <label style={{ fontSize:12, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>BIO</label>
          <textarea value={form.bio} onChange={e => update("bio", e.target.value)} placeholder="Describe your experience, specialties, and availability…" rows={4} style={{ ...inputStyle, resize:"vertical", lineHeight:1.5 }} />
        </div>
        <div>
          <label style={{ fontSize:12, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>LICENSE # (OPTIONAL)</label>
          <input value={form.license} onChange={e => update("license", e.target.value)} placeholder="State license number" style={inputStyle} />
        </div>
        <div style={{ display:"flex", gap:10 }}>
          <Btn label="← Back" onClick={onBack} variant="secondary" />
          <Btn label="Go Live 🚀" onClick={onNext} variant={form.rate && form.bio ? "primary" : "secondary"} />
        </div>
      </div>
    </div>
  );
}

// ── Onboarding walkthrough ──────────────────────────────────────────
// Shown two ways: automatically, full-screen, the very first time a
// brand-new account (onboarded:false on the users row) logs in — see the
// `authUser?.onboarded === false` check in HomeCallApp; and on-demand as
// a normal navigable view ("howitworks") from a "How it Works" entry in
// either Account screen, so anyone can replay it later as a refresher.
// Content differs by role since homeowner and pro apps are genuinely
// different products wearing the same shell.
const ONBOARDING_SLIDES = {
  homeowner: [
    { emoji: "👋", title: "Welcome to Localy", body: "Find trusted local pros for home services in The Woodlands and Greater Houston — all in one place." },
    { emoji: "📝", title: "Post a job", body: "Describe what you need — plumbing, lawn care, cleaning, anything — and nearby pros start sending bids." },
    { emoji: "🤝", title: "Compare & book", body: "Read bids, message pros with questions, then book instantly or accept the bid that works best for you." },
    { emoji: "🧾", title: "Pay securely, in the app", body: "Pay when the job's done. Some repairs (like HVAC or plumbing) start with a diagnostic fee, then an itemized invoice for the actual work — you approve it before anything's charged." },
    { emoji: "📋", title: "Track it all in My Jobs", body: "See what's active, awaiting, or completed, get notified at every step, and message your pro any time." },
  ],
  pro: [
    { emoji: "👋", title: "Welcome to Localy", body: "Grow your business with local jobs from homeowners in The Woodlands and Greater Houston." },
    { emoji: "🔍", title: "Browse & bid", body: "The Job Board shows open jobs near you — place a competitive bid, or set instant rates so homeowners can book you directly." },
    { emoji: "📅", title: "Get booked", body: "Homeowners can message you, accept your bid, or book you outright. Mark a job arrived and complete right from the booking." },
    { emoji: "🧾", title: "Get paid, invoice extra work", body: "Bill parts, labor, or fees beyond the original estimate with an itemized invoice — the homeowner reviews and pays through the same secure checkout." },
    { emoji: "⭐", title: "Build your reputation", body: "Reviews and ratings from completed jobs show up on your profile — the more you deliver, the more bookings you get." },
  ],
};

function OnboardingOverlay({ userType, onDone, mode }) {
  const [i, setI] = useState(0);
  const slides = ONBOARDING_SLIDES[userType] || ONBOARDING_SLIDES.homeowner;
  const isLast = i === slides.length - 1;
  const slide = slides[i];
  const isReplay = mode === "replay";

  return (
    <div style={{
      position: "fixed", inset: 0, background: T.navy, zIndex: 999,
      display: "flex", flexDirection: "column", fontFamily: "'DM Sans', sans-serif",
    }}>
      <div style={{ display: "flex", justifyContent: "flex-end", padding: "16px 20px 0" }}>
        <button onClick={onDone} style={{
          background: "rgba(255,255,255,0.12)", border: "none", color: T.white, borderRadius: 8,
          padding: "6px 12px", cursor: "pointer", fontSize: 12, fontWeight: 700, fontFamily: "'DM Sans', sans-serif",
        }}>
          {isReplay ? "Close ✕" : "Skip"}
        </button>
      </div>

      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "20px 32px", textAlign: "center" }}>
        <div style={{ fontSize: 56, marginBottom: 20 }}>{slide.emoji}</div>
        <div style={{ color: T.white, fontFamily: "'DM Serif Display', serif", fontWeight: 400, fontSize: 24, marginBottom: 14 }}>{slide.title}</div>
        <div style={{ color: "rgba(255,255,255,0.8)", fontSize: 15, lineHeight: 1.6, maxWidth: 320 }}>{slide.body}</div>
      </div>

      <div style={{ display: "flex", justifyContent: "center", gap: 6, marginBottom: 20 }}>
        {slides.map((_, d) => (
          <button key={d} onClick={() => setI(d)} aria-label={`Go to slide ${d + 1}`} style={{
            width: d === i ? 20 : 6, height: 6, borderRadius: 99, border: "none", cursor: "pointer",
            background: d === i ? T.white : "rgba(255,255,255,0.3)", padding: 0, transition: "width 0.2s",
          }} />
        ))}
      </div>

      <div style={{ display: "flex", gap: 10, padding: "0 20px 28px" }}>
        {i > 0 && (
          <button onClick={() => setI(i - 1)} style={{
            flex: 1, padding: "14px", borderRadius: 12, border: "1.5px solid rgba(255,255,255,0.25)",
            background: "none", color: T.white, fontWeight: 700, fontSize: 14, cursor: "pointer", fontFamily: "'DM Sans', sans-serif",
          }}>
            ← Back
          </button>
        )}
        <button onClick={() => isLast ? onDone() : setI(i + 1)} style={{
          flex: 2, padding: "14px", borderRadius: 12, border: "none",
          background: T.green, color: T.white, fontWeight: 700, fontSize: 14, cursor: "pointer", fontFamily: "'DM Sans', sans-serif",
        }}>
          {isLast ? (isReplay ? "Done" : "Get Started 🚀") : "Next →"}
        </button>
      </div>
    </div>
  );
}

function ProSignupView({ onBack }) {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({ name:"", phone:"", city:"", services:[], rate:"", bio:"", license:"" });
  const update = (k, v) => setForm(f => ({ ...f, [k]:v }));
  const toggleService = (id) => setForm(f => ({
    ...f, services: f.services.includes(id) ? f.services.filter(s => s !== id) : [...f.services, id]
  }));

  const inputStyle = { width:"100%", padding:"10px 12px", borderRadius:10, border:`1.5px solid ${T.border}`, fontSize:14, fontFamily:"'DM Sans', sans-serif", color:T.navy, outline:"none", boxSizing:"border-box", background:T.white };

  if (step === 4) return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:40, textAlign:"center", background:T.sand, minHeight:"100%" }}>
      <div style={{ fontSize:60, marginBottom:16 }}>🎉</div>
      <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, marginBottom:8 }}>You're Live!</h2>
      <p style={{ color:T.slate, fontSize:14, marginBottom:24 }}>Your pro profile is now visible to homeowners in your area. Jobs will start coming in!</p>
      <Btn label="Go to Dashboard" onClick={onBack} />
    </div>
  );

  return (
    <div style={{ background:T.sand, minHeight:"100%", padding:16 }}>
      <button onClick={onBack} style={{ background:"none", border:"none", color:T.cobalt, cursor:"pointer", fontSize:14, padding:0, marginBottom:16, fontFamily:"'DM Sans', sans-serif", fontWeight:600 }}>← Back</button>

      {/* Progress */}
      <div style={{ display:"flex", gap:6, marginBottom:20 }}>
        {[1,2,3].map(s => (
          <div key={s} style={{ flex:1, height:4, borderRadius:99, background: s <= step ? T.green : T.border }} />
        ))}
      </div>

      {step === 1 && (
        <div>
          <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, marginBottom:4 }}>Basic Info</h2>
          <p style={{ color:T.slate, fontSize:13, marginBottom:20 }}>Tell us about yourself</p>
          <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
            <div><label style={{ fontSize:12, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>FULL NAME</label><input value={form.name} onChange={e => update("name", e.target.value)} placeholder="Your full name" style={inputStyle} /></div>
            <div><label style={{ fontSize:12, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>PHONE NUMBER</label><input value={form.phone} onChange={e => update("phone", e.target.value)} placeholder="(555) 000-0000" style={inputStyle} /></div>
            <div><label style={{ fontSize:12, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>CITY / SERVICE AREA</label><input value={form.city} onChange={e => update("city", e.target.value)} placeholder="e.g. The Woodlands, TX" style={inputStyle} /></div>
            <Btn label="Next →" onClick={() => { if (form.name && form.phone && form.city) setStep(2); }} variant={form.name && form.phone && form.city ? "primary" : "secondary"} />
          </div>
        </div>
      )}

      {step === 2 && (
        <div>
          <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, marginBottom:4 }}>Your Services</h2>
          <p style={{ color:T.slate, fontSize:13, marginBottom:20 }}>Select all that apply</p>
          <div style={{ display:"flex", flexWrap:"wrap", gap:10, marginBottom:20 }}>
            {CATEGORIES.map(c => (
              <button key={c.id} onClick={() => toggleService(c.id)} style={{
                background: form.services.includes(c.id) ? T.green : T.white,
                color: form.services.includes(c.id) ? T.white : T.navy,
                border:`2px solid ${form.services.includes(c.id) ? T.green : T.border}`,
                borderRadius:10, padding:"8px 14px", cursor:"pointer", fontSize:13, fontWeight:600,
                fontFamily:"'DM Sans', sans-serif", display:"flex", alignItems:"center", gap:6,
              }}>
                <img src={c.icon} alt="" style={{ width:18, height:18, objectFit:"contain", filter: form.services.includes(c.id) ? "brightness(0) invert(1)" : "none" }} />
                {c.label}
              </button>
            ))}
          </div>
          <div style={{ display:"flex", gap:10 }}>
            <Btn label="← Back" onClick={() => setStep(1)} variant="secondary" />
            <Btn label="Next →" onClick={() => { if (form.services.length > 0) setStep(3); }} variant={form.services.length > 0 ? "primary" : "secondary"} />
          </div>
        </div>
      )}

      {step === 3 && (
        <ProStep3Form form={form} update={update} inputStyle={inputStyle} onBack={() => setStep(2)} onNext={() => { if (form.rate && form.bio) setStep(4); }} />
      )}
    </div>
  );
}


// ── Pro Verification Badge Flow ────────────────────────────────
const VERIFICATION_STEPS = [
  { id:"identity",   icon:"🪪", label:"Identity Check",       desc:"Government-issued ID verification",       points:20 },
  { id:"background", icon:"🔍", label:"Background Check",     desc:"Criminal & sex offender registry search", points:30 },
  { id:"license",    icon:"📋", label:"License Verification", desc:"State trade license or certification",    points:25 },
  { id:"insurance",  icon:"🛡️", label:"Liability Insurance",  desc:"Proof of general liability coverage",     points:15 },
  { id:"phone",      icon:"📱", label:"Phone Verification",   desc:"Verified mobile number via SMS",          points:5  },
  { id:"photo",      icon:"📸", label:"Profile Photo",        desc:"Real face photo for homeowner trust",     points:5  },
];

const BADGE_TIERS = [
  { label:"Unverified", min:0,   max:29,  color:"#94A3B8", bg:"#F1F5F9", icon:"○"  },
  { label:"Verified",   min:30,  max:59,  color:T.cobalt,  bg:T.cobaltL, icon:"✓"  },
  { label:"Top Pro",    min:60,  max:84,  color:T.amber,   bg:T.amberL,  icon:"★"  },
  { label:"Elite",      min:85,  max:100, color:T.green,   bg:T.greenL,  icon:"⚡" },
];

function getBadgeTier(points) {
  return BADGE_TIERS.find(t => points >= t.min && points <= t.max) || BADGE_TIERS[0];
}

function VerificationView({ authUser, onBack }) {
  const [rows, setRows]             = useState([]); // real pro_verification rows
  const [proId, setProId]           = useState(null);
  const [badge, setBadge]           = useState('Unverified'); // real pro_profiles.badge — set by admin approval, not computed client-side
  const [activeStep, setActiveStep] = useState(null);
  const [uploading, setUploading]   = useState(false);
  const [uploadError, setUploadError] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);

  // Load this pro's real verification rows + current badge once on mount.
  useEffect(() => {
    if (!authUser?.id || typeof authUser.id !== 'string') return;
    (async () => {
      try {
        const proRows = await sbFetch('pro_profiles', `?user_id=eq.${authUser.id}&select=id,badge`);
        const p = proRows?.[0];
        if (!p?.id) return;
        setProId(p.id);
        setBadge(p.badge || 'Unverified');
        const vRows = await sbFetch('pro_verification', `?pro_id=eq.${p.id}&select=id,step,status,doc_url,submitted_at,approved_at`);
        if (Array.isArray(vRows)) setRows(vRows);
      } catch (err) {
        console.log('Verification load error:', err.message);
      }
    })();
  }, [authUser?.id]);

  const rowFor = (stepId) => rows.find(r => r.step === stepId);

  // Only APPROVED steps count toward points/badge — a submitted-but-not-
  // yet-reviewed document shouldn't inflate trust points before an admin
  // actually looks at it. This is the whole fix: the old version let a pro
  // grant themselves points just by clicking through, with nothing ever
  // reviewed on the other end.
  const approvedPoints = VERIFICATION_STEPS
    .filter(s => rowFor(s.id)?.status === 'approved')
    .reduce((a, s) => a + s.points, 0);
  const nextTier = BADGE_TIERS.find(t => t.min > approvedPoints);
  const pctFull = Math.min((approvedPoints / 100) * 100, 100);
  const tier = BADGE_TIERS.find(t => t.label === badge) || getBadgeTier(approvedPoints);

  const handleVerify = async (stepId) => {
    setActiveStep(stepId);
    setUploadError("");
    setPreviewUrl(null);
    const existing = rowFor(stepId);
    if (existing?.doc_url) {
      try { setPreviewUrl(await sbGetSignedUrl('verification-docs', existing.doc_url)); }
      catch (err) { console.log('Preview link error:', err.message); }
    }
  };

  const handleUpload = async (file) => {
    if (!file) return;
    if (!proId) { setUploadError("You need a pro profile before you can submit verification documents."); return; }
    setUploading(true);
    setUploadError("");
    try {
      const path = `${authUser.id}/${activeStep}-${Date.now()}-${file.name}`;
      await sbUploadFile('verification-docs', path, file); // uploads the bytes — bucket is private, so its "public" return URL isn't usable; we store the path instead
      const nowIso = new Date().toISOString();
      const existing = rowFor(activeStep);
      if (existing) {
        await sbUpdate('pro_verification', existing.id, { doc_url: path, status: 'submitted', submitted_at: nowIso, approved_at: null });
        setRows(prev => prev.map(r => r.id === existing.id ? { ...r, doc_url: path, status: 'submitted', submitted_at: nowIso, approved_at: null } : r));
      } else {
        const inserted = await sbInsert('pro_verification', { pro_id: proId, step: activeStep, doc_url: path, status: 'submitted', submitted_at: nowIso });
        const newRow = inserted?.[0];
        if (newRow) setRows(prev => [...prev, newRow]);
      }
      setPreviewUrl(await sbGetSignedUrl('verification-docs', path).catch(() => null));
      setUploading(false);
    } catch (err) {
      setUploading(false);
      setUploadError(err.message || 'Upload failed — try again.');
    }
  };

  // Step detail modal
  if (activeStep) {
    const step = VERIFICATION_STEPS.find(s => s.id === activeStep);
    return (
      <div style={{ background:T.sand, minHeight:"100%", padding:16 }}>
        <button onClick={() => setActiveStep(null)} style={{ background:"none", border:"none", color:T.cobalt, cursor:"pointer", fontSize:14, padding:0, marginBottom:20, fontFamily:"'DM Sans', sans-serif", fontWeight:600 }}>← Back</button>

        <div style={{ textAlign:"center", marginBottom:28 }}>
          <div style={{ fontSize:52, marginBottom:12 }}>{step.icon}</div>
          <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, marginBottom:6 }}>{step.label}</h2>
          <p style={{ color:T.slate, fontSize:14, lineHeight:1.6 }}>{step.desc}</p>
        </div>

        <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:16, marginBottom:16 }}>
          <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:12 }}>WHAT YOU NEED</div>
          {activeStep === "identity" && (
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {["Driver's License or Passport", "Photo must be clear and unexpired", "Name must match your Localy profile"].map((r,i) => (
                <div key={i} style={{ display:"flex", gap:10, alignItems:"center" }}>
                  <div style={{ width:20, height:20, borderRadius:"50%", background:T.cobaltL, color:T.cobalt, display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:700, flexShrink:0 }}>✓</div>
                  <span style={{ fontSize:13, color:T.navy }}>{r}</span>
                </div>
              ))}
            </div>
          )}
          {activeStep === "background" && (
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {["Takes 1–3 business days", "Powered by Checkr (industry standard)", "You'll be notified when complete", "One-time fee of $25 billed to your account"].map((r,i) => (
                <div key={i} style={{ display:"flex", gap:10, alignItems:"center" }}>
                  <div style={{ width:20, height:20, borderRadius:"50%", background:T.cobaltL, color:T.cobalt, display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:700, flexShrink:0 }}>✓</div>
                  <span style={{ fontSize:13, color:T.navy }}>{r}</span>
                </div>
              ))}
            </div>
          )}
          {activeStep === "license" && (
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {["State-issued trade license or certification", "Must be current and not expired", "Upload front of license card"].map((r,i) => (
                <div key={i} style={{ display:"flex", gap:10, alignItems:"center" }}>
                  <div style={{ width:20, height:20, borderRadius:"50%", background:T.cobaltL, color:T.cobalt, display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:700, flexShrink:0 }}>✓</div>
                  <span style={{ fontSize:13, color:T.navy }}>{r}</span>
                </div>
              ))}
            </div>
          )}
          {activeStep === "insurance" && (
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {["Certificate of Insurance (COI)", "Minimum $500K general liability", "Localy must be listed as certificate holder"].map((r,i) => (
                <div key={i} style={{ display:"flex", gap:10, alignItems:"center" }}>
                  <div style={{ width:20, height:20, borderRadius:"50%", background:T.cobaltL, color:T.cobalt, display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:700, flexShrink:0 }}>✓</div>
                  <span style={{ fontSize:13, color:T.navy }}>{r}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Background/phone/photo checks aren't built yet, on purpose —
            background needs a real Checkr integration and a way to bill
            the $25 fee; phone/photo verification need their own real
            flows too. Shown honestly instead of faking completion, which
            is exactly the bug this whole rebuild was fixing. */}
        {(activeStep === "background" || activeStep === "phone" || activeStep === "photo") && (
          <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:16, marginBottom:16, textAlign:"center" }}>
            <div style={{ fontSize:32, marginBottom:8 }}>🚧</div>
            <div style={{ color:T.navy, fontWeight:700, fontSize:14, marginBottom:4 }}>Not available yet</div>
            <div style={{ color:T.slate, fontSize:13, lineHeight:1.5 }}>This verification type isn't turned on for Localy yet. Check back soon.</div>
          </div>
        )}

        {/* Upload area — identity/license/insurance only */}
        {(activeStep === "identity" || activeStep === "license" || activeStep === "insurance") && (() => {
          const row = rowFor(activeStep);
          const status = row?.status; // undefined | 'submitted' | 'approved' | 'rejected'
          return (
            <>
              <label style={{
                display:"block",
                border:`2px dashed ${status === 'approved' ? T.green : status === 'rejected' ? T.coral : T.border}`,
                background: status === 'approved' ? T.greenL : status === 'rejected' ? T.coralL : T.white,
                borderRadius:14, padding:32, textAlign:"center",
                cursor:"pointer", marginBottom:16, transition:"all 0.2s",
              }}>
                <input type="file" accept="image/*,.pdf" onChange={e => { const f = e.target.files?.[0]; if (f) handleUpload(f); }} style={{ display:"none" }} />
                {uploading ? (
                  <div>
                    <div style={{ fontSize:32, marginBottom:8 }}>⏳</div>
                    <div style={{ color:T.slate, fontSize:14 }}>Uploading document…</div>
                  </div>
                ) : status === 'approved' ? (
                  <div>
                    <div style={{ fontSize:32, marginBottom:8 }}>✅</div>
                    <div style={{ color:T.green, fontWeight:700, fontSize:14 }}>Approved{row?.approved_at ? ` on ${fmtShortDate(row.approved_at)}` : ''}</div>
                    <div style={{ color:T.slate, fontSize:12, marginTop:4 }}>Tap to replace with an updated document</div>
                  </div>
                ) : status === 'submitted' ? (
                  <div>
                    <div style={{ fontSize:32, marginBottom:8 }}>⏳</div>
                    <div style={{ color:T.navy, fontWeight:700, fontSize:14 }}>Submitted — pending review</div>
                    <div style={{ color:T.slate, fontSize:12, marginTop:4 }}>An admin hasn't reviewed this yet. Tap to replace.</div>
                  </div>
                ) : status === 'rejected' ? (
                  <div>
                    <div style={{ fontSize:32, marginBottom:8 }}>❌</div>
                    <div style={{ color:T.coral, fontWeight:700, fontSize:14 }}>Rejected — please resubmit</div>
                    <div style={{ color:T.slate, fontSize:12, marginTop:4 }}>Tap to upload a new document</div>
                  </div>
                ) : (
                  <div>
                    <div style={{ fontSize:32, marginBottom:8 }}>📄</div>
                    <div style={{ color:T.navy, fontWeight:700, fontSize:14 }}>Tap to upload document</div>
                    <div style={{ color:T.slate, fontSize:12, marginTop:4 }}>JPG, PNG, or PDF · Max 10MB</div>
                  </div>
                )}
              </label>
              {previewUrl && (
                <a href={previewUrl} target="_blank" rel="noreferrer" style={{ display:"block", textAlign:"center", color:T.cobalt, fontSize:13, fontWeight:600, marginBottom:16 }}>
                  View submitted document →
                </a>
              )}
              {uploadError && <div style={{ color:T.coral, fontSize:13, marginBottom:16, textAlign:"center" }}>{uploadError}</div>}
            </>
          );
        })()}
      </div>
    );
  }

  return (
    <div style={{ background:T.sand, minHeight:"100%" }}>
      <button onClick={onBack} style={{ background:"none", border:"none", color:T.cobalt, cursor:"pointer", fontSize:14, padding:"16px 16px 0", display:"block", fontFamily:"'DM Sans', sans-serif", fontWeight:600 }}>← Back</button>

      {/* Badge status card */}
      <div style={{ margin:16, background:`linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, borderRadius:20, padding:24, color:T.white }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:16 }}>
          <div>
            <div style={{ fontSize:12, color:"#A8BFDF", letterSpacing:"0.1em", marginBottom:4 }}>YOUR BADGE STATUS</div>
            <div style={{ display:"flex", alignItems:"center", gap:10 }}>
              <div style={{ background: tier.bg, color: tier.color, width:36, height:36, borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", fontSize:18, fontWeight:700 }}>
                {tier.icon}
              </div>
              <div style={{ fontFamily:"'DM Serif Display', serif", fontSize:28, fontWeight:400 }}>{tier.label}</div>
            </div>
          </div>
          <div style={{ textAlign:"right" }}>
            <div style={{ fontSize:32, fontWeight:700 }}>{approvedPoints}</div>
            <div style={{ fontSize:12, color:"#A8BFDF" }}>trust points</div>
          </div>
        </div>

        {/* Progress bar */}
        <div style={{ background:"rgba(255,255,255,0.15)", borderRadius:99, height:8, marginBottom:8 }}>
          <div style={{ background:`linear-gradient(90deg, #07C47F, #A8E6CF)`, borderRadius:99, height:8, width:`${pctFull}%`, transition:"width 0.5s" }} />
        </div>
        <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, color:"#A8BFDF" }}>
          <span>{approvedPoints} pts</span>
          {nextTier && <span>{nextTier.min - approvedPoints} pts to {nextTier.label}</span>}
          <span>100 pts</span>
        </div>

        {/* Tier badges row */}
        <div style={{ display:"flex", gap:8, marginTop:16, flexWrap:"wrap" }}>
          {BADGE_TIERS.map(t => (
            <div key={t.label} style={{
              background: approvedPoints >= t.min ? t.bg : "rgba(255,255,255,0.08)",
              color: approvedPoints >= t.min ? t.color : "rgba(255,255,255,0.3)",
              borderRadius:99, padding:"3px 12px", fontSize:11, fontWeight:700,
              border: `1px solid ${approvedPoints >= t.min ? t.color + "44" : "rgba(255,255,255,0.1)"}`,
            }}>{t.icon} {t.label}</div>
          ))}
        </div>
      </div>

      {/* Verification steps */}
      <div style={{ padding:"0 16px 16px" }}>
        <div style={{ fontSize:11, color:T.slate, fontWeight:700, letterSpacing:"0.1em", marginBottom:12 }}>VERIFICATION CHECKLIST</div>
        <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
          {VERIFICATION_STEPS.map(step => {
            const status = rowFor(step.id)?.status; // undefined | 'submitted' | 'approved' | 'rejected'
            const done = status === 'approved';
            const pending = status === 'submitted';
            return (
              <div key={step.id} style={{
                background:T.white, borderRadius:14, padding:14,
                border:`1.5px solid ${done ? T.green : pending ? T.amber : T.border}`,
                boxShadow: done ? `0 0 0 1px ${T.green}22` : "0 1px 4px rgba(0,0,0,0.05)",
              }}>
                <div style={{ display:"flex", gap:12, alignItems:"center" }}>
                  <div style={{ fontSize:26, flexShrink:0 }}>{step.icon}</div>
                  <div style={{ flex:1 }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                      <div style={{ fontWeight:700, fontSize:14, color: done ? T.green : T.navy }}>{step.label}</div>
                      <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                        <span style={{ fontSize:11, fontWeight:700, color:T.cobalt }}>+{step.points}pts</span>
                        {done
                          ? <div style={{ width:22, height:22, borderRadius:"50%", background:T.green, color:T.white, display:"flex", alignItems:"center", justifyContent:"center", fontSize:13, fontWeight:700 }}>✓</div>
                          : pending
                          ? <div style={{ width:22, height:22, borderRadius:"50%", background:T.amberL, color:T.amber, display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:700 }}>⏳</div>
                          : <div style={{ width:22, height:22, borderRadius:"50%", border:`2px solid ${T.border}` }} />
                        }
                      </div>
                    </div>
                    <div style={{ fontSize:12, color:T.slate, marginTop:2 }}>{step.desc}</div>
                  </div>
                </div>
                {!done && (
                  <button onClick={() => handleVerify(step.id)} style={{
                    width:"100%", marginTop:12, padding:"8px", borderRadius:8,
                    background: pending ? T.amberL : T.cobaltL, color: pending ? T.amber : T.cobalt, border:`1px solid ${(pending ? T.amber : T.cobalt)}33`,
                    fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif",
                  }}>
                    {status === 'rejected' ? 'Resubmit →' : pending ? 'Pending review →' : 'Start Verification →'}
                  </button>
                )}
                {done && (
                  <div style={{ marginTop:8, fontSize:12, color:T.green, fontWeight:600 }}>
                    ✅ Verified & approved
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Benefits section */}
        <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:16, marginTop:16 }}>
          <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:12 }}>WHY VERIFY?</div>
          {[
            { icon:"👀", text:"Verified pros appear first in search results" },
            { icon:"💰", text:"Elite pros earn 40% more on average per job" },
            { icon:"🏷️", text:"Badge displayed on your profile and in listings" },
            { icon:"📈", text:"Homeowners are 3x more likely to book verified pros" },
          ].map((b,i) => (
            <div key={i} style={{ display:"flex", gap:10, alignItems:"center", padding:"8px 0", borderBottom: i<3 ? `1px solid ${T.border}` : "none" }}>
              <span style={{ fontSize:20 }}>{b.icon}</span>
              <span style={{ fontSize:13, color:T.navy }}>{b.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── Ratings & Reviews View ──────────────────────────────────────
const REVIEWS = [
  { id:1, reviewer:"Jennifer P.", init:"JP", rating:5, date:"Aug 8, 2026", comment:"Marcus was incredible — showed up on time, fixed the leak fast, and even cleaned up after. Will definitely book again!", pro:"Marcus Webb" },
  { id:2, reviewer:"Robert C.",   init:"RC", rating:5, date:"Aug 5, 2026", comment:"Lisa's lawn care is top notch. My yard has never looked better. Very professional and friendly.", pro:"Lisa Nguyen" },
  { id:3, reviewer:"Tammy H.",    init:"TH", rating:4, date:"Aug 1, 2026", comment:"Sandra did a great job with the deep clean. A few spots were missed but overall very happy.", pro:"Sandra Torres" },
  { id:4, reviewer:"Mike D.",     init:"MD", rating:5, date:"Jul 28, 2026", comment:"Tony patched the drywall perfectly. You can't even tell there was a hole. Highly recommend!", pro:"Tony Reeves" },
];

function RatingsView({ userType }) {
  const [showForm, setShowForm] = useState(false);
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [reviewText, setReviewText] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const avg = (REVIEWS.reduce((a, r) => a + r.rating, 0) / REVIEWS.length).toFixed(1);

  return (
    <div style={{ padding:16, background:T.sand, minHeight:"100%" }}>
      <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, marginBottom:4 }}>Ratings & Reviews</h2>
      <p style={{ color:T.slate, fontSize:13, marginBottom:16 }}>What the community is saying</p>

      {/* Summary card */}
      <div style={{ background:`linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, borderRadius:16, padding:20, marginBottom:16, color:T.white, textAlign:"center" }}>
        <div style={{ fontSize:48, fontWeight:700, lineHeight:1 }}>{avg}</div>
        <div style={{ fontSize:20, color:T.amber, margin:"6px 0" }}>{"★".repeat(5)}</div>
        <div style={{ fontSize:13, color:"#A8BFDF" }}>Based on {REVIEWS.length} reviews</div>
        <div style={{ display:"flex", justifyContent:"center", gap:24, marginTop:16 }}>
          {[["5★", "75%"], ["4★", "20%"], ["3★", "5%"]].map(([k,v]) => (
            <div key={k} style={{ textAlign:"center" }}>
              <div style={{ fontWeight:700 }}>{v}</div>
              <div style={{ fontSize:11, color:"#A8BFDF" }}>{k}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Leave a review */}
      {userType === "homeowner" && !submitted && (
        <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, marginBottom:16, overflow:"hidden" }}>
          <button onClick={() => setShowForm(!showForm)} style={{ width:"100%", padding:14, background:"none", border:"none", cursor:"pointer", display:"flex", justifyContent:"space-between", alignItems:"center", fontFamily:"'DM Sans', sans-serif" }}>
            <span style={{ fontWeight:700, color:T.navy }}>✍️ Leave a Review</span>
            <span style={{ color:T.slate }}>{showForm ? "▲" : "▼"}</span>
          </button>
          {showForm && (
            <div style={{ padding:"0 14px 14px", borderTop:`1px solid ${T.border}` }}>
              <div style={{ display:"flex", gap:4, margin:"12px 0 8px", justifyContent:"center" }}>
                {[1,2,3,4,5].map(s => (
                  <span key={s} onClick={() => setRating(s)} onMouseEnter={() => setHover(s)} onMouseLeave={() => setHover(0)}
                    style={{ fontSize:32, cursor:"pointer", color: s <= (hover || rating) ? T.amber : T.border }}>★</span>
                ))}
              </div>
              <textarea value={reviewText} onChange={e => setReviewText(e.target.value)}
                placeholder="Share your experience with this pro…" rows={3}
                style={{ width:"100%", padding:"10px 12px", borderRadius:10, border:`1.5px solid ${T.border}`, fontSize:14, fontFamily:"'DM Sans', sans-serif", resize:"none", outline:"none", boxSizing:"border-box" }}
              />
              <div style={{ marginTop:10 }}>
                <Btn label="Submit Review" onClick={() => { if (rating && reviewText) setSubmitted(true); }} variant={rating && reviewText ? "primary" : "secondary"} />
              </div>
            </div>
          )}
        </div>
      )}
      {submitted && (
        <div style={{ background:T.greenL, borderRadius:12, padding:14, marginBottom:16, color:T.green, fontWeight:600, fontSize:14, textAlign:"center" }}>
          ✅ Review submitted! Thank you.
        </div>
      )}

      {/* Reviews list */}
      <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
        {REVIEWS.map(r => (
          <div key={r.id} style={{ background:T.white, borderRadius:14, padding:16, border:`1px solid ${T.border}`, boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
            <div style={{ display:"flex", gap:10, alignItems:"center", marginBottom:8 }}>
              <Avatar initials={r.init} size={36} color={T.slate} />
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:700, fontSize:14, color:T.navy }}>{r.reviewer}</div>
                <div style={{ fontSize:11, color:T.slate }}>{r.date} · Re: {r.pro}</div>
              </div>
              <div style={{ color:T.amber }}>{"★".repeat(r.rating)}</div>
            </div>
            <p style={{ fontSize:13, color:T.navy, lineHeight:1.5, margin:0 }}>{r.comment}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── Notifications View ──────────────────────────────────────────
// Fetch a user's real notifications from Supabase. Before this, the Alerts
// tab always showed the same 7 hardcoded sample notifications (Marcus
// Webb, Tony Reeves, etc.) on both the homeowner and pro side no matter
// what actually happened — nothing ever wrote to (or read from) the
// `notifications` table, even though the table and its RLS SELECT policy
// already existed. Real rows now get written by the send-push Edge
// Function every time sendPushNotification() fires (new bid, new message,
// booking status change, payment, job match, etc.), so this just reads
// them back. Unlike most other data in this file, this does NOT fall back
// to sample data — a notifications list showing fake people/events is
// actively misleading, so an account with no real notifications yet just
// sees an empty state instead.
function useNotifications(authUser) {
  const [notifs, setNotifs] = useState([]);
  const [loading, setLoading] = useState(true);

  useState(() => {
    if (typeof authUser?.id !== 'string') { setLoading(false); return; }
    (async () => {
      try {
        const rows = await sbFetch('notifications', `?user_id=eq.${authUser.id}&select=*&order=created_at.desc&limit=50`);
        const iconFor = { message:"💬", bid:"📋", quote:"💵", booking_status:"✅", job_match:"📍", payment:"💳", invoice:"🧾" };
        setNotifs(Array.isArray(rows) ? rows.map(r => ({
          id:     r.id,
          icon:   iconFor[r.type] || "🔔",
          title:  r.title,
          body:   r.body || '',
          time:   formatTimeAgo(r.created_at),
          unread: !r.read,
          type:   r.type || 'system',
          data:   r.data || {},
        })) : []);
      } catch (err) {
        console.log('Notifications fetch error:', err.message);
      } finally {
        setLoading(false);
      }
    })();
  });

  // Marks the notification read both locally (so the list AND the bottom
  // nav Alerts badge — same hook instance, lifted to the app shell —
  // update immediately) and in Supabase.
  const markRead = (id) => {
    setNotifs(prev => prev.map(x => x.id === id ? { ...x, unread:false } : x));
    if (typeof id === 'string') {
      sbUpdate('notifications', id, { read:true }).catch(err => console.log('Mark read error:', err.message));
    }
  };
  const markAllRead = () => {
    setNotifs(prev => {
      prev.forEach(x => { if (x.unread && typeof x.id === 'string') sbUpdate('notifications', x.id, { read:true }).catch(() => {}); });
      return prev.map(x => ({ ...x, unread:false }));
    });
  };

  return { notifs, loading, markRead, markAllRead };
}

function NotificationsView({ onNavigate, onReview, notifs, loading, markRead, markAllRead }) {
  const unreadCount = notifs.filter(n => n.unread).length;

  const typeColor = { message:"#1565C0", bid:T.green, quote:T.green, booking_status:T.green, booking:T.green, review:T.amber, job_match:T.cobalt, promo:T.cobalt, payment:T.green, invoice:T.green, system:T.slate };

  // Tapping a notification routes using the `data` payload (jobId/
  // conversationId/bookingId) set by whatever triggered it.
  const handleOpen = (n) => {
    markRead(n.id);
    if (!onNavigate) return;
    if (n.type === "message" || n.type === "quote") {
      onNavigate("messages");
    } else if (n.type === "bid" || n.type === "job_match") {
      onNavigate("jobs");
    } else if (n.type === "review") {
      const proName = n.body.match(/with (.+)\?/)?.[1];
      const pro = PROS.find(p => p.name === proName);
      if (pro && onReview) onReview(pro, "manual");
      else onNavigate("dashboard");
    } else if (n.type === "booking_status" || n.type === "booking") {
      onNavigate("dashboard");
    } else if (n.type === "promo") {
      const proName = n.body.split(" is available")[0];
      const pro = PROS.find(p => p.name === proName);
      if (pro) onNavigate("profile", pro);
      else onNavigate("home");
    } else if (n.type === "payment" || n.type === "invoice") {
      onNavigate("dashboard");
    }
    // "system" (e.g. Welcome) has nothing to open — marking it read is enough.
  };

  return (
    <div style={{ padding:16, background:T.sand, minHeight:"100%" }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
        <div>
          <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, margin:0 }}>Notifications</h2>
          {unreadCount > 0 && <div style={{ fontSize:12, color:T.slate }}>{unreadCount} unread</div>}
        </div>
        {unreadCount > 0 && (
          <button onClick={markAllRead} style={{ background:"none", border:"none", color:T.cobalt, cursor:"pointer", fontSize:13, fontWeight:600, fontFamily:"'DM Sans', sans-serif" }}>
            Mark all read
          </button>
        )}
      </div>

      <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
        {loading && (
          <div style={{ textAlign:"center", padding:30, color:T.slate, fontSize:13 }}>⏳ Loading notifications...</div>
        )}
        {!loading && notifs.length === 0 && (
          <div style={{ textAlign:"center", padding:40, color:T.slate }}>
            <div style={{ fontSize:40, marginBottom:12 }}>🔔</div>
            <div style={{ fontWeight:700, fontSize:16, color:T.navy }}>No notifications yet</div>
            <div style={{ fontSize:13, marginTop:4 }}>New bids, messages, and bookings will show up here.</div>
          </div>
        )}
        {notifs.map(n => (
          <div key={n.id} onClick={() => handleOpen(n)}
            style={{
              background: n.unread ? T.cobaltL : T.white,
              borderRadius:14, padding:14, cursor:"pointer",
              border:`1px solid ${n.unread ? T.cobalt + "33" : T.border}`,
              display:"flex", gap:12, alignItems:"flex-start",
              boxShadow:"0 1px 4px rgba(0,0,0,0.05)",
            }}>
            <div style={{ width:42, height:42, borderRadius:12, background:T.white, border:`1px solid ${T.border}`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, flexShrink:0 }}>
              {n.icon}
            </div>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                <div style={{ fontWeight: n.unread ? 700 : 600, fontSize:14, color:T.navy, lineHeight:1.3, flex:1 }}>{n.title}</div>
                {n.unread && <div style={{ width:8, height:8, borderRadius:"50%", background:T.cobalt, flexShrink:0, marginLeft:8, marginTop:4 }} />}
              </div>
              <div style={{ fontSize:13, color:T.slate, margin:"3px 0", lineHeight:1.4 }}>{n.body}</div>
              <div style={{ fontSize:11, color:T.slate }}>{n.time}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


// ── Map View ───────────────────────────────────────────────────
// Pro locations with real-ish Woodlands/Houston area coordinates
// Real pro locations for the map. pro_profiles only ever collects a
// free-text city (see CITY / SERVICE AREA in the signup/edit forms), never
// a street address or precise coordinates, and there's no geocoding
// service wired into the app — so pin placement is a known-city centroid
// (Greater Houston area) plus a small, deterministic-per-pro jitter (hashed
// from the pro's own id, so it lands in the same spot every time instead
// of jumping around on every reload) rather than a genuinely exact address.
// This replaces the old PRO_LOCATIONS mock array, which showed the same 6
// fake pros on the map regardless of who actually has a real profile.
const CITY_COORDS = [
  { match:"the woodlands", lat:30.1658, lng:-95.4613 },
  { match:"spring",        lat:30.0794, lng:-95.4172 },
  { match:"conroe",        lat:30.3118, lng:-95.4560 },
  { match:"kingwood",      lat:30.0430, lng:-95.1730 },
  { match:"atascocita",    lat:29.9955, lng:-95.1799 },
  { match:"humble",        lat:29.9988, lng:-95.2622 },
  { match:"tomball",       lat:30.0972, lng:-95.6161 },
  { match:"cypress",       lat:29.9691, lng:-95.6972 },
  { match:"katy",          lat:29.7858, lng:-95.8244 },
  { match:"magnolia",      lat:30.2093, lng:-95.7488 },
  { match:"shenandoah",    lat:30.1799, lng:-95.4557 },
  { match:"oak ridge",     lat:30.1568, lng:-95.4405 },
  { match:"houston",       lat:29.7604, lng:-95.3698 },
];

function hashStr(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

function getProMapCoords(pro) {
  const key = (pro.city || '').toLowerCase();
  const base = CITY_COORDS.find(c => key.includes(c.match)) || CITY_COORDS[0];
  const h = hashStr(String(pro.id));
  const jx = ((h % 1000) / 1000) * 2 - 1;          // -1..1
  const jy = (((h >> 10) % 1000) / 1000) * 2 - 1;   // -1..1
  const spread = 0.035; // ~2-3mi wobble so same-city pros don't stack exactly
  return { lat: base.lat + jy * spread, lng: base.lng + jx * spread };
}

// SVG map pin component
const MapPin = ({ pro, isSelected, onClick }) => {
  const catColors = {
    plumbing:   "#1565C0", electrical: "#F59E0B", handyman: "#7C3AED",
    lawn:       "#0A9E6A", cleaning:   "#EC4899", painting: "#EA580C",
    detailing:  "#06B6D4", hvac:       "#6366F1",
  };
  const color = catColors[pro.cat] || T.cobalt;
  return (
    <div onClick={onClick} style={{
      position:"absolute",
      transform:"translate(-50%, -100%)",
      cursor:"pointer",
      zIndex: isSelected ? 20 : 10,
      transition:"transform 0.2s",
      filter: isSelected ? "drop-shadow(0 4px 12px rgba(0,0,0,0.3))" : "drop-shadow(0 2px 4px rgba(0,0,0,0.2))",
    }}>
      <div style={{ position:"relative" }}>
        {/* Pin body */}
        <svg width={isSelected ? 44 : 36} height={isSelected ? 52 : 44} viewBox="0 0 44 52" fill="none">
          <path d="M22 0C10 0 0 10 0 22C0 38 22 52 22 52C22 52 44 38 44 22C44 10 34 0 22 0Z" fill={color} />
          <circle cx="22" cy="22" r="14" fill="white" />
        </svg>
        {/* Avatar inside pin */}
        <div style={{
          position:"absolute", top: isSelected ? 8 : 7, left:"50%",
          transform:"translateX(-50%)",
          width: isSelected ? 28 : 22, height: isSelected ? 28 : 22,
          borderRadius:"50%", background:color,
          color:"#fff", display:"flex", alignItems:"center", justifyContent:"center",
          fontSize: isSelected ? 11 : 9, fontWeight:700,
          fontFamily:"'DM Sans', sans-serif",
        }}>{pro.img}</div>
        {/* Availability status dot */}
        <div style={{
          position:"absolute", top:-2, right:-2,
          width:10, height:10, borderRadius:"50%",
          background: getAvailability(pro).dot,
          border:"2px solid white",
        }} />
      </div>
    </div>
  );
};

function MapView({ onNavigate }) {
  const [selectedPro, setSelectedPro]   = useState(null);
  const [filterCat, setFilterCat]       = useState("all");
  const [availableOnly, setAvailableOnly] = useState(false);
  const [mapStyle, setMapStyle]         = useState("street"); // street | satellite
  const [showList, setShowList]         = useState(true); // default to List view

  // Real pros only — usePros() falls back to 6 hardcoded demo pros when
  // there's no real data yet (so Browse still looks populated), but the
  // map should never show those as if they were real people at real
  // locations. Same typeof-id real-vs-mock check used everywhere else in
  // this file. Each real pro then gets an approximate map position — see
  // getProMapCoords() above (pro_profiles only stores a free-text city,
  // never a precise address, so this is a city-centroid + small
  // deterministic jitter, not a geocoded exact location).
  const { pros: allPros } = usePros();
  const mapPros = allPros
    .filter(p => typeof p.id === 'string')
    .map(p => ({ ...p, ...getProMapCoords(p) }));

  const { location, locating, requestLocation } = useLocation();
  const MAP_CENTER = { lat: 30.08, lng: -95.35 };
  // Use real GPS location if available, otherwise default to The Woodlands
  const mapCenter = location ? { lat: location.lat, lng: location.lng } : MAP_CENTER;

  // Bounding box must match the OpenStreetMap iframe's bbox below (±0.15 lng, ±0.10 lat
  // around mapCenter). It used to be hardcoded to the Houston area, so pins were placed
  // using Houston coordinates even while the map itself had re-centered on the user's
  // real GPS location elsewhere — that's why pins looked scattered randomly instead of
  // where the pros actually are.
  const LAT_RANGE = { min: mapCenter.lat - 0.10, max: mapCenter.lat + 0.10 };
  const LNG_RANGE = { min: mapCenter.lng - 0.15, max: mapCenter.lng + 0.15 };

  // Convert lat/lng to a percentage position within our map bounds — used
  // to be raw pixels computed against a hardcoded MAP_W/MAP_H, which only
  // lined up if the map box actually rendered at exactly that size. Using
  // percentages instead means pins stay correctly placed no matter how
  // tall the map box actually renders (which is also what let the map box
  // stop being pinned to a fixed pixel height — see below).
  const toPixel = (lat, lng) => ({
    x: ((lng - LNG_RANGE.min) / (LNG_RANGE.max - LNG_RANGE.min)) * 100,
    y: ((LAT_RANGE.max - lat) / (LAT_RANGE.max - LAT_RANGE.min)) * 100,
  });

  // Localy currently only has real pros in The Woodlands / Greater Houston area.
  // Previously every mock pro showed up everywhere regardless of where the user
  // actually was — "6 pros in this area" even from 250 miles away in Plano.
  // Only count/show pros that are actually within the visible map area.
  const inView = (p) =>
    p.lat >= LAT_RANGE.min && p.lat <= LAT_RANGE.max &&
    p.lng >= LNG_RANGE.min && p.lng <= LNG_RANGE.max;

  const filtered = mapPros.filter(p =>
    inView(p) &&
    (filterCat === "all" || p.cat === filterCat) &&
    (!availableOnly || p.available)
  );

  const catColors = {
    plumbing:"#1565C0", electrical:"#F59E0B", handyman:"#7C3AED",
    lawn:"#0A9E6A", cleaning:"#EC4899", painting:"#EA580C",
  };

  return (
    <div style={{ background:T.sand, minHeight:"100%", display:"flex", flexDirection:"column" }}>

      {/* Filter bar */}
      <div style={{ background:T.white, borderBottom:`1px solid ${T.border}`, padding:"10px 12px" }}>
        <div style={{ display:"flex", gap:8, overflowX:"auto", paddingBottom:2 }}>
          {/* All filter */}
          <button onClick={() => setFilterCat("all")} style={{
            padding:"6px 14px", borderRadius:99, border:`1.5px solid ${filterCat==="all" ? T.navy : T.border}`,
            background: filterCat==="all" ? T.navy : T.white,
            color: filterCat==="all" ? T.white : T.slate,
            fontSize:12, fontWeight:700, cursor:"pointer", whiteSpace:"nowrap",
            fontFamily:"'DM Sans', sans-serif", flexShrink:0,
          }}>All Pros</button>
          {CATEGORIES.slice(0,6).map(c => (
            <button key={c.id} onClick={() => setFilterCat(filterCat===c.id ? "all" : c.id)} style={{
              padding:"6px 12px", borderRadius:99, border:`1.5px solid ${filterCat===c.id ? catColors[c.id]||T.cobalt : T.border}`,
              background: filterCat===c.id ? catColors[c.id]||T.cobalt : T.white,
              color: filterCat===c.id ? T.white : T.slate,
              fontSize:12, fontWeight:600, cursor:"pointer", whiteSpace:"nowrap",
              fontFamily:"'DM Sans', sans-serif", flexShrink:0,
              display:"flex", alignItems:"center", gap:5,
            }}>
              <img src={c.icon} alt="" style={{ width:14, height:14, objectFit:"contain", filter: filterCat===c.id ? "brightness(0) invert(1)" : "none" }} />
              {c.label}
            </button>
          ))}
          {/* Available toggle */}
          <button onClick={() => setAvailableOnly(!availableOnly)} style={{
            padding:"6px 12px", borderRadius:99, border:`1.5px solid ${availableOnly ? T.green : T.border}`,
            background: availableOnly ? T.greenL : T.white,
            color: availableOnly ? T.green : T.slate,
            fontSize:12, fontWeight:700, cursor:"pointer", whiteSpace:"nowrap",
            fontFamily:"'DM Sans', sans-serif", flexShrink:0,
          }}>● Available</button>
        </div>
      </div>

      {/* Map container */}
      <div style={{ position:"relative", flex:1, display:"flex", flexDirection:"column", minHeight:0 }}>
        {/* Live OpenStreetMap — fills all remaining vertical space instead of
            a fixed pixel height, so there's no leftover blank area below it
            on taller screens. Only shrinks to a fixed height when the list
            view is open, so there's room for the scrollable list below it. */}
        <div style={{
          width:"100%", height: showList ? 260 : "100%",
          flex: showList ? "0 0 260px" : "1 1 auto",
          minHeight: showList ? 260 : 320,
          position:"relative", overflow:"hidden",
          transition:"height 0.3s",
        }}>
          {/* Real map using OpenStreetMap */}
          <iframe
            key={`${mapCenter.lat}-${mapCenter.lng}-${mapStyle}`}
            title="Localy Map"
            width="100%"
            height="100%"
            style={{ border:"none", display:"block" }}
            src={`https://www.openstreetmap.org/export/embed.html?bbox=${mapCenter.lng-0.15}%2C${mapCenter.lat-0.10}%2C${mapCenter.lng+0.15}%2C${mapCenter.lat+0.10}&layer=${mapStyle === "satellite" ? "hot" : "mapnik"}&marker=${mapCenter.lat}%2C${mapCenter.lng}`}
          />

          {/* Location label */}
          <div style={{ position:"absolute", top:10, left:12, background:"rgba(255,255,255,0.9)", borderRadius:99, padding:"4px 12px", fontSize:11, fontWeight:700, color:T.navy, backdropFilter:"blur(4px)" }}>
            📍 {location ? location.city : "The Woodlands & Greater Houston"}
          </div>

          {/* GPS locate button */}
          <button onClick={requestLocation} style={{
            position:"absolute", bottom:10, left:"50%", transform:"translateX(-50%)",
            background: location ? T.green : T.white,
            color: location ? T.white : T.navy,
            border:`1px solid ${location ? T.green : T.border}`,
            borderRadius:99, padding:"6px 14px", fontSize:11, fontWeight:700,
            cursor:"pointer", fontFamily:"'DM Sans', sans-serif",
            display:"flex", alignItems:"center", gap:6, zIndex:20,
            boxShadow:"0 2px 8px rgba(0,0,0,0.15)",
          }}>
            {locating ? "⏳ Locating…" : location ? `🎯 ${location.city}` : "📍 Find My Location"}
          </button>

          {/* Map style toggle */}
          <div style={{ position:"absolute", top:10, right:12, display:"flex", gap:4 }}>
            {["street","satellite"].map(s => (
              <button key={s} onClick={() => setMapStyle(s)} style={{
                background: mapStyle===s ? T.navy : "rgba(255,255,255,0.9)",
                color: mapStyle===s ? T.white : T.slate,
                border:"none", borderRadius:6, padding:"4px 10px",
                fontSize:10, fontWeight:700, cursor:"pointer",
                fontFamily:"'DM Sans', sans-serif",
              }}>{s === "street" ? <>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:4, verticalAlign:"middle"}}><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>Map
              </> : <>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:4, verticalAlign:"middle"}}><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>Satellite
              </>}</button>
            ))}
          </div>

          {/* Pro count badge */}
          <div style={{ position:"absolute", bottom:10, left:12, background:T.cobalt, color:T.white, borderRadius:99, padding:"4px 12px", fontSize:11, fontWeight:700 }}>
            {filtered.length} pros in this area
          </div>

          {/* List/Map toggle */}
          <button onClick={() => setShowList(!showList)} style={{
            position:"absolute", bottom:10, right:12,
            background:T.white, color:T.navy, border:`1px solid ${T.border}`,
            borderRadius:99, padding:"4px 12px", fontSize:11, fontWeight:700,
            cursor:"pointer", fontFamily:"'DM Sans', sans-serif",
          }}>
            {showList ? <>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:4, verticalAlign:"middle"}}><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>Map
            </> : <>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:4, verticalAlign:"middle"}}><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>List
            </>}
          </button>

          {/* My Location pin */}
          {location && (() => {
            const px = toPixel(location.lat, location.lng);
            return (
              <div style={{ position:"absolute", left:`${px.x}%`, top:`${px.y}%`, transform:"translate(-50%,-50%)", zIndex:25 }}>
                <div style={{ width:20, height:20, borderRadius:"50%", background:T.cobalt, border:"3px solid white", boxShadow:"0 0 0 4px rgba(21,101,192,0.3)" }} />
              </div>
            );
          })()}

          {/* Pro pins */}
          {filtered.map(pro => {
            const px = toPixel(pro.lat, pro.lng);
            return (
              <div key={pro.id} style={{ position:"absolute", left:`${px.x}%`, top:`${px.y}%`, transform:"translate(-50%,-50%)" }}>
                <MapPin
                  pro={pro}
                  isSelected={selectedPro?.id === pro.id}
                  onClick={() => setSelectedPro(selectedPro?.id === pro.id ? null : pro)}
                />
              </div>
            );
          })}

          {/* Outside service area — no real pros to show here */}
          {filtered.length === 0 && (
            <div style={{
              position:"absolute", top:"50%", left:"50%", transform:"translate(-50%,-50%)",
              background:"rgba(255,255,255,0.95)", borderRadius:16, padding:"18px 22px",
              textAlign:"center", maxWidth:240, boxShadow:"0 4px 20px rgba(0,0,0,0.15)", zIndex:15,
            }}>
              <div style={{ fontSize:26, marginBottom:6 }}>📍</div>
              <div style={{ fontWeight:700, fontSize:13, color:T.navy, marginBottom:4 }}>No pros in this area yet</div>
              <div style={{ fontSize:12, color:T.slate, lineHeight:1.4 }}>Localy currently serves The Woodlands &amp; Greater Houston, TX.</div>
            </div>
          )}

          {/* Selected pro popup */}
          {selectedPro && (
            <div style={{
              position:"absolute", bottom:50, left:"50%", transform:"translateX(-50%)",
              background:T.white, borderRadius:16, padding:14, width:280,
              boxShadow:"0 8px 32px rgba(0,0,0,0.2)", border:`1px solid ${T.border}`,
              zIndex:30,
            }}>
              <button onClick={() => setSelectedPro(null)} style={{ position:"absolute", top:8, right:10, background:"none", border:"none", fontSize:16, cursor:"pointer", color:T.slate }}>✕</button>
              <div style={{ display:"flex", gap:10, alignItems:"center", marginBottom:10 }}>
                <Avatar initials={selectedPro.img} size={40} color={catColors[selectedPro.cat]||T.cobalt} />
                <div>
                  <div style={{ fontWeight:700, fontSize:14, color:T.navy }}>{selectedPro.name}</div>
                  <div style={{ fontSize:12, color:T.slate }}>
                {CATEGORIES.find(c=>c.id===selectedPro.cat)?.label}
                {location && (
                  <span style={{ marginLeft:6, background:T.greenL, color:T.green, fontSize:10, fontWeight:700, padding:"1px 6px", borderRadius:99 }}>
                    📍 {distanceMiles(location.lat, location.lng, selectedPro.lat, selectedPro.lng)} mi away
                  </span>
                )}
              </div>
                </div>
                <Badge label={selectedPro.badge} />
              </div>
              <div style={{ display:"flex", gap:12, marginBottom:12 }}>
                <span style={{ fontSize:13, fontWeight:700, color:T.navy }}>{selectedPro.rate}</span>
                <Stars rating={selectedPro.rating} />
                <span style={{ fontSize:11, color: getAvailability(selectedPro).text, fontWeight:700 }}>
                  ● {getAvailability(selectedPro).label}
                </span>
              </div>
              <div style={{ display:"flex", gap:8 }}>
                <Btn label="Book Now" onClick={() => onNavigate && onNavigate("book", selectedPro)} small />
                <Btn label="Profile" variant="secondary" onClick={() => onNavigate && onNavigate("profile", selectedPro)} small />
              </div>
            </div>
          )}
        </div>

        {/* List view below map */}
        {showList && (
          <div style={{ padding:12, overflowY:"auto", maxHeight:300 }}>
            <div style={{ fontSize:11, color:T.slate, fontWeight:700, letterSpacing:"0.1em", marginBottom:10 }}>PROS IN THIS AREA</div>
            <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
              {filtered.map(pro => (
                <div key={pro.id} onClick={() => setSelectedPro(selectedPro?.id===pro.id ? null : pro)}
                  style={{
                    background: selectedPro?.id===pro.id ? T.cobaltL : T.white,
                    borderRadius:12, padding:12, display:"flex", gap:10, alignItems:"center",
                    border:`1.5px solid ${selectedPro?.id===pro.id ? T.cobalt : T.border}`,
                    cursor:"pointer", boxShadow:"0 1px 4px rgba(0,0,0,0.05)",
                  }}>
                  <Avatar initials={pro.img} size={36} color={catColors[pro.cat]||T.cobalt} />
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:700, fontSize:13, color:T.navy }}>{pro.name}</div>
                    <div style={{ fontSize:11, color:T.slate }}>{CATEGORIES.find(c=>c.id===pro.cat)?.label} · {pro.rate}</div>
                  </div>
                  <div style={{ textAlign:"right" }}>
                    <Stars rating={pro.rating} />
                    <div style={{ fontSize:10, fontWeight:700, color: getAvailability(pro).text }}>
                      ● {getAvailability(pro).label}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}


// ── Blocked Account Screen ──────────────────────────────────────
// Shown instead of the app when a login attempt or a restored session
// belongs to an account an admin has blocked (see account_blocking_
// migration.sql + AdminDashboard's Block/Unblock actions). The point is
// that a blocked person always sees a clear reason, never a silent
// failure or a broken-looking app.
function BlockedScreen({ message, onDismiss }) {
  return (
    <div style={{
      minHeight:"100vh", background:`linear-gradient(160deg, #0A2540 0%, #6B1F1F 60%, #8C2A2A 100%)`,
      display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center",
      padding:32, fontFamily:"'DM Sans', sans-serif", textAlign:"center",
    }}>
      <div style={{ fontSize:56, marginBottom:20 }}>🚫</div>
      <h2 style={{ color:"#FFFFFF", fontFamily:"'DM Serif Display', serif", fontWeight:400, fontSize:24, marginBottom:12 }}>
        Account Blocked
      </h2>
      <p style={{ color:"rgba(255,255,255,0.85)", fontSize:14, lineHeight:1.6, maxWidth:320, marginBottom:28 }}>
        {message}
      </p>
      <button onClick={onDismiss} style={{
        padding:"13px 28px", borderRadius:12, border:"1.5px solid rgba(255,255,255,0.3)",
        background:"rgba(255,255,255,0.1)", color:"#FFFFFF", fontWeight:700, fontSize:14,
        cursor:"pointer", fontFamily:"'DM Sans', sans-serif",
      }}>
        Back to Sign In
      </button>
    </div>
  );
}

// ── Auth System ────────────────────────────────────────────────
// Simulated user store (in real app this is Supabase)
// User store removed — using real Supabase auth only
const USER_STORE = {};

function AuthScreen({ onAuth }) {
  const [screen, setScreen]         = useState("splash");
  const [accountType, setAccountType] = useState(null);
  const [email, setEmail]           = useState("");
  const [password, setPassword]     = useState("");
  const [name, setName]             = useState("");
  const [confirmPw, setConfirmPw]   = useState("");
  const [showPw, setShowPw]         = useState(false);
  const [showConfirmPw, setShowConfirmPw] = useState(false);
  const [loading, setLoading]       = useState(false);
  const [error, setError]           = useState("");
  const [resetSent, setResetSent]   = useState(false);
  // Real password-reset-from-email flow. Previously the recovery link would
  // redirect back here, the app would grab the access_token off the URL
  // hash and then just... throw it away — the banner said "enter a new
  // password below" but there was no such field anywhere, so the user was
  // dropped on the normal sign-in form with no way to actually set a new
  // password. Now the token is kept and used to call Supabase's real
  // update-password endpoint.
  const [recoveryToken, setRecoveryToken] = useState(null);
  const [newPw, setNewPw]           = useState("");
  const [newPwConfirm, setNewPwConfirm] = useState("");
  const [resettingPw, setResettingPw] = useState(false);
  const [resetPwError, setResetPwError] = useState("");
  const [resetPwDone, setResetPwDone] = useState(false);
  // Terms/Privacy links on the signup screen used to be dead <span onClick=
  // {()=>{}}> placeholders. LegalView (the real ToS/Privacy content used
  // elsewhere via navigate("terms")/navigate("privacy")) is a standalone
  // component that only needs {type, onBack}, so it's rendered here as a
  // full-screen overlay rather than threading real navigation into the
  // pre-auth screen.
  const [legalOverlay, setLegalOverlay] = useState(null); // null | 'terms' | 'privacy'
  // Referral code capture — pre-filled from a shared "Give $10, Get $10"
  // link (?ref=<referrerUserId>), but editable in case a friend just texted
  // the code instead of sending the link.
  const [referralCode, setReferralCode] = useState(() => {
    try {
      return new URLSearchParams(window.location.search).get('ref') || '';
    } catch {
      return '';
    }
  });

  // Supabase client
  const SUPABASE_URL = 'https://ksaealvsimnybueigmhd.supabase.co';
  const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtzYWVhbHZzaW1ueWJ1ZWlnbWhkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODY4NjExNzcsImV4cCI6MjEwMjQzNzE3N30.pQ6f2RidqF57AR1sXt2AGXpd-uuq6SbJXEryc6m1TCQ';

  const supabaseAuth = async (endpoint, body) => {
    const res = await fetch(`${SUPABASE_URL}/auth/v1/${endpoint}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'apikey': SUPABASE_KEY },
      body: JSON.stringify(body),
    });
    return res.json();
  };

  const inputStyle = {
    width:"100%", padding:"13px 16px", borderRadius:12,
    border:`1.5px solid ${error ? T.coral : T.border}`,
    fontSize:15, fontFamily:"'DM Sans', sans-serif",
    color:T.navy, outline:"none", boxSizing:"border-box",
    background:T.white, transition:"border 0.2s",
  };

  const validateEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
  const validatePw    = (p) => p.length >= 8 && /[A-Z]/.test(p) && /[0-9]/.test(p);

  // ── REAL LOGIN via Supabase ──
  const handleLogin = async () => {
    setError("");
    if (!validateEmail(email)) { setError("Please enter a valid email address."); return; }
    if (!password) { setError("Please enter your password."); return; }
    setLoading(true);

    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);

      const res = await fetch(`${SUPABASE_URL}/auth/v1/token?grant_type=password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'apikey': SUPABASE_KEY },
        body: JSON.stringify({ email, password }),
        signal: controller.signal,
      });
      clearTimeout(timeout);

      const data = await res.json();

      if (data.error || !data.access_token) {
        setLoading(false);
        setError(data.error_description || data.error || "Incorrect email or password.");
        return;
      }

      // Save the real session FIRST — every sbFetch/sbInsert/sbUpdate call
      // below (and everywhere else in the app from now on) authenticates as
      // this actual logged-in user instead of the shared anon key, which is
      // what lets "only your own row" database rules actually work.
      setSession({
        accessToken:  data.access_token,
        refreshToken: data.refresh_token,
        expiresIn:    data.expires_in,
        userId:       data.user.id,
      });

      // Get user profile
      try {
        const profileRes = await fetch(`${SUPABASE_URL}/rest/v1/users?id=eq.${data.user.id}&select=*`, {
          headers: { 'apikey': SUPABASE_KEY, 'Authorization': `Bearer ${data.access_token}` }
        });
        const profiles = await profileRes.json();
        let profile  = profiles?.[0];
        const resolvedType = profile?.user_type || accountType || 'homeowner';

        // A blocked account authenticates fine (Supabase Auth doesn't know
        // about our own `is_blocked` flag) but should never actually get
        // into the app — sign them back out immediately and show a clear
        // reason instead of a silent failure or letting them in anyway.
        if (profile?.is_blocked) {
          clearSession();
          setLoading(false);
          setError(profile.blocked_reason
            ? `Your account has been blocked: ${profile.blocked_reason}. Contact support@hirelocaly.com for help.`
            : "Your account has been blocked. Contact support@hirelocaly.com for more information.");
          return;
        }

        // Self-heal: this account authenticated fine, but has no `users`
        // row (and if they're a pro, maybe no `pro_profiles` row either) —
        // almost always because those inserts silently failed at signup
        // time before the database had a rule allowing them, or before a
        // real session token existed to sign the request with. Create
        // whatever's missing now, using this fresh, real, authenticated
        // token, so the account is actually usable going forward.
        if (!profile) {
          try {
            await sbInsert('users', { id: data.user.id, email: data.user.email, full_name: name || email.split('@')[0], user_type: resolvedType });
            profile = { full_name: name || email.split('@')[0], user_type: resolvedType };
          } catch (healErr) {
            console.log('Profile self-heal (users) error:', healErr.message);
          }
        }
        if (resolvedType === 'pro') {
          try {
            const proRows = await sbFetch('pro_profiles', `?user_id=eq.${data.user.id}&select=id`);
            if (!proRows || proRows.length === 0) {
              await sbInsert('pro_profiles', { user_id: data.user.id, city: 'The Woodlands', badge: 'Unverified', available: true });
            }
          } catch (healErr) {
            console.log('Profile self-heal (pro_profiles) error:', healErr.message);
          }
        }

        setLoading(false);
        onAuth(resolvedType, {
          name:  profile?.full_name || email.split('@')[0],
          email: data.user.email,
          id:    data.user.id,
          token: data.access_token,
          isAdmin: !!profile?.is_admin,
          onboarded: profile?.onboarded !== false,
        });
      } catch (profileFetchErr) {
        // This used to swallow the error silently — if this branch runs,
        // it also means the self-heal step above never ran (it's inside
        // the try block above this one), which would look identical to
        // "nothing happened" with no console output at all. Logging it
        // now so a failure here is actually visible instead of invisible.
        console.log('Profile fetch error (self-heal skipped):', profileFetchErr?.message || profileFetchErr);
        setLoading(false);
        onAuth(accountType || 'homeowner', {
          name:  email.split('@')[0],
          email: data.user.email,
          id:    data.user.id,
          token: data.access_token,
          onboarded: true,
        });
      }
    } catch (err) {
      setLoading(false);
      if (err.name === 'AbortError') {
        setError("Connection timed out. Check your internet and try again.");
      } else {
        setError("Connection error. Please try again.");
      }
    }
  };

    // ── REAL SIGNUP via Supabase ──
  const handleSignup = async () => {
    setError("");
    if (!accountType)           { setError("Please select Homeowner or Pro first."); return; }
    if (!name.trim())           { setError("Please enter your full name."); return; }
    if (!validateEmail(email))  { setError("Please enter a valid email address."); return; }
    if (!validatePw(password))  { setError("Password needs 8+ chars, one uppercase, one number."); return; }
    if (password !== confirmPw) { setError("Passwords do not match."); return; }
    setLoading(true);

    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);

      // 1. Create Supabase auth account
      // redirect_to tells Supabase where to send the user after they click the
      // confirmation link. It must also be added to Supabase Dashboard →
      // Authentication → URL Configuration → Redirect URLs, or Supabase will
      // silently ignore it and fall back to the project's default Site URL.
      const res = await fetch(`${SUPABASE_URL}/auth/v1/signup?redirect_to=${encodeURIComponent('https://hirelocaly.com/')}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'apikey': SUPABASE_KEY },
        body: JSON.stringify({
          email,
          password,
          data: { full_name: name, user_type: accountType },
        }),
        signal: controller.signal,
      });
      clearTimeout(timeout);

      const data = await res.json();

      if (data.error || data.msg) {
        setLoading(false);
        const errMsg = data.error_description || data.msg || data.error || "Signup failed.";
        if (errMsg.toLowerCase().includes('already registered')) {
          setError("This email is already registered. Please sign in instead.");
        } else {
          setError(errMsg);
        }
        return;
      }

      const userId = data.user?.id;
      const token  = data.access_token || data.session?.access_token || SUPABASE_KEY;

      // If Supabase auto-confirmed this signup (no separate email-click
      // step), a real session exists immediately — save it now so the
      // profile/pro_profile/referral inserts just below (and everything
      // else in the app afterward) authenticate as this real user instead
      // of the anon key. If email confirmation IS required, there's no
      // session yet; handleLogin's self-heal step covers creating these
      // rows once they confirm and log in for the first time.
      const realSession = data.session || (data.access_token ? data : null);
      if (realSession?.access_token && userId) {
        setSession({
          accessToken:  realSession.access_token,
          refreshToken: realSession.refresh_token,
          expiresIn:    realSession.expires_in,
          userId,
        });
      }

      // 2. Save user profile to users table
      if (userId) {
        try {
          await fetch(`${SUPABASE_URL}/rest/v1/users`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'apikey': SUPABASE_KEY,
              'Authorization': `Bearer ${token}`,
              'Prefer': 'return=minimal,resolution=ignore-duplicates',
            },
            body: JSON.stringify({
              id:        userId,
              email,
              full_name: name,
              user_type: accountType,
              onboarded: false,
            }),
          });

          // 3. If pro — create pro_profile row
          if (accountType === 'pro') {
            await fetch(`${SUPABASE_URL}/rest/v1/pro_profiles`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'apikey': SUPABASE_KEY,
                'Authorization': `Bearer ${token}`,
                'Prefer': 'return=minimal,resolution=ignore-duplicates',
              },
              body: JSON.stringify({
                user_id:  userId,
                city:     'The Woodlands',
                badge:    'Unverified',
                available: true,
              }),
            });
          }
        } catch (profileErr) {
          console.log('Profile save error (non-fatal):', profileErr);
        }

        // 4. If they signed up via a referral link, record it — reward is
        // unlocked later, once this new user completes their first payment
        // (see rewardReferralIfEligible, called from PaymentView's onSuccess).
        if (referralCode && referralCode !== userId) {
          try {
            await sbInsert('referrals', {
              referrer_id:    referralCode,
              referred_id:    userId,
              referral_code:  `SIGNUP-${userId.slice(0, 8)}-${Date.now().toString(36)}`,
              status:         'pending',
              reward_amount:  1000,
            });
          } catch (refErr) {
            console.log('Referral save error (non-fatal):', refErr);
          }
        }
      }

      setLoading(false);

      // Show verify screen or go straight in
      if (data.user && !data.session) {
        // Email confirmation required
        setScreen("verify");
      } else if (data.session) {
        // Auto-confirmed — go straight into app. onboarded:false triggers
        // the "how to use Localy" walkthrough the first time this brand-new
        // account lands in the app.
        onAuth(accountType, { name, email, id: userId, token, onboarded: false });
      } else {
        setScreen("verify");
      }

    } catch (err) {
      setLoading(false);
      if (err.name === 'AbortError') {
        setError("Connection timed out. Check your internet and try again.");
      } else {
        setError("Could not create account. Please try again.");
      }
    }
  };

  // ── VERIFY — user clicks the real link Supabase emailed them ──
  // Supabase's confirmation email contains a LINK, not a code — there is no
  // code to type in here. This screen just re-sends that link on request and
  // otherwise waits for the useEffect below to pick up the return trip.
  const [resendState, setResendState] = useState("idle"); // idle | sending | sent | error
  const [resendError, setResendError] = useState("");
  const handleResendVerification = async () => {
    if (!email) {
      setResendState("error");
      setResendError("Missing email address — go back and sign up again.");
      return;
    }
    setResendState("sending");
    setResendError("");
    try {
      const res = await fetch(
        `${SUPABASE_URL}/auth/v1/resend?redirect_to=${encodeURIComponent('https://hirelocaly.com/')}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'apikey': SUPABASE_KEY },
          body: JSON.stringify({ type: 'signup', email }),
        }
      );
      let data = null;
      try { data = await res.json(); } catch { /* non-JSON body */ }
      if (!res.ok) {
        // Surface Supabase's real reason (rate limit, already confirmed, etc.)
        // instead of hiding it — that's what made this "not work" silently before.
        const msg = data?.msg || data?.error_description || data?.error || `Resend failed (HTTP ${res.status}).`;
        throw new Error(msg);
      }
      setResendState("sent");
      // Let them click it again after a bit if it doesn't arrive
      setTimeout(() => setResendState("idle"), 30000);
    } catch (err) {
      setResendState("error");
      setResendError(err.message || "Couldn't resend right now — try again shortly.");
    }
  };

  // ── REAL PASSWORD RESET ──
  const handleForgotPassword = async (emailAddr) => {
    try {
      await supabaseAuth(`recover?redirect_to=${encodeURIComponent('https://hirelocaly.com/')}`, { email: emailAddr });
      setResetSent(true);
    } catch {
      setResetSent(true); // Show success either way for security
    }
  };

  // Actually sets the new password using the one-time recovery token from
  // the email link (Supabase's PUT /auth/v1/user, authenticated as that
  // token rather than a normal session — supabaseAuth() above only does
  // POST with the anon key, so this needs its own fetch call).
  const handleSetNewPassword = async () => {
    setResetPwError("");
    if (!validatePw(newPw)) { setResetPwError("Password must be at least 8 characters with 1 uppercase letter and 1 number."); return; }
    if (newPw !== newPwConfirm) { setResetPwError("Passwords don't match."); return; }
    setResettingPw(true);
    try {
      const res = await fetch(`${SUPABASE_URL}/auth/v1/user`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'apikey': SUPABASE_KEY,
          'Authorization': `Bearer ${recoveryToken}`,
        },
        body: JSON.stringify({ password: newPw }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data?.msg || data?.error_description || data?.error || `Couldn't update password (HTTP ${res.status}).`);
      }
      setRecoveryToken(null);
      setResetPwDone(true);
    } catch (err) {
      setResetPwError(err.message || "Couldn't update your password — the reset link may have expired. Request a new one.");
    } finally {
      setResettingPw(false);
    }
  };

  // ── HANDLE RETURN FROM EMAIL LINK ──
  // When a user clicks the confirmation link in their email, Supabase verifies
  // the token server-side and redirects back here with the result in the URL
  // hash: #access_token=...&type=signup (or type=recovery for password resets).
  // Without this, the link "does nothing" from the user's point of view.
  const [verifiedBanner, setVerifiedBanner] = useState(null);
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash || !hash.includes('access_token')) return;
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const token = params.get('access_token');
    const type  = params.get('type');
    const hashError = params.get('error_description');

    // Clean the token out of the URL either way so it isn't left visible/bookmarkable
    window.history.replaceState(null, '', window.location.pathname);

    if (hashError) {
      setError(decodeURIComponent(hashError.replace(/\+/g, ' ')));
      setScreen('login');
      return;
    }
    if (!token) return;

    if (type === 'signup' || type === 'invite') {
      setVerifiedBanner("✅ Email confirmed! You can now sign in.");
      setScreen('login');
    } else if (type === 'recovery') {
      setRecoveryToken(token);
    }
  }, []);

  // NOTE: Google/Apple/Facebook sign-in used to live here as a 1.2s fake
  // spinner that logged the user in as a fabricated "{provider} User" with
  // no real Supabase Auth session — nothing about that account would have
  // persisted. Real social login needs OAuth apps registered with Google/
  // Apple (a business/console step, not just code) and wired into
  // Supabase Auth providers, which hasn't been done yet. Removed the
  // buttons rather than ship a login flow that fakes a session — email/
  // password below is fully real.

  if (legalOverlay) return (
    <LegalView
      type={legalOverlay}
      onBack={() => setLegalOverlay(null)}
      onSwitch={() => setLegalOverlay(legalOverlay === 'terms' ? 'privacy' : 'terms')}
    />
  );

  // ── SPLASH ──
  if (screen === "splash") return (
    <div style={{ minHeight:"100vh", background:`linear-gradient(160deg, #0A2540 0%, #1565C0 55%, #0A9E6A 100%)`, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:32, fontFamily:"'DM Sans', sans-serif" }}>
      {/* Logo */}
      <div style={{ marginBottom:32, textAlign:"center" }}>

        <img src="data:image/png;base64,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" alt="Localy" style={{ width:200, objectFit:"contain", display:"block", margin:"0 auto 16px" }} />
        <p style={{ color:"rgba(255,255,255,0.6)", fontSize:14, marginTop:8 }}>Find. Hire. Get It Done.</p>
      </div>

      {/* Account type */}
      <div style={{ width:"100%", maxWidth:320, marginBottom:20 }}>
        <div style={{ fontSize:11, color:"rgba(255,255,255,0.5)", fontWeight:700, letterSpacing:"0.1em", textAlign:"center", marginBottom:14 }}>I AM A…</div>
        <div style={{ display:"flex", gap:12 }}>
          {[
            { type:"homeowner", icon:"homeowner_svg", label:"Homeowner", sub:"I need services" },
            { type:"pro",       icon:"pro_svg",       label:"Pro",       sub:"I offer services" },
          ].map(t => (
            <button key={t.type} onClick={() => setAccountType(t.type)} style={{
              flex:1, padding:"16px 12px", borderRadius:16, cursor:"pointer",
              background: accountType===t.type ? "rgba(255,255,255,0.2)" : "rgba(255,255,255,0.08)",
              border: `2px solid ${accountType===t.type ? "rgba(255,255,255,0.6)" : "rgba(255,255,255,0.15)"}`,
              fontFamily:"'DM Sans', sans-serif", textAlign:"center",
              transition:"all 0.2s",
            }}>
              <div style={{ width:72, height:72, margin:"0 auto 10px", borderRadius:20, background:"rgba(255,255,255,0.15)", display:"flex", alignItems:"center", justifyContent:"center" }}>
                {t.icon === "homeowner_svg" ? (
                  <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                    <polyline points="9 22 9 12 15 12 15 22"/>
                  </svg>
                ) : (
                  <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
                  </svg>
                )}
              </div>
              <div style={{ color:T.white, fontWeight:700, fontSize:15 }}>{t.label}</div>
              <div style={{ color:"rgba(255,255,255,0.5)", fontSize:12 }}>{t.sub}</div>
            </button>
          ))}
        </div>
      </div>

      {/* Auth buttons */}
      <div style={{ width:"100%", maxWidth:320, display:"flex", flexDirection:"column", gap:10 }}>
        <button onClick={() => { if(!accountType){setError("Please select Homeowner or Pro first.");return;} setError(""); setScreen("signup"); }}
          style={{ padding:"15px", borderRadius:12, border:"none", cursor:"pointer", background:T.white, color:T.navy, fontWeight:700, fontSize:15, fontFamily:"'DM Sans', sans-serif" }}>
          Create Account
        </button>
        <button onClick={() => { if(!accountType){setError("Please select Homeowner or Pro first.");return;} setError(""); setScreen("login"); }}
          style={{ padding:"15px", borderRadius:12, border:"1.5px solid rgba(255,255,255,0.3)", cursor:"pointer", background:"transparent", color:T.white, fontWeight:600, fontSize:15, fontFamily:"'DM Sans', sans-serif" }}>
          Sign In
        </button>
      </div>

      {error && <div style={{ color:T.coral, fontSize:13, marginTop:12, textAlign:"center", background:"rgba(232,81,42,0.15)", padding:"8px 16px", borderRadius:8 }}>{error}</div>}
    </div>
  );

  // ── SHARED HEADER ──
  const AuthHeader = ({ title, sub }) => (
    <div style={{ textAlign:"center", marginBottom:28 }}>
      <button onClick={() => { setScreen("splash"); setError(""); }} style={{ background:"none", border:"none", color:T.cobalt, cursor:"pointer", fontSize:14, fontWeight:600, fontFamily:"'DM Sans', sans-serif", display:"block", marginBottom:20 }}>← Back</button>
      <div style={{ fontSize:11, color:T.green, fontWeight:700, letterSpacing:"0.1em", marginBottom:6 }}>
        {accountType === "pro" ? "⚙️ PRO ACCOUNT" : "🏠 HOMEOWNER ACCOUNT"}
      </div>
      <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, fontSize:26, margin:"0 0 6px" }}>{title}</h2>
      <p style={{ color:T.slate, fontSize:14 }}>{sub}</p>
    </div>
  );

  const PwStrength = ({ pw }) => {
    const checks = [pw.length>=8, /[A-Z]/.test(pw), /[0-9]/.test(pw), /[^A-Za-z0-9]/.test(pw)];
    const score = checks.filter(Boolean).length;
    const labels = ["", "Weak", "Fair", "Good", "Strong"];
    const colors = ["", T.coral, T.amber, T.cobalt, T.green];
    if (!pw) return null;
    return (
      <div style={{ marginTop:6 }}>
        <div style={{ display:"flex", gap:4, marginBottom:4 }}>
          {[1,2,3,4].map(i => (
            <div key={i} style={{ flex:1, height:3, borderRadius:99, background: i<=score ? colors[score] : T.border, transition:"background 0.2s" }} />
          ))}
        </div>
        <div style={{ fontSize:11, color:colors[score], fontWeight:600 }}>{labels[score]}</div>
      </div>
    );
  };

  // ── SET NEW PASSWORD (landed here from the recovery email link) ──
  if (recoveryToken || resetPwDone) return (
    <div style={{ minHeight:"100vh", background:T.sand, padding:"60px 24px 24px", fontFamily:"'DM Sans', sans-serif" }}>
      <div style={{ maxWidth:360, margin:"0 auto" }}>
        {resetPwDone ? (
          <div style={{ textAlign:"center", padding:"40px 0" }}>
            <div style={{ fontSize:52, marginBottom:16 }}>✅</div>
            <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, marginBottom:8 }}>Password updated!</h2>
            <p style={{ color:T.slate, fontSize:14, lineHeight:1.6, maxWidth:280, margin:"0 auto 24px" }}>Your password has been changed. Sign in with your new password.</p>
            <button onClick={() => { setResetPwDone(false); setNewPw(""); setNewPwConfirm(""); setScreen("login"); }} style={{ padding:"12px 28px", borderRadius:12, border:"none", cursor:"pointer", background:T.cobalt, color:T.white, fontWeight:700, fontSize:14, fontFamily:"'DM Sans', sans-serif" }}>
              Back to Sign In
            </button>
          </div>
        ) : (
          <>
            <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, marginBottom:8 }}>Set a new password</h2>
            <p style={{ color:T.slate, fontSize:14, marginBottom:24, lineHeight:1.6 }}>Your identity is confirmed — choose a new password for your account.</p>
            <label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>NEW PASSWORD</label>
            <input value={newPw} onChange={e => { setNewPw(e.target.value); setResetPwError(""); }}
              placeholder="Min 8 chars, 1 uppercase, 1 number" type="password" style={{ ...inputStyle, marginBottom:6 }} />
            <PwStrength pw={newPw} />
            <div style={{ height:8 }} />
            <label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>CONFIRM NEW PASSWORD</label>
            <input value={newPwConfirm} onChange={e => { setNewPwConfirm(e.target.value); setResetPwError(""); }}
              placeholder="Re-enter password" type="password" style={{ ...inputStyle, marginBottom:14 }} />
            {resetPwError && <div style={{ background:T.coralL, color:T.coral, fontSize:13, padding:"10px 14px", borderRadius:10, fontWeight:600, marginBottom:14 }}>⚠️ {resetPwError}</div>}
            <button onClick={handleSetNewPassword} disabled={resettingPw} style={{ width:"100%", padding:"15px", borderRadius:12, border:"none", cursor:"pointer", background:`linear-gradient(135deg, #1565C0, #0A9E6A)`, color:T.white, fontWeight:700, fontSize:15, fontFamily:"'DM Sans', sans-serif", opacity:resettingPw?0.7:1 }}>
              {resettingPw ? "⏳ Updating…" : "Set New Password"}
            </button>
          </>
        )}
      </div>
    </div>
  );

  // ── LOGIN ──
  if (screen === "login") return (
    <div style={{ minHeight:"100vh", background:T.sand, padding:"40px 24px 24px", fontFamily:"'DM Sans', sans-serif" }}>
      <AuthHeader title="Welcome back" sub="Sign in to your Localy account" />
      <div style={{ display:"flex", flexDirection:"column", gap:14, maxWidth:360, margin:"0 auto" }}>
        {verifiedBanner && (
          <div style={{ background:T.greenL, color:T.green, fontSize:13, padding:"10px 14px", borderRadius:10, fontWeight:600 }}>
            {verifiedBanner}
          </div>
        )}
        <div>
          <label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>EMAIL ADDRESS</label>
          <input value={email} onChange={e => { setEmail(e.target.value); setError(""); }}
            placeholder="you@email.com" type="email" style={inputStyle} />
        </div>
        <div>
          <label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>PASSWORD</label>
          <div style={{ position:"relative" }}>
            <input value={password} onChange={e => { setPassword(e.target.value); setError(""); }}
              placeholder="Your password" type={showPw ? "text" : "password"} style={{ ...inputStyle, paddingRight:44 }} />
            <button type="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setShowPw(prev => !prev); }} style={{ position:"absolute", right:14, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", fontSize:16, color:T.slate, zIndex:10 }}>
              {showPw ? "🙈" : "👁️"}
            </button>
          </div>
        </div>
        <button onClick={() => setScreen("forgot")} style={{ background:"none", border:"none", color:T.cobalt, cursor:"pointer", fontSize:13, fontWeight:600, textAlign:"right", fontFamily:"'DM Sans', sans-serif", padding:0 }}>
          Forgot password?
        </button>
        {error && <div style={{ background:T.coralL, color:T.coral, fontSize:13, padding:"10px 14px", borderRadius:10, fontWeight:600 }}>⚠️ {error}</div>}
        <button onClick={handleLogin} disabled={loading} style={{ padding:"15px", borderRadius:12, border:"none", cursor:"pointer", background:`linear-gradient(135deg, #1565C0, #0A9E6A)`, color:T.white, fontWeight:700, fontSize:15, fontFamily:"'DM Sans', sans-serif", opacity: loading ? 0.7 : 1 }}>
          {loading ? "⏳ Signing in…" : "Sign In"}
        </button>

        <div style={{ textAlign:"center", fontSize:13, color:T.slate }}>
          Don't have an account?{" "}
          <button onClick={() => { setScreen("splash"); setError(""); }} style={{ background:"none", border:"none", color:T.cobalt, fontWeight:700, cursor:"pointer", fontFamily:"'DM Sans', sans-serif", fontSize:13 }}>Sign up</button>
        </div>

      </div>
    </div>
  );

  // ── SIGNUP ──
  if (screen === "signup") return (
    <div style={{ minHeight:"100vh", background:T.sand, padding:"40px 24px 24px", fontFamily:"'DM Sans', sans-serif" }}>
      <AuthHeader title="Create account" sub="Join thousands of Localy users" />
      <div style={{ display:"flex", flexDirection:"column", gap:14, maxWidth:360, margin:"0 auto" }}>
        <div>
          <label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>FULL NAME</label>
          <input value={name} onChange={e => { setName(e.target.value); setError(""); }} placeholder="Your full name" style={inputStyle} />
        </div>
        <div>
          <label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>EMAIL ADDRESS</label>
          <input value={email} onChange={e => { setEmail(e.target.value); setError(""); }} placeholder="you@email.com" type="email" style={inputStyle} />
        </div>
        <div>
          <label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>PASSWORD</label>
          <div style={{ position:"relative" }}>
            <input value={password} onChange={e => { setPassword(e.target.value); setError(""); }}
              placeholder="Min 8 chars, 1 uppercase, 1 number" type={showPw ? "text" : "password"} style={{ ...inputStyle, paddingRight:44 }} />
            <button type="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setShowPw(prev => !prev); }} style={{ position:"absolute", right:14, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", fontSize:16, color:T.slate, zIndex:10 }}>
              {showPw ? "🙈" : "👁️"}
            </button>
          </div>
          <PwStrength pw={password} />
        </div>
        <div>
          <label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>CONFIRM PASSWORD</label>
          <input value={confirmPw} onChange={e => { setConfirmPw(e.target.value); setError(""); }}
            placeholder="Re-enter password" type="password" style={{ ...inputStyle, border:`1.5px solid ${confirmPw && confirmPw !== password ? T.coral : confirmPw && confirmPw === password ? T.green : T.border}` }} />
          {confirmPw && confirmPw === password && <div style={{ fontSize:11, color:T.green, fontWeight:600, marginTop:4 }}>✓ Passwords match</div>}
        </div>

        <div>
          <label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>REFERRAL CODE (OPTIONAL)</label>
          <input value={referralCode} onChange={e => setReferralCode(e.target.value.trim())} placeholder="Paste a friend's referral code" style={inputStyle} />
          {referralCode && (
            <div style={{ fontSize:11, color:T.green, fontWeight:600, marginTop:4 }}>🎁 You'll get $10 off your first booking</div>
          )}
        </div>

        {/* Terms */}
        <div style={{ fontSize:12, color:T.slate, lineHeight:1.5 }}>
          By signing up you agree to Localy's{" "}
          <span onClick={() => setLegalOverlay('terms')} style={{ color:T.cobalt, fontWeight:600, cursor:"pointer", textDecoration:"underline" }}>Terms of Service</span> and{" "}
          <span onClick={() => setLegalOverlay('privacy')} style={{ color:T.cobalt, fontWeight:600, cursor:"pointer", textDecoration:"underline" }}>Privacy Policy</span>.
        </div>

        {error && <div style={{ background:T.coralL, color:T.coral, fontSize:13, padding:"10px 14px", borderRadius:10, fontWeight:600 }}>⚠️ {error}</div>}

        <button onClick={handleSignup} disabled={loading} style={{ padding:"15px", borderRadius:12, border:"none", cursor:"pointer", background:`linear-gradient(135deg, #1565C0, #0A9E6A)`, color:T.white, fontWeight:700, fontSize:15, fontFamily:"'DM Sans', sans-serif", opacity:loading ? 0.7 : 1 }}>
          {loading ? "⏳ Creating account…" : "Create Account →"}
        </button>

        <div style={{ textAlign:"center", fontSize:13, color:T.slate }}>
          Already have an account?{" "}
          <button onClick={() => { setScreen("login"); setError(""); }} style={{ background:"none", border:"none", color:T.cobalt, fontWeight:700, cursor:"pointer", fontFamily:"'DM Sans', sans-serif", fontSize:13 }}>Sign in</button>
        </div>
      </div>
    </div>
  );

  // ── EMAIL VERIFY ──
  if (screen === "verify") return (
    <div style={{ minHeight:"100vh", background:T.sand, padding:"60px 24px 24px", fontFamily:"'DM Sans', sans-serif", textAlign:"center" }}>
      <div style={{ fontSize:52, marginBottom:16 }}>📧</div>
      <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, marginBottom:8 }}>Check your email</h2>
      <p style={{ color:T.slate, fontSize:14, marginBottom:8, lineHeight:1.6 }}>We sent a confirmation link to</p>
      <p style={{ color:T.navy, fontWeight:700, fontSize:16, marginBottom:28 }}>{email}</p>

      <div style={{ maxWidth:300, margin:"0 auto" }}>
        <div style={{ background:T.cobaltL, borderRadius:10, padding:"14px", fontSize:13, color:T.cobalt, marginBottom:20, lineHeight:1.5 }}>
          📧 Open the email from Localy and click <strong>Confirm your email</strong>. It'll bring you right back here, signed in. Check spam if you don't see it within a couple minutes.
        </div>

        {error && <div style={{ background:T.coralL, color:T.coral, fontSize:13, padding:"10px 14px", borderRadius:10, fontWeight:600, marginBottom:14 }}>⚠️ {error}</div>}

        <button onClick={() => setScreen("login")} style={{ width:"100%", padding:"15px", borderRadius:12, border:"none", cursor:"pointer", background:`linear-gradient(135deg, #1565C0, #0A9E6A)`, color:T.white, fontWeight:700, fontSize:15, fontFamily:"'DM Sans', sans-serif", marginBottom:14 }}>
          I've confirmed — Sign In
        </button>

        <button onClick={handleResendVerification} disabled={resendState === "sending"} style={{ background:"none", border:"none", color:T.cobalt, cursor:"pointer", fontSize:13, fontWeight:600, fontFamily:"'DM Sans', sans-serif" }}>
          {resendState === "sending" ? "Sending…" : resendState === "sent" ? "✓ Email resent" : "Resend confirmation email"}
        </button>
        {resendState === "error" && <div style={{ color:T.coral, fontSize:12, marginTop:8 }}>{resendError}</div>}
      </div>
    </div>
  );

  // ── FORGOT PASSWORD ──
  if (screen === "forgot") return (
    <div style={{ minHeight:"100vh", background:T.sand, padding:"60px 24px 24px", fontFamily:"'DM Sans', sans-serif" }}>
      <button onClick={() => { setScreen("login"); setError(""); setResetSent(false); }} style={{ background:"none", border:"none", color:T.cobalt, cursor:"pointer", fontSize:14, fontWeight:600, fontFamily:"'DM Sans', sans-serif", marginBottom:24, display:"block" }}>← Back to Sign In</button>

      {resetSent ? (
        <div style={{ textAlign:"center", padding:"40px 0" }}>
          <div style={{ fontSize:52, marginBottom:16 }}>✅</div>
          <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, marginBottom:8 }}>Reset link sent!</h2>
          <p style={{ color:T.slate, fontSize:14, lineHeight:1.6, maxWidth:280, margin:"0 auto 24px" }}>Check your inbox at <strong>{email}</strong> for a password reset link.</p>
          <button onClick={() => { setScreen("login"); setResetSent(false); }} style={{ padding:"12px 28px", borderRadius:12, border:"none", cursor:"pointer", background:T.cobalt, color:T.white, fontWeight:700, fontSize:14, fontFamily:"'DM Sans', sans-serif" }}>
            Back to Sign In
          </button>
        </div>
      ) : (
        <div style={{ maxWidth:360, margin:"0 auto" }}>
          <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, marginBottom:8 }}>Forgot password?</h2>
          <p style={{ color:T.slate, fontSize:14, marginBottom:24, lineHeight:1.6 }}>No worries. Enter your email and we'll send you a reset link.</p>
          <label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>EMAIL ADDRESS</label>
          <input value={email} onChange={e => { setEmail(e.target.value); setError(""); }}
            placeholder="you@email.com" type="email" style={{ ...inputStyle, marginBottom:14 }} />
          {error && <div style={{ background:T.coralL, color:T.coral, fontSize:13, padding:"10px 14px", borderRadius:10, fontWeight:600, marginBottom:14 }}>⚠️ {error}</div>}
          <button onClick={() => {
            if (!validateEmail(email)) { setError("Please enter a valid email."); return; }
            setLoading(true);
            handleForgotPassword(email).then(() => { setLoading(false); });
          }} disabled={loading} style={{ width:"100%", padding:"15px", borderRadius:12, border:"none", cursor:"pointer", background:`linear-gradient(135deg, #1565C0, #0A9E6A)`, color:T.white, fontWeight:700, fontSize:15, fontFamily:"'DM Sans', sans-serif", opacity:loading?0.7:1 }}>
            {loading ? "⏳ Sending…" : "Send Reset Link"}
          </button>
        </div>
      )}
    </div>
  );

  return null;
}


// ── In-App Review Prompt System ────────────────────────────────
function ReviewPrompt({ pro, trigger, bookingId, authUser, onDone, onSkip }) {
  const [step, setStep]         = useState("prompt");  // prompt | rating | details | thanks
  const [rating, setRating]     = useState(0);
  const [hover, setHover]       = useState(0);
  const [review, setReview]     = useState("");
  const [tags, setTags]         = useState([]);
  const [tipAmount, setTipAmount] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [linkCopied, setLinkCopied] = useState(false);

  // Share-with-a-neighbor row on the thanks screen — same referral link
  // pattern as ReferralsView (?ref=<user id>), just reused here since a
  // fresh review is a natural moment to prompt a share too.
  const referralLink = authUser?.id
    ? `https://hirelocaly.com/?ref=${authUser.id}`
    : "https://hirelocaly.com/";
  const shareText = `I've been using Localy to book home services in The Woodlands — use my link and we both get $10: ${referralLink}`;
  const handleShareText = () => {
    window.location.href = `sms:&body=${encodeURIComponent(shareText)}`;
  };
  const handleShareFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralLink)}`, '_blank', 'noopener,noreferrer');
  };
  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(referralLink);
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000);
    } catch {
      setLinkCopied(false);
    }
  };

  const QUICK_TAGS = [
    "On time", "Great work", "Very clean", "Professional",
    "Fair price", "Friendly", "Would hire again", "Went above & beyond"
  ];

  const TIP_OPTIONS = [0, 5, 10, 15, 20];

  // Only a real booking (real pro, real homeowner, real UUID booking id)
  // can actually be persisted — the RLS policy on `reviews` checks the
  // booking really belongs to this homeowner/pro pair, so a mismatched or
  // mock id would just fail quietly server-side anyway. Same real-vs-mock
  // guard used everywhere else in this file.
  const canPersist = !!(bookingId && authUser?.id && pro?.id && typeof pro.id === 'string');

  const handleSubmit = async () => {
    setSubmitting(true);
    setSubmitError("");
    try {
      if (canPersist) {
        await sbInsert('reviews', {
          booking_id:    bookingId,
          pro_id:        pro.id,
          homeowner_id:  authUser.id,
          reviewer_role: 'homeowner',
          rating,
          review_text:   review || null,
          tags,
          tip_amount:    tipAmount || null,
        });
      }
      setStep("thanks");
    } catch (err) {
      // Don't trap the homeowner behind a broken submit button — surface
      // the error but still let them dismiss the prompt.
      setSubmitError(err.message || "Could not save your review.");
      setStep("thanks");
    } finally {
      setSubmitting(false);
    }
  };

  const toggleTag = (tag) => setTags(prev =>
    prev.includes(tag) ? prev.filter(t => t !== tag) : [...prev, tag]
  );

  // ── INITIAL PROMPT ──
  if (step === "prompt") return (
    <div style={{
      position:"fixed", inset:0, background:"rgba(10,37,64,0.6)",
      display:"flex", alignItems:"flex-end", justifyContent:"center",
      zIndex:999, fontFamily:"'DM Sans', sans-serif",
    }}>
      <div style={{
        background:T.white, borderRadius:"20px 20px 0 0",
        padding:"8px 0 32px", width:"100%", maxWidth:420,
        animation:"slideUp 0.3s ease",
      }}>
        {/* Handle bar */}
        <div style={{ width:40, height:4, borderRadius:99, background:T.border, margin:"12px auto 20px" }} />

        <div style={{ padding:"0 24px", textAlign:"center" }}>
          <div style={{ width:64, height:64, borderRadius:"50%", background:`linear-gradient(135deg, #1565C0, #0A9E6A)`, display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 16px" }}>
            <Avatar initials={pro?.img || "PR"} size={64} color="transparent" />
          </div>
          <h3 style={{ color:T.navy, fontSize:20, fontWeight:700, marginBottom:8 }}>
            How was {pro?.name || "your pro"}?
          </h3>
          <p style={{ color:T.slate, fontSize:14, lineHeight:1.6, marginBottom:24 }}>
            {trigger === "payment"
              ? "Your job is complete! Take a moment to rate your experience."
              : trigger === "24hr"
              ? "It's been 24 hours since your service. How did it go?"
              : "Your booking is done. Let other homeowners know how it went!"}
          </p>

          {/* Quick star tap */}
          <div style={{ display:"flex", gap:8, justifyContent:"center", marginBottom:24 }}>
            {[1,2,3,4,5].map(s => (
              <span key={s} onClick={() => { setRating(s); setStep("rating"); }}
                onMouseEnter={() => setHover(s)} onMouseLeave={() => setHover(0)}
                style={{ fontSize:44, cursor:"pointer", transition:"transform 0.1s", transform: s <= (hover||rating) ? "scale(1.15)" : "scale(1)", color: s <= (hover||rating) ? "#F59E0B" : T.border }}>
                ★
              </span>
            ))}
          </div>

          <div style={{ display:"flex", gap:10 }}>
            <Btn label="Leave a Review" onClick={() => setStep("rating")} />
            <Btn label="Not Now" variant="ghost" onClick={onSkip} small />
          </div>
        </div>
      </div>
    </div>
  );

  // ── RATING + DETAILS ──
  if (step === "rating") return (
    <div style={{
      position:"fixed", inset:0, background:"rgba(10,37,64,0.6)",
      display:"flex", alignItems:"flex-end", justifyContent:"center",
      zIndex:999, fontFamily:"'DM Sans', sans-serif", overflowY:"auto",
    }}>
      <div style={{
        background:T.white, borderRadius:"20px 20px 0 0",
        padding:"8px 0 32px", width:"100%", maxWidth:420,
        maxHeight:"90vh", overflowY:"auto",
      }}>
        <div style={{ width:40, height:4, borderRadius:99, background:T.border, margin:"12px auto 20px" }} />

        <div style={{ padding:"0 20px" }}>
          {/* Pro info */}
          <div style={{ display:"flex", gap:12, alignItems:"center", marginBottom:20 }}>
            <Avatar initials={pro?.img || "PR"} size={44} />
            <div>
              <div style={{ fontWeight:700, fontSize:15, color:T.navy }}>{pro?.name || "Your Pro"}</div>
              <div style={{ fontSize:12, color:T.slate }}>{pro?.rate} · {CATEGORIES.find(c=>c.id===pro?.cat)?.label || "Service"}</div>
            </div>
          </div>

          {/* Star rating */}
          <div style={{ textAlign:"center", marginBottom:16 }}>
            <div style={{ fontSize:13, fontWeight:700, color:T.slate, letterSpacing:"0.08em", marginBottom:10 }}>YOUR RATING</div>
            <div style={{ display:"flex", gap:6, justifyContent:"center", marginBottom:8 }}>
              {[1,2,3,4,5].map(s => (
                <span key={s} onClick={() => setRating(s)}
                  onMouseEnter={() => setHover(s)} onMouseLeave={() => setHover(0)}
                  style={{ fontSize:40, cursor:"pointer", color: s<=(hover||rating) ? "#F59E0B" : T.border, transition:"color 0.1s" }}>
                  ★
                </span>
              ))}
            </div>
            <div style={{ fontSize:14, fontWeight:700, color:T.navy }}>
              {rating === 0 ? "Tap to rate" : rating === 1 ? "😞 Poor" : rating === 2 ? "😕 Fair" : rating === 3 ? "😊 Good" : rating === 4 ? "😄 Great!" : "🤩 Excellent!"}
            </div>
          </div>

          {/* Quick tags */}
          {rating >= 3 && (
            <div style={{ marginBottom:16 }}>
              <div style={{ fontSize:12, fontWeight:700, color:T.slate, letterSpacing:"0.08em", marginBottom:10 }}>WHAT STOOD OUT?</div>
              <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
                {QUICK_TAGS.map(tag => (
                  <button key={tag} onClick={() => toggleTag(tag)} style={{
                    padding:"6px 14px", borderRadius:99, cursor:"pointer", fontSize:12, fontWeight:600,
                    background: tags.includes(tag) ? T.green : T.sand,
                    color: tags.includes(tag) ? T.white : T.navy,
                    border:`1.5px solid ${tags.includes(tag) ? T.green : T.border}`,
                    fontFamily:"'DM Sans', sans-serif",
                  }}>{tags.includes(tag) ? "✓ " : ""}{tag}</button>
                ))}
              </div>
            </div>
          )}

          {/* Written review */}
          <div style={{ marginBottom:16 }}>
            <div style={{ fontSize:12, fontWeight:700, color:T.slate, letterSpacing:"0.08em", marginBottom:8 }}>WRITE A REVIEW <span style={{ fontWeight:400, color:T.slate }}>(optional)</span></div>
            <textarea value={review} onChange={e => setReview(e.target.value)}
              placeholder={rating >= 4 ? "What made this experience great?" : rating > 0 ? "What could have been better?" : "Share your experience…"}
              rows={3} style={{ width:"100%", padding:"10px 12px", borderRadius:10, border:`1.5px solid ${T.border}`, fontSize:14, fontFamily:"'DM Sans', sans-serif", resize:"none", outline:"none", boxSizing:"border-box", lineHeight:1.5 }} />
            <div style={{ textAlign:"right", fontSize:11, color:T.slate, marginTop:4 }}>{review.length}/300</div>
          </div>

          {/* Tip section */}
          {rating >= 4 && (
            <div style={{ background:T.sand, borderRadius:14, padding:14, marginBottom:16 }}>
              <div style={{ fontSize:12, fontWeight:700, color:T.slate, letterSpacing:"0.08em", marginBottom:10 }}>ADD A TIP? 💰</div>
              <div style={{ display:"flex", gap:8 }}>
                {TIP_OPTIONS.map(t => (
                  <button key={t} onClick={() => setTipAmount(t)} style={{
                    flex:1, padding:"8px 0", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:700,
                    background: tipAmount === t ? T.navy : T.white,
                    color: tipAmount === t ? T.white : T.navy,
                    border:`1.5px solid ${tipAmount === t ? T.navy : T.border}`,
                    fontFamily:"'DM Sans', sans-serif",
                  }}>{t === 0 ? "No tip" : `$${t}`}</button>
                ))}
              </div>
              {tipAmount > 0 && <div style={{ fontSize:12, color:T.slate, marginTop:8, textAlign:"center" }}>100% of tips go directly to {pro?.name?.split(" ")[0] || "your pro"} 💚</div>}
            </div>
          )}

          {/* Submit */}
          <button onClick={handleSubmit} disabled={rating === 0 || submitting} style={{
            width:"100%", padding:"15px", borderRadius:12, border:"none",
            background: rating > 0 ? `linear-gradient(135deg, #1565C0, #0A9E6A)` : T.border,
            color:T.white, fontWeight:700, fontSize:15, cursor: rating > 0 ? "pointer" : "not-allowed",
            fontFamily:"'DM Sans', sans-serif", marginBottom:10, opacity: submitting ? 0.7 : 1,
          }}>
            {submitting ? "⏳ Submitting…" : tipAmount > 0 ? `Submit Review & Tip $${tipAmount}` : "Submit Review"}
          </button>
          <button onClick={onSkip} style={{ width:"100%", padding:"10px", background:"none", border:"none", color:T.slate, cursor:"pointer", fontFamily:"'DM Sans', sans-serif", fontSize:13 }}>
            Skip for now
          </button>
        </div>
      </div>
    </div>
  );

  // ── THANK YOU ──
  if (step === "thanks") return (
    <div style={{
      position:"fixed", inset:0, background:"rgba(10,37,64,0.7)",
      display:"flex", alignItems:"center", justifyContent:"center",
      zIndex:999, fontFamily:"'DM Sans', sans-serif", padding:24,
    }}>
      <div style={{ background:T.white, borderRadius:24, padding:36, textAlign:"center", maxWidth:340, width:"100%", boxShadow:"0 20px 60px rgba(0,0,0,0.3)" }}>
        <div style={{ fontSize:64, marginBottom:16 }}>🎉</div>
        <h3 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, fontSize:24, marginBottom:8 }}>
          Thanks for your review!
        </h3>
        <p style={{ color:T.slate, fontSize:14, lineHeight:1.6, marginBottom:8 }}>
          Your {rating}★ review helps other homeowners in The Woodlands find great pros.
        </p>
        {submitError && (
          <div style={{ background:T.coralL, color:T.coral, borderRadius:10, padding:"10px 14px", fontSize:12, marginBottom:16, textAlign:"left" }}>
            ⚠️ Your rating wasn't saved: {submitError}
          </div>
        )}
        {tipAmount > 0 && (
          <div style={{ background:T.greenL, borderRadius:10, padding:"10px 14px", fontSize:13, color:T.green, fontWeight:600, marginBottom:16 }}>
            💚 ${tipAmount} tip sent to {pro?.name?.split(" ")[0] || "your pro"}!
          </div>
        )}
        {tags.length > 0 && (
          <div style={{ display:"flex", flexWrap:"wrap", gap:6, justifyContent:"center", marginBottom:20 }}>
            {tags.map(tag => (
              <span key={tag} style={{ background:T.cobaltL, color:T.cobalt, fontSize:11, fontWeight:700, padding:"3px 10px", borderRadius:99 }}>✓ {tag}</span>
            ))}
          </div>
        )}

        {/* Share prompt */}
        <div style={{ background:T.sand, borderRadius:12, padding:14, marginBottom:20 }}>
          <div style={{ fontSize:13, fontWeight:700, color:T.navy, marginBottom:6 }}>Share Localy with a neighbor?</div>
          <div style={{ fontSize:12, color:T.slate, marginBottom:10 }}>You get $10 off your next booking for every friend who signs up!</div>
          <div style={{ display:"flex", gap:8 }}>
            <button onClick={handleShareText} style={{ flex:1, padding:"7px 4px", borderRadius:8, border:`1px solid ${T.border}`, background:T.white, fontSize:11, fontWeight:600, cursor:"pointer", color:T.navy, fontFamily:"'DM Sans', sans-serif" }}>📱 Text</button>
            <button onClick={handleShareFacebook} style={{ flex:1, padding:"7px 4px", borderRadius:8, border:`1px solid ${T.border}`, background:T.white, fontSize:11, fontWeight:600, cursor:"pointer", color:T.navy, fontFamily:"'DM Sans', sans-serif" }}>📘 Facebook</button>
            <button onClick={handleCopyLink} style={{ flex:1, padding:"7px 4px", borderRadius:8, border:`1px solid ${T.border}`, background:T.white, fontSize:11, fontWeight:600, cursor:"pointer", color:T.navy, fontFamily:"'DM Sans', sans-serif" }}>{linkCopied ? "✅ Copied!" : "📋 Copy Link"}</button>
          </div>
        </div>

        <Btn label="Done ✓" onClick={onDone} />
      </div>
    </div>
  );

  return null;
}

// ── Review Trigger Hook ─────────────────────────────────────────
function useReviewPrompt() {
  const [pendingReview, setPendingReview] = useState(null); // { pro, trigger, bookingId }
  const [dismissed, setDismissed]        = useState([]);

  const triggerReview = (pro, trigger = "manual", bookingId = null) => {
    if (dismissed.includes(pro?.id)) return;
    setPendingReview({ pro, trigger, bookingId });
  };

  const dismissReview = (proId) => {
    setPendingReview(null);
    if (proId) setDismissed(prev => [...prev, proId]);
  };

  return { pendingReview, triggerReview, dismissReview };
}


// ── Terms of Service & Privacy Policy ─────────────────────────
function LegalView({ type, onBack, onSwitch }) {
  const isTerms = type === "terms";

  const TERMS = [
    {
      title: "1. Acceptance of Terms",
      body: "By accessing or using the Localy platform (\"App\"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the App. These terms apply to all users, including homeowners and service professionals (\"Pros\")."
    },
    {
      title: "2. Description of Service",
      body: "Localy is a two-sided marketplace that connects homeowners with independent local service professionals. Localy does not employ Pros directly. Pros are independent contractors responsible for their own work, licensing, insurance, and tax obligations."
    },
    {
      title: "3. User Accounts",
      body: "You must create an account to use Localy. You are responsible for maintaining the confidentiality of your login credentials and for all activity under your account. You must be at least 18 years old to use the App. Localy reserves the right to suspend or terminate accounts that violate these terms."
    },
    {
      title: "4. Bookings & Payments",
      body: "All payments are processed securely through Stripe. Localy collects a 12% service fee on each completed transaction. Homeowners are charged after job completion. Pros receive payment within 2–5 business days after a job is marked complete. Localy is not responsible for disputes arising from work quality — see our Dispute Resolution section."
    },
    {
      title: "5. Cancellation Policy",
      body: "Homeowners may cancel a booking free of charge up to 24 hours before the scheduled start time. Cancellations within 24 hours may incur a fee of up to 25% of the quoted price. Pros who cancel within 12 hours of a job are subject to account penalties including suspension."
    },
    {
      title: "6. Pro Responsibilities",
      body: "Pros must maintain valid licenses and insurance required for their trade. Pros agree to arrive on time, perform work professionally, and communicate clearly with homeowners. Pros are responsible for their own tools, materials, and transportation. Localy may remove Pros who receive consistently low ratings or generate complaints."
    },
    {
      title: "7. Dispute Resolution",
      body: "If a dispute arises between a homeowner and a Pro, both parties should first attempt to resolve it directly. If unresolved within 48 hours, either party may contact Localy support. Localy will review the case and may issue full or partial refunds at its discretion. Localy's decision is final."
    },
    {
      title: "8. Prohibited Conduct",
      body: "You agree not to: use the App for any illegal purpose; harass, threaten, or harm other users; submit false reviews or ratings; attempt to circumvent Localy's payment system by transacting off-platform; or use automated tools to scrape or access the App."
    },
    {
      title: "9. Limitation of Liability",
      body: "To the fullest extent permitted by law, Localy shall not be liable for any indirect, incidental, or consequential damages arising from your use of the App, including but not limited to property damage, personal injury, or loss of income resulting from services arranged through the platform."
    },
    {
      title: "10. Changes to Terms",
      body: "Localy reserves the right to update these Terms of Service at any time. We will notify users of material changes via email or in-app notification. Continued use of the App after changes constitutes acceptance of the new terms."
    },
    {
      title: "11. Governing Law",
      body: "These Terms are governed by the laws of the State of Texas, without regard to its conflict of law provisions. Any disputes shall be resolved in the courts of Montgomery County, Texas."
    },
    {
      title: "12. Contact Us",
      body: "For questions about these Terms, contact us at legal@localy.app or write to: Localy Inc., The Woodlands, TX 77380."
    },
  ];

  const PRIVACY = [
    {
      title: "1. Information We Collect",
      body: "We collect information you provide directly: name, email address, phone number, profile photo, service area, and payment information. We also collect usage data such as pages viewed, bookings made, and interactions within the App. Location data is collected only when you grant permission."
    },
    {
      title: "2. How We Use Your Information",
      body: "We use your information to: operate and improve the Localy platform; match homeowners with nearby Pros; process payments and send receipts; send booking confirmations and service updates; display your profile to other users; and comply with legal obligations."
    },
    {
      title: "3. Location Data",
      body: "Localy requests access to your device's location to show nearby Pros and display your position on the map. Location is only accessed when the App is in use and only if you grant permission. You can revoke location access at any time in your device settings. We do not store precise location history."
    },
    {
      title: "4. How We Share Your Information",
      body: "We share your information only as necessary: with the Pro you book (name, address, job details); with Stripe for payment processing; with Checkr for background checks (Pros only); with service providers who help us operate the App; and as required by law. We never sell your personal data to third parties."
    },
    {
      title: "5. Payment Information",
      body: "All payment information is handled by Stripe, a PCI-DSS Level 1 certified payment processor. Localy never stores your full credit card number. Stripe's privacy policy governs how your payment data is used and protected."
    },
    {
      title: "6. Data Retention",
      body: "We retain your account information for as long as your account is active or as needed to provide services. You may request deletion of your account and personal data at any time by contacting privacy@localy.app. Certain records may be retained for legal compliance purposes."
    },
    {
      title: "7. Cookies & Tracking",
      body: "The Localy App uses cookies and similar technologies to maintain your session, remember preferences, and analyze usage. You can control cookie settings through your browser or device. We do not use cookies for targeted advertising."
    },
    {
      title: "8. Children's Privacy",
      body: "Localy is not intended for users under the age of 18. We do not knowingly collect personal information from minors. If you believe a minor has created an account, please contact us immediately at privacy@localy.app."
    },
    {
      title: "9. Security",
      body: "We use industry-standard security measures including 256-bit SSL encryption, secure data storage, and regular security audits to protect your information. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security."
    },
    {
      title: "10. Your Rights",
      body: "Depending on your location, you may have rights to: access the personal data we hold about you; correct inaccurate data; request deletion of your data; opt out of marketing communications; and data portability. To exercise these rights, contact privacy@localy.app."
    },
    {
      title: "11. Third-Party Links",
      body: "The App may contain links to third-party websites or services. Localy is not responsible for the privacy practices of those sites. We encourage you to review the privacy policies of any third-party services you use."
    },
    {
      title: "12. Changes to This Policy",
      body: "We may update this Privacy Policy from time to time. We will notify you of significant changes via email or in-app notification. The date of the latest revision is shown below."
    },
    {
      title: "13. Contact Us",
      body: "For privacy-related questions or requests, contact our Privacy Team at privacy@localy.app or write to: Localy Inc., Attn: Privacy, The Woodlands, TX 77380."
    },
  ];

  const sections = isTerms ? TERMS : PRIVACY;

  return (
    <div style={{ background:T.sand, minHeight:"100%", fontFamily:"'DM Sans', sans-serif" }}>

      {/* Header */}
      <div style={{ background:`linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, padding:"20px 16px 32px" }}>
        <button onClick={onBack} style={{ background:"rgba(255,255,255,0.15)", border:"none", color:T.white, borderRadius:8, padding:"6px 12px", cursor:"pointer", fontSize:13, marginBottom:16, fontFamily:"'DM Sans', sans-serif" }}>← Back</button>
        <div style={{ fontSize:11, color:"#A8BFDF", letterSpacing:"0.12em", fontWeight:600, marginBottom:8 }}>
          {isTerms ? "LEGAL" : "PRIVACY"}
        </div>
        <h1 style={{ color:T.white, fontFamily:"'DM Serif Display', serif", fontWeight:400, fontSize:26, margin:"0 0 6px" }}>
          {isTerms ? "Terms of Service" : "Privacy Policy"}
        </h1>
        <div style={{ color:"rgba(255,255,255,0.6)", fontSize:12 }}>
          Last updated: August 13, 2026 · Localy Inc.
        </div>
      </div>

      {/* Intro banner */}
      <div style={{ background:T.white, margin:16, borderRadius:14, padding:16, border:`1px solid ${T.border}` }}>
        <div style={{ fontSize:22, marginBottom:8 }}>{isTerms ? "📋" : "🔒"}</div>
        <p style={{ fontSize:13, color:T.slate, lineHeight:1.7, margin:0 }}>
          {isTerms
            ? "These Terms of Service govern your use of the Localy platform. Please read them carefully before using the App. By creating an account, you agree to these terms."
            : "Your privacy matters to us. This policy explains what data we collect, how we use it, and the choices you have. We are committed to protecting your personal information."}
        </p>
      </div>

      {/* Quick links */}
      <div style={{ padding:"0 16px 4px" }}>
        <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:10 }}>JUMP TO SECTION</div>
        <div style={{ display:"flex", flexWrap:"wrap", gap:8, marginBottom:16 }}>
          {sections.slice(0,6).map((s,i) => (
            <button key={i} onClick={() => document.getElementById(`section-${i}`)?.scrollIntoView({ behavior:"smooth" })}
              style={{ padding:"5px 12px", borderRadius:99, border:`1px solid ${T.border}`, background:T.white, color:T.cobalt, fontSize:11, fontWeight:600, cursor:"pointer", fontFamily:"'DM Sans', sans-serif" }}>
              {s.title.split(".")[0]}
            </button>
          ))}
        </div>
      </div>

      {/* Sections */}
      <div style={{ padding:"0 16px 32px", display:"flex", flexDirection:"column", gap:12 }}>
        {sections.map((s, i) => (
          <div key={i} id={`section-${i}`} style={{ background:T.white, borderRadius:14, padding:16, border:`1px solid ${T.border}`, boxShadow:"0 1px 4px rgba(0,0,0,0.04)" }}>
            <div style={{ fontWeight:700, fontSize:14, color:T.navy, marginBottom:8, display:"flex", alignItems:"center", gap:8 }}>
              <div style={{ width:24, height:24, borderRadius:"50%", background:`linear-gradient(135deg, #1565C0, #0A9E6A)`, color:T.white, display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:700, flexShrink:0 }}>
                {i+1}
              </div>
              {s.title.split(". ").slice(1).join(". ")}
            </div>
            <p style={{ fontSize:13, color:T.slate, lineHeight:1.75, margin:0 }}>{s.body}</p>
          </div>
        ))}

        {/* Footer card */}
        <div style={{ background:`linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, borderRadius:14, padding:20, textAlign:"center" }}>
          <div style={{ color:T.white, fontWeight:700, fontSize:15, marginBottom:6 }}>
            Questions about our {isTerms ? "terms" : "privacy practices"}?
          </div>
          <div style={{ color:"rgba(255,255,255,0.7)", fontSize:13, marginBottom:16 }}>
            {isTerms ? "legal@localy.app" : "privacy@localy.app"}
          </div>
          <button onClick={onBack} style={{ background:T.white, color:T.navy, border:"none", borderRadius:10, padding:"10px 24px", fontWeight:700, cursor:"pointer", fontSize:14, fontFamily:"'DM Sans', sans-serif" }}>
            ← Back to App
          </button>
        </div>

        {/* Switch link */}
        {onSwitch && (
          <div style={{ textAlign:"center", padding:"8px 0" }}>
            <button onClick={onSwitch} style={{ background:"none", border:"none", color:T.cobalt, cursor:"pointer", fontSize:13, fontWeight:600, fontFamily:"'DM Sans', sans-serif" }}>
              {isTerms ? "View Privacy Policy →" : "View Terms of Service →"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}


// ── Cancellation Policy System ─────────────────────────────────

// Helper: hours until booking
function hoursUntil(dateStr, timeStr) {
  try {
    const bookingDate = new Date(`${dateStr} ${timeStr}`);
    const now = new Date();
    return Math.max(0, (bookingDate - now) / (1000 * 60 * 60));
  } catch {
    return 48; // default safe value
  }
}

// Calculate cancellation fee
function getCancelFee(hours, total) {
  if (hours >= 24)  return { fee: 0,              pct: 0,   label: "Free cancellation",        color: T.green  };
  if (hours >= 12)  return { fee: Math.round(total * 0.25), pct: 25,  label: "25% cancellation fee",   color: T.amber  };
  if (hours >= 2)   return { fee: Math.round(total * 0.50), pct: 50,  label: "50% cancellation fee",   color: T.coral  };
  return              { fee: total,                pct: 100, label: "Non-refundable",           color: T.coral  };
}

// Cancellation confirmation modal
function CancellationModal({ booking, onConfirm, onClose }) {
  const [step, setStep]     = useState("confirm"); // confirm | reason | done
  const [reason, setReason] = useState("");
  const [other, setOther]   = useState("");
  const [cancelling, setCancelling] = useState(false);
  const [cancelError, setCancelError] = useState('');

  const total    = booking?.total || 190;
  const hours    = booking?.hoursUntil || 30;
  const feeInfo  = getCancelFee(hours, total);
  const refund   = total - feeInfo.fee;

  const REASONS = [
    "Schedule conflict — I need to reschedule",
    "Found a different pro",
    "Job no longer needed",
    "Pro was unresponsive",
    "Price was too high",
    "Emergency / personal reason",
    "Other",
  ];

  // Previously this just faked a 1.5s spinner and jumped straight to a
  // "Booking Cancelled" success screen with a real-looking refund amount —
  // nothing about the booking's actual status (here or in Supabase) ever
  // changed, so it would still show as active in My Jobs, the pro's queue,
  // and the admin dashboard. Now it actually persists the cancellation,
  // same real-vs-mock guard used everywhere else (BOOKING_STORE.upsert
  // keeps the local "My Jobs" list in sync either way).
  const handleCancel = async () => {
    setCancelling(true);
    setCancelError('');
    try {
      if (booking?.id && typeof booking.id === 'string') {
        await sbUpdate('bookings', booking.id, {
          status: 'cancelled',
          cancel_reason: reason === 'Other' ? (other || 'Other') : reason,
          cancellation_fee: feeInfo.fee,
          refund_amount: refund,
          cancelled_at: new Date().toISOString(),
        });
      }
      BOOKING_STORE.upsert({ ...booking, status: 'cancelled' });
      setStep("done");
    } catch (err) {
      setCancelError(err.message || "Could not cancel your booking.");
      setStep("done");
    } finally {
      setCancelling(false);
    }
  };

  // ── CONFIRM SCREEN ──
  if (step === "confirm") return (
    <div style={{ position:"fixed", inset:0, background:"rgba(10,37,64,0.65)", display:"flex", alignItems:"flex-end", justifyContent:"center", zIndex:999, fontFamily:"'DM Sans', sans-serif" }}>
      <div style={{ background:T.white, borderRadius:"20px 20px 0 0", padding:"8px 0 40px", width:"100%", maxWidth:420 }}>
        <div style={{ width:40, height:4, borderRadius:99, background:T.border, margin:"12px auto 20px" }} />
        <div style={{ padding:"0 20px" }}>
          <div style={{ textAlign:"center", marginBottom:20 }}>
            <div style={{ fontSize:44, marginBottom:8 }}>❌</div>
            <h3 style={{ color:T.navy, fontSize:20, fontWeight:700, margin:"0 0 6px" }}>Cancel Booking?</h3>
            <p style={{ color:T.slate, fontSize:13, margin:0 }}>{booking?.job} with {booking?.pro}</p>
          </div>

          {/* Fee breakdown card */}
          <div style={{ background: feeInfo.fee === 0 ? T.greenL : T.coralL, borderRadius:14, padding:16, marginBottom:16, border:`1px solid ${feeInfo.color}33` }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
              <span style={{ fontWeight:700, color:T.navy, fontSize:14 }}>Cancellation Fee</span>
              <span style={{ fontWeight:700, fontSize:16, color:feeInfo.color }}>{feeInfo.label}</span>
            </div>
            {[
              ["Booking total",    `$${total}`         ],
              ["Cancellation fee", feeInfo.fee === 0 ? "None" : `-$${feeInfo.fee} (${feeInfo.pct}%)` ],
              ["Your refund",      `$${refund}`        ],
            ].map(([k,v]) => (
              <div key={k} style={{ display:"flex", justifyContent:"space-between", padding:"5px 0", fontSize:13, borderBottom:`1px solid ${feeInfo.color}22` }}>
                <span style={{ color:T.slate }}>{k}</span>
                <span style={{ fontWeight:700, color: k === "Your refund" ? T.green : T.navy }}>{v}</span>
              </div>
            ))}
            <div style={{ fontSize:12, color:feeInfo.color, fontWeight:600, marginTop:10 }}>
              {hours >= 24
                ? "✅ You're within the free cancellation window"
                : hours >= 12
                ? `⚠️ Booking is in ${Math.round(hours)}hrs — 25% fee applies`
                : `🚫 Less than ${Math.round(hours)}hrs away — ${feeInfo.pct}% fee applies`}
            </div>
          </div>

          {/* Policy reminder */}
          <div style={{ background:T.sand, borderRadius:10, padding:12, marginBottom:20, fontSize:12, color:T.slate, lineHeight:1.6 }}>
            📋 <strong>Cancellation Policy:</strong> Free up to 24hrs before · 25% fee within 24hrs · 50% within 12hrs · Non-refundable within 2hrs
          </div>

          <div style={{ display:"flex", gap:10 }}>
            <button onClick={onClose} style={{ flex:1, padding:"13px", borderRadius:12, border:`1.5px solid ${T.border}`, background:T.white, color:T.navy, fontWeight:700, cursor:"pointer", fontSize:14, fontFamily:"'DM Sans', sans-serif" }}>
              Keep Booking
            </button>
            <button onClick={() => setStep("reason")} style={{ flex:1, padding:"13px", borderRadius:12, border:"none", background:T.coral, color:T.white, fontWeight:700, cursor:"pointer", fontSize:14, fontFamily:"'DM Sans', sans-serif" }}>
              Cancel Booking
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  // ── REASON SCREEN ──
  if (step === "reason") return (
    <div style={{ position:"fixed", inset:0, background:"rgba(10,37,64,0.65)", display:"flex", alignItems:"flex-end", justifyContent:"center", zIndex:999, fontFamily:"'DM Sans', sans-serif" }}>
      <div style={{ background:T.white, borderRadius:"20px 20px 0 0", padding:"8px 0 40px", width:"100%", maxWidth:420, maxHeight:"85vh", overflowY:"auto" }}>
        <div style={{ width:40, height:4, borderRadius:99, background:T.border, margin:"12px auto 20px" }} />
        <div style={{ padding:"0 20px" }}>
          <h3 style={{ color:T.navy, fontSize:18, fontWeight:700, marginBottom:4 }}>Why are you cancelling?</h3>
          <p style={{ color:T.slate, fontSize:13, marginBottom:16 }}>This helps us improve Localy for everyone.</p>

          <div style={{ display:"flex", flexDirection:"column", gap:8, marginBottom:16 }}>
            {REASONS.map(r => (
              <button key={r} onClick={() => setReason(r)} style={{
                padding:"12px 14px", borderRadius:10, cursor:"pointer", textAlign:"left",
                background: reason === r ? T.cobaltL : T.white,
                border:`1.5px solid ${reason === r ? T.cobalt : T.border}`,
                color: reason === r ? T.cobalt : T.navy,
                fontSize:13, fontWeight: reason === r ? 700 : 400,
                fontFamily:"'DM Sans', sans-serif",
                display:"flex", alignItems:"center", gap:10,
              }}>
                <div style={{ width:18, height:18, borderRadius:"50%", border:`2px solid ${reason === r ? T.cobalt : T.border}`, background: reason === r ? T.cobalt : "transparent", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                  {reason === r && <div style={{ width:8, height:8, borderRadius:"50%", background:T.white }} />}
                </div>
                {r}
              </button>
            ))}
          </div>

          {reason === "Other" && (
            <textarea value={other} onChange={e => setOther(e.target.value)}
              placeholder="Tell us more…" rows={3}
              style={{ width:"100%", padding:"10px 12px", borderRadius:10, border:`1.5px solid ${T.border}`, fontSize:13, fontFamily:"'DM Sans', sans-serif", resize:"none", outline:"none", boxSizing:"border-box", marginBottom:16 }}
            />
          )}

          {feeInfo.fee > 0 && (
            <div style={{ background:T.coralL, borderRadius:10, padding:12, marginBottom:16, fontSize:12, color:T.coral, fontWeight:600 }}>
              ⚠️ Confirming will charge a ${feeInfo.fee} cancellation fee. Your refund of ${refund} will be processed in 3–5 business days.
            </div>
          )}

          <div style={{ display:"flex", gap:10 }}>
            <button onClick={() => setStep("confirm")} style={{ flex:1, padding:"13px", borderRadius:12, border:`1.5px solid ${T.border}`, background:T.white, color:T.navy, fontWeight:700, cursor:"pointer", fontSize:14, fontFamily:"'DM Sans', sans-serif" }}>
              ← Back
            </button>
            <button onClick={handleCancel} disabled={!reason || cancelling} style={{
              flex:1, padding:"13px", borderRadius:12, border:"none",
              background: reason ? T.coral : T.border,
              color:T.white, fontWeight:700, cursor: reason ? "pointer" : "not-allowed",
              fontSize:14, fontFamily:"'DM Sans', sans-serif", opacity: cancelling ? 0.7 : 1,
            }}>
              {cancelling ? "⏳ Cancelling…" : "Confirm Cancel"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  // ── DONE SCREEN ──
  if (step === "done") return (
    <div style={{ position:"fixed", inset:0, background:"rgba(10,37,64,0.65)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:999, fontFamily:"'DM Sans', sans-serif", padding:24 }}>
      <div style={{ background:T.white, borderRadius:24, padding:36, textAlign:"center", maxWidth:340, width:"100%", boxShadow:"0 20px 60px rgba(0,0,0,0.3)" }}>
        <div style={{ fontSize:56, marginBottom:16 }}>{feeInfo.fee === 0 ? "✅" : "💸"}</div>
        <h3 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, fontSize:22, marginBottom:8 }}>Booking Cancelled</h3>
        <p style={{ color:T.slate, fontSize:14, lineHeight:1.6, marginBottom:16 }}>
          Your booking with <strong>{booking?.pro}</strong> has been cancelled.
        </p>
        {cancelError && (
          <div style={{ background:T.coralL, color:T.coral, borderRadius:10, padding:"10px 14px", fontSize:12, marginBottom:16, textAlign:"left" }}>
            ⚠️ The cancellation wasn't saved: {cancelError}
          </div>
        )}
        {refund > 0 && (
          <div style={{ background:T.greenL, borderRadius:12, padding:14, marginBottom:16 }}>
            <div style={{ fontWeight:700, color:T.green, fontSize:16 }}>Refund: ${refund}</div>
            <div style={{ fontSize:12, color:T.green, marginTop:4 }}>
              {feeInfo.fee === 0 ? "Full refund — no fee charged" : `Partial refund after ${feeInfo.pct}% fee`}
            </div>
            <div style={{ fontSize:11, color:T.slate, marginTop:4 }}>3–5 business days to your original payment method</div>
          </div>
        )}
        {refund === 0 && (
          <div style={{ background:T.coralL, borderRadius:12, padding:14, marginBottom:16 }}>
            <div style={{ fontWeight:700, color:T.coral, fontSize:14 }}>No refund issued</div>
            <div style={{ fontSize:12, color:T.slate, marginTop:4 }}>Booking was cancelled within 2 hours of service</div>
          </div>
        )}
        <div style={{ display:"flex", gap:10 }}>
          <Btn label="Rebook →" onClick={onClose} variant="secondary" />
          <Btn label="Done" onClick={() => { onConfirm && onConfirm(); onClose(); }} />
        </div>
      </div>
    </div>
  );

  return null;
}

// ── Cancellation Policy Info Screen ────────────────────────────
function CancellationPolicyView({ onBack }) {
  const tiers = [
    { time:"24+ hours before",  fee:"Free",         refund:"100%",  icon:"✅", color:T.green,  bg:T.greenL  },
    { time:"12–24 hours before",fee:"25% fee",      refund:"75%",   icon:"⚠️", color:T.amber,  bg:T.amberL  },
    { time:"2–12 hours before", fee:"50% fee",      refund:"50%",   icon:"🔶", color:T.coral,  bg:T.coralL  },
    { time:"Under 2 hours",     fee:"Non-refundable",refund:"0%",   icon:"🚫", color:T.coral,  bg:T.coralL  },
  ];

  return (
    <div style={{ background:T.sand, minHeight:"100%", fontFamily:"'DM Sans', sans-serif" }}>

      {/* Header */}
      <div style={{ background:`linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, padding:"20px 16px 32px" }}>
        <button onClick={onBack} style={{ background:"rgba(255,255,255,0.15)", border:"none", color:T.white, borderRadius:8, padding:"6px 12px", cursor:"pointer", fontSize:13, marginBottom:16, fontFamily:"'DM Sans', sans-serif" }}>← Back</button>
        <div style={{ fontSize:11, color:"#A8BFDF", letterSpacing:"0.12em", fontWeight:600, marginBottom:8 }}>LOCALY POLICY</div>
        <h1 style={{ color:T.white, fontFamily:"'DM Serif Display', serif", fontWeight:400, fontSize:26, margin:"0 0 6px" }}>Cancellation Policy</h1>
        <p style={{ color:"rgba(255,255,255,0.6)", fontSize:13, margin:0 }}>Last updated August 13, 2026</p>
      </div>

      <div style={{ padding:16, display:"flex", flexDirection:"column", gap:12 }}>

        {/* Fee tiers */}
        <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, overflow:"hidden" }}>
          <div style={{ padding:"12px 16px", borderBottom:`1px solid ${T.border}`, fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em" }}>HOMEOWNER CANCELLATION FEES</div>
          {tiers.map((t, i) => (
            <div key={i} style={{ padding:"14px 16px", borderBottom: i < tiers.length-1 ? `1px solid ${T.border}` : "none", display:"flex", alignItems:"center", gap:12 }}>
              <div style={{ width:40, height:40, borderRadius:10, background:t.bg, display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, flexShrink:0 }}>{t.icon}</div>
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:700, fontSize:13, color:T.navy }}>{t.time}</div>
                <div style={{ fontSize:12, color:T.slate, marginTop:2 }}>Refund: {t.refund} of booking total</div>
              </div>
              <div style={{ textAlign:"right" }}>
                <div style={{ fontWeight:700, fontSize:13, color:t.color }}>{t.fee}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Visual timeline */}
        <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:16 }}>
          <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:14 }}>CANCELLATION TIMELINE</div>
          <div style={{ position:"relative", paddingLeft:24 }}>
            <div style={{ position:"absolute", left:8, top:0, bottom:0, width:2, background:`linear-gradient(180deg, ${T.green}, ${T.amber}, ${T.coral})`, borderRadius:99 }} />
            {[
              { label:"Booking made",         sub:"Cancellation window opens",      dot:T.cobalt },
              { label:"24 hours before",       sub:"⚠️ Free cancellation ends here", dot:T.green  },
              { label:"12 hours before",       sub:"25% fee kicks in",              dot:T.amber  },
              { label:"2 hours before",        sub:"50% fee · then non-refundable", dot:T.coral  },
              { label:"Job start time",        sub:"Service begins",                dot:T.navy   },
            ].map((item, i) => (
              <div key={i} style={{ display:"flex", gap:12, marginBottom:16, alignItems:"flex-start" }}>
                <div style={{ width:14, height:14, borderRadius:"50%", background:item.dot, border:"2px solid white", boxShadow:"0 0 0 2px "+item.dot+"44", flexShrink:0, marginTop:2 }} />
                <div>
                  <div style={{ fontWeight:700, fontSize:13, color:T.navy }}>{item.label}</div>
                  <div style={{ fontSize:12, color:T.slate }}>{item.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Pro cancellation policy */}
        <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:16 }}>
          <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:12 }}>PRO CANCELLATION POLICY</div>
          {[
            { icon:"⚠️", text:"Pros who cancel within 12 hours of a job receive a warning" },
            { icon:"🔶", text:"Second cancellation within 30 days results in account suspension" },
            { icon:"🚫", text:"Three no-shows result in permanent removal from Localy" },
            { icon:"💰", text:"Homeowners receive a full refund when a Pro cancels" },
            { icon:"📱", text:"Localy will help find a replacement Pro within 2 hours" },
          ].map((item, i) => (
            <div key={i} style={{ display:"flex", gap:10, padding:"8px 0", borderBottom: i<4 ? `1px solid ${T.border}` : "none", alignItems:"flex-start" }}>
              <span style={{ fontSize:18, flexShrink:0 }}>{item.icon}</span>
              <span style={{ fontSize:13, color:T.navy, lineHeight:1.5 }}>{item.text}</span>
            </div>
          ))}
        </div>

        {/* Refund processing */}
        <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:16 }}>
          <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:12 }}>REFUND PROCESSING</div>
          {[
            ["Processing time",  "3–5 business days"],
            ["Refund method",    "Original payment method"],
            ["Partial refunds",  "Remaining balance only"],
            ["Tips",             "Always fully refunded"],
            ["Service fee",      "Refunded if Pro cancels"],
          ].map(([k,v],i) => (
            <div key={i} style={{ display:"flex", justifyContent:"space-between", padding:"8px 0", fontSize:13, borderBottom: i<4 ? `1px solid ${T.border}` : "none" }}>
              <span style={{ color:T.slate }}>{k}</span>
              <span style={{ fontWeight:700, color:T.navy }}>{v}</span>
            </div>
          ))}
        </div>

        {/* Contact */}
        <div style={{ background:`linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, borderRadius:14, padding:20, textAlign:"center" }}>
          <div style={{ color:T.white, fontWeight:700, fontSize:15, marginBottom:6 }}>Need to cancel a booking?</div>
          <div style={{ color:"rgba(255,255,255,0.7)", fontSize:13, marginBottom:16 }}>Go to My Jobs → tap the booking → Cancel</div>
          <Btn label="← Back" onClick={onBack} variant="secondary" />
        </div>
      </div>
    </div>
  );
}


// ── Pro Availability Calendar ──────────────────────────────────
const DAYS    = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
const MONTHS  = ["January","February","March","April","May","June","July","August","September","October","November","December"];
const HOURS   = ["8:00 AM","9:00 AM","10:00 AM","11:00 AM","12:00 PM","1:00 PM","2:00 PM","3:00 PM","4:00 PM","5:00 PM","6:00 PM"];

function AvailabilityCalendar({ onBack }) {
  const today      = new Date(2026, 7, 13); // Aug 13 2026
  const [month, setMonth]       = useState(today.getMonth());
  const [year, setYear]         = useState(today.getFullYear());
  const [selectedDate, setSelectedDate] = useState(null);
  const [view, setView]         = useState("month"); // month | week | settings
  const [saved, setSaved]       = useState(false);

  // Availability data: key = "YYYY-MM-DD", value = { status, slots }
  // status: "available" | "unavailable" | "partial"
  const [availability, setAvailability] = useState({
    "2026-08-14": { status:"available",   slots:["8:00 AM","9:00 AM","10:00 AM","1:00 PM","2:00 PM"] },
    "2026-08-15": { status:"partial",     slots:["10:00 AM","11:00 AM"] },
    "2026-08-16": { status:"unavailable", slots:[] },
    "2026-08-17": { status:"available",   slots:["8:00 AM","9:00 AM","10:00 AM","11:00 AM","1:00 PM","2:00 PM","3:00 PM"] },
    "2026-08-18": { status:"available",   slots:["9:00 AM","10:00 AM","11:00 AM","1:00 PM"] },
    "2026-08-19": { status:"unavailable", slots:[] },
    "2026-08-20": { status:"unavailable", slots:[] },
    "2026-08-21": { status:"available",   slots:["8:00 AM","9:00 AM","10:00 AM","11:00 AM","1:00 PM","2:00 PM","3:00 PM","4:00 PM"] },
    "2026-08-22": { status:"available",   slots:["9:00 AM","10:00 AM","2:00 PM","3:00 PM"] },
    "2026-08-25": { status:"partial",     slots:["8:00 AM","9:00 AM"] },
    "2026-08-28": { status:"available",   slots:["10:00 AM","11:00 AM","1:00 PM","2:00 PM","3:00 PM"] },
  });

  // Weekly recurring schedule
  const [weeklySchedule, setWeeklySchedule] = useState({
    0: { active:false, start:"9:00 AM",  end:"5:00 PM" }, // Sun
    1: { active:true,  start:"8:00 AM",  end:"6:00 PM" }, // Mon
    2: { active:true,  start:"8:00 AM",  end:"6:00 PM" }, // Tue
    3: { active:true,  start:"8:00 AM",  end:"6:00 PM" }, // Wed
    4: { active:true,  start:"8:00 AM",  end:"6:00 PM" }, // Thu
    5: { active:true,  start:"8:00 AM",  end:"4:00 PM" }, // Fri
    6: { active:false, start:"9:00 AM",  end:"2:00 PM" }, // Sat
  });

  const [bufferTime, setBufferTime]     = useState(30);  // mins between jobs
  const [maxJobsPerDay, setMaxJobsPerDay] = useState(3);
  const [autoAccept, setAutoAccept]     = useState(false);
  const [vacationMode, setVacationMode] = useState(false);

  const toKey = (d) => {
    const date = new Date(d);
    return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
  };

  const getStatusColor = (status) => ({
    available:   { bg: T.greenL,  dot: T.green,  text: T.green  },
    partial:     { bg: T.amberL,  dot: T.amber,  text: T.amber  },
    unavailable: { bg: T.coralL,  dot: T.coral,  text: T.coral  },
    none:        { bg: T.white,   dot: T.border, text: T.slate  },
  }[status || "none"]);

  // Build calendar grid
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const calCells = [];
  for (let i = 0; i < firstDay; i++) calCells.push(null);
  for (let d = 1; d <= daysInMonth; d++) calCells.push(d);
  while (calCells.length % 7 !== 0) calCells.push(null);

  const prevMonth = () => { if (month === 0) { setMonth(11); setYear(y => y-1); } else setMonth(m => m-1); };
  const nextMonth = () => { if (month === 11) { setMonth(0); setYear(y => y+1); } else setMonth(m => m+1); };

  const toggleSlot = (dateKey, slot) => {
    setAvailability(prev => {
      const current = prev[dateKey] || { status:"available", slots:[] };
      const slots = current.slots.includes(slot)
        ? current.slots.filter(s => s !== slot)
        : [...current.slots, slot].sort((a,b) => HOURS.indexOf(a) - HOURS.indexOf(b));
      const status = slots.length === 0 ? "unavailable" : slots.length >= 6 ? "available" : "partial";
      return { ...prev, [dateKey]: { status, slots } };
    });
  };

  const setDayStatus = (dateKey, status) => {
    const slots = status === "available" ? [...HOURS] : status === "unavailable" ? [] : HOURS.slice(1, 5);
    setAvailability(prev => ({ ...prev, [dateKey]: { status, slots } }));
  };

  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  // ── MONTH VIEW ──
  const MonthView = () => (
    <div>
      {/* Legend */}
      <div style={{ display:"flex", gap:12, padding:"10px 16px", background:T.white, borderBottom:`1px solid ${T.border}`, flexWrap:"wrap" }}>
        {[["available","Available"],["partial","Partial"],["unavailable","Unavailable"],["none","Not set"]].map(([s,l]) => {
          const c = getStatusColor(s);
          return (
            <div key={s} style={{ display:"flex", alignItems:"center", gap:5, fontSize:11, fontWeight:600, color:T.slate }}>
              <div style={{ width:10, height:10, borderRadius:"50%", background:c.dot }} />
              {l}
            </div>
          );
        })}
      </div>

      {/* Day headers */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", background:T.sand }}>
        {DAYS.map(d => (
          <div key={d} style={{ textAlign:"center", padding:"8px 0", fontSize:10, fontWeight:700, color:T.slate, letterSpacing:"0.06em" }}>{d.toUpperCase()}</div>
        ))}
      </div>

      {/* Calendar grid */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:1, background:T.border }}>
        {calCells.map((day, idx) => {
          if (!day) return <div key={idx} style={{ background:T.sand, minHeight:52 }} />;
          const dateKey = toKey(new Date(year, month, day));
          const avail   = availability[dateKey];
          const colors  = getStatusColor(avail?.status);
          const isToday = dateKey === toKey(today);
          const isPast  = new Date(year, month, day) < today;
          const isSel   = selectedDate === dateKey;
          return (
            <div key={idx} onClick={() => !isPast && setSelectedDate(isSel ? null : dateKey)}
              style={{
                background: isPast ? "#F8F8F8" : isSel ? T.cobalt : avail ? colors.bg : T.white,
                minHeight:52, padding:"6px 4px", cursor: isPast ? "default" : "pointer",
                display:"flex", flexDirection:"column", alignItems:"center", gap:3,
                border: isToday ? `2px solid ${T.cobalt}` : "none",
                transition:"all 0.1s",
              }}>
              <div style={{ fontSize:13, fontWeight: isToday ? 800 : 500, color: isPast ? T.border : isSel ? T.white : T.navy }}>
                {day}
              </div>
              {avail && !isPast && (
                <div style={{ width:6, height:6, borderRadius:"50%", background: isSel ? "rgba(255,255,255,0.7)" : colors.dot }} />
              )}
              {avail?.slots?.length > 0 && !isPast && (
                <div style={{ fontSize:9, color: isSel ? "rgba(255,255,255,0.8)" : colors.text, fontWeight:700 }}>
                  {avail.slots.length}h
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Selected date panel */}
      {selectedDate && (
        <div style={{ margin:12, background:T.white, borderRadius:14, border:`1px solid ${T.border}`, overflow:"hidden" }}>
          <div style={{ padding:"12px 16px", background:`linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <div>
              <div style={{ color:"rgba(255,255,255,0.7)", fontSize:11, fontWeight:700, letterSpacing:"0.1em" }}>EDITING</div>
              <div style={{ color:T.white, fontWeight:700, fontSize:15 }}>
                {new Date(selectedDate + 'T12:00:00').toLocaleDateString("en-US", { weekday:"long", month:"long", day:"numeric" })}
              </div>
            </div>
            <button onClick={() => setSelectedDate(null)} style={{ background:"rgba(255,255,255,0.15)", border:"none", color:T.white, borderRadius:8, padding:"4px 10px", cursor:"pointer", fontSize:12, fontFamily:"'DM Sans', sans-serif" }}>✕ Close</button>
          </div>

          {/* Quick status buttons */}
          <div style={{ padding:12, display:"flex", gap:8, borderBottom:`1px solid ${T.border}` }}>
            {[["available","✅ All Day"],["partial","⚡ Partial"],["unavailable","🚫 Off"]].map(([s,l]) => (
              <button key={s} onClick={() => setDayStatus(selectedDate, s)} style={{
                flex:1, padding:"8px 4px", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:700,
                background: availability[selectedDate]?.status === s ? T.navy : T.sand,
                color: availability[selectedDate]?.status === s ? T.white : T.navy,
                border:`1.5px solid ${availability[selectedDate]?.status === s ? T.navy : T.border}`,
                fontFamily:"'DM Sans', sans-serif",
              }}>{l}</button>
            ))}
          </div>

          {/* Time slot picker */}
          <div style={{ padding:12 }}>
            <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.08em", marginBottom:10 }}>SELECT AVAILABLE HOURS</div>
            <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
              {HOURS.map(hour => {
                const isActive = availability[selectedDate]?.slots?.includes(hour);
                return (
                  <button key={hour} onClick={() => toggleSlot(selectedDate, hour)} style={{
                    padding:"7px 12px", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:600,
                    background: isActive ? T.green : T.sand,
                    color: isActive ? T.white : T.navy,
                    border:`1.5px solid ${isActive ? T.green : T.border}`,
                    fontFamily:"'DM Sans', sans-serif",
                    transition:"all 0.15s",
                  }}>{hour}</button>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );

  // ── WEEK VIEW ──
  const WeekView = () => {
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - today.getDay());
    const weekDays = Array.from({length:7}, (_, i) => {
      const d = new Date(startOfWeek);
      d.setDate(startOfWeek.getDate() + i);
      return d;
    });

    return (
      <div style={{ padding:12 }}>
        <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:12 }}>THIS WEEK — {MONTHS[today.getMonth()]} {today.getFullYear()}</div>
        <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
          {weekDays.map((day, i) => {
            const dateKey = toKey(day);
            const avail   = availability[dateKey];
            const colors  = getStatusColor(avail?.status);
            const isToday = dateKey === toKey(today);
            const isPast  = day < today;
            return (
              <div key={i} style={{
                background: T.white, borderRadius:12, border:`1.5px solid ${isToday ? T.cobalt : T.border}`,
                overflow:"hidden", opacity: isPast ? 0.5 : 1,
              }}>
                <div style={{ padding:"10px 14px", display:"flex", justifyContent:"space-between", alignItems:"center", background: avail ? colors.bg : T.sand }}>
                  <div>
                    <div style={{ fontWeight:700, fontSize:14, color:T.navy }}>{DAYS[day.getDay()]} {day.getDate()}</div>
                    <div style={{ fontSize:11, color: avail ? colors.text : T.slate, fontWeight:600 }}>
                      {avail?.status === "available" ? `${avail.slots.length} slots open` :
                       avail?.status === "partial"   ? `${avail.slots.length} slots available` :
                       avail?.status === "unavailable" ? "Not available" : "Not set"}
                    </div>
                  </div>
                  {!isPast && (
                    <div style={{ display:"flex", gap:6 }}>
                      {[["available","✅"],["partial","⚡"],["unavailable","🚫"]].map(([s,e]) => (
                        <button key={s} onClick={() => setDayStatus(dateKey, s)} style={{
                          width:32, height:32, borderRadius:8, border:`1.5px solid ${avail?.status===s ? T.navy : T.border}`,
                          background: avail?.status===s ? T.navy : T.white,
                          cursor:"pointer", fontSize:14, display:"flex", alignItems:"center", justifyContent:"center",
                        }}>{e}</button>
                      ))}
                    </div>
                  )}
                </div>
                {avail?.slots?.length > 0 && (
                  <div style={{ padding:"8px 14px", display:"flex", gap:6, flexWrap:"wrap" }}>
                    {avail.slots.map(slot => (
                      <span key={slot} style={{ background:colors.bg, color:colors.text, fontSize:11, fontWeight:700, padding:"3px 8px", borderRadius:6 }}>{slot}</span>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  // ── SETTINGS VIEW ──
  const SettingsView = () => (
    <div style={{ padding:16, display:"flex", flexDirection:"column", gap:12 }}>

      {/* Vacation Mode */}
      <div style={{ background: vacationMode ? T.coralL : T.white, borderRadius:14, border:`1.5px solid ${vacationMode ? T.coral : T.border}`, padding:16 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <div>
            <div style={{ fontWeight:700, fontSize:14, color: vacationMode ? T.coral : T.navy }}>🏖️ Vacation Mode</div>
            <div style={{ fontSize:12, color:T.slate, marginTop:2 }}>Block all bookings temporarily</div>
          </div>
          <div onClick={() => setVacationMode(!vacationMode)} style={{
            width:44, height:24, borderRadius:99, cursor:"pointer",
            background: vacationMode ? T.coral : T.border, position:"relative", transition:"background 0.2s",
          }}>
            <div style={{ width:20, height:20, borderRadius:"50%", background:T.white, position:"absolute", top:2, left: vacationMode ? 22 : 2, transition:"left 0.2s", boxShadow:"0 1px 4px rgba(0,0,0,0.2)" }} />
          </div>
        </div>
      </div>

      {/* Weekly Schedule */}
      <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, overflow:"hidden" }}>
        <div style={{ padding:"12px 16px", borderBottom:`1px solid ${T.border}`, fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em" }}>WEEKLY RECURRING SCHEDULE</div>
        {DAYS.map((day, idx) => {
          const sched = weeklySchedule[idx];
          return (
            <div key={idx} style={{ padding:"12px 16px", borderBottom: idx<6 ? `1px solid ${T.border}` : "none", display:"flex", alignItems:"center", gap:10 }}>
              <div onClick={() => setWeeklySchedule(prev => ({ ...prev, [idx]:{ ...prev[idx], active:!prev[idx].active } }))}
                style={{ width:20, height:20, borderRadius:6, border:`2px solid ${sched.active ? T.green : T.border}`, background: sched.active ? T.green : "transparent", display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer", flexShrink:0 }}>
                {sched.active && <span style={{ color:T.white, fontSize:12, fontWeight:700 }}>✓</span>}
              </div>
              <div style={{ width:36, fontWeight:700, fontSize:13, color: sched.active ? T.navy : T.slate }}>{day}</div>
              {sched.active ? (
                <div style={{ display:"flex", gap:8, flex:1, alignItems:"center" }}>
                  <select value={sched.start} onChange={e => setWeeklySchedule(prev => ({ ...prev, [idx]:{ ...prev[idx], start:e.target.value } }))}
                    style={{ flex:1, padding:"4px 6px", borderRadius:6, border:`1px solid ${T.border}`, fontSize:12, fontFamily:"'DM Sans', sans-serif", outline:"none" }}>
                    {HOURS.map(h => <option key={h} value={h}>{h}</option>)}
                  </select>
                  <span style={{ fontSize:11, color:T.slate }}>to</span>
                  <select value={sched.end} onChange={e => setWeeklySchedule(prev => ({ ...prev, [idx]:{ ...prev[idx], end:e.target.value } }))}
                    style={{ flex:1, padding:"4px 6px", borderRadius:6, border:`1px solid ${T.border}`, fontSize:12, fontFamily:"'DM Sans', sans-serif", outline:"none" }}>
                    {HOURS.map(h => <option key={h} value={h}>{h}</option>)}
                  </select>
                </div>
              ) : (
                <div style={{ fontSize:12, color:T.slate, flex:1 }}>Not available</div>
              )}
            </div>
          );
        })}
      </div>

      {/* Buffer time */}
      <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:16 }}>
        <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:12 }}>BOOKING PREFERENCES</div>
        <div style={{ marginBottom:16 }}>
          <div style={{ fontWeight:700, fontSize:13, color:T.navy, marginBottom:6 }}>Buffer time between jobs: <span style={{ color:T.cobalt }}>{bufferTime} min</span></div>
          <input type="range" min={0} max={120} step={15} value={bufferTime} onChange={e => setBufferTime(Number(e.target.value))}
            style={{ width:"100%", accentColor:T.cobalt }} />
          <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, color:T.slate, marginTop:4 }}>
            <span>No buffer</span><span>2 hrs</span>
          </div>
        </div>
        <div style={{ marginBottom:16, paddingTop:14, borderTop:`1px solid ${T.border}` }}>
          <div style={{ fontWeight:700, fontSize:13, color:T.navy, marginBottom:8 }}>Max jobs per day: <span style={{ color:T.cobalt }}>{maxJobsPerDay}</span></div>
          <div style={{ display:"flex", gap:8 }}>
            {[1,2,3,4,5].map(n => (
              <button key={n} onClick={() => setMaxJobsPerDay(n)} style={{
                flex:1, padding:"8px 0", borderRadius:8, cursor:"pointer", fontWeight:700, fontSize:13,
                background: maxJobsPerDay===n ? T.cobalt : T.sand,
                color: maxJobsPerDay===n ? T.white : T.navy,
                border:`1.5px solid ${maxJobsPerDay===n ? T.cobalt : T.border}`,
                fontFamily:"'DM Sans', sans-serif",
              }}>{n}</button>
            ))}
          </div>
        </div>
        <div style={{ paddingTop:14, borderTop:`1px solid ${T.border}`, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <div>
            <div style={{ fontWeight:700, fontSize:13, color:T.navy }}>Auto-accept bookings</div>
            <div style={{ fontSize:11, color:T.slate, marginTop:2 }}>Confirm instantly without review</div>
          </div>
          <div onClick={() => setAutoAccept(!autoAccept)} style={{
            width:44, height:24, borderRadius:99, cursor:"pointer",
            background: autoAccept ? T.green : T.border, position:"relative", transition:"background 0.2s",
          }}>
            <div style={{ width:20, height:20, borderRadius:"50%", background:T.white, position:"absolute", top:2, left: autoAccept ? 22 : 2, transition:"left 0.2s", boxShadow:"0 1px 4px rgba(0,0,0,0.2)" }} />
          </div>
        </div>
      </div>

      {/* Save */}
      <button onClick={handleSave} style={{
        width:"100%", padding:"15px", borderRadius:12, border:"none",
        background:`linear-gradient(135deg, #1565C0, #0A9E6A)`,
        color:T.white, fontWeight:700, fontSize:15, cursor:"pointer",
        fontFamily:"'DM Sans', sans-serif",
      }}>
        {saved ? "✅ Saved!" : "Save Schedule"}
      </button>
    </div>
  );

  return (
    <div style={{ background:T.sand, minHeight:"100%", fontFamily:"'DM Sans', sans-serif" }}>

      {/* Header */}
      <div style={{ background:`linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, padding:"16px 16px 20px" }}>
        <button onClick={onBack} style={{ background:"rgba(255,255,255,0.15)", border:"none", color:T.white, borderRadius:8, padding:"6px 12px", cursor:"pointer", fontSize:13, marginBottom:14, fontFamily:"'DM Sans', sans-serif" }}>← Back</button>

        {/* Month nav */}
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
          <button onClick={prevMonth} style={{ background:"rgba(255,255,255,0.15)", border:"none", color:T.white, borderRadius:8, padding:"6px 12px", cursor:"pointer", fontSize:16 }}>‹</button>
          <div style={{ textAlign:"center" }}>
            <div style={{ color:T.white, fontFamily:"'DM Serif Display', serif", fontSize:20, fontWeight:400 }}>
              {MONTHS[month]} {year}
            </div>
            <div style={{ color:"rgba(255,255,255,0.6)", fontSize:12 }}>
              {Object.values(availability).filter(a => a.status === "available").length} days available this month
            </div>
          </div>
          <button onClick={nextMonth} style={{ background:"rgba(255,255,255,0.15)", border:"none", color:T.white, borderRadius:8, padding:"6px 12px", cursor:"pointer", fontSize:16 }}>›</button>
        </div>

        {/* View tabs */}
        <div style={{ display:"flex", gap:6 }}>
          {[["month","📅 Month"],["week","📆 Week"],["settings","⚙️ Settings"]].map(([v,l]) => (
            <button key={v} onClick={() => setView(v)} style={{
              flex:1, padding:"8px 4px", borderRadius:8, border:"none", cursor:"pointer", fontSize:12, fontWeight:700,
              background: view===v ? T.white : "rgba(255,255,255,0.15)",
              color: view===v ? T.navy : T.white,
              fontFamily:"'DM Sans', sans-serif",
            }}>{l}</button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div style={{ overflowY:"auto" }}>
        {view === "month"    && <MonthView />}
        {view === "week"     && <WeekView />}
        {view === "settings" && <SettingsView />}
      </div>
    </div>
  );
}


// ── Real-Time Job Matching System ─────────────────────────────
// Global job store — shared between homeowner and pro views
const JOB_STORE = {
  jobs: [],
  listeners: [],
  subscribe(fn) { this.listeners.push(fn); return () => { this.listeners = this.listeners.filter(l => l !== fn); }; },
  publish(job) { this.jobs = [job, ...this.jobs]; this.listeners.forEach(fn => fn(job)); },
};

// ── Local Booking Registry ──────────────────────────────────────
// A booking made through BookingView shows up here immediately, even when
// the pro is mock/demo data and the real Supabase insert (createBooking)
// is intentionally skipped — otherwise "My Jobs" would never reflect a
// booking made against any of the app's sample pros. Same lightweight
// pattern as JOB_STORE above; useBookings() merges this in.
const BOOKING_STORE = {
  bookings: [],
  listeners: [],
  subscribe(fn) { this.listeners.push(fn); return () => { this.listeners = this.listeners.filter(l => l !== fn); }; },
  publish(booking) { this.bookings = [booking, ...this.bookings]; this.listeners.forEach(fn => fn(booking)); },
  updateStatus(id, status) {
    const b = this.bookings.find(x => x.id === id);
    if (b) { b.status = status; this.listeners.forEach(fn => fn()); }
  },
  // Update-or-insert — needed for bookings that came from a real Supabase
  // fetch (not originally published here) so status changes to them still
  // show up instantly, same as locally-created ones. useBookings() merges
  // this store's entries ahead of the fetched list, so an upserted copy
  // here always wins the dedupe.
  upsert(booking) {
    const idx = this.bookings.findIndex(b => b.id === booking.id);
    if (idx >= 0) this.bookings[idx] = { ...this.bookings[idx], ...booking };
    else this.bookings = [booking, ...this.bookings];
    this.listeners.forEach(fn => fn());
  },
};

// Match a job to nearby available pros
function matchProsToJob(job) {
  return PROS.filter(p =>
    p.available &&
    // "Other" jobs don't fit a single trade, so broadcast them to every
    // available pro (same treatment as "handyman") instead of matching zero
    // pros, since no pro is ever categorized as "other".
    (p.cat === job.cat || job.cat === "handyman" || job.cat === "other") &&
    ["The Woodlands","Spring","Conroe","Kingwood","Humble"].includes(p.city)
  );
}

// Fan out a "job match" push notification to real (Supabase) pros whose
// services include this job's category. This is separate from
// matchProsToJob() above, which only matches against the mock PROS array
// for the on-screen "broadcasting…" animation — that animation has no real
// users to notify. This runs quietly in the background any time a job is
// posted with a real category, same fire-and-forget pattern as every other
// sendPushNotification() call site.
async function notifyMatchedProsOfNewJob(jobTitle, category) {
  if (!category) return;
  try {
    const cat = category === 'other' ? 'handyman' : category;
    const matched = await sbFetch('pro_profiles',
      `?available=eq.true&approved=eq.true&services=cs.{${cat}}&select=user_id`
    );
    if (!Array.isArray(matched) || matched.length === 0) return;
    matched.forEach(p => {
      if (p.user_id) sendPushNotification(p.user_id, 'New job match 🔧', `A new "${jobTitle}" job just posted near you.`, { type: 'job_match' });
    });
  } catch (err) {
    console.log('Job match notify error:', err.message);
  }
}

// ── Job Match Alert (shown to pro) ────────────────────────────
function JobMatchAlert({ job, onAccept, onDecline, onView }) {
  const [timeLeft, setTimeLeft] = useState(45);
  const [accepting, setAccepting] = useState(false);
  const [declined, setDeclined]   = useState(false);
  const cat = CATEGORIES.find(c => c.id === job.cat);

  // Countdown timer
  useState(() => {
    const t = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) { clearInterval(t); onDecline(); return 0; }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  });

  const pct = (timeLeft / 45) * 100;

  if (declined) return null;

  return (
    <div style={{
      position:"fixed", inset:0, background:"rgba(10,37,64,0.75)",
      display:"flex", alignItems:"flex-end", justifyContent:"center",
      zIndex:1000, fontFamily:"'DM Sans', sans-serif",
    }}>
      <div style={{
        background:T.white, borderRadius:"24px 24px 0 0",
        width:"100%", maxWidth:420, overflow:"hidden",
        boxShadow:"0 -8px 40px rgba(0,0,0,0.3)",
        animation:"slideUp 0.3s ease",
      }}>
        {/* Urgency timer bar */}
        <div style={{ height:4, background:T.border }}>
          <div style={{
            height:4, borderRadius:0,
            background: timeLeft > 20 ? T.green : timeLeft > 10 ? T.amber : T.coral,
            width:`${pct}%`, transition:"width 1s linear, background 0.3s",
          }} />
        </div>

        {/* Alert header */}
        <div style={{ background:`linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, padding:"16px 20px" }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <div>
              <div style={{ fontSize:11, color:"#A8BFDF", fontWeight:700, letterSpacing:"0.12em", marginBottom:4 }}>⚡ NEW JOB MATCH</div>
              <div style={{ color:T.white, fontWeight:700, fontSize:18 }}>{job.title}</div>
            </div>
            <div style={{ textAlign:"center" }}>
              <div style={{ fontSize:28, fontWeight:800, color: timeLeft > 20 ? "#07C47F" : timeLeft > 10 ? "#F59E0B" : T.coral }}>{timeLeft}</div>
              <div style={{ fontSize:10, color:"rgba(255,255,255,0.6)", fontWeight:600 }}>SECONDS</div>
            </div>
          </div>
        </div>

        <div style={{ padding:20 }}>
          {/* Job details */}
          <div style={{ background:T.sand, borderRadius:12, padding:14, marginBottom:16 }}>
            <div style={{ display:"flex", gap:10, alignItems:"center", marginBottom:10 }}>
              <img src={cat?.icon} alt="" style={{ width:32, height:32, objectFit:"contain" }} />
              <div>
                <div style={{ fontWeight:700, fontSize:14, color:T.navy }}>{cat?.label}</div>
                <div style={{ fontSize:12, color:T.slate }}>📍 {job.city} · Posted just now</div>
              </div>
              <div style={{ marginLeft:"auto", textAlign:"right" }}>
                <div style={{ fontWeight:700, fontSize:16, color:T.navy }}>{job.budget}</div>
                <div style={{ fontSize:11, color:T.slate }}>budget</div>
              </div>
            </div>
            <p style={{ fontSize:13, color:T.slate, margin:0, lineHeight:1.5 }}>{job.desc}</p>
          </div>

          {/* Match quality */}
          <div style={{ display:"flex", gap:8, marginBottom:16 }}>
            {[
              { icon:"📍", label:"2.3 mi away",     color:T.green  },
              { icon:"⭐", label:"Matches your skills", color:T.cobalt },
              { icon:"💰", label:"Est. $" + (parseInt(job.budget?.replace(/[^0-9]/g,"").slice(0,3)||"120")+20), color:T.amber  },
            ].map((b,i) => (
              <div key={i} style={{ flex:1, background:T.sand, borderRadius:10, padding:"8px 6px", textAlign:"center" }}>
                <div style={{ fontSize:16, marginBottom:2 }}>{b.icon}</div>
                <div style={{ fontSize:10, fontWeight:700, color:b.color }}>{b.label}</div>
              </div>
            ))}
          </div>

          {/* Action buttons */}
          <div style={{ display:"flex", gap:10 }}>
            <button onClick={() => { setDeclined(true); onDecline(); }} style={{
              flex:1, padding:"13px", borderRadius:12, border:`1.5px solid ${T.border}`,
              background:T.white, color:T.slate, fontWeight:700, cursor:"pointer",
              fontSize:14, fontFamily:"'DM Sans', sans-serif",
            }}>✕ Pass</button>
            <button onClick={() => { setAccepting(true); setTimeout(() => { onAccept(job); }, 800); }} style={{
              flex:2, padding:"13px", borderRadius:12, border:"none",
              background: accepting ? T.green : `linear-gradient(135deg, #1565C0, #0A9E6A)`,
              color:T.white, fontWeight:700, cursor:"pointer",
              fontSize:14, fontFamily:"'DM Sans', sans-serif",
              transition:"background 0.3s",
            }}>
              {accepting ? "✅ Accepted!" : "⚡ Accept Job"}
            </button>
          </div>
          <button onClick={onView} style={{ width:"100%", marginTop:8, padding:"8px", background:"none", border:"none", color:T.cobalt, cursor:"pointer", fontFamily:"'DM Sans', sans-serif", fontSize:13, fontWeight:600 }}>
            View full details →
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Job Posting Success with Live Matching ─────────────────────
function JobPostedMatchingView({ job, onDone }) {
  const [phase, setPhase]         = useState("broadcasting"); // broadcasting | matching | posted
  const [matchedPros, setMatchedPros] = useState([]);
  const [notifiedCount, setNotifiedCount] = useState(0);

  useState(() => {
    const matched = matchProsToJob(job);

    // Phase 1: broadcasting
    setTimeout(() => {
      setPhase("matching");
      setMatchedPros(matched);

      // Simulate pros being notified one by one
      matched.forEach((pro, i) => {
        setTimeout(() => {
          setNotifiedCount(prev => prev + 1);
        }, i * 600);
      });
    }, 1200);

    // Phase 2: done — this used to fabricate a specific "accepted" pro
    // (picked from the mock PROS array, not a real account) and publish a
    // fake "assigned" job into JOB_STORE alongside the real job that was
    // actually saved to Supabase. That meant every homeowner who posted a
    // job saw a "You got a match!" screen naming a pro who doesn't really
    // exist, with "Message Pro" / "Book Now" buttons that could never work
    // since there was no real bid, conversation, or booking behind them —
    // which is exactly what looked like "messaging is broken." Real bids
    // come from real pros via the Job Board / View Bids screen, where
    // messaging already works; this screen now just confirms the post
    // succeeded instead of inventing a match.
    setTimeout(() => {
      setPhase("posted");
    }, 3200);
  });

  if (phase === "broadcasting") return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:40, textAlign:"center", background:T.sand, minHeight:"100%" }}>
      <div style={{ width:80, height:80, borderRadius:"50%", background:`linear-gradient(135deg, #1565C0, #0A9E6A)`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:36, marginBottom:20, animation:"pulse 1s infinite" }}>📡</div>
      <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, marginBottom:8 }}>Broadcasting your job…</h2>
      <p style={{ color:T.slate, fontSize:14, marginBottom:24 }}>Finding available pros in your area right now.</p>
      <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:16, width:"100%", textAlign:"left" }}>
        {[["Job", job.title], ["Category", CATEGORIES.find(c=>c.id===job.cat)?.label], ["Budget", job.budget], ["Location", "The Woodlands"]].map(([k,v]) => (
          <div key={k} style={{ display:"flex", justifyContent:"space-between", padding:"6px 0", fontSize:13, borderBottom:`1px solid ${T.border}` }}>
            <span style={{ color:T.slate }}>{k}</span>
            <span style={{ color:T.navy, fontWeight:600 }}>{v}</span>
          </div>
        ))}
      </div>
    </div>
  );

  if (phase === "matching") return (
    <div style={{ padding:20, background:T.sand, minHeight:"100%" }}>
      <div style={{ textAlign:"center", marginBottom:24 }}>
        <div style={{ fontSize:44, marginBottom:8 }}>⚡</div>
        <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, marginBottom:4 }}>Notifying pros!</h2>
        <p style={{ color:T.slate, fontSize:13 }}>{notifiedCount} of {matchedPros.length} pros notified</p>
        {/* Progress bar */}
        <div style={{ background:T.border, borderRadius:99, height:6, margin:"12px 0" }}>
          <div style={{ background:`linear-gradient(90deg, #1565C0, #0A9E6A)`, borderRadius:99, height:6, width:`${(notifiedCount/Math.max(matchedPros.length,1))*100}%`, transition:"width 0.5s" }} />
        </div>
      </div>

      <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:10 }}>MATCHED PROS BEING NOTIFIED</div>
      <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
        {matchedPros.map((pro, i) => {
          const notified = i < notifiedCount;
          return (
            <div key={pro.id} style={{
              background:T.white, borderRadius:14, padding:14, border:`1px solid ${T.border}`,
              display:"flex", alignItems:"center", gap:12,
              opacity: notified ? 1 : 0.4, transition:"opacity 0.4s",
            }}>
              <Avatar initials={pro.img} size={40} color={notified ? T.cobalt : T.slate} />
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:700, fontSize:14, color:T.navy }}>{pro.name}</div>
                <div style={{ fontSize:12, color:T.slate }}>{pro.city} · {CATEGORIES.find(c=>c.id===pro.cat)?.label}</div>
              </div>
              <div style={{ fontSize:12, fontWeight:700 }}>
                {notified
                  ? <span style={{ color:T.green }}>✅ Notified</span>
                  : <span style={{ color:T.slate }}>⏳ Pending</span>}
              </div>
            </div>
          );
        })}
        {matchedPros.length === 0 && (
          <div style={{ textAlign:"center", padding:24, color:T.slate, fontSize:14 }}>
            No available pros found nearby. Your job is still posted on the board — pros will see it shortly.
          </div>
        )}
      </div>
    </div>
  );

  if (phase === "posted") return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:32, textAlign:"center", background:T.sand, minHeight:"100%" }}>
      <div style={{ width:80, height:80, borderRadius:"50%", background:T.greenL, display:"flex", alignItems:"center", justifyContent:"center", fontSize:44, marginBottom:20 }}>✅</div>
      <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, marginBottom:8 }}>Your job is posted!</h2>
      <p style={{ color:T.slate, fontSize:14, marginBottom:20 }}>
        Nearby pros have been notified. You'll get an alert as bids start coming in — check the Job Board to view and accept them.
      </p>

      <div style={{ background:T.cobaltL, borderRadius:12, padding:14, width:"100%", marginBottom:20, fontSize:13, color:T.cobalt, lineHeight:1.6 }}>
        💬 Once you accept a pro's bid, you can message them directly from My Bids or the Job Board.
      </div>

      <div style={{ width:"100%" }}>
        <Btn label="Done" onClick={onDone} />
      </div>
    </div>
  );

  return null;
}

// ── Pro Job Alert Hook ─────────────────────────────────────────
function useJobMatching(userType) {
  const [incomingJob, setIncomingJob] = useState(null);
  const [acceptedJob, setAcceptedJob] = useState(null);

  useState(() => {
    if (userType !== "pro") return;
    const unsub = JOB_STORE.subscribe(job => {
      const matches = matchProsToJob(job);
      if (matches.length > 0) setIncomingJob(job);
    });
    return unsub;
  });

  const acceptJob = (job) => {
    setAcceptedJob(job);
    setIncomingJob(null);
  };

  const declineJob = () => setIncomingJob(null);

  return { incomingJob, acceptedJob, acceptJob, declineJob };
}


// ── Instant Quote / Bid System ─────────────────────────────────

// Global bid store
const BID_STORE = {
  bids: {
    1: [
      { id:1, proId:1, proName:"Marcus Webb",    proImg:"MW", proRating:4.9, proBadge:"Top Pro",  amount:195, desc:"Parts + labor. Includes washer replacement and full inspection.", eta:"1-2 hrs", available:"Tomorrow 10am", instantBook:true,  submitted:"5m ago",  status:"pending" },
      { id:2, proId:5, proName:"Tony Reeves",    proImg:"TR", proRating:4.8, proBadge:"Verified", amount:175, desc:"Quick fix guaranteed. Will assess on-site and provide receipt.", eta:"1 hr",   available:"Today 3pm",      instantBook:false, submitted:"12m ago", status:"pending" },
      { id:3, proId:2, proName:"Sandra Torres",  proImg:"ST", proRating:4.8, proBadge:"Verified", amount:220, desc:"Full plumbing inspection included. Eco-friendly sealant.",       eta:"2 hrs",  available:"Tomorrow 9am",   instantBook:false, submitted:"18m ago", status:"pending" },
    ],
    2: [
      { id:4, proId:4, proName:"Lisa Nguyen",    proImg:"LN", proRating:4.7, proBadge:"Elite",    amount:75,  desc:"Weekly visits with mow, edge, and blow. Hedge trim +$20.",      eta:"2 hrs",  available:"Saturday 9am",   instantBook:true,  submitted:"2m ago",  status:"pending" },
      { id:5, proId:6, proName:"Maria Castillo", proImg:"MC", proRating:4.9, proBadge:"Verified", amount:90,  desc:"Full lawn care package. First visit includes aeration.",         eta:"2-3 hrs",available:"Saturday 8am",   instantBook:false, submitted:"8m ago",  status:"pending" },
    ],
    4: [
      { id:6, proId:2, proName:"Sandra Torres",  proImg:"ST", proRating:4.8, proBadge:"Verified", amount:265, desc:"Deep clean all rooms, bathrooms, kitchen. Eco products.",        eta:"4-5 hrs",available:"Tomorrow 10am", instantBook:true,  submitted:"3m ago",  status:"pending" },
      { id:7, proId:6, proName:"Maria Castillo", proImg:"MC", proRating:4.9, proBadge:"Verified", amount:290, desc:"Move-in special: includes fridge, oven, and window cleaning.",   eta:"5-6 hrs",available:"Friday 9am",     instantBook:false, submitted:"9m ago",  status:"pending" },
    ],
    5: [
      { id:8, proId:5, proName:"Tony Reeves",    proImg:"TR", proRating:4.8, proBadge:"Verified", amount:380, desc:"Drywall patch, sand, prime, and paint. Matches existing color.", eta:"3-4 hrs",available:"Thursday 2pm",   instantBook:true,  submitted:"1m ago",  status:"pending" },
      { id:9, proId:1, proName:"Marcus Webb",    proImg:"MW", proRating:4.9, proBadge:"Top Pro",  amount:420, desc:"Two-coat finish. Includes texturing to match existing wall.",    eta:"4-5 hrs",available:"Friday 10am",    instantBook:false, submitted:"7m ago",  status:"pending" },
    ],
    6: [
      { id:10, proId:3, proName:"Derek Okafor",  proImg:"DO", proRating:5.0, proBadge:"Top Pro",  amount:160, desc:"Full interior detail: vacuum, shampoo, wipe-down, glass clean.", eta:"2-3 hrs",available:"Today 4pm",      instantBook:true,  submitted:"8m ago",  status:"pending" },
    ],
  },
  listeners: [],
  subscribe(fn) { this.listeners.push(fn); return () => { this.listeners = this.listeners.filter(l => l !== fn); }; },
  addBid(jobId, bid) {
    if (!this.bids[jobId]) this.bids[jobId] = [];
    this.bids[jobId] = [bid, ...this.bids[jobId]];
    this.listeners.forEach(fn => fn(jobId, bid));
  },
  getBids(jobId) { return this.bids[jobId] || []; },
};

// ── Saved / Favorite Pros Store ─────────────────────────────────
// Previously "Save" on a pro's profile only flipped local component state
// that vanished the moment you navigated away, and the account page's
// "Saved Pros" list was a hardcoded array with no way to ever add to it —
// so saving a pro didn't actually do anything. This is a real shared store
// (same pub/sub pattern as JOB_STORE/BID_STORE above) so a save in one
// screen is reflected everywhere else in the app immediately.
// It now also syncs to Supabase's saved_pros table (see toggle() and the
// hydration effect in useSavedPros() below) so favorites persist across
// reloads/devices — but only once both the homeowner and the pro are real
// Supabase rows (recognizable by UUID ids), same as the bookings/bids sync.
const SAVED_STORE = {
  pros: new Map(),
  listeners: [],
  hydratedFor: null,
  subscribe(fn) { this.listeners.push(fn); return () => { this.listeners = this.listeners.filter(l => l !== fn); }; },
  isSaved(id) { return this.pros.has(id); },
  toggle(pro, homeownerId) {
    const wasSaved = this.pros.has(pro.id);
    if (wasSaved) this.pros.delete(pro.id);
    else this.pros.set(pro.id, pro);
    this.listeners.forEach(fn => fn());

    if (homeownerId && typeof pro.id === 'string') {
      if (wasSaved) {
        sbDelete('saved_pros', `?homeowner_id=eq.${homeownerId}&pro_id=eq.${pro.id}`)
          .catch(err => console.log('Unsave sync error:', err));
      } else {
        sbInsert('saved_pros', { homeowner_id: homeownerId, pro_id: pro.id })
          .catch(err => console.log('Save sync error:', err));
      }
    }
  },
  getAll() { return Array.from(this.pros.values()); },
  setAll(prosArray) {
    this.pros = new Map(prosArray.map(p => [p.id, p]));
    this.listeners.forEach(fn => fn());
  },
};

// Hook: subscribe a component to the saved-pros store, and (if a real
// homeowner id is passed) hydrate it from Supabase's saved_pros table once
// per login so favorites are there on reload, not just for the session.
function useSavedPros(homeownerId) {
  const [, forceUpdate] = useState(0);
  useEffect(() => {
    const unsubscribe = SAVED_STORE.subscribe(() => forceUpdate(n => n + 1));
    return unsubscribe;
  }, []);

  useEffect(() => {
    if (!homeownerId || SAVED_STORE.hydratedFor === homeownerId) return;
    SAVED_STORE.hydratedFor = homeownerId;
    (async () => {
      try {
        const rows = await sbFetch('saved_pros',
          `?homeowner_id=eq.${homeownerId}&select=pro_profiles(id,user_id,bio,hourly_rate,services,city,badge,avg_rating,review_count,jobs_completed,available,users(full_name,avatar_url))`
        );
        if (rows && rows.length > 0) {
          const mapped = rows.filter(r => r.pro_profiles).map(r => {
            const p = r.pro_profiles;
            return {
              id:        p.id,
              userId:    p.user_id,
              name:      p.users?.full_name || 'Pro',
              cat:       p.services?.[0] || 'handyman',
              rating:    parseFloat(p.avg_rating) || 0,
              reviews:   p.review_count || 0,
              rate:      p.hourly_rate ? `$${p.hourly_rate}/hr` : 'Contact for rate',
              city:      p.city || 'The Woodlands',
              available: p.available ?? true,
              img:       (p.users?.full_name || 'PR').split(' ').map(n=>n[0]).join('').slice(0,2).toUpperCase(),
              avatar:    p.users?.avatar_url || null,
              badge:     p.badge || 'Verified',
            };
          });
          SAVED_STORE.setAll(mapped);
        }
      } catch (err) {
        console.log('Using local saved pros:', err.message);
      }
    })();
  }, [homeownerId]);

  return {
    savedPros: SAVED_STORE.getAll(),
    isSaved: (id) => SAVED_STORE.isSaved(id),
    toggleSaved: (pro) => SAVED_STORE.toggle(pro, homeownerId),
  };
}

// ── Pro Rates Customer — Store ───────────────────────────────────
// Ratings pros leave for homeowners after a job, keyed by job id so each
// completed job can only be rated once. Same in-memory pub/sub pattern as
// the other stores above (SAVED_STORE, BID_STORE, JOB_STORE) — this is
// session-only until it's wired to the real `reviews` table in Supabase.
const CUSTOMER_RATING_STORE = {
  ratings: {}, // jobId -> { rating, tags, note, client, submittedAt }
  listeners: [],
  subscribe(fn) { this.listeners.push(fn); return () => { this.listeners = this.listeners.filter(l => l !== fn); }; },
  isRated(jobId) { return !!this.ratings[jobId]; },
  getRating(jobId) { return this.ratings[jobId] || null; },
  submit(jobId, data) {
    this.ratings[jobId] = { ...data, submittedAt: Date.now() };
    this.listeners.forEach(fn => fn());
  },
};

function useCustomerRatings() {
  const [, forceUpdate] = useState(0);
  useEffect(() => {
    const unsubscribe = CUSTOMER_RATING_STORE.subscribe(() => forceUpdate(n => n + 1));
    return unsubscribe;
  }, []);
  return {
    isRated: (jobId) => CUSTOMER_RATING_STORE.isRated(jobId),
    getRating: (jobId) => CUSTOMER_RATING_STORE.getRating(jobId),
    submitRating: (jobId, data) => CUSTOMER_RATING_STORE.submit(jobId, data),
  };
}

// ── Rate Customer Modal (shown to pro after a completed job) ────
function RateCustomerPrompt({ job, authUser, onDone, onSkip }) {
  const { submitRating } = useCustomerRatings();
  const [rating, setRating]     = useState(0);
  const [hover, setHover]       = useState(0);
  const [note, setNote]         = useState("");
  const [tags, setTags]         = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const QUICK_TAGS = [
    "On time", "Clear instructions", "Respectful", "Paid promptly",
    "Easy to work with", "Great communication", "Would work with again",
  ];

  const toggleTag = (tag) => setTags(prev =>
    prev.includes(tag) ? prev.filter(t => t !== tag) : [...prev, tag]
  );

  // Real only when this is an actual completed booking (real UUID id,
  // real pro/homeowner ids) — the app's mock/demo "recent jobs" no longer
  // exist, but this guard is cheap insurance against any local-only
  // booking slipping through. Same real-vs-mock pattern used everywhere
  // else in this file.
  const canPersist = !!(job?.id && typeof job.id === 'string' && job?.proId && job?.homeownerId);

  const handleSubmit = async () => {
    setSubmitting(true);
    setSubmitError("");
    try {
      if (canPersist) {
        await sbInsert('reviews', {
          booking_id:    job.id,
          pro_id:        job.proId,
          homeowner_id:  job.homeownerId,
          reviewer_role: 'pro',
          rating,
          review_text:   note || null,
          tags,
        });
      }
      submitRating(job.id, { rating, tags, note, client: job.client });
      onDone && onDone();
    } catch (err) {
      setSubmitError(err.message || "Could not save this rating.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{
      position:"fixed", inset:0, background:"rgba(10,37,64,0.6)",
      display:"flex", alignItems:"flex-end", justifyContent:"center",
      zIndex:999, fontFamily:"'DM Sans', sans-serif", overflowY:"auto",
    }}>
      <div style={{
        background:T.white, borderRadius:"20px 20px 0 0",
        padding:"8px 0 32px", width:"100%", maxWidth:420,
        maxHeight:"90vh", overflowY:"auto",
      }}>
        <div style={{ width:40, height:4, borderRadius:99, background:T.border, margin:"12px auto 20px" }} />

        <div style={{ padding:"0 20px" }}>
          {/* Customer info */}
          <div style={{ display:"flex", gap:12, alignItems:"center", marginBottom:20 }}>
            <Avatar initials={(job.client || "HO").split(" ").map(n=>n[0]).join("").slice(0,2).toUpperCase()} size={44} color={T.green} />
            <div>
              <div style={{ fontWeight:700, fontSize:15, color:T.navy }}>Rate {job.client}</div>
              <div style={{ fontSize:12, color:T.slate }}>{job.job}</div>
            </div>
          </div>

          {/* Star rating */}
          <div style={{ textAlign:"center", marginBottom:16 }}>
            <div style={{ fontSize:13, fontWeight:700, color:T.slate, letterSpacing:"0.08em", marginBottom:10 }}>HOW WAS THIS CUSTOMER?</div>
            <div style={{ display:"flex", gap:6, justifyContent:"center", marginBottom:8 }}>
              {[1,2,3,4,5].map(s => (
                <span key={s} onClick={() => setRating(s)}
                  onMouseEnter={() => setHover(s)} onMouseLeave={() => setHover(0)}
                  style={{ fontSize:40, cursor:"pointer", color: s<=(hover||rating) ? "#F59E0B" : T.border, transition:"color 0.1s" }}>
                  ★
                </span>
              ))}
            </div>
            <div style={{ fontSize:14, fontWeight:700, color:T.navy }}>
              {rating === 0 ? "Tap to rate" : rating === 1 ? "😞 Poor" : rating === 2 ? "😕 Fair" : rating === 3 ? "😊 Good" : rating === 4 ? "😄 Great!" : "🤩 Excellent!"}
            </div>
          </div>

          {/* Quick tags */}
          {rating >= 3 && (
            <div style={{ marginBottom:16 }}>
              <div style={{ fontSize:12, fontWeight:700, color:T.slate, letterSpacing:"0.08em", marginBottom:10 }}>WHAT STOOD OUT?</div>
              <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
                {QUICK_TAGS.map(tag => (
                  <button key={tag} onClick={() => toggleTag(tag)} style={{
                    padding:"6px 14px", borderRadius:99, cursor:"pointer", fontSize:12, fontWeight:600,
                    background: tags.includes(tag) ? T.green : T.sand,
                    color: tags.includes(tag) ? T.white : T.navy,
                    border:`1.5px solid ${tags.includes(tag) ? T.green : T.border}`,
                    fontFamily:"'DM Sans', sans-serif",
                  }}>{tags.includes(tag) ? "✓ " : ""}{tag}</button>
                ))}
              </div>
            </div>
          )}

          {/* Private note */}
          <div style={{ marginBottom:20 }}>
            <div style={{ fontSize:12, fontWeight:700, color:T.slate, letterSpacing:"0.08em", marginBottom:8 }}>PRIVATE NOTE <span style={{ fontWeight:400, color:T.slate }}>(optional, not shown to customer)</span></div>
            <textarea value={note} onChange={e => setNote(e.target.value)}
              placeholder="Anything worth remembering for next time…"
              rows={3} style={{ width:"100%", padding:"10px 12px", borderRadius:10, border:`1.5px solid ${T.border}`, fontSize:14, fontFamily:"'DM Sans', sans-serif", resize:"none", outline:"none", boxSizing:"border-box", lineHeight:1.5 }} />
          </div>

          {submitError && (
            <div style={{ background:T.coralL, color:T.coral, borderRadius:10, padding:"8px 12px", fontSize:12, marginBottom:10 }}>
              ⚠️ {submitError}
            </div>
          )}
          <div style={{ display:"flex", gap:10 }}>
            <button onClick={handleSubmit} disabled={!rating || submitting} style={{
              flex:1, padding:"10px 20px", borderRadius:8, border:"none", cursor: rating && !submitting ? "pointer" : "not-allowed",
              background: rating ? T.cobalt : T.border, color:T.white, fontWeight:600, fontSize:14,
              fontFamily:"'DM Sans', sans-serif", opacity: submitting ? 0.7 : 1,
            }}>
              {submitting ? "⏳ Submitting…" : "Submit Rating"}
            </button>
            <Btn label="Skip" variant="ghost" onClick={onSkip} small />
          </div>
        </div>
      </div>
    </div>
  );
}

// ── View Bids Screen (Homeowner) ───────────────────────────────
function ViewBidsView({ job, onBack, onBook, authUser }) {
  const [bids, setBids]           = useState(BID_STORE.getBids(job?.id));
  const [sortBy, setSortBy]       = useState("recommended"); // recommended | price_low | price_high | rating | fastest
  const [filter, setFilter]       = useState("all");         // all | instant
  const [selectedBid, setSelectedBid] = useState(null);
  const [acceptedBid, setAcceptedBid] = useState(null);
  const [counterBid, setCounterBid]   = useState(null);
  const [counterAmt, setCounterAmt]   = useState("");
  const [counterDate, setCounterDate] = useState("");
  const [counterTime, setCounterTime] = useState("");
  const [showCounter, setShowCounter] = useState(false);
  const cat = CATEGORIES.find(c => c.id === job?.cat);

  // Pull in any real bids from Supabase (only jobs with a real UUID id — i.e.
  // posted while a real pro_profiles/jobs pipeline exists — will have rows
  // here). Merges into BID_STORE so the rest of this screen doesn't need to
  // know whether a bid is real or mock.
  useEffect(() => {
    if (!job?.id || typeof job.id !== 'string') return;
    (async () => {
      try {
        const data = await sbFetch('bids', `?job_id=eq.${job.id}&select=*,pro_profiles(id,user_id,badge,avg_rating,subscription_tier,users(full_name,avatar_url))`);
        if (data && data.length > 0) {
          const mapped = data.map(b => ({
            id: b.id, proId: b.pro_id, proUserId: b.pro_profiles?.user_id || null,
            proName:   b.pro_profiles?.users?.full_name || 'Pro',
            proImg:    (b.pro_profiles?.users?.full_name || 'PR').split(' ').map(n=>n[0]).join('').slice(0,2).toUpperCase(),
            proAvatar: b.pro_profiles?.users?.avatar_url || null,
            proRating: parseFloat(b.pro_profiles?.avg_rating) || 0,
            proBadge:  b.pro_profiles?.badge || 'Verified',
            proIsPlus: b.pro_profiles?.subscription_tier === 'plus',
            amount:    b.amount, desc: b.description, eta: b.eta,
            available: b.available_when, instantBook: b.instant_book,
            submitted: formatTimeAgo(b.created_at), status: b.status,
          }));
          mapped.forEach(b => BID_STORE.addBid(job.id, b));
          setBids(BID_STORE.getBids(job.id));
        }
      } catch (err) {
        console.log('Using mock bids:', err.message);
      }
    })();
  }, [job?.id]);

  // Accept a bid: update the local/mock view immediately, and if it's a real
  // (Supabase) bid, persist the accepted status too. Instant Book bids skip
  // the "Bid Accepted!" interstitial entirely and go straight to payment —
  // that's the whole point of Instant Book: no extra step, no waiting on
  // the pro to confirm. A regular bid still shows the interstitial since
  // the pro hasn't pre-committed to same-day availability.
  const handleAccept = (bid) => {
    if (typeof bid.id === 'string') {
      sbUpdate('bids', bid.id, { status: 'accepted' }).catch(err => console.log('Bid accept save error:', err));
      if (bid.instantBook && typeof job?.id === 'string') {
        sbUpdate('jobs', job.id, { status: 'assigned' }).catch(err => console.log('Job status update error:', err));
      }
      // Tell the pro — before this, accepting a bid only ever updated the
      // row in Supabase; nothing ever notified the pro that they'd won the
      // job, so they'd only find out by happening to reopen My Bids.
      if (bid.proUserId) {
        sendPushNotification(
          bid.proUserId,
          'Your bid was accepted! 🎉',
          `${authUser?.name || 'A homeowner'} accepted your $${bid.amount} bid on "${job?.title || 'their job'}".`,
          { type: 'bid', jobId: job?.id }
        );
      }
    }
    if (bid.instantBook) {
      onBook && onBook(bid);
    } else {
      setAcceptedBid(bid);
    }
  };

  // Send a counter offer back to the pro. The bids table already has a
  // counter_amount column and a 'countered' status for exactly this (see
  // localy_database.sql) and the homeowner already has UPDATE rights on
  // their own job's bids (rls_fix_migration.sql) — this was previously just
  // a dead button that closed the panel without saving anything.
  const [counterError, setCounterError] = useState(null);

  // Turns whatever the homeowner filled in (date only, time only, or
  // both) into a short display string like "Aug 28 · 2:00 PM" — same
  // free-text idea as the pro's own available_when field, just built
  // from real date/time inputs instead of typed text.
  const formatCounterWhen = (dateStr, timeStr) => {
    if (!dateStr && !timeStr) return '';
    try {
      const d = new Date(`${dateStr || new Date().toISOString().slice(0,10)}T${timeStr || '00:00'}`);
      if (!isNaN(d.getTime())) {
        const dateLabel = dateStr ? d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '';
        const timeLabel = timeStr ? d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }) : '';
        return [dateLabel, timeLabel].filter(Boolean).join(' · ');
      }
    } catch {}
    return [dateStr, timeStr].filter(Boolean).join(' ');
  };

  const handleSendCounter = async (bid) => {
    const amt = Number(counterAmt);
    if (!amt || amt <= 0) return;
    setCounterError(null);
    const counterWhen = formatCounterWhen(counterDate, counterTime);
    if (typeof bid.id === 'string') {
      try {
        await sbUpdate('bids', bid.id, { status: 'countered', counter_amount: amt, counter_available_when: counterWhen || null });
      } catch (err) {
        setCounterError(err.message);
        return;
      }
    }
    setBids(prev => prev.map(b => b.id === bid.id ? { ...b, status: 'countered', counterAmount: amt, counterAvailableWhen: counterWhen } : b));
    if (bid.proUserId) {
      sendPushNotification(
        bid.proUserId,
        'You got a counter-offer',
        `${authUser?.name || 'A homeowner'} countered your bid on "${job?.title || 'their job'}" with $${amt}${counterWhen ? ` for ${counterWhen}` : ''}.`,
        { type: 'bid', jobId: job?.id }
      );
    }
    setShowCounter(false);
    setSelectedBid(null);
  };

  const sorted = [...bids]
    .filter(b => filter === "instant" ? b.instantBook : true)
    .sort((a,b) => {
      if (sortBy === "price_low")  return a.amount - b.amount;
      if (sortBy === "price_high") return b.amount - a.amount;
      if (sortBy === "rating")     return b.proRating - a.proRating;
      if (sortBy === "fastest")    return a.eta.localeCompare(b.eta);
      // Recommended: Pro Plus first (the featured-placement perk they're
      // paying for), then instant book, then by rating.
      if (a.proIsPlus !== b.proIsPlus) return b.proIsPlus ? 1 : -1;
      if (a.instantBook !== b.instantBook) return b.instantBook ? 1 : -1;
      return b.proRating - a.proRating;
    });

  const avgBid = bids.length ? Math.round(bids.reduce((a,b) => a+b.amount, 0) / bids.length) : 0;
  const lowestBid = bids.length ? Math.min(...bids.map(b => b.amount)) : 0;

  if (acceptedBid) return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:32, textAlign:"center", background:T.sand, minHeight:"100%", fontFamily:"'DM Sans', sans-serif" }}>
      <div style={{ width:80, height:80, borderRadius:"50%", background:T.greenL, display:"flex", alignItems:"center", justifyContent:"center", fontSize:44, marginBottom:20 }}>🎉</div>
      <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, marginBottom:8 }}>Bid Accepted!</h2>
      <p style={{ color:T.slate, fontSize:14, marginBottom:20 }}>
        <strong>{acceptedBid.proName}</strong> has been notified and will confirm shortly.
      </p>
      <div style={{ background:T.white, borderRadius:16, border:`1px solid ${T.border}`, padding:20, width:"100%", marginBottom:20, textAlign:"left" }}>
        {[
          ["Pro",       acceptedBid.proName],
          ["Amount",    `$${acceptedBid.amount}`],
          ["Est. Time", acceptedBid.eta],
          ["Available", acceptedBid.available],
          ["Job",       job?.title],
        ].map(([k,v]) => (
          <div key={k} style={{ display:"flex", justifyContent:"space-between", padding:"7px 0", fontSize:14, borderBottom:`1px solid ${T.border}` }}>
            <span style={{ color:T.slate }}>{k}</span>
            <span style={{ color:T.navy, fontWeight:600 }}>{v}</span>
          </div>
        ))}
      </div>
      <div style={{ display:"flex", gap:10, width:"100%" }}>
        <Btn label="💬 Message Pro" onClick={onBack} variant="secondary" />
        <Btn label="💳 Pay Now" onClick={() => onBook && onBook(acceptedBid)} />
      </div>
    </div>
  );

  return (
    <div style={{ background:T.sand, minHeight:"100%", fontFamily:"'DM Sans', sans-serif" }}>

      {/* Header */}
      <div style={{ background:`linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, padding:"16px 16px 20px" }}>
        <button onClick={onBack} style={{ background:"rgba(255,255,255,0.15)", border:"none", color:T.white, borderRadius:8, padding:"6px 12px", cursor:"pointer", fontSize:13, marginBottom:12, fontFamily:"'DM Sans', sans-serif" }}>← Back</button>
        <div style={{ display:"flex", gap:10, alignItems:"center", marginBottom:12 }}>
          {cat?.icon && <img src={cat.icon} alt="" style={{ width:28, height:28, objectFit:"contain", filter:"brightness(0) invert(1)" }} />}
          <div>
            <div style={{ color:T.white, fontWeight:700, fontSize:16 }}>{job?.title}</div>
            <div style={{ color:"rgba(255,255,255,0.7)", fontSize:12 }}>📍 {job?.city} · {job?.budget} budget</div>
          </div>
        </div>
        {/* Bid summary stats */}
        <div style={{ display:"flex", gap:0, background:"rgba(255,255,255,0.12)", borderRadius:12, overflow:"hidden" }}>
          {[
            [bids.length, "Total Bids"],
            [`$${lowestBid}`, "Lowest"],
            [`$${avgBid}`, "Average"],
            [bids.filter(b=>b.instantBook).length, "Instant Book"],
          ].map(([v,l],i) => (
            <div key={l} style={{ flex:1, textAlign:"center", padding:"10px 6px", borderRight: i<3 ? "1px solid rgba(255,255,255,0.15)" : "none" }}>
              <div style={{ color:T.white, fontWeight:800, fontSize:18 }}>{v}</div>
              <div style={{ color:"rgba(255,255,255,0.6)", fontSize:10, fontWeight:600 }}>{l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Controls */}
      <div style={{ background:T.white, borderBottom:`1px solid ${T.border}`, padding:"10px 14px", display:"flex", gap:8, alignItems:"center" }}>
        <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={{ flex:1, padding:"6px 10px", borderRadius:8, border:`1px solid ${T.border}`, fontSize:12, fontWeight:700, fontFamily:"'DM Sans', sans-serif", outline:"none", color:T.navy }}>
          <option value="recommended">⭐ Recommended</option>
          <option value="price_low">💲 Lowest Price</option>
          <option value="price_high">💰 Highest Price</option>
          <option value="rating">🌟 Top Rated</option>
          <option value="fastest">⚡ Fastest</option>
        </select>
        <button onClick={() => setFilter(filter==="instant" ? "all" : "instant")} style={{
          padding:"6px 12px", borderRadius:8, border:`1.5px solid ${filter==="instant" ? T.green : T.border}`,
          background: filter==="instant" ? T.greenL : T.white, color: filter==="instant" ? T.green : T.slate,
          fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"'DM Sans', sans-serif", whiteSpace:"nowrap",
        }}>⚡ Instant Only</button>
      </div>

      {/* Bid cards */}
      <div style={{ padding:14, display:"flex", flexDirection:"column", gap:12 }}>
        {sorted.map((bid, idx) => {
          const isSelected = selectedBid?.id === bid.id;
          const isRecommended = idx === 0 && sortBy === "recommended";
          return (
            <div key={bid.id} style={{
              background:T.white, borderRadius:16,
              border:`2px solid ${isSelected ? T.cobalt : isRecommended ? T.green : T.border}`,
              overflow:"hidden", boxShadow: isSelected ? "0 4px 20px rgba(21,101,192,0.15)" : "0 1px 6px rgba(0,0,0,0.06)",
              transition:"all 0.2s",
            }}>
              {/* Recommended badge */}
              {isRecommended && (
                <div style={{ background:`linear-gradient(90deg, ${T.green}, #07C47F)`, padding:"5px 14px", display:"flex", alignItems:"center", gap:6 }}>
                  <span style={{ color:T.white, fontSize:11, fontWeight:800, letterSpacing:"0.08em" }}>⭐ LOCALY RECOMMENDED</span>
                </div>
              )}
              {bid.instantBook && !isRecommended && (
                <div style={{ background:`linear-gradient(90deg, #1565C0, #0A9E6A)`, padding:"4px 14px" }}>
                  <span style={{ color:T.white, fontSize:10, fontWeight:800, letterSpacing:"0.08em" }}>⚡ INSTANT BOOK AVAILABLE</span>
                </div>
              )}

              <div style={{ padding:16 }}>
                {/* Pro info row */}
                <div style={{ display:"flex", gap:12, alignItems:"flex-start", marginBottom:12 }}>
                  <Avatar initials={bid.proImg} src={bid.proAvatar} size={46} color={T.cobalt} />
                  <div style={{ flex:1 }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                      <div>
                        <div style={{ fontWeight:700, fontSize:15, color:T.navy }}>{bid.proName}</div>
                        <Stars rating={bid.proRating} />
                      </div>
                      <div style={{ textAlign:"right" }}>
                        <div style={{ fontSize:24, fontWeight:800, color:T.navy }}>${bid.amount}</div>
                        <div style={{ fontSize:11, color:T.slate }}>total est.</div>
                      </div>
                    </div>
                    <div style={{ display:"flex", gap:6, marginTop:4, flexWrap:"wrap" }}>
                      <Badge label={bid.proBadge} />
                      {bid.proIsPlus && <span style={{ background:"#FFF4D6", color:"#8A6300", fontSize:10, fontWeight:700, padding:"2px 8px", borderRadius:99 }}>⭐ Pro Plus</span>}
                      {bid.instantBook && <span style={{ background:T.greenL, color:T.green, fontSize:10, fontWeight:700, padding:"2px 8px", borderRadius:99 }}>⚡ Instant</span>}
                    </div>
                  </div>
                </div>

                {/* Bid details */}
                <div style={{ background:T.sand, borderRadius:10, padding:12, marginBottom:12 }}>
                  <p style={{ fontSize:13, color:T.navy, lineHeight:1.6, margin:"0 0 8px" }}>{bid.desc}</p>
                  <div style={{ display:"flex", gap:16 }}>
                    {[["⏱️", bid.eta], ["📅", bid.available], ["🕐", bid.submitted]].map(([icon, val]) => (
                      <div key={val} style={{ fontSize:11, color:T.slate }}>{icon} {val}</div>
                    ))}
                  </div>
                </div>

                {/* Price comparison */}
                {avgBid > 0 && (
                  <div style={{ marginBottom:12 }}>
                    <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, color:T.slate, marginBottom:4 }}>
                      <span>vs average bid (${avgBid})</span>
                      <span style={{ fontWeight:700, color: bid.amount < avgBid ? T.green : T.coral }}>
                        {bid.amount < avgBid ? `$${avgBid - bid.amount} below avg` : bid.amount > avgBid ? `$${bid.amount - avgBid} above avg` : "At average"}
                      </span>
                    </div>
                    <div style={{ background:T.border, borderRadius:99, height:4 }}>
                      <div style={{ background: bid.amount <= avgBid ? T.green : T.cobalt, borderRadius:99, height:4, width:`${Math.min(100, (bid.amount/Math.max(...bids.map(b=>b.amount)))*100)}%` }} />
                    </div>
                  </div>
                )}

                {/* Action buttons */}
                {!isSelected ? (
                  <div style={{ display:"flex", gap:8 }}>
                    <button onClick={() => setSelectedBid(bid)} style={{ flex:1, padding:"10px", borderRadius:10, border:`1.5px solid ${T.border}`, background:T.white, color:T.navy, fontWeight:600, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                      View Details
                    </button>
                    {bid.instantBook ? (
                      <button onClick={() => handleAccept(bid)} style={{ flex:2, padding:"10px", borderRadius:10, border:"none", background:`linear-gradient(135deg, #1565C0, #0A9E6A)`, color:T.white, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                        ⚡ Book Instantly — ${bid.amount}
                      </button>
                    ) : (
                      <button onClick={() => handleAccept(bid)} style={{ flex:2, padding:"10px", borderRadius:10, border:"none", background:T.cobalt, color:T.white, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                        ✓ Accept Bid — ${bid.amount}
                      </button>
                    )}
                  </div>
                ) : (
                  <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                    <div style={{ display:"flex", gap:8 }}>
                      <button onClick={() => setSelectedBid(null)} style={{ flex:1, padding:"10px", borderRadius:10, border:`1.5px solid ${T.border}`, background:T.white, color:T.slate, fontWeight:600, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                        ← Back
                      </button>
                      {/* Countering defeats the point of Instant Book — that
                          price is the pro's pre-committed, no-negotiation rate. */}
                      {!bid.instantBook && (
                        <button onClick={() => { setShowCounter(true); setCounterAmt(String(Math.round(bid.amount * 0.9))); setCounterDate(""); setCounterTime(""); }} style={{ flex:1, padding:"10px", borderRadius:10, border:`1.5px solid ${T.amber}`, background:T.amberL, color:T.amber, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                          💬 Counter
                        </button>
                      )}
                      {bid.instantBook ? (
                        <button onClick={() => handleAccept(bid)} style={{ flex:2, padding:"10px", borderRadius:10, border:"none", background:`linear-gradient(135deg, #1565C0, #0A9E6A)`, color:T.white, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                          ⚡ Book Now
                        </button>
                      ) : (
                        <button onClick={() => handleAccept(bid)} style={{ flex:2, padding:"10px", borderRadius:10, border:"none", background:T.green, color:T.white, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                          ✓ Accept
                        </button>
                      )}
                    </div>
                    {/* Counter offer input */}
                    {showCounter && (
                      <div style={{ background:T.amberL, borderRadius:10, padding:12, border:`1px solid ${T.amber}33` }}>
                        <div style={{ fontSize:12, fontWeight:700, color:T.amber, marginBottom:8 }}>💬 COUNTER OFFER</div>
                        <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                          <span style={{ fontSize:16, fontWeight:700, color:T.navy }}>$</span>
                          <input value={counterAmt} onChange={e => setCounterAmt(e.target.value.replace(/[^0-9]/g,""))}
                            placeholder="Your offer"
                            style={{ flex:1, padding:"8px 12px", borderRadius:8, border:`1px solid ${T.border}`, fontSize:16, fontWeight:700, fontFamily:"'DM Sans', sans-serif", outline:"none", color:T.navy }} />
                          <button onClick={() => handleSendCounter(bid)} disabled={!counterAmt} style={{ padding:"8px 14px", borderRadius:8, border:"none", background:T.amber, color:T.white, fontWeight:700, cursor: counterAmt ? "pointer" : "default", opacity: counterAmt ? 1 : 0.6, fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                            Send
                          </button>
                        </div>
                        <div style={{ fontSize:11, fontWeight:700, color:T.slate, marginTop:10, marginBottom:6, letterSpacing:"0.06em" }}>PREFERRED DATE &amp; TIME (OPTIONAL)</div>
                        <div style={{ display:"flex", gap:8 }}>
                          <input type="date" value={counterDate} onChange={e => setCounterDate(e.target.value)}
                            style={{ flex:1, padding:"8px 10px", borderRadius:8, border:`1px solid ${T.border}`, fontSize:13, fontFamily:"'DM Sans', sans-serif", outline:"none", color:T.navy, background:T.white }} />
                          <input type="time" value={counterTime} onChange={e => setCounterTime(e.target.value)}
                            style={{ flex:1, padding:"8px 10px", borderRadius:8, border:`1px solid ${T.border}`, fontSize:13, fontFamily:"'DM Sans', sans-serif", outline:"none", color:T.navy, background:T.white }} />
                        </div>
                        <div style={{ fontSize:11, color:T.slate, marginTop:6 }}>
                          Original: ${bid.amount}{bid.available ? ` · ${bid.available}` : ''} · Your offer: {counterAmt ? `$${counterAmt}` : "—"} {counterAmt && bid.amount ? `(${Math.round(((Number(counterAmt)-bid.amount)/bid.amount)*100)}%)` : ""}{(counterDate || counterTime) ? ` for ${formatCounterWhen(counterDate, counterTime)}` : ''}
                        </div>
                        {counterError && (
                          <div style={{ fontSize:11, color:T.coral, marginTop:6 }}>⚠️ Couldn't send counter offer: {counterError}</div>
                        )}
                      </div>
                    )}
                    {bid.status === 'countered' && !showCounter && (
                      <div style={{ background:T.amberL, borderRadius:10, padding:"8px 12px", fontSize:12, color:T.amber, fontWeight:700 }}>
                        💬 Counter offer sent: ${bid.counterAmount}{bid.counterAvailableWhen ? ` for ${bid.counterAvailableWhen}` : ''} — waiting on {bid.proName} to respond
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          );
        })}

        {sorted.length === 0 && (
          <div style={{ textAlign:"center", padding:40, color:T.slate }}>
            <div style={{ fontSize:40, marginBottom:12 }}>📭</div>
            <div style={{ fontWeight:700, fontSize:16, color:T.navy }}>No bids yet</div>
            <div style={{ fontSize:13, marginTop:4 }}>Pros in your area will see this job and send quotes shortly.</div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── Place Bid Screen (Pro) ─────────────────────────────────────
function PlaceBidView({ job, onBack, authUser }) {
  const [amount, setAmount]     = useState("");
  const [desc, setDesc]         = useState("");
  const [eta, setEta]           = useState("1-2 hrs");
  const [available, setAvail]   = useState("Today");
  const [availTime, setAvailTime] = useState("10:00 AM");
  const [instantBook, setInstantBook] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [bidError, setBidError] = useState('');
  const cat = CATEGORIES.find(c => c.id === job?.cat);

  // A pro can only have one active bid per job — if they already bid on
  // this one, load it so they're adjusting their existing offer instead of
  // unknowingly submitting a second, competing bid.
  const [existingBid, setExistingBid] = useState(null);
  useEffect(() => {
    if (typeof job?.id !== 'string' || typeof authUser?.id !== 'string') return;
    (async () => {
      try {
        const proId = await getProProfileId(authUser.id);
        if (!proId) return;
        const rows = await sbFetch('bids', `?job_id=eq.${job.id}&pro_id=eq.${proId}&select=id,amount,description,eta,available_when,instant_book,status&order=created_at.desc&limit=1`);
        const b = rows?.[0];
        if (b && !['withdrawn', 'declined'].includes(b.status)) {
          setExistingBid(b);
          setAmount(String(b.amount ?? ''));
          setDesc(b.description || '');
          setEta(b.eta || '1-2 hrs');
          setInstantBook(!!b.instant_book);
        }
      } catch (err) {
        console.log('Existing bid check error:', err.message);
      }
    })();
  }, [job?.id, authUser?.id]);

  const budget = job?.budget || "$0";
  const budgetNum = parseInt(budget.replace(/[^0-9]/g,"").slice(0,4)) || 200;

  const handleSubmit = async () => {
    if (!amount || !desc) return;
    setSubmitting(true);
    setBidError('');
    // Save to Supabase first and actually check the result — this used to
    // fire-and-forget with just a console.log on failure, so a real
    // rejection (like the free-tier active-bid cap below) was invisible:
    // the pro would still see "Bid Submitted!" even though nothing was
    // saved. "skipped"/"no pro_profiles row yet" are the expected no-ops
    // for a mock job or a not-fully-set-up pro — those still fall through
    // to the local demo success state below.
    const result = await createBid({
      jobId: job.id, proUserId: authUser?.id, amount, desc, eta,
      availableText: `${available} ${availTime}`, instantBook,
    }).catch(err => ({ data: null, error: err.message }));
    const isNoOp = result?.error?.startsWith('skipped') || result?.error === 'no pro_profiles row yet';
    if (result?.error && !isNoOp) {
      setSubmitting(false);
      setBidError(result.error);
      return;
    }
    const newBid = {
      id: Date.now(), proId:1, proName:"You", proImg:"ME",
      proRating:4.9, proBadge:"Verified",
      amount:Number(amount), desc, eta,
      available:`${available} ${availTime}`,
      instantBook, submitted:"Just now", status:"pending",
    };
    setTimeout(() => {
      BID_STORE.addBid(job.id, newBid);
      setSubmitting(false);
      setSubmitted(true);
    }, 1200);
  };

  const inputStyle = { width:"100%", padding:"11px 14px", borderRadius:10, border:`1.5px solid ${T.border}`, fontSize:14, fontFamily:"'DM Sans', sans-serif", color:T.navy, outline:"none", boxSizing:"border-box", background:T.white };

  if (submitted) return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:36, textAlign:"center", background:T.sand, minHeight:"100%", fontFamily:"'DM Sans', sans-serif" }}>
      <div style={{ width:80, height:80, borderRadius:"50%", background:T.greenL, display:"flex", alignItems:"center", justifyContent:"center", fontSize:44, marginBottom:20 }}>✅</div>
      <h2 style={{ color:T.navy, fontFamily:"'DM Serif Display', serif", fontWeight:400, marginBottom:8 }}>{existingBid ? "Bid Updated!" : "Bid Submitted!"}</h2>
      <p style={{ color:T.slate, fontSize:14, marginBottom:20 }}>Your ${amount} bid is now live. The homeowner will be notified immediately.</p>
      <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:16, width:"100%", textAlign:"left", marginBottom:20 }}>
        {[["Job",job?.title],["Your Bid",`$${amount}`],["Est. Time",eta],["Available",`${available} ${availTime}`],["Instant Book",instantBook?"Yes — homeowner can book without waiting":"No — awaiting acceptance"]].map(([k,v]) => (
          <div key={k} style={{ display:"flex", justifyContent:"space-between", padding:"6px 0", fontSize:13, borderBottom:`1px solid ${T.border}` }}>
            <span style={{ color:T.slate }}>{k}</span>
            <span style={{ color:T.navy, fontWeight:600, textAlign:"right", maxWidth:"60%" }}>{v}</span>
          </div>
        ))}
      </div>
      {instantBook && (
        <div style={{ background:T.greenL, borderRadius:12, padding:14, marginBottom:20, width:"100%", fontSize:13, color:T.green, fontWeight:600, lineHeight:1.5 }}>
          ⚡ You enabled Instant Book — the homeowner can confirm right away without you needing to respond again.
        </div>
      )}
      <Btn label="Back to Jobs" onClick={onBack} />
    </div>
  );

  return (
    <div style={{ background:T.sand, minHeight:"100%", fontFamily:"'DM Sans', sans-serif" }}>

      {/* Header */}
      <div style={{ background:`linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, padding:"16px 16px 24px" }}>
        <button onClick={onBack} style={{ background:"rgba(255,255,255,0.15)", border:"none", color:T.white, borderRadius:8, padding:"6px 12px", cursor:"pointer", fontSize:13, marginBottom:14, fontFamily:"'DM Sans', sans-serif" }}>← Back</button>
        <div style={{ fontSize:11, color:"#A8BFDF", fontWeight:700, letterSpacing:"0.1em", marginBottom:6 }}>{existingBid ? "UPDATE YOUR BID" : "PLACE YOUR BID"}</div>
        {existingBid && (
          <div style={{ background:"rgba(255,255,255,0.15)", borderRadius:8, padding:"6px 10px", fontSize:11, color:T.white, marginBottom:6, display:"inline-block" }}>
            ✏️ You already bid on this job — adjusting it below instead of submitting a new one.
          </div>
        )}
        <div style={{ color:T.white, fontWeight:700, fontSize:18, marginBottom:4 }}>{job?.title}</div>
        <div style={{ color:"rgba(255,255,255,0.7)", fontSize:13 }}>📍 {job?.city} · Budget: {job?.budget}</div>
        {/* Budget range visual */}
        <div style={{ background:"rgba(255,255,255,0.1)", borderRadius:10, padding:"10px 14px", marginTop:12 }}>
          <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, color:"rgba(255,255,255,0.7)", marginBottom:6 }}>
            <span>Homeowner budget range</span>
            <span>{job?.budget}</span>
          </div>
          <div style={{ background:"rgba(255,255,255,0.2)", borderRadius:99, height:4 }}>
            <div style={{ background:"#07C47F", borderRadius:99, height:4, width:`${amount ? Math.min(100,(Number(amount)/budgetNum)*100) : 0}%`, transition:"width 0.3s" }} />
          </div>
          {amount && <div style={{ fontSize:11, color:"rgba(255,255,255,0.7)", marginTop:4, textAlign:"right" }}>Your bid: ${amount} ({Math.round((Number(amount)/budgetNum)*100)}% of budget)</div>}
        </div>
      </div>

      <div style={{ padding:16, display:"flex", flexDirection:"column", gap:14 }}>

        {/* Bid amount */}
        <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:16 }}>
          <label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:10, letterSpacing:"0.08em" }}>YOUR BID AMOUNT</label>
          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
            <span style={{ fontSize:28, fontWeight:700, color:T.slate }}>$</span>
            <input value={amount} onChange={e => setAmount(e.target.value.replace(/[^0-9]/g,""))}
              placeholder="0"
              style={{ flex:1, padding:"8px 4px", border:"none", borderBottom:`2px solid ${amount ? T.cobalt : T.border}`, fontSize:32, fontWeight:800, fontFamily:"'DM Sans', sans-serif", color:T.navy, outline:"none", background:"transparent", transition:"border 0.2s" }} />
          </div>
          {amount && Number(amount) < budgetNum * 0.7 && (
            <div style={{ fontSize:12, color:T.amber, fontWeight:600, marginTop:8 }}>⚠️ Your bid is well below the budget — great chance of winning!</div>
          )}
          {amount && Number(amount) > budgetNum * 1.1 && (
            <div style={{ fontSize:12, color:T.coral, fontWeight:600, marginTop:8 }}>🔴 Your bid exceeds the homeowner budget — consider lowering it.</div>
          )}
        </div>

        {/* Description */}
        <div>
          <label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>WHAT YOU WILL DO</label>
          <textarea value={desc} onChange={e => setDesc(e.target.value)}
            placeholder="Describe your approach, what materials you'll bring, and any guarantees you offer..."
            rows={4} style={{ ...inputStyle, resize:"none", lineHeight:1.6 }} />
          <div style={{ fontSize:11, color:T.slate, marginTop:4, textAlign:"right" }}>{desc.length}/300</div>
        </div>

        {/* Time & Availability */}
        <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:16 }}>
          <label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:12, letterSpacing:"0.08em" }}>AVAILABILITY & TIMING</label>
          <div style={{ display:"flex", gap:10, marginBottom:10 }}>
            <div style={{ flex:1 }}>
              <label style={{ fontSize:10, color:T.slate, fontWeight:600, display:"block", marginBottom:4 }}>WHEN</label>
              <select value={available} onChange={e => setAvail(e.target.value)} style={{ ...inputStyle, padding:"8px 10px", fontSize:13 }}>
                {["Today","Tomorrow","This Week","Next Week"].map(d => <option key={d} value={d}>{d}</option>)}
              </select>
            </div>
            <div style={{ flex:1 }}>
              <label style={{ fontSize:10, color:T.slate, fontWeight:600, display:"block", marginBottom:4 }}>TIME</label>
              <select value={availTime} onChange={e => setAvailTime(e.target.value)} style={{ ...inputStyle, padding:"8px 10px", fontSize:13 }}>
                {HOURS.map(h => <option key={h} value={h}>{h}</option>)}
              </select>
            </div>
          </div>
          <div style={{ display:"flex", gap:10 }}>
            <div style={{ flex:1 }}>
              <label style={{ fontSize:10, color:T.slate, fontWeight:600, display:"block", marginBottom:4 }}>EST. DURATION</label>
              <select value={eta} onChange={e => setEta(e.target.value)} style={{ ...inputStyle, padding:"8px 10px", fontSize:13 }}>
                {["30 min","1 hr","1-2 hrs","2-3 hrs","3-4 hrs","Half day","Full day"].map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
          </div>
        </div>

        {/* Instant Book toggle */}
        <div style={{ background:T.white, borderRadius:14, border:`2px solid ${instantBook ? T.green : T.border}`, padding:16, transition:"border 0.2s" }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <div>
              <div style={{ fontWeight:700, fontSize:14, color:T.navy }}>⚡ Enable Instant Book</div>
              <div style={{ fontSize:12, color:T.slate, marginTop:2 }}>Homeowner can confirm immediately — no waiting</div>
              {instantBook && <div style={{ fontSize:11, color:T.green, fontWeight:700, marginTop:4 }}>✅ Your bid will appear with the Instant Book badge</div>}
            </div>
            <div onClick={() => setInstantBook(!instantBook)} style={{ width:46, height:26, borderRadius:99, cursor:"pointer", background: instantBook ? T.green : T.border, position:"relative", transition:"background 0.2s", flexShrink:0 }}>
              <div style={{ width:22, height:22, borderRadius:"50%", background:T.white, position:"absolute", top:2, left: instantBook ? 22 : 2, transition:"left 0.2s", boxShadow:"0 1px 4px rgba(0,0,0,0.2)" }} />
            </div>
          </div>
        </div>

        {/* Competing bids info */}
        {BID_STORE.getBids(job?.id).length > 0 && (
          <div style={{ background:T.cobaltL, borderRadius:12, padding:14, fontSize:13, color:T.cobalt, lineHeight:1.6 }}>
            💡 <strong>{BID_STORE.getBids(job?.id).length} pros</strong> have already bid on this job. Average bid: <strong>${Math.round(BID_STORE.getBids(job?.id).reduce((a,b)=>a+b.amount,0)/BID_STORE.getBids(job?.id).length)}</strong>. Enable Instant Book to stand out!
          </div>
        )}

        {bidError && (
          <div style={{ background:T.coralL, color:T.coral, borderRadius:10, padding:"10px 14px", fontSize:12, marginBottom:14, lineHeight:1.5 }}>
            ⚠️ {bidError}
          </div>
        )}

        {/* Submit */}
        <button onClick={handleSubmit} disabled={!amount || !desc || submitting} style={{
          width:"100%", padding:"16px", borderRadius:12, border:"none",
          background: amount && desc ? `linear-gradient(135deg, #1565C0, #0A9E6A)` : T.border,
          color:T.white, fontWeight:700, fontSize:15, cursor: amount && desc ? "pointer" : "not-allowed",
          fontFamily:"'DM Sans', sans-serif", opacity: submitting ? 0.7 : 1,
          boxShadow: amount && desc ? "0 4px 16px rgba(21,101,192,0.3)" : "none",
        }}>
          {submitting ? "⏳ Submitting…" : amount && desc ? `${existingBid ? "Update Bid" : "Submit Bid"} — $${amount}` : "Fill in all fields to submit"}
        </button>
      </div>
    </div>
  );
}


// ── Full Profile System ────────────────────────────────────────

// ── Pro Public Profile ─────────────────────────────────────────
function ProPublicProfile({ pro, onBack, onBook, onMessage, userType, authUser }) {
  const [activeTab, setActiveTab] = useState("about"); // about | portfolio | reviews | availability
  const { isSaved, toggleSaved }  = useSavedPros(authUser?.id);
  const saved = isSaved(pro.id);
  // Tapping the small header avatar used to do nothing — no way to see the
  // uploaded photo at actual size.
  const [showPhotoLightbox, setShowPhotoLightbox] = useState(false);

  const cat       = CATEGORIES.find(c => c.id === pro.cat);
  // Fake reviews for the app's mock/demo pros (small integer ids) — a real
  // pro (UUID id) gets their actual reviews loaded below instead. Same
  // real-vs-mock split used everywhere else in this file.
  const DEMO_REVIEWS = [
    { reviewer:"Jennifer P.", init:"JP", rating:5, date:"Aug 8",  comment:"Marcus was incredible — showed up on time, fixed the leak fast. Will definitely book again!" },
    { reviewer:"Robert C.",   init:"RC", rating:5, date:"Aug 5",  comment:"Professional, clean, and fairly priced. Highly recommend!" },
    { reviewer:"Tammy H.",    init:"TH", rating:4, date:"Jul 28", comment:"Great work overall. Was a bit late but the quality made up for it." },
    { reviewer:"Mike D.",     init:"MD", rating:5, date:"Jul 20", comment:"Best pro I have ever hired through any app. Will use again!" },
  ];
  const [realReviews, setRealReviews] = useState(null); // null = not loaded yet (or a mock pro)

  useEffect(() => {
    if (typeof pro.id !== 'string') return; // mock/demo pro — keep DEMO_REVIEWS
    (async () => {
      try {
        const rows = await sbFetch('reviews',
          `?pro_id=eq.${pro.id}&reviewer_role=eq.homeowner&select=rating,review_text,created_at,homeowner:users!homeowner_id(full_name)&order=created_at.desc&limit=20`
        );
        if (Array.isArray(rows)) {
          setRealReviews(rows.map(r => {
            const name = r.homeowner?.full_name || 'A homeowner';
            const parts = name.trim().split(/\s+/);
            return {
              reviewer: parts.length > 1 ? `${parts[0]} ${parts[parts.length-1][0]}.` : name,
              init: parts.map(n => n[0]).join('').slice(0,2).toUpperCase() || 'H',
              rating: r.rating,
              date: formatTimeAgo(r.created_at),
              comment: r.review_text || '',
            };
          }));
        }
      } catch (err) {
        console.log('Reviews load error:', err.message);
      }
    })();
  }, [pro.id]);

  const proReviews = realReviews !== null ? realReviews : DEMO_REVIEWS;

  const portfolioPhotos = [
    "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=200&h=200&fit=crop",
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=200&fit=crop",
    "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=200&h=200&fit=crop",
    "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=200&h=200&fit=crop",
    "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=200&h=200&fit=crop",
    "https://images.unsplash.com/photo-1581579186913-45ac3e6efe93?w=200&h=200&fit=crop",
  ];

  const tabs = [
    { id:"about",        label:"About"       },
    { id:"portfolio",    label:"Portfolio"   },
    { id:"reviews",      label:`Reviews (${proReviews.length})` },
    { id:"availability", label:"Availability"},
  ];

  return (
    <div style={{ background:T.sand, minHeight:"100%", fontFamily:"'DM Sans', sans-serif" }}>

      {/* Hero */}
      <div style={{ background:`linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, padding:"16px 16px 56px", position:"relative" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
          <button onClick={onBack} style={{ background:"rgba(255,255,255,0.15)", border:"none", color:T.white, borderRadius:8, padding:"6px 12px", cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>← Back</button>
          <button onClick={() => toggleSaved(pro)} style={{ background:"rgba(255,255,255,0.15)", border:"none", color:T.white, borderRadius:8, padding:"6px 14px", cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif", display:"flex", alignItems:"center", gap:6 }}>
            {saved ? "❤️ Saved" : "🤍 Save"}
          </button>
        </div>

        {/* Pro identity */}
        <div style={{ display:"flex", gap:16, alignItems:"flex-start" }}>
          <div style={{ position:"relative" }} onClick={() => pro.avatar && setShowPhotoLightbox(true)}>
            <Avatar initials={pro.img} src={pro.avatar} size={72} color={T.green} />
            {pro.avatar && (
              <div style={{ position:"absolute", inset:0, borderRadius:"50%", cursor:"zoom-in" }} />
            )}
            <div style={{ position:"absolute", bottom:0, right:0, width:16, height:16, borderRadius:"50%", background: getAvailability(pro).dot, border:"2px solid white" }} />
          </div>
          <div style={{ flex:1 }}>
            <div style={{ color:T.white, fontWeight:800, fontSize:22, marginBottom:2 }}>{pro.name}</div>
            <div style={{ color:"rgba(255,255,255,0.8)", fontSize:13, marginBottom:6 }}>
              {cat?.label} · 📍 {pro.city}
            </div>
            <div style={{ display:"flex", gap:8, alignItems:"center", flexWrap:"wrap" }}>
              <Stars rating={pro.rating} />
              <span style={{ color:"rgba(255,255,255,0.7)", fontSize:12 }}>({pro.reviews} reviews)</span>
              <Badge label={pro.badge} />
            </div>
          </div>
        </div>
      </div>

      {/* Floating stats card */}
      <div style={{ margin:"0 16px", marginTop:-28, position:"relative", zIndex:10 }}>
        <div style={{ background:T.white, borderRadius:16, padding:16, display:"flex", justifyContent:"space-around", border:`1px solid ${T.border}`, boxShadow:"0 8px 24px rgba(0,0,0,0.12)" }}>
          {[
            { val:pro.rating,  label:"Rating",    icon:"⭐" },
            { val:pro.reviews, label:"Reviews",   icon:"💬" },
            { val:pro.jobs,    label:"Jobs Done", icon:"✅" },
            { val:"2.3mi",     label:"Away",      icon:"📍" },
          ].map(s => (
            <div key={s.label} style={{ textAlign:"center" }}>
              <div style={{ fontSize:14, marginBottom:2 }}>{s.icon}</div>
              <div style={{ fontWeight:800, fontSize:18, color:T.navy }}>{s.val}</div>
              <div style={{ fontSize:10, color:T.slate, fontWeight:600 }}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Rate + CTA */}
      <div style={{ margin:"12px 16px", background:T.white, borderRadius:14, padding:14, border:`1px solid ${T.border}`, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
        <div>
          <div style={{ fontSize:22, fontWeight:800, color:T.navy }}>{pro.rate}</div>
          <div style={{ fontSize:12, fontWeight:600, color:getAvailability(pro).text }}>● {getAvailability(pro).label}</div>
        </div>
        <div style={{ display:"flex", gap:8 }}>
          <button onClick={onMessage} style={{ padding:"10px 16px", borderRadius:10, border:`1.5px solid ${T.border}`, background:T.white, color:T.navy, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif", display:"flex", alignItems:"center", gap:6 }}>
            💬 Message
          </button>
          {pro.available && (
            <button onClick={onBook} style={{ padding:"10px 18px", borderRadius:10, border:"none", background:`linear-gradient(135deg, #1565C0, #0A9E6A)`, color:T.white, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
              Book Now
            </button>
          )}
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display:"flex", background:T.white, borderBottom:`1px solid ${T.border}`, margin:"0 0 12px", overflowX:"auto" }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => setActiveTab(t.id)} style={{
            flex:1, padding:"11px 8px", background:"none", border:"none", cursor:"pointer",
            borderBottom:`2px solid ${activeTab===t.id ? T.cobalt : "transparent"}`,
            color: activeTab===t.id ? T.cobalt : T.slate,
            fontSize:12, fontWeight:700, fontFamily:"'DM Sans', sans-serif", whiteSpace:"nowrap",
          }}>{t.label}</button>
        ))}
      </div>

      {/* Tab content */}
      <div style={{ padding:"0 16px 24px" }}>

        {/* ABOUT */}
        {activeTab === "about" && (
          <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
            <div style={{ background:T.white, borderRadius:14, padding:16, border:`1px solid ${T.border}` }}>
              <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:10 }}>ABOUT</div>
              <p style={{ fontSize:14, color:T.navy, lineHeight:1.7, margin:0 }}>{pro.bio}</p>
            </div>
            <div style={{ background:T.white, borderRadius:14, padding:16, border:`1px solid ${T.border}` }}>
              <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:12 }}>DETAILS</div>
              {[
                ["Service",      cat?.label || "—"],
                ["Hourly Rate",  pro.rate],
                ["City",         pro.city],
                ["Jobs Done",    `${pro.jobs} completed`],
                ["Member Since", "January 2024"],
                ["Response Time","Under 30 minutes"],
                ["Languages",    "English, Spanish"],
              ].map(([k,v]) => (
                <div key={k} style={{ display:"flex", justifyContent:"space-between", padding:"8px 0", fontSize:13, borderBottom:`1px solid ${T.border}` }}>
                  <span style={{ color:T.slate }}>{k}</span>
                  <span style={{ color:T.navy, fontWeight:600 }}>{v}</span>
                </div>
              ))}
            </div>
            <div style={{ background:T.white, borderRadius:14, padding:16, border:`1px solid ${T.border}` }}>
              <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:12 }}>BADGES & VERIFICATION</div>
              {[
                { icon:"✅", label:"Identity Verified",    color:T.green  },
                { icon:"🔍", label:"Background Checked",   color:T.green  },
                { icon:"📋", label:"License Verified",     color:T.green  },
                { icon:"🛡️", label:"Insured ($1M liability)",color:T.green },
                { icon:"⭐", label:pro.badge + " Status",  color:T.amber  },
              ].map((b,i) => (
                <div key={i} style={{ display:"flex", alignItems:"center", gap:10, padding:"7px 0", borderBottom:`1px solid ${T.border}` }}>
                  <span style={{ fontSize:18 }}>{b.icon}</span>
                  <span style={{ fontSize:13, color:T.navy, fontWeight:600 }}>{b.label}</span>
                  <span style={{ marginLeft:"auto", fontSize:11, fontWeight:700, color:b.color }}>✓ Verified</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* PORTFOLIO */}
        {activeTab === "portfolio" && (
          <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
            <div style={{ fontSize:13, color:T.slate, marginBottom:4 }}>{portfolioPhotos.length} photos · Before & after work samples</div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:6 }}>
              {portfolioPhotos.map((url, i) => (
                <div key={i} style={{ aspectRatio:"1", borderRadius:10, overflow:"hidden", position:"relative" }}>
                  <img src={url} alt="" style={{ width:"100%", height:"100%", objectFit:"cover" }}
                    onError={e => { e.target.src = `https://via.placeholder.com/150x150/E3EEFA/1565C0?text=📸`; }} />
                  {i === 0 && (
                    <div style={{ position:"absolute", top:6, left:6, background:"rgba(10,37,64,0.8)", color:T.white, fontSize:9, fontWeight:700, padding:"2px 6px", borderRadius:4 }}>FEATURED</div>
                  )}
                </div>
              ))}
            </div>
            <div style={{ background:T.cobaltL, borderRadius:12, padding:14, fontSize:13, color:T.cobalt, lineHeight:1.5 }}>
              📸 All photos are verified by Localy and were taken at actual job sites.
            </div>
          </div>
        )}

        {/* REVIEWS */}
        {activeTab === "reviews" && (
          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
            {/* Rating breakdown */}
            <div style={{ background:T.white, borderRadius:14, padding:16, border:`1px solid ${T.border}`, display:"flex", gap:16, alignItems:"center" }}>
              <div style={{ textAlign:"center" }}>
                <div style={{ fontSize:44, fontWeight:800, color:T.navy, lineHeight:1 }}>{pro.rating}</div>
                <Stars rating={pro.rating} />
                <div style={{ fontSize:11, color:T.slate, marginTop:4 }}>{pro.reviews} reviews</div>
              </div>
              <div style={{ flex:1 }}>
                {[5,4,3,2,1].map(star => {
                  const pct = proReviews.length > 0
                    ? Math.round((proReviews.filter(r => r.rating === star).length / proReviews.length) * 100)
                    : 0;
                  return (
                    <div key={star} style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4 }}>
                      <span style={{ fontSize:11, color:T.slate, width:12 }}>{star}</span>
                      <span style={{ color:"#F59E0B", fontSize:11 }}>★</span>
                      <div style={{ flex:1, background:T.border, borderRadius:99, height:6 }}>
                        <div style={{ background:"#F59E0B", borderRadius:99, height:6, width:`${pct}%` }} />
                      </div>
                      <span style={{ fontSize:11, color:T.slate, width:28 }}>{pct}%</span>
                    </div>
                  );
                })}
              </div>
            </div>
            {proReviews.length === 0 && (
              <div style={{ background:T.white, borderRadius:14, padding:24, border:`1px solid ${T.border}`, textAlign:"center", color:T.slate, fontSize:13 }}>
                No reviews yet — be the first to book and leave one!
              </div>
            )}
            {proReviews.map((r,i) => (
              <div key={i} style={{ background:T.white, borderRadius:14, padding:16, border:`1px solid ${T.border}` }}>
                <div style={{ display:"flex", gap:10, alignItems:"center", marginBottom:8 }}>
                  <Avatar initials={r.init} size={36} color={T.slate} />
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:700, fontSize:14, color:T.navy }}>{r.reviewer}</div>
                    <div style={{ fontSize:11, color:T.slate }}>{r.date}</div>
                  </div>
                  <Stars rating={r.rating} />
                </div>
                <p style={{ fontSize:13, color:T.navy, lineHeight:1.6, margin:0 }}>{r.comment}</p>
              </div>
            ))}
          </div>
        )}

        {/* AVAILABILITY */}
        {activeTab === "availability" && (
          <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
            <div style={{ background:T.white, borderRadius:14, padding:16, border:`1px solid ${T.border}` }}>
              <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:12 }}>THIS WEEK</div>
              {[
                { day:"Mon Aug 14", slots:5, status:"available"   },
                { day:"Tue Aug 15", slots:2, status:"partial"     },
                { day:"Wed Aug 16", slots:0, status:"unavailable" },
                { day:"Thu Aug 17", slots:7, status:"available"   },
                { day:"Fri Aug 18", slots:4, status:"available"   },
                { day:"Sat Aug 19", slots:0, status:"unavailable" },
                { day:"Sun Aug 20", slots:0, status:"unavailable" },
              ].map((d,i) => {
                const colors = { available:{ dot:T.green, text:T.green, bg:T.greenL }, partial:{ dot:T.amber, text:T.amber, bg:T.amberL }, unavailable:{ dot:T.border, text:T.slate, bg:T.sand } };
                const c = colors[d.status];
                return (
                  <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 0", borderBottom:`1px solid ${T.border}` }}>
                    <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                      <div style={{ width:10, height:10, borderRadius:"50%", background:c.dot }} />
                      <span style={{ fontSize:13, color:T.navy, fontWeight:500 }}>{d.day}</span>
                    </div>
                    <span style={{ fontSize:12, fontWeight:700, color:c.text, background:c.bg, padding:"3px 10px", borderRadius:99 }}>
                      {d.status === "unavailable" ? "Unavailable" : `${d.slots} slots open`}
                    </span>
                  </div>
                );
              })}
            </div>
            {pro.available && (
              <button onClick={onBook} style={{ width:"100%", padding:"15px", borderRadius:12, border:"none", background:`linear-gradient(135deg, #1565C0, #0A9E6A)`, color:T.white, fontWeight:700, fontSize:15, cursor:"pointer", fontFamily:"'DM Sans', sans-serif" }}>
                📅 Book an Available Slot
              </button>
            )}
          </div>
        )}
      </div>

      {showPhotoLightbox && pro.avatar && (
        <div onClick={() => setShowPhotoLightbox(false)} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.92)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1001, cursor:"zoom-out" }}>
          <img src={pro.avatar} alt={pro.name} style={{ maxWidth:"95%", maxHeight:"90vh", borderRadius:12, objectFit:"contain" }} />
          <button onClick={() => setShowPhotoLightbox(false)} style={{ position:"absolute", top:20, right:20, background:"rgba(255,255,255,0.15)", border:"none", color:"white", borderRadius:"50%", width:36, height:36, fontSize:18, cursor:"pointer" }}>✕</button>
        </div>
      )}
    </div>
  );
}

// ── Go Pro Plus (pitch + request) ───────────────────────────────
// Phase 1: no real billing. "Request Upgrade" just timestamps
// pro_profiles.plus_requested_at — the admin sees a "Requested Plus"
// badge next to this pro in the Admin Dashboard (see AdminDashboard's
// pros tab) and grants it by hand from there. This screen exists to
// validate that pros actually want this before building real recurring
// billing — see pro_plus_migration.sql.
function GoProPlusView({ authUser, onBack }) {
  const [status, setStatus] = useState('loading'); // loading | free | requested | plus
  const [proId, setProId] = useState(null);
  const [requesting, setRequesting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (typeof authUser?.id !== 'string') { setStatus('free'); return; }
    (async () => {
      try {
        const pid = await getProProfileId(authUser.id);
        setProId(pid);
        if (!pid) { setStatus('free'); return; }
        const rows = await sbFetch('pro_profiles', `?id=eq.${pid}&select=subscription_tier,plus_requested_at`);
        const row = rows?.[0];
        if (row?.subscription_tier === 'plus') setStatus('plus');
        else if (row?.plus_requested_at) setStatus('requested');
        else setStatus('free');
      } catch (err) {
        console.log('Go Plus status fetch error:', err.message);
        setStatus('free');
      }
    })();
  }, [authUser?.id]);

  const handleRequest = async () => {
    if (!proId) return;
    setRequesting(true);
    setError('');
    try {
      await sbUpdate('pro_profiles', proId, { plus_requested_at: new Date().toISOString() });
      setStatus('requested');
    } catch (err) {
      setError(err.message);
    } finally {
      setRequesting(false);
    }
  };

  const FEATURES = [
    ["💰", "6% platform fee", "Half the standard 12% commission on every job you complete."],
    ["⭐", "Featured placement", "Your bids get the LOCALY RECOMMENDED banner and sort to the top."],
    ["📋", "Unlimited active bids", "No cap on how many open jobs you can bid on at once."],
    ["🚀", "Fast-track verification", "Your documents jump to the front of the review queue."],
    ["🧾", "Branded invoices", "Add your business name to every invoice you send."],
    ["⚡", "Early job alerts", "See new jobs the instant they're posted, before free-tier pros."],
  ];

  return (
    <div style={{ background:T.sand, minHeight:"100%", fontFamily:"'DM Sans', sans-serif" }}>
      <div style={{ background:`linear-gradient(135deg, #0A2540, #1565C0 60%, #8A6300 100%)`, padding:"16px 16px 24px" }}>
        <button onClick={onBack} style={{ background:"rgba(255,255,255,0.15)", border:"none", color:T.white, borderRadius:8, padding:"6px 12px", cursor:"pointer", fontSize:13, marginBottom:14, fontFamily:"'DM Sans', sans-serif" }}>← Back</button>
        <div style={{ fontSize:32, marginBottom:6 }}>⭐</div>
        <div style={{ color:T.white, fontWeight:700, fontSize:22, fontFamily:"'DM Serif Display', serif" }}>Localy Pro Plus</div>
        <div style={{ color:"rgba(255,255,255,0.8)", fontSize:13, marginTop:4 }}>Lower fees. More visibility. Grow faster.</div>
      </div>

      <div style={{ padding:16 }}>
        {status === 'plus' && (
          <div style={{ background:"#FFF4D6", border:"1px solid #D9A400", borderRadius:14, padding:16, textAlign:"center", marginBottom:16 }}>
            <div style={{ fontSize:28, marginBottom:8 }}>🎉</div>
            <div style={{ fontWeight:700, color:"#8A6300", fontSize:15 }}>You're on Pro Plus</div>
            <div style={{ fontSize:13, color:T.slate, marginTop:4 }}>All the features below are already active on your account.</div>
          </div>
        )}
        {status === 'requested' && (
          <div style={{ background:T.cobaltL, border:`1px solid ${T.cobalt}33`, borderRadius:14, padding:16, textAlign:"center", marginBottom:16 }}>
            <div style={{ fontSize:28, marginBottom:8 }}>⏳</div>
            <div style={{ fontWeight:700, color:T.cobalt, fontSize:15 }}>Request sent</div>
            <div style={{ fontSize:13, color:T.slate, marginTop:4 }}>We'll reach out shortly to get you set up.</div>
          </div>
        )}

        <div style={{ display:"flex", flexDirection:"column", gap:10, marginBottom:20 }}>
          {FEATURES.map(([icon, title, body]) => (
            <div key={title} style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:14, display:"flex", gap:12 }}>
              <div style={{ fontSize:24 }}>{icon}</div>
              <div>
                <div style={{ fontWeight:700, fontSize:14, color:T.navy }}>{title}</div>
                <div style={{ fontSize:12, color:T.slate, marginTop:2, lineHeight:1.5 }}>{body}</div>
              </div>
            </div>
          ))}
        </div>

        {error && <div style={{ background:T.coralL, color:T.coral, borderRadius:10, padding:"10px 14px", fontSize:12, marginBottom:14 }}>⚠️ {error}</div>}

        {status === 'free' && (
          <button onClick={handleRequest} disabled={requesting} style={{
            width:"100%", padding:"15px", borderRadius:12, border:"none",
            background:"linear-gradient(135deg, #8A6300, #D9A400)", color:T.white, fontWeight:700, fontSize:15,
            cursor: requesting ? "default" : "pointer", fontFamily:"'DM Sans', sans-serif",
          }}>
            {requesting ? "⏳ Sending…" : "Request Upgrade — $39/mo"}
          </button>
        )}
      </div>
    </div>
  );
}

// ── Pro Profile Editor ─────────────────────────────────────────
function ProProfileEditor({ authUser, onBack, onLogout, onAdmin, onNavigate }) {
  const [form, setForm] = useState({
    name:    authUser?.name || "",
    phone:   "",
    email:   authUser?.email || "",
    city:    "The Woodlands, TX",
    bio:     "",
    rate:    "",
    diagnosticFee: "",
    license: "",
    services:[],
    instagram:"",
    website: "",
    businessName: "",
  });
  const [profilePhoto, setProfilePhoto] = useState([]);
  const [workPhotos, setWorkPhotos]     = useState([]);
  const [activeSection, setActiveSection] = useState("basic");
  const [saved, setSaved]               = useState(false);
  const [saving, setSaving]             = useState(false);
  const [saveError, setSaveError]       = useState("");
  const [proId, setProId]               = useState(null);
  const [proApproved, setProApproved]   = useState(true); // optimistic default — flips to false only once the real row loads
  // Branded invoices (business name on invoices) is a Pro Plus perk — see
  // pro_plus_migration.sql / GoProPlusView.
  const [isPlus, setIsPlus]             = useState(false);

  // Load this pro's real saved data (from users + pro_profiles) once on
  // mount, so Save Changes edits actual values instead of overwriting them
  // with placeholder demo data. Only applies to real (string/UUID) ids —
  // mock/demo sessions keep the blank/placeholder defaults above.
  useEffect(() => {
    if (!authUser?.id || typeof authUser.id !== 'string') return;
    (async () => {
      try {
        const [userRows, proRows] = await Promise.all([
          sbFetch('users', `?id=eq.${authUser.id}&select=full_name,phone,avatar_url`),
          sbFetch('pro_profiles', `?user_id=eq.${authUser.id}&select=id,bio,hourly_rate,diagnostic_fee,services,city,license_number,instagram,website,approved,subscription_tier,business_name`),
        ]);
        const u = userRows?.[0];
        const p = proRows?.[0];
        if (p?.id) setProId(p.id);
        if (p) setProApproved(!!p.approved);
        if (p) setIsPlus(p.subscription_tier === 'plus');
        setForm(f => ({
          ...f,
          name:      u?.full_name || f.name,
          phone:     u?.phone || f.phone,
          bio:       p?.bio || f.bio,
          rate:      (p?.hourly_rate != null && p.hourly_rate !== '') ? String(p.hourly_rate) : f.rate,
          diagnosticFee: (p?.diagnostic_fee != null && p.diagnostic_fee !== '') ? String(p.diagnostic_fee) : f.diagnosticFee,
          city:      p?.city || f.city,
          license:   p?.license_number || f.license,
          services:  (p?.services && p.services.length) ? p.services : f.services,
          instagram: p?.instagram || f.instagram,
          website:   p?.website || f.website,
          businessName: p?.business_name || f.businessName,
        }));
        if (u?.avatar_url) setProfilePhoto([{ url: u.avatar_url, name: 'profile.jpg', size:'' }]);
        if (p?.id) {
          const photoRows = await sbFetch('pro_photos', `?pro_id=eq.${p.id}&select=id,photo_url&order=sort_order.asc`);
          if (Array.isArray(photoRows) && photoRows.length > 0) {
            setWorkPhotos(photoRows.map(r => ({ url: r.photo_url, name: 'work.jpg', size:'', rowId: r.id })));
          }
        }
      } catch (err) {
        console.log('Profile load error:', err.message);
      }
    })();
  }, [authUser?.id]);

  // Persist a real, already-uploaded photo URL to the right table — called
  // by PhotoUploader's onUploaded after the file itself lands in Storage.
  const saveProfilePhoto = async (url) => {
    try { await sbUpdate('users', authUser.id, { avatar_url: url }); }
    catch (err) { console.log('Profile photo save error:', err.message); }
  };
  const saveWorkPhoto = async (url) => {
    if (!proId) return;
    try {
      const rows = await sbInsert('pro_photos', { pro_id: proId, photo_url: url });
      const rowId = rows?.[0]?.id;
      if (rowId) setWorkPhotos(prev => prev.map(p => (p.url === url && !p.rowId) ? { ...p, rowId } : p));
    } catch (err) {
      console.log('Work photo save error:', err.message);
    }
  };
  const removeProfilePhoto = async () => {
    try { await sbUpdate('users', authUser.id, { avatar_url: null }); }
    catch (err) { console.log('Profile photo remove error:', err.message); }
  };
  const removeWorkPhoto = async (idx, photo) => {
    if (photo?.rowId) {
      try { await sbDelete('pro_photos', `?id=eq.${photo.rowId}`); }
      catch (err) { console.log('Work photo remove error:', err.message); }
    }
  };

  const update = (k, v) => setForm(f => ({ ...f, [k]:v }));
  const toggleService = (id) => setForm(f => ({
    ...f, services: f.services.includes(id) ? f.services.filter(s=>s!==id) : [...f.services, id]
  }));

  // Real save: writes the name/phone to `users` and the rest to
  // `pro_profiles`. Checks for a 0-row response (RLS silently blocking the
  // write) instead of treating it as success, since that failure mode has
  // bitten this app before.
  const handleSave = async () => {
    if (!authUser?.id || typeof authUser.id !== 'string') {
      setSaveError("You're not signed into a real account, so there's nothing to save to yet.");
      return;
    }
    setSaving(true);
    setSaveError("");
    try {
      const userRes = await sbUpdate('users', authUser.id, {
        full_name: form.name,
        phone: form.phone,
      });
      if (Array.isArray(userRes) && userRes.length === 0) {
        throw new Error("Profile update didn't go through — try logging out and back in.");
      }
      if (proId) {
        const proRes = await sbUpdate('pro_profiles', proId, {
          bio: form.bio,
          hourly_rate: form.rate ? parseInt(form.rate, 10) : null,
          diagnostic_fee: form.diagnosticFee ? parseInt(form.diagnosticFee, 10) : null,
          services: form.services,
          city: form.city,
          license_number: form.license,
          instagram: form.instagram,
          website: form.website,
          ...(isPlus ? { business_name: form.businessName || null } : {}),
        });
        if (Array.isArray(proRes) && proRes.length === 0) {
          throw new Error("Service details didn't save — try logging out and back in.");
        }
      }
      setSaving(false);
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (err) {
      setSaving(false);
      setSaveError(err.message || 'Could not save — check your connection and try again.');
    }
  };

  // ── Change Password ──
  // Same real flow as HomeownerAccount — updates the password directly on
  // the pro's own active session via Supabase Auth's PUT /user.
  const [pwOpen, setPwOpen]     = useState(false);
  const [newPw, setNewPw]       = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [pwError, setPwError]   = useState("");
  const [pwSaving, setPwSaving] = useState(false);
  const [pwSaved, setPwSaved]   = useState(false);

  const handleChangePassword = async () => {
    setPwError("");
    if (newPw.length < 8 || !/[A-Z]/.test(newPw) || !/[0-9]/.test(newPw)) {
      setPwError("Password needs at least 8 characters, including a capital letter and a number.");
      return;
    }
    if (newPw !== confirmPw) {
      setPwError("Passwords don't match.");
      return;
    }
    setPwSaving(true);
    try {
      const res = await fetch(`${SUPABASE_URL}/auth/v1/user`, {
        method: 'PUT',
        headers: { 'Content-Type':'application/json', 'apikey': SUPABASE_KEY, 'Authorization': `Bearer ${await authBearer()}` },
        body: JSON.stringify({ password: newPw }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.msg || data.error_description || data.error || 'Could not update password.');
      setPwSaving(false);
      setPwSaved(true);
      setNewPw(""); setConfirmPw("");
      setTimeout(() => { setPwSaved(false); setPwOpen(false); }, 2000);
    } catch (err) {
      setPwSaving(false);
      setPwError(err.message || 'Could not update password — try again.');
    }
  };

  // ── Delete Account ──
  // Same real flow as HomeownerAccount — was previously missing entirely
  // for pros, who only had a Log Out button here with no way to actually
  // delete their account. Irreversible, so it requires typing the
  // account's own email to confirm before calling the delete-account
  // Edge Function (which removes both the app data and the actual login).
  const [delOpen, setDelOpen]       = useState(false);
  const [delConfirm, setDelConfirm] = useState("");
  const [delError, setDelError]     = useState("");
  const [delSaving, setDelSaving]   = useState(false);

  const handleDeleteAccount = async () => {
    setDelError("");
    if (delConfirm.trim().toLowerCase() !== (form.email || "").trim().toLowerCase()) {
      setDelError("Type your email exactly as shown to confirm.");
      return;
    }
    setDelSaving(true);
    try {
      const res = await fetch(`${SUPABASE_URL}/functions/v1/delete-account`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'apikey': SUPABASE_KEY, 'Authorization': `Bearer ${await authBearer()}` },
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.error) throw new Error(data.error || `Server error (${res.status}) — the delete-account function may not be deployed yet.`);
      onLogout && onLogout();
    } catch (err) {
      setDelSaving(false);
      setDelError(err.message || 'Could not delete your account — check your connection and try again.');
    }
  };

  const inputStyle = { width:"100%", padding:"11px 14px", borderRadius:10, border:`1.5px solid ${T.border}`, fontSize:14, fontFamily:"'DM Sans', sans-serif", color:T.navy, outline:"none", boxSizing:"border-box", background:T.white };

  const sections = [
    { id:"basic",     label:"Basic Info",  icon:"👤" },
    { id:"services",  label:"Services",    icon:"🔧" },
    { id:"photos",    label:"Photos",      icon:"📸" },
    { id:"social",    label:"Social",      icon:"🌐" },
  ];

  return (
    <div style={{ background:T.sand, minHeight:"100%", fontFamily:"'DM Sans', sans-serif" }}>

      {/* Header */}
      <div style={{ background:`linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, padding:"16px 16px 20px" }}>
        {/* Primary row: navigate back / commit changes — the two actions
            that actually act on this screen, kept visually distinct from
            the utility row below. */}
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:8, marginBottom:8 }}>
          <button onClick={onBack} style={{ background:"rgba(255,255,255,0.15)", border:"none", color:T.white, borderRadius:8, padding:"8px 16px", cursor:"pointer", fontSize:13, fontWeight:600, fontFamily:"'DM Sans', sans-serif", whiteSpace:"nowrap" }}>
            ← Back
          </button>
          <button onClick={handleSave} style={{ background: saved ? T.green : T.white, border:"none", color: saved ? T.white : T.navy, borderRadius:8, padding:"8px 18px", cursor:"pointer", fontSize:13, fontWeight:700, fontFamily:"'DM Sans', sans-serif", transition:"all 0.3s", whiteSpace:"nowrap" }}>
            {saving ? "⏳ Saving…" : saved ? "✅ Saved!" : "Save Changes"}
          </button>
        </div>

        {/* Utility row: equal-width pills so they stay one line and line
            up cleanly regardless of how many show (Admin only for admins). */}
        <div style={{ display:"flex", gap:6, marginBottom:16 }}>
          {authUser?.isAdmin && (
            <button onClick={onAdmin} style={{ flex:1, background:"rgba(255,255,255,0.15)", border:"none", color:T.white, borderRadius:8, padding:"7px 4px", cursor:"pointer", fontSize:11, fontWeight:700, fontFamily:"'DM Sans', sans-serif", whiteSpace:"nowrap" }}>
              🛡️ Admin
            </button>
          )}
          <button onClick={() => onNavigate && onNavigate("howitworks")} style={{ flex:1, background:"rgba(255,255,255,0.15)", border:"none", color:T.white, borderRadius:8, padding:"7px 4px", cursor:"pointer", fontSize:11, fontWeight:700, fontFamily:"'DM Sans', sans-serif", whiteSpace:"nowrap" }}>
            💡 Help
          </button>
          <button onClick={() => onNavigate && onNavigate("goplus")} style={{ flex:1, background:"rgba(255,196,0,0.22)", border:"1px solid rgba(255,196,0,0.4)", color:T.white, borderRadius:8, padding:"7px 4px", cursor:"pointer", fontSize:11, fontWeight:700, fontFamily:"'DM Sans', sans-serif", whiteSpace:"nowrap" }}>
            ⭐ Plus
          </button>
          <button onClick={onLogout} style={{ flex:1, background:"rgba(255,255,255,0.15)", border:"none", color:T.white, borderRadius:8, padding:"7px 4px", cursor:"pointer", fontSize:11, fontWeight:700, fontFamily:"'DM Sans', sans-serif", whiteSpace:"nowrap" }}>
            🚪 Log Out
          </button>
        </div>
        <div style={{ color:"rgba(255,255,255,0.7)", fontSize:11, fontWeight:700, letterSpacing:"0.1em", marginBottom:6 }}>EDIT PROFILE</div>
        <div style={{ color:T.white, fontWeight:700, fontSize:18 }}>{form.name}</div>
      </div>

      {!proApproved && (
        <div style={{ background:T.amberL, borderBottom:`1px solid ${T.amber}33`, padding:"12px 16px", fontSize:13, color:T.amber, fontWeight:600 }}>
          ⏳ Your profile is pending admin review — homeowners won't see you in search results or get matched to your jobs until it's approved.
        </div>
      )}

      {/* Section tabs */}
      <div style={{ display:"flex", background:T.white, borderBottom:`1px solid ${T.border}` }}>
        {sections.map(s => (
          <button key={s.id} onClick={() => setActiveSection(s.id)} style={{
            flex:1, padding:"10px 4px", background:"none", border:"none", cursor:"pointer",
            borderBottom:`2px solid ${activeSection===s.id ? T.cobalt : "transparent"}`,
            fontFamily:"'DM Sans', sans-serif",
            display:"flex", flexDirection:"column", alignItems:"center", gap:2,
          }}>
            <span style={{ fontSize:16 }}>{s.icon}</span>
            <span style={{ fontSize:10, fontWeight:700, color: activeSection===s.id ? T.cobalt : T.slate, letterSpacing:"0.04em" }}>{s.label.toUpperCase()}</span>
          </button>
        ))}
      </div>

      <div style={{ padding:16, display:"flex", flexDirection:"column", gap:14 }}>

        {/* BASIC INFO */}
        {activeSection === "basic" && (
          <>
            <div><label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>FULL NAME</label><input value={form.name} onChange={e => update("name",e.target.value)} style={inputStyle} /></div>
            <div><label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>EMAIL</label>
              <input value={form.email} disabled type="email" style={{ ...inputStyle, background:T.sand, color:T.slate, cursor:"not-allowed" }} />
              <div style={{ fontSize:11, color:T.slate, marginTop:4 }}>This is your login email — contact support to change it.</div>
            </div>
            <div><label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>PHONE</label><input value={form.phone} onChange={e => update("phone",e.target.value)} style={inputStyle} /></div>
            <div><label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>CITY / SERVICE AREA</label><input value={form.city} onChange={e => update("city",e.target.value)} style={inputStyle} /></div>
            <div><label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>HOURLY RATE ($)</label>
              <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                <span style={{ fontWeight:700, color:T.slate, fontSize:18 }}>$</span>
                <input value={form.rate} onChange={e => update("rate",e.target.value.replace(/[^0-9]/g,""))} placeholder="75" style={{ ...inputStyle, flex:1 }} />
                <span style={{ color:T.slate, fontSize:13 }}>/hr</span>
              </div>
            </div>
            {form.services.some(s => DIAGNOSTIC_FEE_CATEGORIES.includes(s)) && (
              <div>
                <label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>DIAGNOSTIC / TRIP FEE ($)</label>
                <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                  <span style={{ fontWeight:700, color:T.slate, fontSize:18 }}>$</span>
                  <input value={form.diagnosticFee} onChange={e => update("diagnosticFee",e.target.value.replace(/[^0-9]/g,""))} placeholder="e.g. 89" style={{ ...inputStyle, flex:1 }} />
                </div>
                <div style={{ fontSize:11, color:T.slate, marginTop:4 }}>
                  Charged up front when a homeowner books you for {form.services.filter(s => DIAGNOSTIC_FEE_CATEGORIES.includes(s)).map(s => CATEGORIES.find(c=>c.id===s)?.label).join('/')} — you'll send a separate itemized invoice for parts/labor once you've diagnosed the job. Leave blank to charge your hourly rate instead.
                </div>
              </div>
            )}
            <div>
              <label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>BUSINESS NAME ON INVOICES</label>
              {isPlus ? (
                <>
                  <input value={form.businessName} onChange={e => update("businessName", e.target.value)} placeholder="e.g. Webb Plumbing Co." style={inputStyle} />
                  <div style={{ fontSize:11, color:T.slate, marginTop:4 }}>Shows at the top of every invoice you send instead of just the job title.</div>
                </>
              ) : (
                <button onClick={() => onNavigate && onNavigate("goplus")} style={{ width:"100%", textAlign:"left", padding:"11px 14px", borderRadius:10, border:`1.5px dashed #D9A400`, background:"#FFF9EC", color:"#8A6300", fontSize:13, fontWeight:600, cursor:"pointer", fontFamily:"'DM Sans', sans-serif" }}>
                  ⭐ Branded invoices are a Pro Plus feature — tap to learn more
                </button>
              )}
            </div>
            <div><label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>BIO</label>
              <textarea value={form.bio} onChange={e => update("bio",e.target.value)} rows={4} style={{ ...inputStyle, resize:"none", lineHeight:1.6 }} />
              <div style={{ fontSize:11, color:T.slate, textAlign:"right", marginTop:4 }}>{form.bio.length}/300</div>
            </div>
            <div><label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>LICENSE # (OPTIONAL)</label><input value={form.license} onChange={e => update("license",e.target.value)} placeholder="State license number" style={inputStyle} /></div>

            <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:14 }}>
              <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.08em", marginBottom:12 }}>PASSWORD</div>
              {!pwOpen ? (
                <button onClick={() => setPwOpen(true)} style={{ width:"100%", padding:"10px", borderRadius:8, border:`1px solid ${T.border}`, background:T.sand, color:T.cobalt, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                  🔒 Change Password
                </button>
              ) : (
                <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                  <input type="password" placeholder="New password" value={newPw} onChange={e => setNewPw(e.target.value)} style={inputStyle} />
                  <input type="password" placeholder="Confirm new password" value={confirmPw} onChange={e => setConfirmPw(e.target.value)} style={inputStyle} />
                  {pwError && <div style={{ color:T.coral, fontSize:12 }}>{pwError}</div>}
                  <div style={{ display:"flex", gap:8 }}>
                    <button onClick={() => { setPwOpen(false); setNewPw(""); setConfirmPw(""); setPwError(""); }} style={{ flex:1, padding:"10px", borderRadius:8, border:`1px solid ${T.border}`, background:T.white, color:T.slate, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>Cancel</button>
                    <button onClick={handleChangePassword} style={{ flex:1, padding:"10px", borderRadius:8, border:"none", background: pwSaved ? T.green : T.cobalt, color:T.white, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                      {pwSaving ? "⏳ Updating…" : pwSaved ? "✅ Updated!" : "Update Password"}
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div style={{ background:T.coralL, borderRadius:14, border:`1px solid ${T.coral}33`, padding:16 }}>
              <div style={{ fontSize:11, fontWeight:700, color:T.coral, letterSpacing:"0.08em", marginBottom:10 }}>DANGER ZONE</div>
              {!delOpen ? (
                <button onClick={() => setDelOpen(true)} style={{ width:"100%", padding:"10px", borderRadius:8, border:`1.5px solid ${T.coral}`, background:"transparent", color:T.coral, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                  Delete Account
                </button>
              ) : (
                <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                  <div style={{ fontSize:12, color:T.coral, lineHeight:1.5 }}>
                    This permanently deletes your account and all your data — there's no undo. Type your email (<strong>{form.email}</strong>) below to confirm.
                  </div>
                  <input placeholder="Type your email to confirm" value={delConfirm} onChange={e => setDelConfirm(e.target.value)} style={inputStyle} />
                  {delError && <div style={{ color:T.coral, fontSize:12 }}>{delError}</div>}
                  <div style={{ display:"flex", gap:8 }}>
                    <button onClick={() => { setDelOpen(false); setDelConfirm(""); setDelError(""); }} style={{ flex:1, padding:"10px", borderRadius:8, border:`1px solid ${T.border}`, background:T.white, color:T.slate, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>Cancel</button>
                    <button onClick={handleDeleteAccount} style={{ flex:1, padding:"10px", borderRadius:8, border:"none", background:T.coral, color:T.white, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                      {delSaving ? "⏳ Deleting…" : "Permanently Delete"}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </>
        )}

        {/* SERVICES */}
        {activeSection === "services" && (
          <>
            <div style={{ fontSize:13, color:T.slate, marginBottom:4 }}>Select all services you offer</div>
            <div style={{ display:"flex", flexWrap:"wrap", gap:10 }}>
              {CATEGORIES.map(c => {
                const active = form.services.includes(c.id);
                return (
                  <button key={c.id} onClick={() => toggleService(c.id)} style={{
                    display:"flex", alignItems:"center", gap:8, padding:"10px 14px",
                    borderRadius:10, cursor:"pointer",
                    background: active ? T.green : T.white,
                    color: active ? T.white : T.navy,
                    border:`2px solid ${active ? T.green : T.border}`,
                    fontFamily:"'DM Sans', sans-serif", fontSize:13, fontWeight:600,
                  }}>
                    <img src={c.icon} alt="" style={{ width:20, height:20, objectFit:"contain", filter: active ? "brightness(0) invert(1)" : "none" }} />
                    {c.label}
                  </button>
                );
              })}
            </div>
            <div style={{ background:T.cobaltL, borderRadius:12, padding:14, fontSize:13, color:T.cobalt, lineHeight:1.5 }}>
              💡 Adding more services increases your chances of being matched to jobs. You only pay Localy when you complete a job.
            </div>
          </>
        )}

        {/* PHOTOS */}
        {activeSection === "photos" && (
          <>
            <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:14 }}>
              <PhotoUploader
                label="PROFILE PHOTO" multiple={false} photos={profilePhoto} setPhotos={setProfilePhoto}
                hint="A clear face photo increases bookings by 3x"
                uploadPath={(file) => `${authUser.id}/profile-${Date.now()}-${file.name}`}
                onUploaded={saveProfilePhoto}
                onRemoved={removeProfilePhoto}
                cropSquare
              />
            </div>
            <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:14 }}>
              <PhotoUploader
                label="WORK PORTFOLIO (UP TO 8)" multiple={true} photos={workPhotos} setPhotos={setWorkPhotos}
                hint="Show your best before & after work"
                uploadPath={(file) => `${authUser.id}/work-${Date.now()}-${file.name}`}
                onUploaded={saveWorkPhoto}
                onRemoved={removeWorkPhoto}
              />
            </div>
          </>
        )}

        {/* SOCIAL */}
        {activeSection === "social" && (
          <>
            <div><label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>INSTAGRAM (OPTIONAL)</label>
              <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                <span style={{ color:T.slate }}>@</span>
                <input value={form.instagram} onChange={e => update("instagram",e.target.value)} placeholder="yourusername" style={{ ...inputStyle, flex:1 }} />
              </div>
            </div>
            <div><label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>WEBSITE (OPTIONAL)</label><input value={form.website} onChange={e => update("website",e.target.value)} placeholder="https://yoursite.com" type="url" style={inputStyle} /></div>
            <div style={{ background:T.sand, borderRadius:12, padding:14, fontSize:13, color:T.slate, lineHeight:1.6 }}>
              🔗 Adding social links builds trust with homeowners and helps your profile stand out.
            </div>
          </>
        )}

        {saveError && <div style={{ color:T.coral, fontSize:13, textAlign:"center", background:"rgba(232,81,42,0.1)", padding:"10px 14px", borderRadius:10 }}>{saveError}</div>}
        <button onClick={handleSave} style={{ width:"100%", padding:"15px", borderRadius:12, border:"none", background:`linear-gradient(135deg, #1565C0, #0A9E6A)`, color:T.white, fontWeight:700, fontSize:15, cursor:"pointer", fontFamily:"'DM Sans', sans-serif", opacity: saving ? 0.7 : 1 }}>
          {saving ? "⏳ Saving…" : saved ? "✅ Saved!" : "Save Changes"}
        </button>
      </div>
    </div>
  );
}

// ── Homeowner Account Page ─────────────────────────────────────
function HomeownerAccount({ authUser, onBack, onNavigate, onLogout, onAdmin }) {
  const [activeSection, setActiveSection] = useState("profile");
  const [form, setForm] = useState({
    name:    authUser?.name || "",
    email:   authUser?.email || "",
    phone:   "",
    address: "",
    homeType:"",
    sqft:    "",
  });
  // Backed by the real SAVED_STORE now — this used to be a hardcoded array
  // with no setter, so pros saved from a profile page never actually showed
  // up here.
  const { savedPros, toggleSaved } = useSavedPros(authUser?.id);
  const [notifications, setNotifications] = useState({
    newBids:        true,
    bookingReminders:true,
    proMessages:    true,
    promotions:     false,
    weeklyDigest:   true,
  });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved]   = useState(false);
  const [saveError, setSaveError] = useState("");
  const update = (k, v) => setForm(f => ({ ...f, [k]:v }));
  const toggleNotif = (k) => setNotifications(prev => ({ ...prev, [k]:!prev[k] }));

  // Load this homeowner's real saved data once on mount, so Save Changes
  // edits actual values instead of overwriting them with placeholder demo
  // data. Only applies to real (string/UUID) ids — mock/demo sessions keep
  // the blank defaults above.
  useEffect(() => {
    if (!authUser?.id || typeof authUser.id !== 'string') return;
    (async () => {
      try {
        const rows = await sbFetch('users', `?id=eq.${authUser.id}&select=full_name,phone,address,home_type,sqft`);
        const u = rows?.[0];
        if (!u) return;
        setForm(f => ({
          ...f,
          name:    u.full_name || f.name,
          phone:   u.phone || f.phone,
          address: u.address || f.address,
          homeType:u.home_type || f.homeType,
          sqft:    u.sqft || f.sqft,
        }));
      } catch (err) {
        console.log('Homeowner profile load error:', err.message);
      }
    })();
  }, [authUser?.id]);

  // Real save: writes straight to `users` (homeowner profile fields all
  // live there, unlike pros which also have a separate pro_profiles row).
  // Checks for a 0-row response (RLS silently blocking the write) instead
  // of treating it as success — that failure mode has bitten this app
  // before.
  const handleSave = async () => {
    if (!authUser?.id || typeof authUser.id !== 'string') {
      setSaveError("You're not signed into a real account, so there's nothing to save to yet.");
      return;
    }
    setSaving(true);
    setSaveError("");
    try {
      const res = await sbUpdate('users', authUser.id, {
        full_name: form.name,
        phone: form.phone,
        address: form.address,
        home_type: form.homeType,
        sqft: form.sqft,
      });
      if (Array.isArray(res) && res.length === 0) {
        throw new Error("Profile update didn't go through — try logging out and back in.");
      }
      setSaving(false);
      setSaved(true);
      setTimeout(()=>setSaved(false),2500);
    } catch (err) {
      setSaving(false);
      setSaveError(err.message || 'Could not save — check your connection and try again.');
    }
  };

  // ── Change Password ──
  // Updates the password directly on the user's own active session — no
  // separate "current password" check needed, since Supabase Auth already
  // required a valid, current login to get this far.
  const [pwOpen, setPwOpen]     = useState(false);
  const [newPw, setNewPw]       = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [pwError, setPwError]   = useState("");
  const [pwSaving, setPwSaving] = useState(false);
  const [pwSaved, setPwSaved]   = useState(false);

  const handleChangePassword = async () => {
    setPwError("");
    if (newPw.length < 8 || !/[A-Z]/.test(newPw) || !/[0-9]/.test(newPw)) {
      setPwError("Password needs at least 8 characters, including a capital letter and a number.");
      return;
    }
    if (newPw !== confirmPw) {
      setPwError("Passwords don't match.");
      return;
    }
    setPwSaving(true);
    try {
      const res = await fetch(`${SUPABASE_URL}/auth/v1/user`, {
        method: 'PUT',
        headers: { 'Content-Type':'application/json', 'apikey': SUPABASE_KEY, 'Authorization': `Bearer ${await authBearer()}` },
        body: JSON.stringify({ password: newPw }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.msg || data.error_description || data.error || 'Could not update password.');
      setPwSaving(false);
      setPwSaved(true);
      setNewPw(""); setConfirmPw("");
      setTimeout(() => { setPwSaved(false); setPwOpen(false); }, 2000);
    } catch (err) {
      setPwSaving(false);
      setPwError(err.message || 'Could not update password — try again.');
    }
  };

  // ── Delete Account ──
  // Irreversible, so it requires typing the account's own email to confirm
  // before the delete-account Edge Function (which removes both the app
  // data and the actual login) is ever called.
  const [delOpen, setDelOpen]       = useState(false);
  const [delConfirm, setDelConfirm] = useState("");
  const [delError, setDelError]     = useState("");
  const [delSaving, setDelSaving]   = useState(false);

  const handleDeleteAccount = async () => {
    setDelError("");
    if (delConfirm.trim().toLowerCase() !== (form.email || "").trim().toLowerCase()) {
      setDelError("Type your email exactly as shown to confirm.");
      return;
    }
    setDelSaving(true);
    try {
      const res = await fetch(`${SUPABASE_URL}/functions/v1/delete-account`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'apikey': SUPABASE_KEY, 'Authorization': `Bearer ${await authBearer()}` },
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.error) throw new Error(data.error || `Server error (${res.status}) — the delete-account function may not be deployed yet.`);
      onLogout && onLogout();
    } catch (err) {
      setDelSaving(false);
      setDelError(err.message || 'Could not delete your account — check your connection and try again.');
    }
  };

  const inputStyle = { width:"100%", padding:"11px 14px", borderRadius:10, border:`1.5px solid ${T.border}`, fontSize:14, fontFamily:"'DM Sans', sans-serif", color:T.navy, outline:"none", boxSizing:"border-box", background:T.white };

  const sections = [
    { id:"profile",   label:"Profile",    icon:"👤" },
    { id:"home",      label:"My Home",    icon:"🏠" },
    { id:"saved",     label:"Saved Pros", icon:"❤️" },
    { id:"neighborhood", label:"Neighborhood", icon:"📍", external:true },
    { id:"referrals", label:"Refer & Earn", icon:"🎁", external:true },
    { id:"notifs",    label:"Alerts",     icon:"🔔" },
    { id:"payment",   label:"Payment",    icon:"💳" },
    { id:"howitworks", label:"How it Works", icon:"💡", external:true },
    ...(authUser?.isAdmin ? [{ id:"admin", label:"Admin", icon:"🛡️", action:"admin" }] : []),
    { id:"logout",    label:"Log Out",    icon:"🚪", action:"logout" },
  ];

  return (
    <div style={{ background:T.sand, minHeight:"100%", fontFamily:"'DM Sans', sans-serif" }}>

      {/* Header */}
      <div style={{ background:`linear-gradient(135deg, #0A2540, #1565C0 60%, #0A9E6A 100%)`, padding:"16px 16px 24px" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
          <button onClick={onBack} style={{ background:"rgba(255,255,255,0.15)", border:"none", color:T.white, borderRadius:8, padding:"6px 12px", cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>← Back</button>
          {["profile","home"].includes(activeSection) && (
            <button onClick={handleSave} style={{ background: saved ? T.green : T.white, border:"none", color: saved ? T.white : T.navy, borderRadius:8, padding:"8px 16px", cursor:"pointer", fontSize:13, fontWeight:700, fontFamily:"'DM Sans', sans-serif" }}>
              {saving ? "⏳" : saved ? "✅ Saved!" : "Save"}
            </button>
          )}
        </div>
        <div style={{ display:"flex", gap:14, alignItems:"center" }}>
          <div style={{ width:60, height:60, borderRadius:"50%", background:"rgba(255,255,255,0.2)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:24, fontWeight:700, color:T.white, border:"3px solid rgba(255,255,255,0.4)" }}>
            {form.name.charAt(0)}
          </div>
          <div>
            <div style={{ color:T.white, fontWeight:800, fontSize:20 }}>{form.name}</div>
            <div style={{ color:"rgba(255,255,255,0.7)", fontSize:13 }}>{form.email}</div>
            <div style={{ color:"rgba(255,255,255,0.6)", fontSize:12, marginTop:2 }}>🏠 Homeowner · The Woodlands</div>
          </div>
        </div>
      </div>

      {/* Section tabs */}
      <div style={{ display:"flex", background:T.white, borderBottom:`1px solid ${T.border}`, overflowX:"auto" }}>
        {sections.map(s => (
          <button key={s.id} onClick={() => s.action === "logout" ? (onLogout && onLogout()) : s.action === "admin" ? (onAdmin && onAdmin()) : s.external ? (onNavigate && onNavigate(s.id)) : setActiveSection(s.id)} style={{
            flex:"0 0 auto", padding:"10px 12px", background:"none", border:"none", cursor:"pointer",
            borderBottom:`2px solid ${activeSection===s.id ? T.cobalt : "transparent"}`,
            fontFamily:"'DM Sans', sans-serif",
            display:"flex", flexDirection:"column", alignItems:"center", gap:2, minWidth:64,
          }}>
            <span style={{ fontSize:16 }}>{s.icon}</span>
            <span style={{ fontSize:10, fontWeight:700, color: activeSection===s.id ? T.cobalt : T.slate, letterSpacing:"0.04em", whiteSpace:"nowrap" }}>{s.label.toUpperCase()}</span>
          </button>
        ))}
      </div>

      <div style={{ padding:16, display:"flex", flexDirection:"column", gap:14 }}>

        {/* PROFILE */}
        {activeSection === "profile" && (
          <>
            <div><label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>FULL NAME</label><input value={form.name} onChange={e => update("name",e.target.value)} style={inputStyle} /></div>
            <div><label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>EMAIL ADDRESS</label>
              <input value={form.email} disabled type="email" style={{ ...inputStyle, background:T.sand, color:T.slate, cursor:"not-allowed" }} />
              <div style={{ fontSize:11, color:T.slate, marginTop:4 }}>This is your login email — contact support to change it.</div>
            </div>
            <div><label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>PHONE NUMBER</label><input value={form.phone} onChange={e => update("phone",e.target.value)} style={inputStyle} /></div>
            {saveError && <div style={{ color:T.coral, fontSize:13, background:"rgba(232,81,42,0.1)", padding:"10px 14px", borderRadius:10 }}>{saveError}</div>}
            <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:14 }}>
              <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.08em", marginBottom:12 }}>PASSWORD</div>
              {!pwOpen ? (
                <button onClick={() => setPwOpen(true)} style={{ width:"100%", padding:"10px", borderRadius:8, border:`1px solid ${T.border}`, background:T.sand, color:T.cobalt, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                  🔒 Change Password
                </button>
              ) : (
                <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                  <input type="password" placeholder="New password" value={newPw} onChange={e => setNewPw(e.target.value)} style={inputStyle} />
                  <input type="password" placeholder="Confirm new password" value={confirmPw} onChange={e => setConfirmPw(e.target.value)} style={inputStyle} />
                  {pwError && <div style={{ color:T.coral, fontSize:12 }}>{pwError}</div>}
                  <div style={{ display:"flex", gap:8 }}>
                    <button onClick={() => { setPwOpen(false); setNewPw(""); setConfirmPw(""); setPwError(""); }} style={{ flex:1, padding:"10px", borderRadius:8, border:`1px solid ${T.border}`, background:T.white, color:T.slate, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>Cancel</button>
                    <button onClick={handleChangePassword} style={{ flex:1, padding:"10px", borderRadius:8, border:"none", background: pwSaved ? T.green : T.cobalt, color:T.white, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                      {pwSaving ? "⏳ Updating…" : pwSaved ? "✅ Updated!" : "Update Password"}
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div style={{ background:T.coralL, borderRadius:14, border:`1px solid ${T.coral}33`, padding:16 }}>
              <div style={{ fontSize:11, fontWeight:700, color:T.coral, letterSpacing:"0.08em", marginBottom:10 }}>DANGER ZONE</div>
              {!delOpen ? (
                <button onClick={() => setDelOpen(true)} style={{ width:"100%", padding:"10px", borderRadius:8, border:`1.5px solid ${T.coral}`, background:"transparent", color:T.coral, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                  Delete Account
                </button>
              ) : (
                <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                  <div style={{ fontSize:12, color:T.coral, lineHeight:1.5 }}>
                    This permanently deletes your account and all your data — there's no undo. Type your email (<strong>{form.email}</strong>) below to confirm.
                  </div>
                  <input placeholder="Type your email to confirm" value={delConfirm} onChange={e => setDelConfirm(e.target.value)} style={inputStyle} />
                  {delError && <div style={{ color:T.coral, fontSize:12 }}>{delError}</div>}
                  <div style={{ display:"flex", gap:8 }}>
                    <button onClick={() => { setDelOpen(false); setDelConfirm(""); setDelError(""); }} style={{ flex:1, padding:"10px", borderRadius:8, border:`1px solid ${T.border}`, background:T.white, color:T.slate, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>Cancel</button>
                    <button onClick={handleDeleteAccount} style={{ flex:1, padding:"10px", borderRadius:8, border:"none", background:T.coral, color:T.white, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                      {delSaving ? "⏳ Deleting…" : "Permanently Delete"}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </>
        )}

        {/* MY HOME */}
        {activeSection === "home" && (
          <>
            <div style={{ background:T.cobaltL, borderRadius:12, padding:14, fontSize:13, color:T.cobalt, lineHeight:1.5 }}>
              🏠 Adding your home details helps pros give more accurate quotes without an on-site visit.
            </div>
            {saveError && <div style={{ color:T.coral, fontSize:13, background:"rgba(232,81,42,0.1)", padding:"10px 14px", borderRadius:10 }}>{saveError}</div>}
            <div><label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>HOME ADDRESS</label><input value={form.address} onChange={e => update("address",e.target.value)} style={inputStyle} /></div>
            <div><label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>HOME TYPE</label>
              <select value={form.homeType} onChange={e => update("homeType",e.target.value)} style={inputStyle}>
                {["Single Family Home","Townhouse","Condo / Apartment","Mobile Home","Commercial"].map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div><label style={{ fontSize:11, fontWeight:700, color:T.slate, display:"block", marginBottom:6, letterSpacing:"0.08em" }}>SQ FOOTAGE</label><input value={form.sqft} onChange={e => update("sqft",e.target.value.replace(/[^0-9]/g,""))} placeholder="e.g. 2400" style={inputStyle} /></div>
            <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:14 }}>
              <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.08em", marginBottom:10 }}>HOME PHOTOS (OPTIONAL)</div>
              <button style={{ width:"100%", padding:"10px", borderRadius:8, border:`2px dashed ${T.border}`, background:T.sand, color:T.slate, fontWeight:600, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                📸 Add exterior / interior photos
              </button>
            </div>
          </>
        )}

        {/* SAVED PROS */}
        {activeSection === "saved" && (
          <>
            <div style={{ fontSize:13, color:T.slate, marginBottom:4 }}>{savedPros.length} saved pros</div>
            {savedPros.map(pro => (
              <div key={pro.id} style={{ background:T.white, borderRadius:14, padding:14, border:`1px solid ${T.border}`, display:"flex", gap:12, alignItems:"center" }}>
                <Avatar initials={pro.img} size={44} color={T.cobalt} />
                <div style={{ flex:1 }}>
                  <div style={{ fontWeight:700, fontSize:14, color:T.navy }}>{pro.name}</div>
                  <div style={{ fontSize:12, color:T.slate }}>{CATEGORIES.find(c=>c.id===pro.cat)?.label}</div>
                  <Stars rating={pro.rating} />
                </div>
                <div style={{ display:"flex", flexDirection:"column", gap:6, alignItems:"flex-end" }}>
                  <Badge label={pro.badge} />
                  <div style={{ display:"flex", gap:6 }}>
                    <button onClick={() => toggleSaved(pro)} title="Remove from saved" style={{ padding:"5px 8px", borderRadius:6, border:`1px solid ${T.border}`, background:T.white, color:T.coral, fontSize:11, fontWeight:700, cursor:"pointer", fontFamily:"'DM Sans', sans-serif" }}>🤍</button>
                    <button onClick={() => onNavigate && onNavigate("profile", pro)} style={{ padding:"5px 10px", borderRadius:6, border:`1px solid ${T.border}`, background:T.white, color:T.cobalt, fontSize:11, fontWeight:700, cursor:"pointer", fontFamily:"'DM Sans', sans-serif" }}>Book</button>
                  </div>
                </div>
              </div>
            ))}
            {savedPros.length === 0 && (
              <div style={{ textAlign:"center", padding:40, color:T.slate }}>
                <div style={{ fontSize:36, marginBottom:8 }}>🤍</div>
                <div style={{ fontWeight:700 }}>No saved pros yet</div>
                <div style={{ fontSize:13, marginTop:4 }}>Tap the 🤍 on any pro profile to save them</div>
              </div>
            )}
          </>
        )}

        {/* NOTIFICATIONS */}
        {activeSection === "notifs" && (
          <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
          {/* Homeowners had no way at all to open their actual alerts feed —
              the bottom nav only shows it for pros, and this screen used to
              only have the push-permission toggle and preference switches
              below, with no link to the real notification list. */}
          <button onClick={() => onNavigate && onNavigate("notifications")} style={{ background:T.cobaltL, borderRadius:14, border:`1px solid ${T.cobalt}33`, padding:16, display:"flex", justifyContent:"space-between", alignItems:"center", cursor:"pointer", width:"100%", textAlign:"left", fontFamily:"'DM Sans', sans-serif" }}>
            <div>
              <div style={{ fontWeight:700, fontSize:14, color:T.navy }}>🔔 View All Alerts</div>
              <div style={{ fontSize:12, color:T.slate, marginTop:2 }}>New bids, messages, bookings, and payments</div>
            </div>
            <span style={{ color:T.cobalt, fontWeight:700 }}>→</span>
          </button>
          <NotificationsToggle authUser={authUser} />
          <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, overflow:"hidden" }}>
            {[
              { key:"newBids",          label:"New bids on my jobs",    sub:"Get notified when pros submit quotes"     },
              { key:"bookingReminders", label:"Booking reminders",      sub:"24hr and 1hr before your scheduled job"  },
              { key:"proMessages",      label:"Pro messages",           sub:"New messages from service professionals" },
              { key:"promotions",       label:"Promotions & offers",    sub:"Discounts and special offers from Localy" },
              { key:"weeklyDigest",     label:"Weekly digest",          sub:"Summary of activity in your area"        },
            ].map((n,i) => (
              <div key={n.key} style={{ padding:"14px 16px", display:"flex", alignItems:"center", gap:12, borderBottom:`1px solid ${T.border}` }}>
                <div style={{ flex:1 }}>
                  <div style={{ fontWeight:700, fontSize:13, color:T.navy }}>{n.label}</div>
                  <div style={{ fontSize:11, color:T.slate, marginTop:2 }}>{n.sub}</div>
                </div>
                <div onClick={() => toggleNotif(n.key)} style={{ width:44, height:24, borderRadius:99, cursor:"pointer", background: notifications[n.key] ? T.green : T.border, position:"relative", transition:"background 0.2s", flexShrink:0 }}>
                  <div style={{ width:20, height:20, borderRadius:"50%", background:T.white, position:"absolute", top:2, left: notifications[n.key] ? 22 : 2, transition:"left 0.2s", boxShadow:"0 1px 4px rgba(0,0,0,0.2)" }} />
                </div>
              </div>
            ))}
          </div>
          </div>
        )}

        {/* PAYMENT */}
        {activeSection === "payment" && (
          <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
            <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, overflow:"hidden" }}>
              <div style={{ padding:"12px 16px", borderBottom:`1px solid ${T.border}`, fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em" }}>SAVED PAYMENT METHODS</div>
              {[
                { type:"Visa",       last4:"4242", exp:"12/27", icon:"💳" },
                { type:"Apple Pay",  last4:"",     exp:"",      icon:"" },
              ].map((card,i) => (
                <div key={i} style={{ padding:"14px 16px", display:"flex", gap:12, alignItems:"center", borderBottom:`1px solid ${T.border}` }}>
                  <span style={{ fontSize:24 }}>{card.icon}</span>
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:700, fontSize:13, color:T.navy }}>{card.type}{card.last4 ? ` ···· ${card.last4}` : ""}</div>
                    {card.exp && <div style={{ fontSize:11, color:T.slate }}>Expires {card.exp}</div>}
                  </div>
                  {i === 0 && <span style={{ fontSize:10, fontWeight:700, color:T.green, background:T.greenL, padding:"2px 8px", borderRadius:99 }}>Default</span>}
                </div>
              ))}
              <button style={{ width:"100%", padding:"13px", background:"none", border:"none", color:T.cobalt, fontWeight:700, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans', sans-serif" }}>
                + Add Payment Method
              </button>
            </div>
            <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, padding:16 }}>
              <div style={{ fontSize:11, fontWeight:700, color:T.slate, letterSpacing:"0.1em", marginBottom:12 }}>BILLING HISTORY</div>
              {[
                { desc:"Lawn maintenance — Lisa Nguyen", amount:"$62",  date:"Aug 6" },
                { desc:"Faucet repair — Marcus Webb",    amount:"$191", date:"Aug 4" },
                { desc:"Deep clean — Sandra Torres",     amount:"$258", date:"Jul 28" },
              ].map((t,i) => (
                <div key={i} style={{ display:"flex", justifyContent:"space-between", padding:"8px 0", fontSize:13, borderBottom:`1px solid ${T.border}` }}>
                  <div>
                    <div style={{ fontWeight:600, color:T.navy }}>{t.desc}</div>
                    <div style={{ fontSize:11, color:T.slate }}>{t.date}</div>
                  </div>
                  <div style={{ fontWeight:700, color:T.navy }}>{t.amount}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}


// ── Nav SVG Icons ──────────────────────────────────────────────
const NAV_SVG = {
  // Explore — compass rose
  explore:   (color) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg>,
  // Map — location pin
  map:       (color) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>,
  // Jobs — briefcase
  jobs:      (color) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>,
  // Messages — chat bubble
  messages:  (color) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
  // My Jobs — clipboard check
  myjobs:    (color) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>,
  // Dashboard — bar chart
  dashboard: (color) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
  // Alerts — bell
  alerts:    (color) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
  // Pros — wrench (service pro)
  pros:      (color) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>,
};

// ── App Shell ──────────────────────────────────────────────────
export default function HomeCallApp() {
  const [userType, setUserType]   = useState(null);
  const [authUser, setAuthUser]   = useState(null);
  const [adminMode, setAdminMode] = useState(false);
  const [view, setView]           = useState("home");
  const [selectedPro, setSelectedPro] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [activeTab, setActiveTab]     = useState("home");
  const { pendingReview, triggerReview, dismissReview } = useReviewPrompt();
  const { incomingJob, acceptedJob, acceptJob, declineJob } = useJobMatching(userType);
  const [cancelBooking, setCancelBooking] = useState(null);
  // Pro's own job queue count for the bottom nav badge — same
  // "not completed yet" definition DashboardView already uses
  // (confirmed or in_progress; pending bids and completed jobs don't count).
  const { bookings: myBookings } = useBookings(authUser, userType);
  const proQueueCount = userType === "pro"
    ? myBookings.filter(b => b.status === "confirmed" || b.status === "in_progress").length
    : 0;
  // Single shared notifications instance — used for both the Alerts
  // bottom-nav badge AND the NotificationsView list below. Previously
  // these were two separate useNotifications() calls with their own
  // independent local state, so marking a notification read inside the
  // list never updated the badge count until the whole app remounted.
  const { notifs: navNotifs, loading: navNotifsLoading, markRead: markNotifRead, markAllRead: markAllNotifsRead } = useNotifications(authUser);
  // Split by type so an unread message doesn't get counted on both the
  // Messages icon AND the Alerts icon — each unread notification should
  // show up on exactly one badge.
  const unreadMsgCount   = navNotifs.filter(n => n.unread && n.type === 'message').length;
  const unreadNotifCount = navNotifs.filter(n => n.unread && n.type !== 'message').length;
  // Holds the real amount/pro/hours for whichever booking or accepted bid is
  // headed to checkout, so PaymentView shows a real total instead of a
  // hardcoded placeholder — set right before navigating to "payment".
  const [checkout, setCheckout] = useState(null);

  const AUTH_STORAGE_KEY = 'localy_authuser';

  const handleAuth = (type, user) => {
    setUserType(type);
    setAuthUser(user);
    // Pros live on the Job Board, not the browse/"Pros" home tab that
    // makes sense for a homeowner — land them straight on My Bids instead
    // of a screen with nothing useful for them to do.
    if (type === "pro") { setView("jobs"); setActiveTab("jobs"); }
    // Persisted alongside the session token (see setSession in the
    // Supabase helpers above) so a page refresh doesn't drop back to the
    // login screen — the token by itself is useless if the app forgets
    // who was using it.
    try { localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify({ type, user })); } catch {}
  };

  // Marks the "how to use Localy" walkthrough as seen, both in the
  // database (so it never shows again on any device) and in the local
  // authUser/localStorage copy (so it disappears immediately without
  // needing a re-fetch).
  const handleOnboardingComplete = () => {
    if (typeof authUser?.id === 'string') {
      sbUpdate('users', authUser.id, { onboarded: true }).catch(err => console.log('Onboarding complete update error:', err.message));
    }
    const updatedUser = { ...authUser, onboarded: true };
    setAuthUser(updatedUser);
    try { localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify({ type: userType, user: updatedUser })); } catch {}
  };

  const handleLogout = () => {
    clearSession();
    try { localStorage.removeItem(AUTH_STORAGE_KEY); } catch {}
    setUserType(null);
    setAuthUser(null);
    setView("home");
  };

  // Restore a previous login on page load/refresh — only if a real
  // session token also survived (see loadStoredSession at module load),
  // otherwise this would show a "logged in" screen with no way to
  // actually authenticate any Supabase requests.
  //
  // Also re-checks is_blocked on every restore, not just at the moment of
  // login — an admin could block this account any time after the user's
  // last visit, and a stale local session shouldn't let a blocked user
  // keep using the app just because they never logged out.
  const [blockedMessage, setBlockedMessage] = useState(null);
  // Same "pro lands on Job Board, not Home" behavior as a fresh login —
  // a restored session shouldn't feel different from just having signed in.
  const applyRestoredAuth = (type, user) => {
    setUserType(type);
    setAuthUser(user);
    if (type === "pro") { setView("jobs"); setActiveTab("jobs"); }
  };
  useEffect(() => {
    if (!SESSION.accessToken) return;
    try {
      const raw = localStorage.getItem(AUTH_STORAGE_KEY);
      if (raw) {
        const { type, user } = JSON.parse(raw);
        if (type && user) {
          if (typeof user.id === 'string') {
            sbFetch('users', `?id=eq.${user.id}&select=is_blocked,blocked_reason`).then(rows => {
              const row = rows?.[0];
              if (row?.is_blocked) {
                clearSession();
                try { localStorage.removeItem(AUTH_STORAGE_KEY); } catch {}
                setBlockedMessage(row.blocked_reason
                  ? `Your account has been blocked: ${row.blocked_reason}. Contact support@hirelocaly.com for help.`
                  : "Your account has been blocked. Contact support@hirelocaly.com for more information.");
              } else {
                applyRestoredAuth(type, user);
              }
            }).catch(() => {
              // Can't reach Supabase to check right now — fail open rather
              // than locking out a legitimate user over a network blip.
              applyRestoredAuth(type, user);
            });
          } else {
            applyRestoredAuth(type, user);
          }
        }
      }
    } catch {}
  }, []);

  const navigate = (to, data = null) => {
    if (to === "profile")   { setSelectedPro(data); setView("profile"); }
    else if (to === "book")    { setSelectedPro(data); setView("book"); }
    else if (to === "postjob") { setView("postjob"); }
    else if (to === "bid")     { setSelectedJob(data); setView("bid"); }
    else if (to === "viewbids"){ setSelectedJob(data); setView("viewbids"); }
    else if (to === "prosignup"){ setView("prosignup"); }
    else { setView(to); }
  };

  // "Message"/"Contact Pro" used to just switch to the Messages tab with
  // nothing selected — no conversation was ever created, so the homeowner
  // landed on their inbox list with no thread to actually talk in. This
  // finds (or creates) the real conversation row for this homeowner+pro
  // pair, then hands MessagingView enough info to open it immediately.
  const [openConversation, setOpenConversation] = useState(null);
  // setView() alone only swaps which screen renders — it doesn't touch
  // activeTab, the separate state the bottom nav actually highlights off
  // of. Every other navigation path goes through handleTab(), which sets
  // both together; these two handlers were setting view directly and
  // skipping activeTab, so the content correctly switched to Messages but
  // the nav bar kept the previous tab (e.g. Jobs) highlighted.
  const handleMessagePro = async (pro) => {
    if (!pro) { setActiveTab("messages"); setView("messages"); return; }
    if (typeof pro.id === 'string' && typeof authUser?.id === 'string' && userType === 'homeowner') {
      const { id, error } = await getOrCreateConversation(authUser.id, pro.id);
      if (id) {
        setOpenConversation({
          id,
          name: pro.name || 'Pro',
          init: (pro.name || 'PR').split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase(),
          lastMsg: '', time: 'Now', unread: 0, job: 'Booking',
          recipientUserId: pro.userId || null,
        });
      } else {
        console.log('Could not open conversation:', error);
      }
    }
    setActiveTab("messages");
    setView("messages");
  };

  // Same idea in reverse — a pro messaging the homeowner on a job they've
  // bid on (most importantly, once that bid is accepted). Before this,
  // pros had no path to the homeowner at all: no My Bids screen, and no
  // way to resolve who to even message.
  const handleMessageHomeowner = async (homeownerId, homeownerName) => {
    if (!homeownerId) { setActiveTab("messages"); setView("messages"); return; }
    if (typeof homeownerId === 'string' && typeof authUser?.id === 'string' && userType === 'pro') {
      const myProId = await getProProfileId(authUser.id);
      if (myProId) {
        const { id, error } = await getOrCreateConversation(homeownerId, myProId);
        if (id) {
          setOpenConversation({
            id,
            name: homeownerName || 'Homeowner',
            init: (homeownerName || 'HO').split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase(),
            lastMsg: '', time: 'Now', unread: 0, job: 'Booking',
            recipientUserId: homeownerId,
          });
        } else {
          console.log('Could not open conversation:', error);
        }
      }
    }
    setActiveTab("messages");
    setView("messages");
  };

  // A homeowner tapping "Approve & Pay" on a sent invoice — routes through
  // the same Stripe Connect checkout already used for bookings/bids, just
  // with the invoice's total and an invoiceId so PaymentView's onSuccess
  // knows to mark the invoice paid instead of touching booking status.
  const handlePayInvoice = (invoice, booking) => {
    setCheckout({
      pro: { id: invoice.proId, name: booking?.pro || 'Pro', userId: invoice.proUserId },
      amount: invoice.total,
      hours: null,
      jobTitle: `Invoice — ${booking?.job || 'Booking'}`,
      invoiceId: invoice.id,
    });
    setView("payment");
  };

  // ── Admin ──
  // Real gate lives in the database (is_admin_user() RLS policies — see
  // admin_role_migration.sql): this client-side check is just so the
  // button only shows up for an admin, not the actual security boundary.
  const handleAdminEnter = () => { if (authUser?.isAdmin) setAdminMode(true); };
  if (adminMode) return <AdminDashboard onExit={() => setAdminMode(false)} />;

  // ── Blocked account ──
  // Shown when a restored session belongs to an account an admin blocked
  // since the person's last visit — see the restore useEffect above.
  if (blockedMessage) return <BlockedScreen message={blockedMessage} onDismiss={() => setBlockedMessage(null)} />;

  // ── Auth ──
  if (!userType) return <AuthScreen onAuth={handleAuth} />;

  // ── First-time onboarding ──
  // onboarded:false only ever happens right after a brand-new signup (see
  // handleSignup) — every existing account was backfilled to true by the
  // migration, so this never interrupts anyone already using the app.
  if (authUser?.onboarded === false) {
    return <OnboardingOverlay userType={userType} onDone={handleOnboardingComplete} />;
  }

  // ── Legacy placeholder (kept for structure) ──
  if (false) return (
    <div style={{
      minHeight: "100vh", background: `linear-gradient(160deg, #0A2540 0%, #1565C0 55%, #0A9E6A 100%)`,
      display: "flex", flexDirection: "column", alignItems: "center",
      justifyContent: "center", padding: 32, fontFamily: "'DM Sans', sans-serif",
    }}>
      <img src="data:image/png;base64,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" alt="Localy" style={{ width: 220, objectFit: "contain", marginBottom: 8 }} />
      <p style={{ color: "#A8BFDF", textAlign: "center", fontSize: 15, marginBottom: 40, maxWidth: 280 }}>
        Find. Hire. Get It Done.
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: 14, width: "100%", maxWidth: 320 }}>
        <button onClick={() => setUserType("homeowner")} style={{
          background: T.white, color: T.navy, border: "none",
          borderRadius: 14, padding: "18px 20px", cursor: "pointer",
          fontFamily: "'DM Sans', sans-serif", textAlign: "left",
        }}>
          <div style={{ fontSize: 22, marginBottom: 4 }}>🏠</div>
          <div style={{ fontWeight: 700, fontSize: 16 }}>I need a service</div>
          <div style={{ fontSize: 13, color: T.slate }}>Find and book local pros</div>
        </button>
        <button onClick={() => setUserType("pro")} style={{
          background: "rgba(255,255,255,0.12)", color: T.white,
          border: `1.5px solid rgba(255,255,255,0.25)`,
          borderRadius: 14, padding: "18px 20px", cursor: "pointer",
          fontFamily: "'DM Sans', sans-serif", textAlign: "left",
        }}>
          <div style={{ fontSize: 22, marginBottom: 4 }}>🔧</div>
          <div style={{ fontWeight: 700, fontSize: 16 }}>I'm a service pro</div>
          <div style={{ fontSize: 13, color: "#A8BFDF" }}>Find jobs and grow your business</div>
        </button>
      </div>
      <p style={{ color: "rgba(255,255,255,0.3)", fontSize: 11, marginTop: 32 }}>
        Serving The Woodlands & Greater Houston
      </p>
      <button onClick={() => setAdminMode(true)} style={{ marginTop:16, background:"none", border:"none", color:"rgba(255,255,255,0.2)", fontSize:11, cursor:"pointer", fontFamily:"'DM Sans', sans-serif" }}>
        Admin Login
      </button>
    </div>
  );

  // ── Main nav shell ──
  const tabs = userType === "homeowner"
    ? [
        { id:"home",          icon:"explore",   label:"Explore"  },
        { id:"map",           icon:"map",       label:"Map"      },
        { id:"jobs",          icon:"jobs",      label:"Jobs"     },
        { id:"messages",      icon:"messages",  label:"Messages", badge: unreadMsgCount || undefined },
        { id:"dashboard",     icon:"myjobs",    label:"My Jobs"  },
      ]
    : [
        { id:"jobs",          icon:"jobs",       label:"Jobs"      },
        { id:"dashboard",     icon:"dashboard",  label:"Dashboard" },
        { id:"messages",      icon:"messages",   label:"Messages",  badge: unreadMsgCount || undefined },
        { id:"notifications", icon:"alerts",     label:"Alerts",    badge: unreadNotifCount || undefined },
        { id:"home",          icon:"pros",       label:"Pros",     badge: proQueueCount || undefined },
      ];

  const handleTab = (id) => { setActiveTab(id); setView(id === "home" ? "home" : id); };

  const renderView = () => {
    if (view === "profile"  && selectedPro) return <ProPublicProfile pro={selectedPro} onBack={() => setView("home")} onBook={() => { setView("book"); }} onMessage={() => handleMessagePro(selectedPro)} userType={userType} authUser={authUser} />;
    if (view === "book"     && selectedPro) return <BookingView pro={selectedPro} onBack={() => setView("home")} onConfirm={() => {}} onPay={(details) => { setCheckout(details); setView("payment"); }} authUser={authUser} />;
    if (view === "postjob")                  return <PostJobView onBack={() => setView("jobs")} authUser={authUser} />;
    if (view === "prosignup")                return <ProSignupView onBack={() => setView("dashboard")} />;
    if (view === "jobs")                     return <JobBoardView onNavigate={navigate} userType={userType} authUser={authUser} onMessageHomeowner={handleMessageHomeowner} />;
    if (view === "dashboard")                return <DashboardView userType={userType} onNavigate={navigate} onCancelBooking={(b) => setCancelBooking(b)} onPayInvoice={handlePayInvoice} authUser={authUser} />;
    if (view === "messages")                 return <MessagingView userType={userType} onNavigate={navigate} authUser={authUser} openConversation={openConversation} onConsumeOpenConversation={() => setOpenConversation(null)} />;
    if (view === "notifications")            return <NotificationsView onNavigate={navigate} onReview={triggerReview} notifs={navNotifs} loading={navNotifsLoading} markRead={markNotifRead} markAllRead={markAllNotifsRead} />;
    if (view === "ratings")                  return <RatingsView userType={userType} />;
    if (view === "payment")                 return <PaymentView pro={checkout?.pro || selectedPro} booking={checkout} authUser={authUser} onBack={() => setView("home")} onSuccess={() => {
      // Paying an itemized invoice (diagnostic-fee follow-up, etc.) is a
      // different event than confirming a fresh booking — the booking
      // itself was already confirmed a while ago, so none of the
      // booking-status logic below applies. Mark the invoice paid, notify
      // both sides with invoice-specific language, and stop here.
      if (checkout?.invoiceId) {
        sbUpdate('invoices', checkout.invoiceId, { status: 'paid', paid_at: new Date().toISOString() })
          .catch(err => console.log('Invoice paid-status update error:', err.message));
        sendPushNotification(
          authUser?.id,
          'Invoice paid ✅',
          `Your $${checkout.amount} invoice for "${checkout?.jobTitle || 'your booking'}" is paid.`,
          { type: 'invoice' }
        );
        if (checkout?.pro?.userId) {
          sendPushNotification(
            checkout.pro.userId,
            'Invoice paid! 💰',
            `${authUser?.name || 'A homeowner'} paid your $${checkout.amount} invoice for "${checkout?.jobTitle || 'the booking'}".`,
            { type: 'invoice' }
          );
        }
        setCheckout(null);
        return;
      }
      // Only a real (Supabase UUID) booking id can back a real review row —
      // mock/demo bookings and bid-accept placeholders ("local-...") don't
      // have one, so the review just won't persist for those (same
      // real-vs-mock split used everywhere else in this file).
      const reviewBookingId = checkout?.localBookingIds?.find(id => typeof id === 'string' && !id.startsWith('local-')) || null;
      triggerReview(checkout?.pro || selectedPro, "payment", reviewBookingId);
      rewardReferralIfEligible(authUser);
      sendPushNotification(
        authUser?.id,
        'Payment received ✅',
        `Your booking with ${checkout?.pro?.name || selectedPro?.name || 'your pro'} is confirmed.`,
        { type: 'payment' }
      );
      // Tell the pro too — before this, only the homeowner ever heard
      // anything when a booking was paid for/confirmed; the pro had no way
      // to find out except by happening to check their dashboard.
      const payingProUserId = checkout?.pro?.userId || selectedPro?.userId || null;
      if (payingProUserId) {
        sendPushNotification(
          payingProUserId,
          'Booking confirmed! 📅',
          `${authUser?.name || 'A homeowner'} confirmed and paid for "${checkout?.jobTitle || 'your booking'}".`,
          { type: 'booking_status' }
        );
      }
      // Flip this session's local "My Jobs" entries from pending -> confirmed
      // now that payment actually succeeded.
      if (checkout?.localBookingIds?.length) {
        checkout.localBookingIds.forEach(id => BOOKING_STORE.updateStatus(id, "confirmed"));
      } else if (checkout?.bidId) {
        // Bid-accept flow never had a pending entry — create the confirmed
        // one now, same "My Jobs" registry the direct-booking flow uses.
        BOOKING_STORE.publish({
          id: `local-bid-${checkout.bidId}`,
          job: checkout.jobTitle || "Booking",
          pro: checkout.pro?.name || "Pro",
          date: "",
          status: "confirmed",
          total: checkout.amount || 0,
          hoursUntil: 999,
        });
      }
      setCheckout(null);
    }} />;
    if (view === "map")                      return <MapView onNavigate={navigate} />;
    if (view === "terms")                    return <LegalView type="terms" onBack={() => setView("home")} onSwitch={() => setView("privacy")} />;
    if (view === "cancellation")             return <CancellationPolicyView onBack={() => setView("home")} />;
    if (view === "availability")             return <AvailabilityCalendar onBack={() => setView("dashboard")} />;
    if (view === "earnings")                 return <EarningsAnalyticsView authUser={authUser} onBack={() => setView("dashboard")} />;
    if (view === "referrals")                return <ReferralsView authUser={authUser} onBack={() => setView("account")} />;
    if (view === "neighborhood")             return <NeighborhoodFeedView authUser={authUser} onNavigate={navigate} onBack={() => setView("home")} />;
    if (view === "verification")             return <VerificationView authUser={authUser} onBack={() => setView("dashboard")} />;
    if (view === "howitworks")               return <OnboardingOverlay userType={userType} onDone={() => setView("account")} mode="replay" />;
    if (view === "goplus")                   return <GoProPlusView authUser={authUser} onBack={() => setView("account")} />;
    if (view === "viewbids"  && selectedJob)  return <ViewBidsView job={selectedJob} authUser={authUser} onBack={() => setView("jobs")} onBook={(bid) => {
      setCheckout({
        pro: { name: bid.proName, rate: `$${bid.amount}`, city: selectedJob?.city || "", userId: bid.proUserId || null },
        amount: bid.amount,
        hours: null,
        jobTitle: selectedJob?.title,
        bidId: bid.id,
      });
      setView("payment");
    }} />;
    if (view === "account")                  return userType === "pro" ? <ProProfileEditor authUser={authUser} onBack={() => setView("dashboard")} onLogout={handleLogout} onAdmin={handleAdminEnter} onNavigate={navigate} /> : <HomeownerAccount authUser={authUser} onBack={() => setView("dashboard")} onNavigate={navigate} onLogout={handleLogout} onAdmin={handleAdminEnter} />;
    if (view === "editprofile")              return <ProProfileEditor authUser={authUser} onBack={() => setView("dashboard")} />;
    if (view === "bid"       && selectedJob)  return <PlaceBidView job={selectedJob} onBack={() => setView("jobs")} authUser={authUser} />;
    if (view === "privacy")                  return <LegalView type="privacy" onBack={() => setView("home")} onSwitch={() => setView("terms")} />;
    return <HomeView onNavigate={navigate} userType={userType} authUser={authUser} />;
  };

  return (
    <div style={{
      maxWidth: 420, margin: "0 auto", fontFamily: "'DM Sans', sans-serif",
      background: T.sand, minHeight: "100vh", display: "flex", flexDirection: "column",
      boxShadow: "0 0 40px rgba(0,0,0,0.15)",
    }}>
      {/* Top bar */}
      <div style={{
        background: T.white, borderBottom: `1px solid ${T.border}`,
        padding: "12px 16px", display: "flex", justifyContent: "space-between", alignItems: "center",
      }}>
        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAADICAYAAABS39xVAAA8qUlEQVR42u2deXxkR3Xvf6fq3l7Uklr7Pvt4Vs+M7bHxgm0NNgTMFhLcBgMxhBDgJQESIATySIRIXkiAkMQJeYCBPAMBPDKEgFltYgtjA97XmfHsmpE02lutrfsuVef9ca+W0datGY0Zmfp+6A+eTV23btWvTp065xRgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDYdmh8GMwmDFnOG8RSKXk9NghBL+GMF1jODcilZJoaRFT462lRQApacTLkIcWMa1awHuAqFjgzw2G5RErmjKtGBB7AUmnGVxGtJ5P83ZlWVaAXl1Vf8lA6fp3KJm4goUoIaihiD92X23/s184PDJyZPLvmddrWIb5wQJAWeO2VC5W80Ylops0sZDaPxZzB78xcuLJ/9SYqWcGI1ihWBGgq9Zc9OGR+JqPu5GkzczBGCECMcP2BtKVY0f+4FTnof8yomVYBsuKLysprtxXs+uruVj9DVrEwRAAFACC1B7iuc4fXth//1t+OcLpcDoZ0TrHFstKQALQVY1bbhku2fgJxy6x2M/5UI6GdjV8R7NyPTdSUz5UsumbaxsvuDwUK2leseFMBeudYHt/9Y7/nCjecIOC5bNyFFROQ7kaKqcU4E0Ub7jhmaqrbm8BEdBitoZGsEAA6xcBpSPxhr/1KBEMGCILRAIgASIBIht+zncj1ZH+otqPBw/WYlY7w9JpbrYA6G+t3vrGiaLGl7PneoCyQJAgFiAIEElA2dp3vVy8/tWfW73xlUCrWSSNYKUEQHyocf01XqRiFZSHYLDMK22SlcuuLLm6KZlcFw4g44Q3LI09ezQBmIhUvkFTXAOa5veeEMCKfBnnUbvmzQQAqZTpv99owWruIwDQdkkjhGQQL2I1EYEZWkSLJuLlq6ZHlcGwBFo/rgmAltGqwGnFYtEdAIN8EQ3GW9te4zc9h1grp6EWAUz5/eiBI55s8XwPHFqkQYaVAyEYaCBNNogB4jzrHgFEynSdsbCmZ70tHFChQcYM+M9H3zVbQcAqUziqZ32I0dIiAp+ICTJcSfgAgYgKf2Vs3q2xsKbRWmvKO3gYCP2hlnVOHo2AlEDLNkZrqwbaNdoAAuFaoPhkOWRCQ4wL6HIAu9M8cVtrq8czzcJUSqKtjWFCLs7n5TF418I40I1gnYViFbq5YpwLAyslgTsV0KaoFaiNxdaMl228RsVLrvas2JYHYa9joggEERPpk0rTU5V+Okr+wZhyHo866Z9t6Xru4Z+1tY0Fj9EigFYY4VoJO0SDEaylL3rEzIH/kxZXLtYavp9dxq0fM0BqLyD/pGnra8ZiNW8bEMXXaStRwjICJgr+CnjKY6UsAKA6j8RWl/Vvi7iDX5RsOF7sj9xVNtZ9e2dP6yM8JYRtGsbXdR6OOS74tRhZM4IV0D75H4X7NGnZHiwlgTYlQKho2HrT7xXV/7kfrbhUySJAK0ArBeUFHlni0x1swVhngFhDshaWhF251o1U/EnOrvxf8ZKm/ypL7/u77oG2x2dkgBhr67yxqhisVfgi88uRWW2eH1aM011NDYrC1rKz3xIGYrW+quSC6Pprvpcu336HE2+8VMHS8BwFrRjEEoQgoBAkAKLTPkQiCDZUFlgRlKPhe74ni+REfM2N/ZVXPli+dvcn3gqOwUTmn3f2FcGc/BnBWirNk4secXBIWIiZTrAs+yyW15QktKm6xs2pzqqrH8wWr321gqWhchpgAQEZWFS8tB8bCJgFVoDvKs9KxjIlWz9856aX3LupsnJLqMtGtM6PrQfzojF/BiNYi013Ip3fY0DL4FBICUKbKmvY+sGB0q17XbuyCr6jABYgIZbHc0EAQYI91tr3x+Orr+iouvRnq+tXv9iI1q/fspoxPfR0lEq+V2oSKoxgzTfRz2m4S7NFaFNlTdv/PFO29VO+LNJQjl4wFWh6jDPAGgx12gd5VmgCAWzBy/pOtK66N7n9roaahiufZ9Ga9L2JGZ/zoarm7HY9720iIdi40887y3eFKCsLKmwHVvjJzizLSgJtftWqzW9LF2/6pBZxBfYESCwyYlkDpEHSAkkKAltnahgDrBnQOjzepAXMRwt+Vjl2VdlAcvv31ijn6o7BwQM4NyVygliy5j5C+30KEJNHmzxXLzSheY9Eew0D5zx2LBCk5maBmhpG251qbrvC7kvdKNEGFNim6eetqWH09VH4PIWczNJU3Pvy6pZAc/PpxkJ7uz7H/Xv6d7YDwDn/zt9cwQp8oMhjYQWBo2dghQmgTW2or7/kRNH6f/dlkQZ7tKDAgBkQGsKWxFoIf5SFzh0R2jslQBNgFiAklIiu92WiTltFMhAvXwEs5x39RBLKVW68rrK3bOvXUoM/v6YNLQ7QukyF4VJyOuC1TaEdECD8FRD5RjFKR6xYQhC0ZohiPzfx5jHO/A3I1e0zzi9aWgRa99Eyh2EEgoI7A4u0vT3I4wPEbwHx/RUo83XMilg59/IBHv4WkNVtber0Ni0YzyYAmnreufr46ziZDQ5zQoGaRYsAWhnLe+gY9u9C3xm2Z+Xssc5zmpsttLf7ZWsv/r2RxOavaCYF0otsl4gFZymZfvqa9KmjPw+3VmrxPmihV6M19tON1/4qG19zIZSjFtwGMmtISwj2YTvpA3E3/ZUir/uHL+vuPvAVIDezY3eXoPJI8cbd2Wj1TZ5ddpMfrSoB+xpQC4shky8kWcnRA38/fPzxj3AQGa/OboIE1goB2FqEuq7y7S/27OIXs5XYqclarUkmNaiYadKW4AkBlbGYT0rOPhnzRh8sGzn44JGhbOf0Se2NyzDQp9smANTUrbp0PFa7R0WKdyuObNdEpaBIuSZYxOyS9tOS0C/1xOMxlbm/auTgvQcHs908/2QXADQDVN249YaJWNlLIWUCvh4tUun/6e/Y/0OaWuFmixZBgmFvuv7hXLT+UmhXL+ikYihIW0bcrvu95+69lqfTtOZfdEG8o6KiqaN43et8GdmuBVGEvePlub4fnejueIJnqOlyTqON1dUbBkrWvsqT0a2smS0/+0xFZt/3jw/nOlaYU2hlCFbJul1vGU9s+apmoYDFBEuw5CxVjD51Tf/JAgQrFISy1Tv/KpPc8XFWygfxQpangrCl7QwMJ3LdLS878dRtbUD2tC0UPhb26ccms2ZBANaVlFzQV7Xro9l47S1KxEHsMs8rWsygiI6oYV2fefryju6OxwsQ3QWsxhYArVoAqKzf/PLxeM3bXav4pdoqrtAyOj0vpgIkxXTYEQXuo+BgNgfhjWYi7nh7LNt7+7d6Dnz3JYAfTkA6AyslLHbXql8GJB5p2HnLeLzq95VdfJm2E2Cyg902OPgKDttJBIjA0Bacg3DH05Y/+oOK0Y5/6+7r+CWf7pfVmysrN58o2/FFN1p1tbLC52XA0g6i7tAD1cMH/vh4f9eTc0UrECxr03UPO9GGwgTL6brfO7ioYAkB6JKGnR/Ilqz6iBdJVjJEeP6iYXmjynYG7mg4+os/PQz0L4NoEQBqAcQ/r7744xNFje9RkWSxDl2jpHxIL5MpdXv+cfD4o39L09/HRrDO0hEOtPul63a9eTSx+WvMcjkFSwDgiysr65+p3P2sF6kthXYJ8yUtMmvIiIjlup9tGHj85qPp9NMAAc3XWqGpPd/LDmZ9KgW0tSkBoGr19ndkEuv/zbGSUWiX57W0GAp2VCYmjtw1ceiB13Cw7VmKKEgASgCorr3gVSOJVR/youXX+lY8aKJWGsw62GbztLU36asJBCwUXMEgIpCQgITUDiIq/Vgid+rTQx1Pf0PP+L6ltq1qzY6bR2KNf+XaZVs12QD7ALMPnmwXEKQR0IytuEZweicIgiSEBdsb1UVu720XHXnww+3AMJCS28rvaTxWecnPskVNa6BcFfgSp7zpBBGV0VzXQNPwE1ce6e8/MrninC5Y1//Kida/KL9gRWTE6b7fO/jTBQSrRRBadcmqi/5hrHTzh7SwAK38mZkREFKCLCqaOPbIZQNPvaw9kxk5OwEJv3P17i+NJbe8XTMA7funDU1hW5YASsee+0z66EMf4MBKPa99WiunWgMEERfin1rCO06lCAAfLl79bj9aVQbt8sJiZYt49uRTl3f9z0sDsdptA0xob/fDgc4LNEaFWzqh0Wz1nXj2i1UjB15veWkXZPO8J4nEEsrTObvildWNa64IxarAU8OUBKDWxmJrYuuu3jtYseuubKLpWl/YGspT0F6Q30Swgm2vmA54pdDxHQhUkEVObAFagj0GO0pB6my0/pJ06favRzde+6M1lcWT8WOiULHamUBNYuPVe4dKt309F63ZqhkKytFgBYBnBuIKUJhFQExBpU8hQGQBkGCf4TvKk3EaKd74rl9tvO6+tZUNm4E2dbz8gk9kixrWQDkuoCYDfIMPlITOum68vqqv9IJPBnZXy3x+RQIKG06LDEsJtOq6+nXXTJSs/pAmyw8EkC1gRpu0BrTn5orXXPpU5cYPAdBIpc50fkqgVVfVb3j5ePGat2vNHtjj0/qA2ALntM/wR2L176+rX3XNSqiYumICRyWICw0aLdBwJLS1qd3lSObsyrczWwvkYLCGiMDO9fU39j3+u+0T6AkOKx71ZjUmKCOTSkmkUjIsszuzfzXQ7gO77a6uQ98vGz3yJ4JzAmzx9LZnxjNorZWVFKPRmncUXskycKBW1615Rfeqax6cKFmXCoQqF8aRQS58kJC3uyh4DUrAz2mlpMrG1778VPmLH2isXX9dKNoin1g1lpXt3F/3kvtHi9alfC0U/JwGWIblrgtevkAaYEkgkmCf2HO8XNGqXT2VW7+9o6HmeteufC2UZjDsuT+XALDNWmknUnHD+qbqjfNVp5UFb0I43MLOuyiCAIzEqn/ft0oB7Ye7w3n6l7WlNfSYLP/93UAyXOjO4H21MAGYiNW9V8kEA/4CJ9RCQLnwrRKMxBrfjoLHmRGsvGjSBddqYHABqTnNEgCOlWz+LRUtawR7GjRffwgIzorSiaMfCK4Qa7ZweuYPhXcharS3+2hrCyyqKcsrNWvFetRDc7M11HXgtvj4iTshZHANy+xdBLGEBnxZ9uqdSZTlH7xBdH5107b3pMt2fN+N1TbAd31AifxxZEt2JAiQL6Ec3y2qqxhMrv/aRXXF1Vg48S6w+qobd/XXXPZjL9G0KWxbKFQLWcqFWNLhVxJsqJzORaq3HS190U+0LC0G/Omt5bwCoaBEPJYRlVvCPqT5G5En2x40/9ABgLa9WgPkWcUXhrtFscBZUdCvWrEfKa87umbzq2aO06XN6Va9saZmvRtJviQUUrHYGRUY8Oyii/cCMggnOX9dRee/YLVPbcsoyCUucAXOa4zUMAFw7PIbtIzyaT6O05zslrCdngcGuo58LSjW167m7gZadX1V/e7Emqv+Pr7+2m/GN1zzn8l1l39ge3n5qvAkbU7MjQbT6rFjf2l7AxOBaM3eGhKBfa3s0toTxeuvDBstFhOriqbtH0yXbrnVt5JB3iLBOqdjj2DBz/lurLb+WGzjWwEwmudMMAFAbaqs3HKqfNsP3XhDHXxH5W8b5f1ykJ47npl53CoVusDHZgKUZc1rHqmpa+TOxkcsuA0QWsiSgsYsa7CMcjZS87bga/cszacUxlr1lTT9rh9NxqGVLsSqZoiSthWQYbFitoQCk4Hhy3KWQGi7U/0hYLsicTmYaP6Vj0hwDkVO/60EMNr6Zp7cENAi3gnYidWX/VN/5WUPTZSu/4tcYu0bsol1bxop3vDpQ7VXPlG1evs7aO52SSN1kzgwMHAo6qf/m0gSeJ5EW2bNVpTdaMW1QV/0LWC9tKnqxk1vGS694FN+EPCKuWlE5062NBPnrJLrCAD2nDbBCGjBVUDJibKte51YfT28nL98Fh/N/5vsL9NJ11n7nxnQ9AZACfb7AWJwHmuNWEBr8mXptavr67cs+SKV9vsUAyInkm9kWIW4UBggtrR7Yi/gAX8tcB6fFK6cXEJpcaFaRIX8JTB+UlbWwCKyLjSbabZagKSQbqZ358jBn4SjYYaotBChVX9j9SW3TpRt+VPfLgYrL7i7zncUa+W7dmXFcPHG26oaN74es6sxtPURAxT1M3tJZ7HA1ogYkjxRdDEBQPuc1VYApNZUNVw8VLz+C0okNLQnzsxPNRWaz3lTiubYKExa2NUEAK0f19N9mRKEVv306ov/wSlavQO+4weW1Rm3TRfWvqU8f3AuckbL3myf2rwL7h7JACJu5qcEv4CQeSKw9pVdGh2K1b1pptVUmLOduKqu7hLfKr4IKqwokkewiD2SXuYeAhjN953XmrByysuo8GXnjXQvLFUVADLxilUsYnEwzw0vYNIQBMG5h3+WwTBaWmauPBJo1bV1a5uziaZ3a6V8sE9TpWYIEoAF5fi+LOVMbNUnXwYkQs8szRA/Lvd7HxFqbAw0z7aQmIKg+kjjXwMWMFMMAuvlPeBob9mG2/xodRza56mTrcJ0QAf+OGKQTdMfixCUVikgVCFYoSX7maDxUyu0BNpUXfXqF2eLmt7FTCr/5JnzOhVACmQF7RIRARGZbJ8uKF+zAPwFpXiyL/nMC2KF0eXrRo5/yXKHMhBSEHMeO0sLhoRjJd+UAuJBClUB+tncTADgxBvfoGVSBgW9aPGFgKRlecNjq5zer81srxGss/RhCWaRvwJksGMjcJ5lPHixbCU2sIhggSMeJmZI5RxkALhvxsozefITr73Zt0sZ7M+/qhNZ0B77sfL1jzRtuCZ03oqZ7b24a6gPvtcZhvnwfDNBk1V5VyB4M/1WAmjVX121/d1OvGE3lOeHQlmgxUIKMiJISEvCIctNj1ruYMZyB4ctL6MILEG2BEsGL7o3YiKfIt5wOwOYXqFbeC8gh5OrPuXbZQLaW4LlwxoQDBmRglhaXsaz3MEh2+nrsLN93ZabGResBGRUAhEKhXf5rfp827dZduaC+8pUSj4zNNQZ89PfJAIxSC0ugSSgfe3b5Rvubdh4/dxxs8Dgb/+Z/zIg4Vtlr+fAxyfyNFqDBKI6850DPT0dgY/2/M4tXDG5hIomB8/yba81ZFFQ3nieHzo5oLTOzPmztr0aICgZ2xZkvCw6ETWLKHmidBeAH6G5mdDePvUgdwKuBc6EF0vNDTxlBiDK+pPJCmQymemWtendxcVVT8UbPsIcYcApMCyANcgWAkraTu/+qJ+5I+5kfmZlTxyycllfEHiiuLY6Z9VcmY2U36giVb+lIkUE7flBHuR0FCcYPqyIbTvdAw1j3V8cAShYoVMSaFV/1LDx1U605kpoXxfst2JSkJaUagJ2Ln1f1El/I+n2/jwy1tN/8RiyfYB1sjxWOly04dJctPz1nl3xei9SGoX2w4Di5TtkYFqm0iBtbWCAkqNdn81ZVW/37KQVLnKLrSmsZQJjRTV/QDh8F7e0cJgzuQApAbTph5ou+C03UrYO7OX3fZEg6We4JNfzhbGwnec7K0awiEiDaFndgXqxxWQyqWZe3/XHgnhwQQ6ogFWYmRgqO9NiXOrUOW10NzdLtLf7ByvXvtWPVNdCK1WYILCGsEXEGUwXOT0f/e2OJ758O5Abmf3Xxnt7gd5nCLitqn7Dy8dK13/GidVt05oBDosoEBGksO3cwFjpyPFbDgwMnMJkikvLNkGtwHi8+o+0TDB8jwsMjVMkhYy6vQdKJ07+xcDJ576bAzC5Yhye/Gvp3DDSz54g4NsbGho+3R2/4J+y8frmIAtCLU20mGEtQ+pvnlGg0NIiulpbn44Xrf6RF6l4DVgtXkKIWIA1fCv58g3V1RsOt7YewWLVO1q2MbWC3Vj1zVrGGb6nFw4ZCbfbQkrLGXr4X04ee/CmIObivE+CXjkVRwtyhU4lwhXooeQsTSnTgiOnZm6b7hMMwHYyD4DVIjlfHCxjagIxN/1guMfVMx/k5UAUROWB05bnxgGRALMaLs9khqa3yfepFBBxrcq3M1kM8qlQsYpPdO5bM/DQi4c7nvj320G5MMBV4vSaUwJothgtov/UkR+/+Lm7ryrJPPf3Vm7gpPRGIdU4LDczmpg4+V/V6aeuGeg5+sMZk0mgtVU3Vldv9Ozyl0BrWjD2aI4RTTIxcfyea0/d8+K+k899V6NFhHFvM9sWti8lOZWSh7u7H//+kfaXlowevU0QS0AucdIRfPk8nOa3thIDKHZP3SrUKABBBTjflbLL4n0ljak8zneB1la9saKi0beSL4dmyusvJIJgBzFn4Is3AQrYsyKKRq4Yp7sscPAVRk0gMHrieBB5jPlP6AjQMnrBnBO60DFZP9H5VdsZzELaAsxqtv0GZg8yIqK5gfsGek4+NhVgOtVYxv7aZD0Lu2n+k8rJsaX7/jcwGvxxigDi+1atf5EfKd+2SPtniVVERHNdh9Z3tb/i0NDQ/lmpRQrT6UVhjal2PzhST8l7gEzm+EMf2X7oRzsrhh67uHziid1NfQ/smDjc/rvd/d1PnLbyh5NqJN7wCmWXxkLHL+VvnyXj2Y5fvu7Ig6/7yQgNBULVGrbjtLaF7WubTHmSLwGrsY6H3lk0evQOCDqTRPGzta8KqTiqAKbe7mP/E3GGfjUVMLx4txBDwpFlN98LWAs638M+70+uep2KlJUG1htRHme7tPzh/q2j3XeGg1oZwVpGpzugCiyxXUj6ThsDQInb3ylU1gUsmuPHIhbQDF9EL91VXFwdxsPQtBpBHO7vP1Ke7Xq/pSdCB7BQAPmBaS01rJgdyXX2Vw0f+ZMgFmumD6JZAKC0XX+FtoqLAsGbc1LJIILFfu8bAAX8tZiMxZqQ5a/SsgiFnQRZsPy0Uz9y6PeezeFkIFZzUosW6qtgkqRS8klguL+/+4mBEyceOz483BEky87apuzZowmAaxW/lIPK6Pn3ZGST7Q6M1GYOvvVroPHAV9Ze6D0iCiDSYLqi46F3xZ3eIxARsXCuzHxrnDprp3thvuo9kgAd8/o/K9gNXYKLWkFB5LtduvONjWuuXtD5HsZeuVbZm3Qhfc6kSDCiauSOX46MDIXOdjaCtaxedxQoVgVtCRkgXNk/0kXsnAx0Yr5Ic620XVZxrGzVa6Z8R6ePUNF/8pnPlQ8/d0tkoveo0K4kgkXEUnJOxLMd7Y3DB156Mt377JyJ3bJHE8B+pOxmLaMLzS8GNEs/9+TUCVz7fUoA8GViD5OFsAjdIk8qNBFEUa77cx29Xb8KtoCPekt1os1IDZpRSrl1dsVKQmurvhYoVlb8kinhX3wIaiJFCaf3M8cGBg6i+VrrDCwkjeY98h4gU5TraRXsEPjsh/byz+B2BTDtyu7/L8sZOgZhybzCylopWYqRSO0tgW89Nc/mg7ixoWGXa5VePnWb02JPJaSU7rCXHD3++fBQYMVctvGCrJxfQC4hI3WjvBPI2jr3CISeP/KPFWmKIher+dPPAzZqambnymkGRH/Xs1+99MhPLiodevI1scz+9ydGn/vjyuHHr3IO/WzPsb6up+Zxlkq0flyvqqrf7USqblhwkBEJoXJke+n7AQBjYwQQNxUV1WuR2Aqdz//GDCGk9NLZmrHOf+WpU7yzmsN6xmdee+VITc06TbGm/EZOuDVxh8cbnI7/wNm0rz0Qg0tOPPtt6aRPQNiFW1kLL30F5hIu4cc275Ht/RiLuYNfIvIQlKhe1JsvwQzfTr76spKSyjk5paGAjUQa3uzbpRJa5bG4SYEE2X7mf7p6e5+Z5aYwgrVsBpYsZMWbjsPKS18fBRHI6e8RuzRvwCWRgPa0F6vb8eHVO96PtjaF3butuXuBlHwQNDrce/iu7Mkn/2ms44l/7+vu+IUOBo6YY4U0N5MAo7949T8ou8yG1nruIAsj7b2RoZp0V+Cwf7SYAcAtrWhiEUkGuyFezPTXEBKWP/bLo/39R8IePIeDM0geHreTq1jGwvioRXwpYRyQ8McfOXAqfeIs28dI3STuAcYjevynQal60gUp00IjiZZiaolChVUDQMP4c1+2nPTQvAHD81j6fqSs+mBy1WtnWfqEtjvVbqDIsUtfv2hy9cxBrbOIZ/u+EHzpvhV1y8bKuzWngHWRC3ms9nYFEC7MdP3AdtKnAFvMHyDJpNnSY0VrWtc0rtmDRx/1Ah/QbD8PExCWlZk6eWOaI1a7d1vU3u6XNm3/aK549fVBSMJ8ZwqkiQhRf+T7h8bGBgI/Q3BYMG4n6rWMBEfTvJhzlRhQsPyJezUANJ/jk6DQv6Zk8QYWNoLLN/K9MAXBE79YlvYFixBJnXuE2D/zSjoz1oxzgEYqJQ8MTJyK+IPfhMD8eaSnbwvBIsq5aPlbRegnDBcIATAdaVh3nbLL1oaJzmLRHyQsYbsDz72m69APgvHZpo1g/dp8WEuq8spI3Sh/nsmko276dhJM85tmRIBHnlUWPZXYvHddXd1lkyViZvUfh4X+/Rknb3zaNrClhejRR73Kxq3vHSvd9DfMtgqLb873akj4GS7Jnvo8B34GAIEgCIpWB3X3dL6CBySUQsR3OgORfn5elbasRGFiQRBaQ2r/+PK4iGoYAEs10UHaK2h8B9WX5wbbLTVKeUnSFviMqNw99TnLGXYhpFxUHYkltIayK65qaGraERZ0FEgF21Y3Xn+ztooAzrNAsGCCj6ibvv12IBcuEGwE61wgZYHLJRUeNhgOnLqRY/8mnb40yBbzRr2DCNrVbqSmuit50Y/rmy74HZqsd5VKybDm1ey786bimUI/gZKtrTrZtOuj6eTmf/FFXIMXKKzGUJBSRJz+7/ecOvHA5L+fjElTbFeHry5vKj6xDyH8vuCXNc/T4Ay3uPkCxcM/FircxiyToEoq3OdEQRDsIhvDwq74WqItp4EW6ursfNr20j8BCVp8+0qA1krZpXYmUv9GAMDu3RJtbWp7TaLWs0puCCtay8X9mVJKb3i0wun7+sztqRGsc9FQZlFYUbfJ+2EKHTgpcWhoqKs41/MvBE1BvfD5t/5gV7uR6vKB0h3fLt5w9ec3lkY3UFubCo/+9WQicDh8p+KZBFp1Q/XqqyIbrr17pGzz36hArOb3mwWnOGS5aVU10dUaPFErzZzQAiqDvAGvk10hwbDKwj3T8+SvEKLgq9aIQDKMNW9etsVtKcsWLPhn/51LXgomA0l7PyvVOBa//xIAtGAWcOzSm1JAHK9+tQKArtj61yq7rDx0ti/uLxSA7Q5/p2OF5A2uTMFqntog2fkPa2haJwq3zzXAdGHmqVttt7cTUi5yukQC2mFPxHgssfadHXUvfbxo/dW3Jxu3/O7qmuT6d4JtAYYAYyeQqC2v3V7cuOMPI+uu/VFf5cUPZBNrXqpZKLASi1zzpYhIRJ3er3X2nHxkskb7TAtJa68XU3dI5PF+CAlXROoB0LIJQr5B5fvjBe3hOdiNKSFrsBxJgKEPzYW1hoWFQgYCE+DzbOt9svxf6F44N3apApj6Oo/cbbnpRyAsWtTxQSTAnvbtso13N2y8Hq2tmgFyohU3s4gWUHFHkPRHkZzo+SIH5cGxElk5F6lq1lTQBRRiqWOfgZvkzzNIVyR7PjZsV31RQ+qFxzoR2Af7pDy7vMSLld8iYvW3jPkbs18u9zpsVlkwsA+inMlere1iwSIS3Ajju6GDnRYx222y3MHM6vThlv1zbmAJBlmcR3tyyoOWluQFqxIjzGG0oGTsKgI+zXv26DDx+twQ+JAgKXeE2AWTlS8Cn5glfIpcQQBz+x59VvvCIOwEjMQlwVVhbt6hQLxYFsVSlOoMjJXmPZLa4Vd4vf/XjVV/KagxsmhhDK0pLrLRqt8HDt9VU92406Xiq1n7HJwO0sLiKKS0s8OP3tpz/IGbgjGjVqJgrZhIdw1ZwFbvTK9Wa9NAi3jPiWdvj+W6HwkC+hYzESi8Ccpl+J7SJLWKJON+pHaLE2m82InVX+zHataqSFIwSAXXTCnOW/6FhSbyRSLb9en9w8MdwE2zQyIYAEqzfSehs2OhkbaYs1aAGZ5VvGdrdVEdWlv53L7zIAAxkR08KXxH5z2yn0zwFcVXrk0kasOLUM+0fYS2vfoVQNSxYnuCEmcFRI/SIlvrQsIizmpstysAtG5k/7dsJ90ZOt8Xy8iXYIaKlL38z4C4U1r/ShUrs6HzpT8RCC7i/tBtNwHqnJ8WGx/W0tybwfUuSyoNwkArtQJ+5cTxP7P8tAJJ5LWziSgQIRZgj6FzGjqroR0N7eqgVC/Lgm6rCW6UltFs94Grvac/Ezja5xw5M0A4nM51SnYOBm2kxWN4tFK+XVHendj0LgQ118UyjBmxwNhhANja13dUsHty4Rpfp1mrSkWTFQMVa28+u/Y1S4D44foNr/Dtso3Qvi4kwW+Gv3EeTxwVXNCd6IyazUilxKNpZOLu4JcJ+WLHgjr/vl2W+Oba3Z/2ZNnNzHnqXjFrkJSWM9RbP3SibYZQGsE6pz4sraxgbuqCRI1oyaujAlKy89TJn0ezPf9BRHJpKywFGbAU3qcXfKhgvSSLpRpFWbbrA3edwkToaOe5A/xGSQDbauIXQYJ1njaSFgypx2P177+gomIr2n/mhxUQlkhqZlxZ+Aljz2a2r6VF3AOMCz3xZHhSmMfc1cSIsBNv+PPLqovqgvYteVwKtOzRbwVi44mmv9EivqQtmlpAebXmAstyA2ccDT95Up07+h+WOzQWpuvwos/K4MGiTX/kWJU7wsKIi/SX0CBG1B/6+v4Vlje4si0sKQu0sIiZJBSi8cBKaV6CpdXGjBaxs3///444PV1hFYZzf5LCpCCELMqd2tvbdfQHpzvaZzcx+L+Y0/8DqSeCyyYWNSaJwB48u7K0s/zCb74KXA4sSbREaO0pAnFTaenGqvrVu1cnk+sDl3+bCsMuAu4LSu/E3NG7SReiPSRIe9qL1jbsL7v4Nhn4V5ZyoacAUkStrfo7ay/5JyfeuCMo5leoycMLOhWnsu0LuUhV63jwXx9b6uGBRiolDvZmjkfcoW+HgaQ634BxSWudN6UjSM2y3GG3bLzvyzwtkDCCdc59WH6uoDWMtdYiDg+x3yG0auzeTEGQZ0qGk1Quonoa2Ee/GB/vK8uefL/kLIEsPrcLEmtIm+xc7+Dq9KEPBreqLjao2jRAuKLr6H3SzRwP6pvnE1US0L7KFjXtvHfD1f99VZwbgmoITDMCYGnWZ/IyWC3Qqmvqt74usv669p66a54aTu565FTt1U/FNl7/07rGTTfQzJtdwtieqmz3D6WfyeUNigTABMnaVxOx1a9OrLvy/+0FRwCoGTFuszPaT2ufRJsqW3vJ344lNrybNVT+MghzHQjzL31UiA9MgBVrimxvikY3AK0a27ZFgrZPjrs88yyoSIrS3KlbpTviQ4gCQngKOF0KUrPI8jN3d/V2PhPeS6BXsmCtAOfbiwjYx7Gi4nVOrPbmcAzRIgOIAIKWsV1VMTqafe4nT3JHhwb2MdChMXXRXEoGvzebfQykZHbk/mcSpaXb3WjVhdCsFr4p86xfgRLsyuTYwfee6Ou6D9gngX2LD6rmZutgR4dTVFJW4UWr9oChCnAwCzCUFylf21tUe2NF3O7Kjb7n2aBvppJ8Z3YtU0eHviAZXe82Xf1vYyXr/o8bq1yjRcTWFIWWRREVLV/nRJNvTsZsNzfSez+mKo62iPQPfjAUL6+9yrPLNkJrnb//WDCTciOVF3+/tOol9VH91MivftE1/Y4IgSV3H0LnPFNHh95Um1yXrb3si2OJNe/SsPTSKo4SEzQVOf17s5m+A8B2EX6fILSzVdF0o2+XXRAemIiFXQGa2SqKuPH4lma/84fHuvrHsG9yvO3jya3yIie0DLSIibHvdkeTNdf6kaoNYcrW2Y05IgjOUenE8Q9NjAw+h3bIcA4YwTp37CMAXBn19Xi08V1sFVmA4oX9Q0SAhpZxKxcpf328vP7SomRNbTRZuSZaWn1RSbyo/C1jw92PYt/kfmU+0SIGYzu994FBu+IWbZclwkG7vIGXDAVpW/Gxo98bO/HUhzi8aj7vv+voAADssP0DA3bybcpKFoFVIUH+IqhiWVruRCpTdnnj9aXFyWiZdMc3ZLN+D+DuA2wUoVpXbLiMqjf/+UBy67858YbLFKChPA1oAjMBmqF9rUUMnh1/aXXUu398NH0USEm09xOwjyuKIyO5SNmbmOwC9vKTieKsvEj52nEr+bZ4Wc3G8lhkfAuGRnpdTADtLNCKC4FyXdX0IlG79QODxZs+68QbL2HNGtBiaSEtxASmuDtwx2mC1QyJjg4dLa+70ItUvDi/4BIBzCpasbE70XhTUVn16khFdU2srHp7rKhqa61wcyM//vHQ4j6NGsHYxxXFdiYbqbyZg4rXZzHewnLYuZ7n3nb8sQ8+BNbA76/o7eBZdsjz28wUOPLdjdc/5sQbtkM7BZwAMQOSSNog9sNa5ARSDix/7OnS7ImPD3Q9dycvWCc7EI/K+o1vGi7f9Z+KYgrwl1HgWYMiFHF7+rcOPHbJk0OD3aEIF7gCBu0rX3PhhzMlF35Ca/JB2ir4u9kiSIuIPQhvzBfK6WfSQwDZRFYNy3iZssIb0LQKr+iaLzCffFi2TEwc+9HE4Z+/Mijq18oAYy9I3LLhmgdyRWsvh3JU4ReosgYsQUJC+BMQaqKf2Otk9nuIrDKGXKetWJ2yioPXvGACed5xpQWUKJ3Y99rhY89+D1MLRvjuV2367Uxy13d8lhqFFdjSELYQRIAKbk+DZpA/Nhb3h76zfezIB3/V19eL6fibWXORcS9IvuKCPY86saYd0C4X7oub82yKBGTp6P6/yBx/8pNobrbCHNcVzcpwuqdulG2AK73hnwIFlg0BEaDAvqO0YsVaKA0oJWPsxOt3DJdtb6to2vbHCMvDzONYUEilZPrU4a/Hcx1fh4QM7sFbHtMKsLTUE1SePfHeJ4eGuuaJucp3QKCBFvHajmf+OZLtfAKWZYX39BUymAWgCcpTrEkpK2l5sbp6P9aw3Y/VbvIilWW+iDJr3wf7vGiwK2kJrcmTxZdtLUVFWNQPAImbAJUcO/ER6WeAoNhggSs8CcBnVp5SFGXPrqp2Y/UXe/E1N7ixhiu9WHWdEgmG9tV0+850LWQEFuPsvgXWpg8+IJ2RQZAlCmy7gHa19j1fMymthdKwlLLLi8dLNr/l2bJtd+9MJGoWMBYYzXvkSwA/7gx+geBS3lpZiy3WJKV005m60c4Vcd/gC0uwwjSCUqfrq9LL6KAeNhd2XypBgrRk0jJwxmqC7yiPEpwpavpUU3X1xnAbJub5XtZoEZv7Drwvmus+AWnLsykKN8MqUZBkxbMnvtJ38uAdKHQrOEf1WnE7KFeTOfIO2xnMgiI0f/L2AhOVWIK0BPsM7TCUo6E9DXY5TE+xCg3NYBbREQvxGb+lgJTs6+24tzjX/TlhCQmQmsy2LGjBIZYgRUGArq+h3CAIV/kciow86xoyDAQHK7N+N5WSj41hwPIH7wpra6mCxZbYAikZfHwJ9pl9xx2Lr9pxpHbb3wWFAVPzlDoOSh5tGe74hpUb6gFZZzbegvQuRL2hbx0cHOxeqXmDK1ewAAW0iN6enkdi7uAPgwjqs3gBAhLaVSpaFR9OrHpz6MgW85r4aKVHx8YGKkaPvdPyRhiIcMGisNB2R9oyOtF5cMPQI+8LtlBnfNSsgRvliYFTjybHjr7P4nEBiujC2jfjTgcKAtcCxz0v7ap7nlQ/Z7QBGJ1tqTBaRPPIIx+Kjp/cD4pYDFZLvu2PQBBagLQMRIwJyxSEzgRA8HyLVXByN9r1r5Y7rCAknXGBLGIClA2ltWuVpbZWF9UtsEgyUjfKX46MDMX84a8Ez3gGD0pCCn9EJ5zu23jGgm8E63klyG4vG+v4S8sbdEARnGWFNWIS7MnEhQRM5aHNL5Yp2XPq+I+Lsx3/SMFVUmc4W5hBEbbdtF87fuztT2YwHAaInsXsC3wug10HbisbPfRRi3MSZOn8xfPodN1b4hVpp/UPgSL+2E8fHsLIrMBEBlrx3UGMVg4euCni9vQHl3UENwzRuXEB8xn8ZF7wvQ+cejSe6/0PEiQLt7IWsBhZkbaKS7ujDZtDXwfNZ9UDoJqxjtssNz0Byh8WMutJFIQkyxv6ZW9X10OhJCsjWL8WKyslu/q6nioZP/6XAo4ELHV2okWkqZAE8DbNSMnf63jyo0XZjocgrDMcvFIJuLI4e+yjJ0+deGDRANElihYjJQdPPv1/kmPPfdjiCQkRFYX73M5wV8WsIG1hO/1u+VjXpxYITNQAZGe695nqzME32G5/FiIq85fdP0OLk4hi2qGCU2oYgLtQNwWBxFsGn/twPNt9CHbMAvPZtJsBARZkL/oMqZQ42t9/OOZnvgshaUkZFyQgdQ4JZ+gLwU1NKzdvcKUL1pQ1kTm57zMlo4dvFaQskK3zVlpcaPCwhq2cEwwAfX15bmht438FOY3D+99qe70ZiAiB9VLEUpGQVtFEx12ZE/v+IQxh0MvZN4yUHDrx9D+UD+1/WySXzkDGJFiq5Y/W5+CeDxmRlj8qSsdPvrezr/NpLHwzcbDY9HbcWzv4zA2RbPcpyIjFRP7y1CFmgOFBRkXMHdi3duTJ10s15oEkL/zzmQEBUlk/6o4cnRSoeVwCeHh0dLApc/DGmNPbBytuBWK71HYzgwSRynoJP31ige87bTta4vZ8VvoZHdTKKmSXzxokpPTSXZeM7ftO6BhTRrB+vaKlNVrEaMfj70uOHPiEpSYkrJgAKJyYzIUNHguWGkUy17M3dHjm+3cauFEeHBw8UDF69N1SjwmQXej3aQhbRnLdJ7b3PvMOPR3NvsybokC0+nsO3F43+IuriiaO3SNJSciIAIQKTxHPzv8G+CCbSFpW1OnrqBrZd+NQ177PY7Fr1GcsNp0Dne2r+x6+pmj8+N2CYEFECIB/ZqLKwRYIUsGK2PFs1+GmkWdSB7qOfjvmDfwYwqIFLTmGDylFzB36n/7ezsVuj9EAxMG+rqca049fF892PkOWbYEmf3aB7WYoCItsP/OLru6Bw/PU+5/js+0+efSBiDP8i+AGoEIsesEghu2lv3ZPGpmVnjc47x5lZTa7HYwW4WTuuKfK9p7wyd7FVryGrQiFDuNZNxmHZZIYHFxzZDFJshITx780dHL/Z4PBWsix7z4Gmq2J0ceeKimKVbux6suhsXhEMjODbLb8YV07cvB39qf7nwVaz+GpTRCpn8k+2qfTHV9N2tzhQ2+CjNWyjIqp/mHwLFfP9F1+xJjuOwoTnQWBbEGAsP3hoeJs961betvfdmhw6NGl9R/kkOMMuukTX7s1IgYVyYu0nUgG4sKMqVr4PN9+dbpNjOC0WFhC6pwoynV9e3V3e+pgeuwYkJJrrMd/OW4Vv0FFy0vB2g+eFxy8D2jImB1xe8ZqJ46/eXg00wO00yKTmwHI9Ph476VDx+5Ix2OlzNYujhTZQWoUOOzTYMzN7D8O+09GLdsd8CvGDt3ywbGRjnAMLCImNaIV+3R5SSzjWOU3Msmw5vRitdQkWf6wUz/x7LuHR7OD2LePXmiCRSu7+UE4wMuAxENNF92ci1e8TYn4ZdpKRFhETq+fNeVTZkg/i+j4ya+9quOhd7YBuUUcrwv0WUrsRZt827or7p4o3ngtlB8GLvI8FoD0BXtWSWbfBzPd+/4xyC97XgL4wlsqGG8FYt9t2P66XLzqLb5dcp22iuOKrOBReHLXxDPvXaAgXpHC/2kINQHLHXvGzqXvqBl/9itH07kTM9/BmbbtwgRqT1TtfkfWLn+LjpRs0bIouPVoqkmaw9KkgAAFektBm/xRjriZn5VMnPrngVMHv6Ondw0MgNfVNO7sLb3gtlys5kWaouHzaAj2EXEGj5SNHPqDnp7j7fmtw9N2JJoANJTV7Ewn17/diyZfw1ZiPcs4NAnwzJHEk12oYLsD/cmxo/9roOvwt7iw7xMAeFcFGvZVveKgZ1cVAe7CGR4MBcuSifEjd2WP/PI1Ogjg1XiBQSv/EVISuFMhvNxrVWX9lkyi+jJfFl/iicgagCoIdimISxh6zIb3ZEmu9xs9nc/9eEaSGp/JhNteXrbqUNUlv3KjDfXQjp5bFIl8EsIqGj7w1YmTj93CZza5l7V/1lVXb8zEVzdnI0XNHuIXK5K1ILsKwiKGDsOfNMD+iNBev9DOwajK/qpYZ+5uOfHcw+8CglujUymJtjZ9Fis4BbFIQX+8B4je0bDp6gm7/OWeVXy5lpH1TFYVk4yFwcJg7eQEqT6L/UMRnri/aKzv+309Rx8JZuWU9cEzxeXzgP0XTRfe5ETKX6GEbJDgwZgeu3fn0Ue/0Q4ML0Gs5rSbALwUSDxRv+liN5Z8kS+jWz1YTcRWJUgkObgE9VRUZX66evjpLz2bzp0s+PvCyPTk6p0fHCnd+inWUoHUIjsi0hKOqBp5+rW9Jw9/D7+WsWYEa4mD6M7TIr0nD+kVQDcAkR8C7nTE6ZwBfibbabWqfu1v9Zbt+IErkwC70zFMQZ6gTEwcf+KVR35+TRtaJiaTdn99/bONJ1fd0IEitpagfDDW2MSWKFWWzewzCe05Rd5g14VD2YEfA85pPZq6UYYngXrZ2pZKCbRNvzsB4IpKlJwQ1bUO4jUes7QJDCfTUz8ycuoZYHz6y5mCLIF5J+eUJTd7XzlT1M7Ygk2laGa7Z4651wOROoA+CzjTX1Cw1SPQ0oLXtrYmfrjp+me9aMOqxdPRWENERCzbdeAPD9970b9O14ZmI1gr4iChWaAZwYWTrR/j01IcUjfKoKbUcqw+wfauevWF7xkq3XarYukByg7yBG2Kun3pzWP7rnyq+9TBMBdNnzf9k6rh2ZNt/uHx1wLN94nwUEKfw0kQXIvW3Exov2+RK60p2JU175FhuonO/3NTAikAbXs1UjcJ9PVRWHWTl7XdNTWMbdsYrR+f0aalthUCzS1E7a1+6brd/zxSvOl9rPImXysSkCUj+z4y0vHU379Q8gZ/UwQr33Mu84RrtgjtfmL1JV8aL93ydtbsQUjL8oepOrP/dadOHfnvSWvsPO6X+SJGZ4TC/9raRpjX6b4iLId8F90HFtq2beFNbpMLa7B1r1678z0DiY23KkTV4iVzmEE2LK9/dG3/I9sPDw11nqXlaATrhS+GLfQetNpfXnP5t5yiplcBrk6MHv/ISOfTn+QXqC/BcLZ+xWBMzFwxrgcST5Q37BovXfs+p7jhJkU2g30Ai9xZyFBkWbJo7OCXJo4+/A4OfIvqBTzZDMvUj8wAVdWsvy6is+megVOP8Qt4pTOczZYcelNl/Zbeig1vzVFkp4YCsV3KEE1aRNcquxRgFSag54lnJsmWGuW69BNXdPZ0PnweW/NGsM5H0Zr+5QvzWNlwdmJFgC5t3PZnE8Vr/lbFqov0ZKqfnozG8AHWCoXESIYHO7Hs0Z9mDz/4MkILvdDHnGXG0LIxGekVjjwjVobTkABUZcMFb0wnN39GyQTgOT5YTFeeCG4KFkAhhQ4ZIAtSjaBkvO+TQe7OPvFC70RhxtGyi5Yy20DDXOubdTNQPFLU9AklSxjKUyBYEDq4tzIoklh4iWcmBSllxOm/e/DU4Z9M3mxkBMtgMCzDPCN+umbdFX6kfC2UzzirtDhmCBuWM5CtHD35gWB1bP1N6UiDwXBuCe7G9OLJXaA4B3F6ZyFWsJRETpbnTnwwqJLxwqkoagTLYDhfJhurEUCdUZXEGWKlBXlWyeiRTw12PPvv+A0LmzGCZTCcc4JKFsW53l9Jf5xBtMRyy2H9MbLJgiuTIwf/fqTj8Q8FCc5tv1H+UiNYBsO5RwMtorOv7xnLGfgphCUA4S0esM8c1gjzQRZB2pbtDQ2Vje5/x/CJJz+ip65Te+HlCy6GicMyGJ4/40A3lFRuHqy7+D4n3lgH5eipAoCTskMUhDaQIJAEQUG6mfG4l/5m3eCzf3cokzn6mxzjZwTLYHieRWtTZf2W7vLNn81FKq5TMhYWH51ULAWhPZByRqTO7ov6o3dVjh5rOz4wcDD4G7/ZqV5GsAyGX4NoCQA1dRdcO2IVX8ugYmEJBpMjyDsW9ceOl010HTk6lO2cMqOCHMHlLOtjMBgMhYpWIbYCBYX8jK/ZWFgGw3mARHPz3DkY1B4z1pTBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDC8k/j/Q9kIaoNeeSgAAAABJRU5ErkJggg==" alt="Localy" style={{ height: 36, objectFit: "contain" }} />
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{
            fontSize: 11, fontWeight: 700, color: T.cobalt,
            background: T.cobaltL, padding: "3px 10px", borderRadius: 99,
          }}>
            {userType === "homeowner" ? "Homeowner" : "Pro"}
          </span>
          <a href="mailto:support@hirelocaly.com?subject=Localy%20Support" style={{
            fontSize: 12, color: T.slate, fontFamily: "'DM Sans', sans-serif", textDecoration: "none",
          }}>
            💬 Support
          </a>
          <button onClick={handleLogout} style={{
            background: "none", border: "none", cursor: "pointer",
            fontSize: 12, color: T.coral, fontFamily: "'DM Sans', sans-serif",
          }}>Sign Out</button>
        </div>
      </div>

      {/* Content */}
      <div style={{ flex: 1, overflowY: "auto" }}>
        {renderView()}
      </div>

      {/* Job Match Alert — shown to pros when a new job is posted */}
      {incomingJob && userType === "pro" && (
        <JobMatchAlert
          job={incomingJob}
          onAccept={acceptJob}
          onDecline={declineJob}
          onView={() => { declineJob(); navigate("jobs"); }}
        />
      )}

      {/* Job Accepted Confirmation — shown to pro after accepting */}
      {acceptedJob && (
        <div style={{ position:"fixed", bottom:80, left:"50%", transform:"translateX(-50%)", zIndex:999, background:T.green, color:T.white, borderRadius:99, padding:"10px 20px", fontSize:13, fontWeight:700, fontFamily:"'DM Sans', sans-serif", boxShadow:"0 4px 20px rgba(0,0,0,0.2)", whiteSpace:"nowrap" }}>
          ✅ Job accepted! Check Messages for details.
        </div>
      )}

      {/* Cancellation Modal */}
      {cancelBooking && (
        <CancellationModal
          booking={cancelBooking}
          onConfirm={() => setCancelBooking(null)}
          onClose={() => setCancelBooking(null)}
        />
      )}

      {/* Review Prompt Overlay */}
      {pendingReview && (
        <ReviewPrompt
          pro={pendingReview.pro}
          trigger={pendingReview.trigger}
          bookingId={pendingReview.bookingId}
          authUser={authUser}
          onDone={() => dismissReview(pendingReview.pro?.id)}
          onSkip={() => dismissReview(pendingReview.pro?.id)}
        />
      )}

      {/* Legal footer links */}
      <div style={{ background:T.white, borderTop:`1px solid ${T.border}`, padding:"8px 16px", display:"flex", justifyContent:"center", gap:16 }}>
        <button onClick={() => navigate("terms")} style={{ background:"none", border:"none", color:T.slate, cursor:"pointer", fontSize:10, fontFamily:"'DM Sans', sans-serif", fontWeight:600 }}>Terms</button>
        <span style={{ color:T.border, fontSize:10 }}>·</span>
        <button onClick={() => navigate("privacy")} style={{ background:"none", border:"none", color:T.slate, cursor:"pointer", fontSize:10, fontFamily:"'DM Sans', sans-serif", fontWeight:600 }}>Privacy</button>
        <span style={{ color:T.border, fontSize:10 }}>·</span>
        <button onClick={() => navigate("cancellation")} style={{ background:"none", border:"none", color:T.slate, cursor:"pointer", fontSize:10, fontFamily:"'DM Sans', sans-serif", fontWeight:600 }}>Cancellations</button>
        <span style={{ color:T.border, fontSize:10 }}>·</span>
        <span style={{ color:T.slate, fontSize:10 }}>© 2026 Localy</span>
      </div>

      {/* Bottom nav */}
      <div style={{
        background: T.white, borderTop: `1px solid ${T.border}`,
        display: "flex", justifyContent: "space-around", padding: "10px 0 14px",
      }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => handleTab(t.id)} style={{
            background: "none", border: "none", cursor: "pointer",
            display: "flex", flexDirection: "column", alignItems: "center", gap: 3,
            fontFamily: "'DM Sans', sans-serif", position: "relative",
          }}>
            <span style={{ color: activeTab === t.id ? T.cobalt : T.slate, display:"flex", position:"relative" }}>
              {NAV_SVG[t.icon] ? NAV_SVG[t.icon](activeTab === t.id ? T.cobalt : T.slate) : t.icon}
              {!!t.badge && (
                <span style={{
                  position:"absolute", top:-6, right:-10, background:T.coral, color:"#fff",
                  fontSize:9, fontWeight:800, borderRadius:99, minWidth:15, height:15,
                  display:"flex", alignItems:"center", justifyContent:"center", padding:"0 3px",
                  lineHeight:1,
                }}>{t.badge}</span>
              )}
            </span>
            <span style={{
              fontSize: 10, fontWeight: 700, letterSpacing: "0.05em",
              color: activeTab === t.id ? T.cobalt : T.slate,
            }}>{t.label.toUpperCase()}</span>
            {activeTab === t.id && (
              <div style={{ width: 20, height: 2, background: T.cobalt, borderRadius: 99 }} />
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
